webpackJsonp([1],{

/***/ 1245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jsonwebtoken__);




var TABLE = '/ano/';

// initial state
var state = {
    data: []

    // getters
};var getters = {
    getAll: function getAll(state) {
        return state.data;
    },
    getById: function getById(state) {
        return function (id) {
            if (!id) return;
            return state.data.find(function (el) {
                return el.id_ano == id;
            });
        };
    }

    // actions
};var actions = {
    get: function get(_ref) {
        var commit = _ref.commit;

        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].get(TABLE).then(function (res) {
            commit('setData', res.data.data || null);
        }).catch(function (err) {
            commit('setData', null);
        });
    },
    insert: function insert(_ref2, params) {
        var dispatch = _ref2.dispatch;


        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].post(TABLE, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params)).then(function (res) {
            if (!res.data.errors) {
                dispatch('get');
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    },
    update: function update(_ref3, params) {
        var dispatch = _ref3.dispatch;

        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].put(TABLE, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params)).then(function (res) {
            if (!res.data.errors) {
                dispatch('get');
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    },
    delete: function _delete(_ref4, _ref5) {
        var dispatch = _ref4.dispatch;
        var id = _ref5.id;

        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].delete(TABLE + id).then(function (res) {
            if (!res.data.errors) {
                dispatch('get');
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    }
};

// mutations
var mutations = {
    setData: function setData(state, data) {
        state.data = data ? data : [];
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ 1246:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jsonwebtoken__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jsonwebtoken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jsonwebtoken__);



// initial state
var state = {
    data: [{
        id_tipo_acao: 1,
        nome: 'Ação inserida em Projeto de ED'
    }, {
        id_tipo_acao: 2,
        nome: 'Ação inserida noutro tipo de projeto'
    }, {
        id_tipo_acao: 3,
        nome: 'Ação não inserida em projeto'
    }]

    // getters
};var getters = {
    getAll: function getAll(state) {
        return state.data;
    },
    getById: function getById(state) {
        return function (id) {
            if (!id) return;
            return state.data.find(function (el) {
                return el.id_tipo_acao == id;
            });
        };
    }
};

var actions = {};

var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ 1247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jsonwebtoken__);




var TABLE = '/fase/';

// initial state
var state = {
    data: []

    // getters
};var getters = {
    getAll: function getAll(state) {
        return state.data;
    },
    getById: function getById(state) {
        return function (id) {
            if (!id) return;
            return state.data.find(function (el) {
                return el.id_fase == id;
            });
        };
    },
    isPlanificacaoAberta: function isPlanificacaoAberta(state) {
        return function (id) {
            if (!id || state.data.length == 0) return;
            var fase = state.data.find(function (el) {
                return el.id_ano == id && el.tipo == 1 && new Date() >= new Date(el.data_inicio + ' 00:00') && new Date() <= new Date(el.data_fim + ' 23:59');
            });
            return typeof fase != 'undefined' ? true : false;
        };
    },
    isReporteAberta: function isReporteAberta(state) {
        return function (id) {
            if (!id || state.data.length == 0) return;
            var fase = state.data.find(function (el) {
                return el.id_ano == id && el.tipo == 2 && new Date() >= new Date(el.data_inicio + ' 00:00') && new Date() <= new Date(el.data_fim + ' 23:59');
            });
            return typeof fase != 'undefined' ? true : false;
        };
    }

    // actions
};var actions = {
    get: function get(_ref) {
        var commit = _ref.commit;

        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].get(TABLE).then(function (res) {
            commit('setData', res.data.data || null);
        }).catch(function (err) {
            commit('setData', null);
        });
    },
    insert: function insert(_ref2, params) {
        var dispatch = _ref2.dispatch;


        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].post(TABLE, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params)).then(function (res) {
            if (!res.data.errors) {
                dispatch('get');
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    },
    update: function update(_ref3, params) {
        var dispatch = _ref3.dispatch;

        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].put(TABLE, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params)).then(function (res) {
            if (!res.data.errors) {
                dispatch('get');
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    },
    delete: function _delete(_ref4, _ref5) {
        var dispatch = _ref4.dispatch;
        var id = _ref5.id;

        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].delete(TABLE + id).then(function (res) {
            if (!res.data.errors) {
                dispatch('get');
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    }
};

// mutations
var mutations = {
    setData: function setData(state, data) {
        state.data = data ? data : [];
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ 1248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jsonwebtoken__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jsonwebtoken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jsonwebtoken__);



// initial state
var state = {
    data: [{
        id_mes: 1,
        nome: 'Janeiro'
    }, {
        id_mes: 2,
        nome: 'Fevereiro'
    }, {
        id_mes: 3,
        nome: 'Março'
    }, {
        id_mes: 4,
        nome: 'Abril'
    }, {
        id_mes: 5,
        nome: 'Maio'
    }, {
        id_mes: 6,
        nome: 'Junho'
    }, {
        id_mes: 7,
        nome: 'Julho'
    }, {
        id_mes: 8,
        nome: 'Agosto'
    }, {
        id_mes: 9,
        nome: 'Setembro'
    }, {
        id_mes: 10,
        nome: 'Outubro'
    }, {
        id_mes: 11,
        nome: 'Novembro'
    }, {
        id_mes: 12,
        nome: 'Dezembro'
    }]

    // getters
};var getters = {
    getAll: function getAll(state) {
        return state.data;
    },
    getById: function getById(state) {
        return function (id) {
            if (!id) return;
            return state.data.find(function (el) {
                return el.id_mes == id;
            });
        };
    }
};

var actions = {};

var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ 1249:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(430);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b699f278_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(1275);
function injectStyle (ssrContext) {
  __webpack_require__(1250)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b699f278_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1250:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.auth == 1)?_c('v-app',{attrs:{"id":"inspire"}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.altpwd),callback:function ($$v) {_vm.altpwd=$$v},expression:"altpwd"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Alterar password")])]),_vm._v(" "),_c('v-form',{ref:"form"},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Password")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#f8ac4a","type":"password"},model:{value:(_vm.pwd),callback:function ($$v) {_vm.pwd=$$v},expression:"pwd"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Confirmar password")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#f8ac4a","type":"password","rules":_vm.pwdRules},model:{value:(_vm.cpwd),callback:function ($$v) {_vm.cpwd=$$v},expression:"cpwd"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":""},nativeOn:{"click":function($event){_vm.altpwd = false}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":""},nativeOn:{"click":function($event){return _vm.changeData($event)}}},[_vm._v("Guardar")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.excel),callback:function ($$v) {_vm.excel=$$v},expression:"excel"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Exportar excel")])]),_vm._v(" "),_c('v-form',{ref:"form"},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[(_vm.getSession.user.super)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Instituição")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#f8ac4a","items":[
                    { id_instituicao: 0, nome: 'TODAS' } ].concat( _vm.getAllInstituicoes ),"item-text":"nome","item-value":"id_instituicao"},model:{value:(_vm.INSTITUICAO),callback:function ($$v) {_vm.INSTITUICAO=$$v},expression:"INSTITUICAO"}}),_vm._v(" "),_c('span',{staticStyle:{"font-size":"12px","color":"grey"}},[_vm._v("* a opção TODAS poderá demorar alguns minutos")])],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Ano")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#f8ac4a","items":_vm.getAnos,"item-text":"nome","item-value":"nome"},model:{value:(_vm.ANO),callback:function ($$v) {_vm.ANO=$$v},expression:"ANO"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":""},nativeOn:{"click":function($event){_vm.excel = false}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":""},nativeOn:{"click":function($event){return _vm.exportar($event)}}},[_vm._v("Exportar")])],1)],1)],1)],1),_vm._v(" "),_c('v-navigation-drawer',{attrs:{"clipped":_vm.$vuetify.breakpoint.lgAndUp,"fixed":"","app":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',{attrs:{"dense":""}},[_vm._l((_vm.items),function(item,index){return [(
            item.super == 0 || (item.super == 1 && _vm.getSession.user.super == 1)
          )?_c('v-list-tile',{key:index,attrs:{"to":item.to}},[_c('v-list-tile-action',{staticClass:"pm-text"},[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',{staticClass:"pm-text"},[_c('v-list-tile-title',[_vm._v(_vm._s(item.text))])],1)],1):_vm._e()]})],2)],1),_vm._v(" "),_c('v-toolbar',{attrs:{"clipped-left":_vm.$vuetify.breakpoint.lgAndUp,"color":"#f8ac4a","dark":"","app":"","fixed":""}},[_c('v-toolbar-title',{staticClass:"ml-0 pl-3",staticStyle:{"width":"600px"}},[_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}}),_vm._v(" "),_c('span',{staticClass:"hidden-sm-and-down"},[_vm._v("ENED")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('span',{staticClass:"wlcTxt"},[_vm._v("Bem-vindo, "+_vm._s(_vm.getSession.user.nome))]),_vm._v(" "),_c('span',{staticClass:"divi"},[_vm._v("|")]),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
          var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();_vm.altpwd = true}}},on),[_c('v-icon',[_vm._v("settings")])],1)]}}],null,false,2594968532)},[_vm._v(" "),_c('span',[_vm._v("Alterar password")])]),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
          var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();_vm.excel = true}}},on),[_c('v-icon',[_vm._v("grid_on")])],1)]}}],null,false,3971258042)},[_vm._v(" "),_c('span',[_vm._v("Exportar excel")])]),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
          var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();return _vm.logout($event)}}},on),[_c('v-icon',[_vm._v("power_settings_new")])],1)]}}],null,false,2534286127)},[_vm._v(" "),_c('span',[_vm._v("Sair")])])],1),_vm._v(" "),_c('v-content',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',[_c('router-view')],1)],1)],1)],1):(this.auth == 0)?_c('Login'):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Login__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Administradores__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Instituicoes__ = __webpack_require__(1285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Objetivos__ = __webpack_require__(1287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Medidas__ = __webpack_require__(1289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Acoes__ = __webpack_require__(1291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Dimensoes__ = __webpack_require__(1293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Perguntas__ = __webpack_require__(1295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Formularios__ = __webpack_require__(1297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Setores__ = __webpack_require__(1299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Propostas__ = __webpack_require__(1301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Anos__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_tables_Table_Administradores__ = __webpack_require__(1305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_tables_Table_Instituicoes__ = __webpack_require__(1307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_tables_Table_Objetivos__ = __webpack_require__(1309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_tables_Table_Medidas__ = __webpack_require__(1311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_tables_Table_Acoes__ = __webpack_require__(1313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_tables_Table_Dimensoes__ = __webpack_require__(1315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_tables_Table_Perguntas__ = __webpack_require__(1319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_tables_Table_Formularios__ = __webpack_require__(1322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_tables_Table_Setores__ = __webpack_require__(1324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_tables_Table_Propostas__ = __webpack_require__(1326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_tables_Table_Anos__ = __webpack_require__(1335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_tables_Table_Fases__ = __webpack_require__(1337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_tables_Table_Propostas_Admin__ = __webpack_require__(1339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_tables_Table_Home__ = __webpack_require__(1342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_Perfil__ = __webpack_require__(1345);
















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Login', __WEBPACK_IMPORTED_MODULE_3__components_Login__["a" /* default */]);

// -- TABLES

















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Table_Administradores', __WEBPACK_IMPORTED_MODULE_15__components_tables_Table_Administradores__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Table_Instituicoes', __WEBPACK_IMPORTED_MODULE_16__components_tables_Table_Instituicoes__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Table_Objetivos', __WEBPACK_IMPORTED_MODULE_17__components_tables_Table_Objetivos__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Table_Medidas', __WEBPACK_IMPORTED_MODULE_18__components_tables_Table_Medidas__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Table_Acoes', __WEBPACK_IMPORTED_MODULE_19__components_tables_Table_Acoes__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Table_Dimensoes', __WEBPACK_IMPORTED_MODULE_20__components_tables_Table_Dimensoes__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Table_Perguntas', __WEBPACK_IMPORTED_MODULE_21__components_tables_Table_Perguntas__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Table_Formularios', __WEBPACK_IMPORTED_MODULE_22__components_tables_Table_Formularios__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Table_Setores', __WEBPACK_IMPORTED_MODULE_23__components_tables_Table_Setores__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Table_Propostas', __WEBPACK_IMPORTED_MODULE_24__components_tables_Table_Propostas__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Table_Anos', __WEBPACK_IMPORTED_MODULE_25__components_tables_Table_Anos__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Table_Fases', __WEBPACK_IMPORTED_MODULE_26__components_tables_Table_Fases__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Table_Propostas_Admin', __WEBPACK_IMPORTED_MODULE_27__components_tables_Table_Propostas_Admin__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Table_Home', __WEBPACK_IMPORTED_MODULE_28__components_tables_Table_Home__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('perfil', __WEBPACK_IMPORTED_MODULE_29__components_Perfil__["a" /* default */]);

// -- TABLES


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */]
  }, {
    path: '/administradores',
    name: 'administradores',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Administradores__["a" /* default */]
  }, {
    path: '/instituicoes',
    name: 'instituicoes',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Instituicoes__["a" /* default */]
  }, {
    path: '/objetivos',
    name: 'objetivos',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Objetivos__["a" /* default */]
  }, {
    path: '/medidas',
    name: 'medidas',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Medidas__["a" /* default */]
  }, {
    path: '/acoes',
    name: 'acoes',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Acoes__["a" /* default */]
  }, {
    path: '/dimensoes',
    name: 'dimensoes',
    component: __WEBPACK_IMPORTED_MODULE_9__components_Dimensoes__["a" /* default */]
  }, {
    path: '/perguntas',
    name: 'perguntas',
    component: __WEBPACK_IMPORTED_MODULE_10__components_Perguntas__["a" /* default */]
  }, {
    path: '/formularios',
    name: 'formularios',
    component: __WEBPACK_IMPORTED_MODULE_11__components_Formularios__["a" /* default */]
  }, {
    path: '/setores',
    name: 'setores',
    component: __WEBPACK_IMPORTED_MODULE_12__components_Setores__["a" /* default */]
  }, {
    path: '/propostas',
    name: 'propostas',
    component: __WEBPACK_IMPORTED_MODULE_13__components_Propostas__["a" /* default */]
  }, {
    path: '/anos',
    name: 'anos',
    component: __WEBPACK_IMPORTED_MODULE_14__components_Anos__["a" /* default */]
  }, {
    path: '/perfil',
    name: 'perfil',
    component: __WEBPACK_IMPORTED_MODULE_29__components_Perfil__["a" /* default */]
  }]
}));

/***/ }),

/***/ 1278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33072e6a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(1279);
var normalizeComponent = __webpack_require__(12)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33072e6a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1279:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('Table_Home')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(442);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_466cf66b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(1282);
function injectStyle (ssrContext) {
  __webpack_require__(1281)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-466cf66b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_466cf66b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1281:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[_c('v-content',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{staticStyle:{"display":"flex"},attrs:{"wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}},[_c('v-layout',{staticStyle:{"display":"flex","margin-top":"15vh"},attrs:{"wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('div',{staticClass:"logo-login"},[_c('span',[_vm._v("ENED")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-form',{ref:"form"},[_c('label',{staticClass:"label-modal"},[_vm._v("Username")]),_vm._v(" "),_c('v-text-field',{attrs:{"required":"","color":"#f8ac4a","rules":[function () { return this$1.username.length > 0 || _vm.required; }],"autocomplete":"off","prepend-icon":"person","name":"username","type":"text"},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.login($event)}},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}}),_vm._v(" "),_c('label',{staticClass:"label-modal"},[_vm._v("Password")]),_vm._v(" "),_c('v-text-field',{attrs:{"required":"","color":"#f8ac4a","rules":[function () { return this$1.password.length > 0 || _vm.required; }],"id":"password","prepend-icon":"lock","name":"password","type":"password"},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.login($event)}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"flex"},attrs:{"xs12":"","sm12":"","md12":"","justify-end":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"color":"#f8ac4a","loading":_vm.loading},on:{"click":function($event){$event.stopPropagation();return _vm.login()}}},[_vm._v("Entrar")])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1283:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Administradores_vue__ = __webpack_require__(443);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43010c55_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Administradores_vue__ = __webpack_require__(1284);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Administradores_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43010c55_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Administradores_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[(_vm.getSession.user.super == 1)?_c('Table_Administradores'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1285:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Instituicoes_vue__ = __webpack_require__(444);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00f5868e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Instituicoes_vue__ = __webpack_require__(1286);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Instituicoes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00f5868e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Instituicoes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1286:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[(_vm.getSession.user.super == 1)?_c('Table_Instituicoes'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Objetivos_vue__ = __webpack_require__(445);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b74b4bd_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Objetivos_vue__ = __webpack_require__(1288);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Objetivos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b74b4bd_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Objetivos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[(_vm.getSession.user.super == 1)?_c('Table_Objetivos'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1289:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Medidas_vue__ = __webpack_require__(446);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e874c40e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Medidas_vue__ = __webpack_require__(1290);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Medidas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e874c40e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Medidas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1290:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[(_vm.getSession.user.super == 1)?_c('Table_Medidas'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1291:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Acoes_vue__ = __webpack_require__(447);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_376a2235_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Acoes_vue__ = __webpack_require__(1292);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Acoes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_376a2235_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Acoes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1292:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[(_vm.getSession.user.super == 1)?_c('Table_Acoes'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1293:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dimensoes_vue__ = __webpack_require__(448);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cd2f1b5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dimensoes_vue__ = __webpack_require__(1294);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dimensoes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cd2f1b5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dimensoes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[(_vm.getSession.user.super == 1)?_c('Table_Dimensoes'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1295:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Perguntas_vue__ = __webpack_require__(449);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_564484b6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Perguntas_vue__ = __webpack_require__(1296);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Perguntas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_564484b6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Perguntas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[(_vm.getSession.user.super == 1)?_c('Table_Perguntas'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Formularios_vue__ = __webpack_require__(450);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a3c55ae_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Formularios_vue__ = __webpack_require__(1298);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Formularios_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a3c55ae_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Formularios_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[(_vm.getSession.user.super == 1)?_c('Table_Formularios'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1299:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Setores_vue__ = __webpack_require__(451);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46266f76_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Setores_vue__ = __webpack_require__(1300);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Setores_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46266f76_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Setores_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1300:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[(_vm.getSession.user.super == 1)?_c('Table_Setores'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1301:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Propostas_vue__ = __webpack_require__(452);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d1c7cae_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Propostas_vue__ = __webpack_require__(1302);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Propostas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d1c7cae_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Propostas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[(_vm.getSession.user.super == 0)?_c('Table_Propostas'):_vm._e(),_vm._v(" "),(_vm.getSession.user.super == 1)?_c('Table_Propostas_Admin'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1303:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Anos_vue__ = __webpack_require__(453);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47c24f8f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Anos_vue__ = __webpack_require__(1304);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Anos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47c24f8f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Anos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1304:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[(_vm.getSession.user.super == 1)?_c('Table_Fases'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1305:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Administradores_vue__ = __webpack_require__(454);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_420f7a8a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Administradores_vue__ = __webpack_require__(1306);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Administradores_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_420f7a8a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Administradores_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1306:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[_c('div',{staticClass:"elevation-3"},[_c('div',{staticClass:"tableHeader"},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('v-btn',{staticClass:"mb-2",attrs:{"slot":"activator","color":"#f8ac4a","dark":""},slot:"activator"},[_c('v-icon',{staticClass:"buttonIconText",attrs:{"color":"white"}},[_vm._v("playlist_add")]),_vm._v(" Novo "+_vm._s(_vm.name))],1),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();}}},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Nome")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#f8ac4a","rules":_vm.defaultRules},model:{value:(_vm.editedItem.nome),callback:function ($$v) {_vm.$set(_vm.editedItem, "nome", $$v)},expression:"editedItem.nome"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Username")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#f8ac4a","rules":_vm.defaultRules},model:{value:(_vm.editedItem.username),callback:function ($$v) {_vm.$set(_vm.editedItem, "username", $$v)},expression:"editedItem.username"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Email")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#f8ac4a","rules":_vm.defaultRules},model:{value:(_vm.editedItem.email),callback:function ($$v) {_vm.$set(_vm.editedItem, "email", $$v)},expression:"editedItem.email"}})],1),_vm._v(" "),(_vm.editedIndex==-1)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Password")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#f8ac4a","type":"password","rules":_vm.defaultRules},model:{value:(_vm.editedItem.password),callback:function ($$v) {_vm.$set(_vm.editedItem, "password", $$v)},expression:"editedItem.password"}})],1):_vm._e(),_vm._v(" "),(_vm.editedIndex==-1)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Confirmar password")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#f8ac4a","type":"password","rules":_vm.pwdRules},model:{value:(_vm.cpwd),callback:function ($$v) {_vm.cpwd=$$v},expression:"cpwd"}})],1):_vm._e(),_vm._v(" "),(_vm.editedIndex>-1)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}}):_vm._e(),_vm._v(" "),(_vm.editedIndex>-1)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Ativo?")]),_vm._v(" "),_c('v-checkbox',{attrs:{"color":"#f8ac4a"},model:{value:(_vm.editedItem.ativo),callback:function ($$v) {_vm.$set(_vm.editedItem, "ativo", $$v)},expression:"editedItem.ativo"}})],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":""},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":""},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Guardar")])],1)],1)],1)],1),_vm._v(" "),_c('v-text-field',{staticClass:"searchTable",attrs:{"color":"#f8ac4a","append-icon":"search","label":"Pesquisa","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"390"},model:{value:(_vm.deleteM),callback:function ($$v) {_vm.deleteM=$$v},expression:"deleteM"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline",staticStyle:{"margin-left":"0px !important"}},[_vm._v("Apagar "+_vm._s(_vm.name))]),_vm._v(" "),_c('v-card-text',[_vm._v("De certeza que quer apagar este "+_vm._s(_vm.name)+"?")]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"margin-top":"0px !important"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":"flat"},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":"flat"},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Apagar")])],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.DATA,"search":_vm.search,"loading":_vm.loading,"item-key":"id","disable-initial-sort":true,"rows-per-page-items":[10,25,50,{"text":"Todos","value":-1}],"rows-per-page-text":"Itens por página:"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"textLeft",on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v(_vm._s(props.item.id_instituicao))]),_vm._v(" "),_c('td',{staticClass:"textCenter",on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v(_vm._s(props.item.nome))]),_vm._v(" "),_c('td',{staticClass:"textCenter",on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v(_vm._s(props.item.username))]),_vm._v(" "),_c('td',{staticClass:"textCenter",on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v(_vm._s(props.item.email))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[(props.item.ativo)?_c('span',{staticStyle:{"background-color":"green","height":"10px","width":"10px","border-radius":"50px","position":"absolute"}}):_c('span',{staticStyle:{"background-color":"red","height":"10px","width":"10px","border-radius":"50px","position":"absolute"}})]),_vm._v(" "),_c('td',{staticClass:" px-0 textTable textCenter"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_c('v-icon',{attrs:{"color":"light-green darken-1"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item, false)}}},[_c('v-icon',{attrs:{"color":"red lighten-1"}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{staticClass:"alertTable",slot:"no-data"},[_c('v-alert',{attrs:{"value":true,"icon":"warning"}},[_vm._v("\n                    De momento não há nada a apresentar! :(\n                ")])],1)],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1307:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Instituicoes_vue__ = __webpack_require__(455);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f148416e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Instituicoes_vue__ = __webpack_require__(1308);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Instituicoes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f148416e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Instituicoes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1308:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[_c('div',{staticClass:"elevation-3"},[_c('div',{staticClass:"tableHeader"},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('v-btn',{staticClass:"mb-2",attrs:{"slot":"activator","color":"#f8ac4a","dark":""},slot:"activator"},[_c('v-icon',{staticClass:"buttonIconText",attrs:{"color":"white"}},[_vm._v("playlist_add")]),_vm._v("\n          Nova "+_vm._s(_vm.name))],1),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();}}},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Nome")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#f8ac4a","rules":_vm.defaultRules},model:{value:(_vm.editedItem.nome),callback:function ($$v) {_vm.$set(_vm.editedItem, "nome", $$v)},expression:"editedItem.nome"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Username")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#f8ac4a","rules":_vm.defaultRules},model:{value:(_vm.editedItem.username),callback:function ($$v) {_vm.$set(_vm.editedItem, "username", $$v)},expression:"editedItem.username"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Email")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#f8ac4a","rules":_vm.defaultRules},model:{value:(_vm.editedItem.email),callback:function ($$v) {_vm.$set(_vm.editedItem, "email", $$v)},expression:"editedItem.email"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Entidade ou Associada?")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#f8ac4a","items":_vm.classes,"item-text":"nome","item-value":"id_classe","rules":_vm.defaultRules},model:{value:(_vm.editedItem.associada),callback:function ($$v) {_vm.$set(_vm.editedItem, "associada", $$v)},expression:"editedItem.associada"}})],1),_vm._v(" "),(_vm.editedItem.associada == 2)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Entidade associada?")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#f8ac4a","items":_vm.associadas,"multiple":"","item-text":"nome","item-value":"id_associada","rules":_vm.defaultRules},model:{value:(_vm.editedItem.associadas),callback:function ($$v) {_vm.$set(_vm.editedItem, "associadas", $$v)},expression:"editedItem.associadas"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Tipo instituição")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#f8ac4a","items":_vm.tipos,"item-text":"nome","item-value":"id_tipo","rules":_vm.defaultRules},model:{value:(_vm.editedItem.publico),callback:function ($$v) {_vm.$set(_vm.editedItem, "publico", $$v)},expression:"editedItem.publico"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Fins lucrativos")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#f8ac4a","items":_vm.fins_lucrativos},model:{value:(_vm.editedItem.fins_lucrativos),callback:function ($$v) {_vm.$set(_vm.editedItem, "fins_lucrativos", $$v)},expression:"editedItem.fins_lucrativos"}})],1),_vm._v(" "),(_vm.editedItem.fins_lucrativos == 'Sem fins lucrativos')?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Tipo")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#f8ac4a","items":_vm.tipo_fins_lucrativos},model:{value:(_vm.editedItem.tipo_fins_lucrativos),callback:function ($$v) {_vm.$set(_vm.editedItem, "tipo_fins_lucrativos", $$v)},expression:"editedItem.tipo_fins_lucrativos"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("A entidade trabalha formalmente em setores diretamente\n                      relacionados com a educação?")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#f8ac4a","items":['Sim', 'Não']},model:{value:(_vm.editedItem.trabalha_educacao),callback:function ($$v) {_vm.$set(_vm.editedItem, "trabalha_educacao", $$v)},expression:"editedItem.trabalha_educacao"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("A entidade reconhece formalmente a Educação para o\n                      Desenvolvimento em documentos estratégicos e/ou\n                      operacionais?")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#f8ac4a","items":['Sim', 'Não']},model:{value:(_vm.editedItem.trabalha_estrategicos),callback:function ($$v) {_vm.$set(_vm.editedItem, "trabalha_estrategicos", $$v)},expression:"editedItem.trabalha_estrategicos"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Selecione o distrito onde a entidade desempenha uma\n                      intervenção mais ativa")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#f8ac4a","items":_vm.distritos,"item-text":"name","item-value":"name"},model:{value:(_vm.editedItem.distrito),callback:function ($$v) {_vm.$set(_vm.editedItem, "distrito", $$v)},expression:"editedItem.distrito"}})],1),_vm._v(" "),(_vm.editedIndex == -1)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Password")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#f8ac4a","type":"password","rules":_vm.defaultRules,"append-icon":"cached"},on:{"click:append":function($event){return _vm.gerarPassword()}},model:{value:(_vm.editedItem.password),callback:function ($$v) {_vm.$set(_vm.editedItem, "password", $$v)},expression:"editedItem.password"}})],1):_vm._e(),_vm._v(" "),(_vm.editedIndex == -1)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Confirmar password")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#f8ac4a","rules":_vm.pwdRules,"type":_vm.show ? 'text' : 'password',"append-icon":!_vm.show ? 'visibility' : 'visibility_off'},on:{"click:append":function($event){_vm.show = !_vm.show}},model:{value:(_vm.cpwd),callback:function ($$v) {_vm.cpwd=$$v},expression:"cpwd"}})],1):_vm._e(),_vm._v(" "),(_vm.editedIndex > -1)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Ativo?")]),_vm._v(" "),_c('v-checkbox',{attrs:{"color":"#f8ac4a"},model:{value:(_vm.editedItem.ativo),callback:function ($$v) {_vm.$set(_vm.editedItem, "ativo", $$v)},expression:"editedItem.ativo"}})],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":""},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":""},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Guardar")])],1)],1)],1)],1),_vm._v(" "),_c('v-text-field',{staticClass:"searchTable",attrs:{"color":"#f8ac4a","append-icon":"search","label":"Pesquisa","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"390"},model:{value:(_vm.deleteM),callback:function ($$v) {_vm.deleteM=$$v},expression:"deleteM"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline",staticStyle:{"margin-left":"0px !important"}},[_vm._v("Apagar "+_vm._s(_vm.name))]),_vm._v(" "),_c('v-card-text',[_vm._v("De certeza que quer apagar este "+_vm._s(_vm.name)+"?")]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"margin-top":"0px !important"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":"flat"},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":"flat"},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Apagar")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"390"},model:{value:(_vm.modal_setores),callback:function ($$v) {_vm.modal_setores=$$v},expression:"modal_setores"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline",staticStyle:{"margin-left":"0px !important"}},[_vm._v("Setores")]),_vm._v(" "),_c('v-card-text',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Selecione o(s) setor(es) de atividade da entidade")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#f8ac4a","items":_vm.getSectores,"multiple":"","item-text":"nome","item-value":"id_setor"},model:{value:(_vm.setores),callback:function ($$v) {_vm.setores=$$v},expression:"setores"}})],1)],1),_vm._v(" "),_c('v-card-actions',{staticStyle:{"margin-top":"0px !important"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":"flat"},nativeOn:{"click":function($event){_vm.modal_setores = false}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":"flat"},nativeOn:{"click":function($event){return _vm.saveSetores($event)}}},[_vm._v("Guardar")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.novaPwd),callback:function ($$v) {_vm.novaPwd=$$v},expression:"novaPwd"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Nova password")])]),_vm._v(" "),_c('v-form',{ref:"formPwd"},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Password")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#f8ac4a","type":"password","rules":_vm.defaultRules,"append-icon":"cached"},on:{"click:append":function($event){return _vm.gerarPassword()}},model:{value:(_vm.editedItem.password),callback:function ($$v) {_vm.$set(_vm.editedItem, "password", $$v)},expression:"editedItem.password"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Confirmar password")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#f8ac4a","rules":_vm.pwdRules,"type":_vm.show ? 'text' : 'password',"append-icon":!_vm.show ? 'visibility' : 'visibility_off'},on:{"click:append":function($event){_vm.show = !_vm.show}},model:{value:(_vm.cpwd),callback:function ($$v) {_vm.cpwd=$$v},expression:"cpwd"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":""},nativeOn:{"click":function($event){_vm.novaPwd = false}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":""},nativeOn:{"click":function($event){return _vm.updatePwd($event)}}},[_vm._v("Guardar")])],1)],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.DATA,"search":_vm.search,"loading":_vm.loading,"item-key":"id","disable-initial-sort":true,"rows-per-page-items":[10, 25, 50, { text: 'Todos', value: -1 }],"rows-per-page-text":"Itens por página:"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"textLeft",on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v("\n          "+_vm._s(props.item.id_instituicao)+"\n        ")]),_vm._v(" "),_c('td',{staticClass:"textLeft",on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v("\n          "+_vm._s(props.item.nome)+"\n        ")]),_vm._v(" "),_c('td',{staticClass:"textCenter",on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v("\n          "+_vm._s(props.item.username)+"\n        ")]),_vm._v(" "),_c('td',{staticClass:"textCenter",on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v("\n          "+_vm._s(props.item.email)+"\n        ")]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[(props.item.ativo)?_c('span',{staticStyle:{"background-color":"green","height":"10px","width":"10px","border-radius":"50px","position":"absolute"}}):_c('span',{staticStyle:{"background-color":"red","height":"10px","width":"10px","border-radius":"50px","position":"absolute"}})]),_vm._v(" "),_c('td',{staticClass:"px-0 textTable textCenter"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.viewSetores(props.item, true)}}},[_c('v-icon',{attrs:{"color":"light-green darken-1"}},[_vm._v("account_balance")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_c('v-icon',{attrs:{"color":"light-green darken-1"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.nPwd(props.item)}}},[_c('v-icon',{attrs:{"color":"amber"}},[_vm._v("lock")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item, false)}}},[_c('v-icon',{attrs:{"color":"red lighten-1"}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{staticClass:"alertTable",slot:"no-data"},[_c('v-alert',{attrs:{"value":true,"icon":"warning"}},[_vm._v("\n          De momento não há nada a apresentar! :(\n        ")])],1)],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1309:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Objetivos_vue__ = __webpack_require__(457);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48b77d7a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Objetivos_vue__ = __webpack_require__(1310);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Objetivos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48b77d7a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Objetivos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1310:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[_c('div',{staticClass:"elevation-3"},[_c('div',{staticClass:"noTableHeader"},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('v-btn',{staticClass:"mb-2",attrs:{"slot":"activator","color":"#f8ac4a","dark":""},slot:"activator"},[_c('v-icon',{staticClass:"buttonIconText",attrs:{"color":"white"}},[_vm._v("playlist_add")]),_vm._v(" Novo "+_vm._s(_vm.name))],1),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();}}},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Nome")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#f8ac4a","autofocus":true,"rules":_vm.defaultRules},model:{value:(_vm.editedItem.nome),callback:function ($$v) {_vm.$set(_vm.editedItem, "nome", $$v)},expression:"editedItem.nome"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Descrição")]),_vm._v(" "),_c('v-textarea',{attrs:{"color":"#f8ac4a","rules":_vm.defaultRules,"auto-grow":"","rows":1},model:{value:(_vm.editedItem.descricao),callback:function ($$v) {_vm.$set(_vm.editedItem, "descricao", $$v)},expression:"editedItem.descricao"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":""},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":""},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Guardar")])],1)],1)],1)],1),_vm._v(" "),_c('v-text-field',{staticClass:"searchTable",attrs:{"color":"#f8ac4a","append-icon":"search","label":"Pesquisa","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"390"},model:{value:(_vm.deleteM),callback:function ($$v) {_vm.deleteM=$$v},expression:"deleteM"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline",staticStyle:{"margin-left":"0px !important"}},[_vm._v("Apagar "+_vm._s(_vm.name))]),_vm._v(" "),_c('v-card-text',[_vm._v("De certeza que quer apagar este "+_vm._s(_vm.name)+"?")]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"margin-top":"0px !important"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":"flat"},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":"flat"},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Apagar")])],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.DATA,"search":_vm.search,"loading":_vm.loading,"item-key":"id","disable-initial-sort":true,"rows-per-page-items":[10,25,50,{"text":"Todos","value":-1}],"rows-per-page-text":"Itens por página:"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"textLeft",staticStyle:{"width":"15%"},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v(_vm._s(props.item.id_objetivo))]),_vm._v(" "),_c('td',{staticClass:"textLeft",staticStyle:{"width":"60%"},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v(_vm._s(props.item.nome)+" - "+_vm._s(props.item.descricao))]),_vm._v(" "),_c('td',{staticClass:" px-0 textTable textCenter"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_c('v-icon',{attrs:{"color":"light-green darken-1"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item, false)}}},[_c('v-icon',{attrs:{"color":"red lighten-1"}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{staticClass:"alertTable",slot:"no-data"},[_c('v-alert',{attrs:{"value":true,"icon":"warning"}},[_vm._v("\n        De momento não há nada a apresentar! :(\n    ")])],1)],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1311:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Medidas_vue__ = __webpack_require__(458);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e6fac96_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Medidas_vue__ = __webpack_require__(1312);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Medidas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e6fac96_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Medidas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1312:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[_c('div',{staticClass:"elevation-3"},[_c('div',{staticClass:"noTableHeader"},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('v-btn',{staticClass:"mb-2",attrs:{"slot":"activator","color":"#f8ac4a","dark":""},slot:"activator"},[_c('v-icon',{staticClass:"buttonIconText",attrs:{"color":"white"}},[_vm._v("playlist_add")]),_vm._v(" Nova "+_vm._s(_vm.name))],1),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();}}},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Nome")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#f8ac4a","autofocus":true,"rules":_vm.defaultRules},model:{value:(_vm.editedItem.nome),callback:function ($$v) {_vm.$set(_vm.editedItem, "nome", $$v)},expression:"editedItem.nome"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Descrição")]),_vm._v(" "),_c('v-textarea',{attrs:{"color":"#f8ac4a","rules":_vm.defaultRules,"auto-grow":"","rows":1},model:{value:(_vm.editedItem.descricao),callback:function ($$v) {_vm.$set(_vm.editedItem, "descricao", $$v)},expression:"editedItem.descricao"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Objetivo")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#f8ac4a","items":_vm.getObjetivos,"item-text":"nome","item-value":"id_objetivo","rules":_vm.defaultRules},model:{value:(_vm.editedItem.id_objetivo),callback:function ($$v) {_vm.$set(_vm.editedItem, "id_objetivo", $$v)},expression:"editedItem.id_objetivo"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":""},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":""},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Guardar")])],1)],1)],1)],1),_vm._v(" "),_c('v-text-field',{staticClass:"searchTable",attrs:{"color":"#f8ac4a","append-icon":"search","label":"Pesquisa","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"390"},model:{value:(_vm.deleteM),callback:function ($$v) {_vm.deleteM=$$v},expression:"deleteM"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline",staticStyle:{"margin-left":"0px !important"}},[_vm._v("Apagar "+_vm._s(_vm.name))]),_vm._v(" "),_c('v-card-text',[_vm._v("De certeza que quer apagar esta "+_vm._s(_vm.name)+"?")]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"margin-top":"0px !important"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":"flat"},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":"flat"},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Apagar")])],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.DATA,"search":_vm.search,"loading":_vm.loading,"item-key":"id","disable-initial-sort":true,"rows-per-page-items":[10,25,50,{"text":"Todos","value":-1}],"rows-per-page-text":"Itens por página:"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"textLeft",staticStyle:{"width":"15%"},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v(_vm._s(props.item.id_medida))]),_vm._v(" "),_c('td',{staticClass:"textLeft",staticStyle:{"width":"30%"},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v(_vm._s(props.item.nome)+" - "+_vm._s(props.item.descricao))]),_vm._v(" "),_c('td',{staticClass:"textCenter",staticStyle:{"width":"30%"},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v(_vm._s(_vm.getObjetivoById(props.item.id_objetivo).nome))]),_vm._v(" "),_c('td',{staticClass:" px-0 textTable textCenter"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_c('v-icon',{attrs:{"color":"light-green darken-1"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item, false)}}},[_c('v-icon',{attrs:{"color":"red lighten-1"}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{staticClass:"alertTable",slot:"no-data"},[_c('v-alert',{attrs:{"value":true,"icon":"warning"}},[_vm._v("\n        De momento não há nada a apresentar! :(\n    ")])],1)],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1313:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Acoes_vue__ = __webpack_require__(459);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b840f0f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Acoes_vue__ = __webpack_require__(1314);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Acoes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b840f0f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Acoes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1314:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[_c('div',{staticClass:"elevation-3"},[_c('div',{staticClass:"noTableHeader"},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('v-btn',{staticClass:"mb-2",attrs:{"slot":"activator","color":"#f8ac4a","dark":""},slot:"activator"},[_c('v-icon',{staticClass:"buttonIconText",attrs:{"color":"white"}},[_vm._v("playlist_add")]),_vm._v(" Nova "+_vm._s(_vm.name))],1),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();}}},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Nome")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#f8ac4a","autofocus":true,"rules":_vm.defaultRules},model:{value:(_vm.editedItem.nome),callback:function ($$v) {_vm.$set(_vm.editedItem, "nome", $$v)},expression:"editedItem.nome"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Descrição")]),_vm._v(" "),_c('v-textarea',{attrs:{"color":"#f8ac4a","rules":_vm.defaultRules,"auto-grow":"","rows":1},model:{value:(_vm.editedItem.descricao),callback:function ($$v) {_vm.$set(_vm.editedItem, "descricao", $$v)},expression:"editedItem.descricao"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Medida")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#f8ac4a","items":_vm.getMedidas,"item-text":"nome","item-value":"id_medida","rules":_vm.defaultRules},model:{value:(_vm.editedItem.id_medida),callback:function ($$v) {_vm.$set(_vm.editedItem, "id_medida", $$v)},expression:"editedItem.id_medida"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Formulário")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#f8ac4a","items":_vm.getFormularios,"item-text":"nome","item-value":"id_formulario","rules":_vm.defaultRules},model:{value:(_vm.editedItem.id_formulario),callback:function ($$v) {_vm.$set(_vm.editedItem, "id_formulario", $$v)},expression:"editedItem.id_formulario"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":""},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":""},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Guardar")])],1)],1)],1)],1),_vm._v(" "),_c('v-text-field',{staticClass:"searchTable",attrs:{"color":"#f8ac4a","append-icon":"search","label":"Pesquisa","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"390"},model:{value:(_vm.deleteM),callback:function ($$v) {_vm.deleteM=$$v},expression:"deleteM"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline",staticStyle:{"margin-left":"0px !important"}},[_vm._v("Apagar "+_vm._s(_vm.name))]),_vm._v(" "),_c('v-card-text',[_vm._v("De certeza que quer apagar esta "+_vm._s(_vm.name)+"?")]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"margin-top":"0px !important"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":"flat"},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":"flat"},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Apagar")])],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.DATA,"search":_vm.search,"loading":_vm.loading,"item-key":"id","disable-initial-sort":true,"rows-per-page-items":[10,25,50,{"text":"Todos","value":-1}],"rows-per-page-text":"Itens por página:"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"textLeft",staticStyle:{"width":"5%"},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v(_vm._s(props.item.id_acao))]),_vm._v(" "),_c('td',{staticClass:"textLeft",staticStyle:{"width":"20%"},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v(_vm._s(props.item.nome)+" - "+_vm._s(props.item.descricao))]),_vm._v(" "),_c('td',{staticClass:"textCenter",staticStyle:{"width":"20%"},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v(_vm._s(_vm.getMedidaById(props.item.id_medida).nome))]),_vm._v(" "),_c('td',{staticClass:"textCenter",staticStyle:{"width":"20%"},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v(_vm._s(_vm.getFormularioById(props.item.id_formulario).nome))]),_vm._v(" "),_c('td',{staticClass:" px-0 textTable textCenter"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_c('v-icon',{attrs:{"color":"light-green darken-1"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item, false)}}},[_c('v-icon',{attrs:{"color":"red lighten-1"}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{staticClass:"alertTable",slot:"no-data"},[_c('v-alert',{attrs:{"value":true,"icon":"warning"}},[_vm._v("\n        De momento não há nada a apresentar! :(\n    ")])],1)],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1315:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Dimensoes_vue__ = __webpack_require__(460);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bd7c29b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Dimensoes_vue__ = __webpack_require__(1318);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Dimensoes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bd7c29b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Dimensoes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1318:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[_c('div',{staticClass:"elevation-3"}),_vm._v(" "),_c('div',{staticClass:"elevation-3"},[_c('div',{staticClass:"noTableHeader"},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('v-btn',{staticClass:"mb-2",attrs:{"slot":"activator","color":"#f8ac4a","dark":""},slot:"activator"},[_c('v-icon',{staticClass:"buttonIconText",attrs:{"color":"white"}},[_vm._v("playlist_add")]),_vm._v(" Nova "+_vm._s(_vm.name))],1),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();}}},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Nome")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#f8ac4a","autofocus":true,"rules":_vm.defaultRules},model:{value:(_vm.editedItem.nome),callback:function ($$v) {_vm.$set(_vm.editedItem, "nome", $$v)},expression:"editedItem.nome"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":""},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":""},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Guardar")])],1)],1)],1)],1),_vm._v(" "),_c('v-text-field',{staticClass:"searchTable",attrs:{"color":"#f8ac4a","append-icon":"search","label":"Pesquisa","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"390"},model:{value:(_vm.deleteM),callback:function ($$v) {_vm.deleteM=$$v},expression:"deleteM"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline",staticStyle:{"margin-left":"0px !important"}},[_vm._v("Apagar "+_vm._s(_vm.name))]),_vm._v(" "),_c('v-card-text',[_vm._v("De certeza que quer apagar esta "+_vm._s(_vm.name)+"?")]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"margin-top":"0px !important"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":"flat"},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":"flat"},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Apagar")])],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.DATA,"search":_vm.search,"loading":_vm.loading,"item-key":"id","disable-initial-sort":true,"rows-per-page-items":[10,25,50,{"text":"Todos","value":-1}],"rows-per-page-text":"Itens por página:"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticStyle:{"width":"10%"}},[_c('v-select',{attrs:{"color":"#f8ac4a","items":_vm.getItems(),"item-value":"id","item-text":"nome"},on:{"change":function($event){return _vm.sortDimensao()}},model:{value:(props.item.ordem),callback:function ($$v) {_vm.$set(props.item, "ordem", $$v)},expression:"props.item.ordem"}})],1),_vm._v(" "),_c('td',{staticClass:"textLeft",on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v(_vm._s(props.item.nome))]),_vm._v(" "),_c('td',{staticClass:" px-0 textTable textCenter"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_c('v-icon',{attrs:{"color":"light-green darken-1"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item, false)}}},[_c('v-icon',{attrs:{"color":"red lighten-1"}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{staticClass:"alertTable",slot:"no-data"},[_c('v-alert',{attrs:{"value":true,"icon":"warning"}},[_vm._v("\n        De momento não há nada a apresentar! :(\n    ")])],1)],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1319:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Perguntas_vue__ = __webpack_require__(461);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25fcfb61_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Perguntas_vue__ = __webpack_require__(1321);
function injectStyle (ssrContext) {
  __webpack_require__(1320)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-25fcfb61"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Perguntas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25fcfb61_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Perguntas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1320:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1321:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[_c('div',{staticClass:"elevation-3"},[_c('div',{staticClass:"noTableHeader"},[_c('v-dialog',{attrs:{"persistent":"","max-width":"1000px"},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('v-btn',{staticClass:"mb-2",attrs:{"slot":"activator","color":"#f8ac4a","dark":""},slot:"activator"},[_c('v-icon',{staticClass:"buttonIconText",attrs:{"color":"white"}},[_vm._v("playlist_add")]),_vm._v(" Nova "+_vm._s(_vm.name))],1),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[(_vm.isLoading)?_c('div',{staticStyle:{"width":"100%","text-align":"center"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"amber"}})],1):_vm._e(),_vm._v(" "),(!_vm.isLoading)?_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();}}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Pergunta")]),_vm._v(" "),(_vm.pergunta.id_tipo != 5)?_c('v-text-field',{attrs:{"prepend-icon":_vm.pergunta.required ? 'check_box' : 'check_box_outline_blank',"color":"#f8ac4a","rules":_vm.defaultRules},on:{"click:prepend":function($event){_vm.pergunta.required = !_vm.pergunta.required}},model:{value:(_vm.pergunta.nome),callback:function ($$v) {_vm.$set(_vm.pergunta, "nome", $$v)},expression:"pergunta.nome"}}):_c('v-text-field',{attrs:{"color":"#f8ac4a","rules":_vm.defaultRules},model:{value:(_vm.pergunta.nome),callback:function ($$v) {_vm.$set(_vm.pergunta, "nome", $$v)},expression:"pergunta.nome"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Dimensão")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#f8ac4a","items":_vm.getDimensoes,"item-text":"nome","item-value":"id_dimensao","rules":_vm.defaultRules},model:{value:(_vm.pergunta.id_dimensao),callback:function ($$v) {_vm.$set(_vm.pergunta, "id_dimensao", $$v)},expression:"pergunta.id_dimensao"}})],1),_vm._v(" "),_c('v-flex',{class:[(_vm.pergunta.id_tipo == 5 || _vm.pergunta.id_tipo == 1 || _vm.pergunta.id_tipo == 2) && _vm.editedIndex == -1 ? 'xs2 sm2 md2' : 'xs3 sm3 md3']},[_c('label',{staticClass:"label-modal"},[_vm._v("Tipo pergunta")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#f8ac4a","items":_vm.getTipos,"disabled":_vm.editedIndex != -1,"item-text":"nome","item-value":"id_tipo","rules":_vm.defaultRules},on:{"change":_vm.changeTipo},model:{value:(_vm.pergunta.id_tipo),callback:function ($$v) {_vm.$set(_vm.pergunta, "id_tipo", $$v)},expression:"pergunta.id_tipo"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pActions",attrs:{"xs1":"","sm1":"","md1":""}},[((_vm.pergunta.id_tipo == 5 || _vm.pergunta.id_tipo == 1 || _vm.pergunta.id_tipo == 2) && _vm.editedIndex == -1)?_c('v-btn',{attrs:{"fab":"","dark":"","small":"","color":"#f8ac4a"},on:{"click":_vm.addChildren}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("add")])],1):_vm._e()],1)],1)],1),_vm._v(" "),_vm._l((_vm.pergunta.children),function(child,i){return _c('v-flex',{key:i,attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{staticClass:"parent",attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{staticClass:"child-1",class:[(_vm.pergunta.id_tipo == 5 || _vm.pergunta.id_tipo == 1 || _vm.pergunta.id_tipo == 2 || child.expansivel) ? 'xs5 sm5 md5' : 'xs6 sm6 md6']},[_c('label',{staticClass:"label-modal"},[_vm._v("Opção")]),_vm._v(" "),(_vm.pergunta.id_tipo == 5)?_c('v-text-field',{attrs:{"prepend-icon":child.required ? 'check_box' : 'check_box_outline_blank',"color":"#f8ac4a","rules":_vm.defaultRules},on:{"click:prepend":function($event){child.required = !child.required}},model:{value:(child.nome),callback:function ($$v) {_vm.$set(child, "nome", $$v)},expression:"child.nome"}}):_c('v-text-field',{attrs:{"color":"#f8ac4a","rules":_vm.defaultRules},model:{value:(child.nome),callback:function ($$v) {_vm.$set(child, "nome", $$v)},expression:"child.nome"}})],1),_vm._v(" "),(_vm.pergunta.id_tipo == 5 || child.expansivel || (_vm.editedIndex!=-1 && child.id_tipo > 0))?_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Tipo pergunta")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#f8ac4a","disabled":_vm.editedIndex != -1,"items":_vm.getTipos.filter(function (el){ return el.id_tipo != 5 }),"item-text":"nome","item-value":"id_tipo"},on:{"change":function($event){return _vm.changeTipoChild(child)}},model:{value:(child.id_tipo),callback:function ($$v) {_vm.$set(child, "id_tipo", $$v)},expression:"child.id_tipo"}})],1):_vm._e(),_vm._v(" "),(_vm.pergunta.id_tipo == 1 || _vm.pergunta.id_tipo == 2)?_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Expansível")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#f8ac4a","disabled":_vm.editedIndex != -1,"items":_vm.isExpansivel,"item-text":"nome","item-value":"expansivel"},model:{value:(child.expansivel),callback:function ($$v) {_vm.$set(child, "expansivel", $$v)},expression:"child.expansivel"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"pActions",class:[((_vm.pergunta.id_tipo == 5 || _vm.pergunta.id_tipo == 1 || _vm.pergunta.id_tipo == 2) && (child.id_tipo == 1 || child.id_tipo == 2 || child.expansivel) && _vm.editedIndex == -1) ? 'xs2 sm2 md2' : 'xs1 sm1 md1']},[((_vm.pergunta.id_tipo == 5 || _vm.pergunta.id_tipo == 1 || _vm.pergunta.id_tipo == 2) && (child.id_tipo == 1 || child.id_tipo == 2 || child.expansivel) && _vm.editedIndex == -1)?_c('v-btn',{attrs:{"fab":"","dark":"","small":"","color":"#f8ac4a"},on:{"click":function($event){return _vm.addChild(child)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("add")])],1):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"fab":"","dark":"","small":"","color":"#ff5252"},on:{"click":function($event){return _vm.deleteChildren(child)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1)],1)],1)],1),_vm._v(" "),_vm._l((child.children),function(c,j){return _c('v-flex',{key:j,attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{staticClass:"child-2",class:[(child.id_tipo == 5 || child.id_tipo == 1 || child.id_tipo == 2) ? 'xs5 sm5 md5' : 'xs6 sm6 md6']},[_c('label',{staticClass:"label-modal"},[_vm._v("Opção")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#f8ac4a","rules":_vm.defaultRules},model:{value:(c.nome),callback:function ($$v) {_vm.$set(c, "nome", $$v)},expression:"c.nome"}})],1),_vm._v(" "),(c.expansivel || (_vm.editedIndex!=-1 && c.id_tipo > 0))?_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Tipo pergunta")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#f8ac4a","items":_vm.getTipos.filter(function (el){ return el.id_tipo != 5}),"disabled":_vm.editedIndex != -1,"item-text":"nome","item-value":"id_tipo"},model:{value:(c.id_tipo),callback:function ($$v) {_vm.$set(c, "id_tipo", $$v)},expression:"c.id_tipo"}})],1):_vm._e(),_vm._v(" "),(child.id_tipo == 1 || child.id_tipo == 2)?_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Expansível")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#f8ac4a","disabled":_vm.editedIndex != -1,"items":_vm.isExpansivel,"item-text":"nome","item-value":"expansivel"},model:{value:(c.expansivel),callback:function ($$v) {_vm.$set(c, "expansivel", $$v)},expression:"c.expansivel"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"pActions",class:[((c.expansivel) && _vm.editedIndex == -1) ? 'xs2 sm2 md2' : 'xs1 sm1 md1']},[((c.expansivel) && _vm.editedIndex == -1)?_c('v-btn',{attrs:{"fab":"","dark":"","small":"","color":"#f8ac4a"},on:{"click":function($event){return _vm.addChildChild(child, c)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("add")])],1):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"fab":"","dark":"","small":"","color":"#ff5252"},on:{"click":function($event){return _vm.deleteChild(child, c)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1)],1)],1)],1),_vm._v(" "),_vm._l((c.children),function(n,k){return _c('v-flex',{key:k,attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{staticClass:"child-3",class:[(c.id_tipo == 1 || c.id_tipo == 2) ? 'xs5 sm5 md5' : 'xs6 sm6 md6']},[_c('label',{staticClass:"label-modal"},[_vm._v("Opção")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#f8ac4a","rules":_vm.defaultRules},model:{value:(n.nome),callback:function ($$v) {_vm.$set(n, "nome", $$v)},expression:"n.nome"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pActions",attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{attrs:{"fab":"","dark":"","small":"","color":"#ff5252"},on:{"click":function($event){return _vm.deleteChildChild(c, n)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1)],1)],1)],1)})],2)})],2)],1)})],2)],1)],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":""},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","disabled":_vm.isLoading,"flat":""},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Guardar")])],1)],1)],1),_vm._v(" "),_c('v-text-field',{staticClass:"searchTable",attrs:{"color":"#f8ac4a","append-icon":"search","label":"Pesquisa","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"390"},model:{value:(_vm.deleteM),callback:function ($$v) {_vm.deleteM=$$v},expression:"deleteM"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline",staticStyle:{"margin-left":"0px !important"}},[_vm._v("Apagar "+_vm._s(_vm.name))]),_vm._v(" "),_c('v-card-text',[_vm._v("De certeza que quer apagar esta "+_vm._s(_vm.name)+"?")]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"margin-top":"0px !important"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":"flat"},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":"flat"},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Apagar")])],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.DATA,"search":_vm.search,"loading":_vm.loading,"item-key":"id","disable-initial-sort":true,"rows-per-page-items":[10,25,50,{"text":"Todos","value":-1}],"rows-per-page-text":"Itens por página:"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"textLeft",staticStyle:{"width":"15%"},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v(_vm._s(props.item.id_pergunta))]),_vm._v(" "),_c('td',{staticClass:"textLeft",staticStyle:{"width":"60%"},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v(_vm._s(props.item.nome))]),_vm._v(" "),_c('td',{staticClass:" px-0 textTable textCenter"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_c('v-icon',{attrs:{"color":"light-green darken-1"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item, false)}}},[_c('v-icon',{attrs:{"color":"red lighten-1"}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{staticClass:"alertTable",slot:"no-data"},[_c('v-progress-circular',{staticStyle:{"margin-left":"50% !important"},attrs:{"indeterminate":"","color":"#f8ac4a"}})],1)],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1322:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Formularios_vue__ = __webpack_require__(462);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e891b554_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Formularios_vue__ = __webpack_require__(1323);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Formularios_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e891b554_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Formularios_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1323:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[_c('div',{staticClass:"elevation-3"},[_c('div',{staticClass:"noTableHeader"},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('v-btn',{staticClass:"mb-2",attrs:{"slot":"activator","color":"#f8ac4a","dark":""},slot:"activator"},[_c('v-icon',{staticClass:"buttonIconText",attrs:{"color":"white"}},[_vm._v("playlist_add")]),_vm._v(" Novo "+_vm._s(_vm.name))],1),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();}}},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[(_vm.isLoading)?_c('div',{staticStyle:{"width":"100%","text-align":"center"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"amber"}})],1):_vm._e(),_vm._v(" "),(!_vm.isLoading)?_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Nome")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#f8ac4a","autofocus":true,"rules":_vm.defaultRules},model:{value:(_vm.editedItem.nome),callback:function ($$v) {_vm.$set(_vm.editedItem, "nome", $$v)},expression:"editedItem.nome"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Perguntas")]),_vm._v(" "),_c('v-select',{attrs:{"color":"#f8ac4a","items":_vm.getPerguntas,"multiple":"","item-text":"nome","item-value":"id_pergunta","rules":_vm.defaultRules},model:{value:(_vm.editedItem.perguntas),callback:function ($$v) {_vm.$set(_vm.editedItem, "perguntas", $$v)},expression:"editedItem.perguntas"}})],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":""},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","disabled":_vm.isLoading,"flat":""},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Guardar")])],1)],1)],1)],1),_vm._v(" "),_c('v-text-field',{staticClass:"searchTable",attrs:{"color":"#f8ac4a","append-icon":"search","label":"Pesquisa","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"390"},model:{value:(_vm.deleteM),callback:function ($$v) {_vm.deleteM=$$v},expression:"deleteM"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline",staticStyle:{"margin-left":"0px !important"}},[_vm._v("Apagar "+_vm._s(_vm.name))]),_vm._v(" "),_c('v-card-text',[_vm._v("De certeza que quer apagar este "+_vm._s(_vm.name)+"?")]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"margin-top":"0px !important"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":"flat"},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":"flat"},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Apagar")])],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.DATA,"search":_vm.search,"loading":_vm.loading,"item-key":"id","disable-initial-sort":true,"rows-per-page-items":[10,25,50,{"text":"Todos","value":-1}],"rows-per-page-text":"Itens por página:"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"textLeft",staticStyle:{"width":"15%"},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v(_vm._s(props.item.id_formulario))]),_vm._v(" "),_c('td',{staticClass:"textLeft",staticStyle:{"width":"60%"},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v(_vm._s(props.item.nome))]),_vm._v(" "),_c('td',{staticClass:" px-0 textTable textCenter"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_c('v-icon',{attrs:{"color":"light-green darken-1"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item, false)}}},[_c('v-icon',{attrs:{"color":"red lighten-1"}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{staticClass:"alertTable",slot:"no-data"},[_c('v-alert',{attrs:{"value":true,"icon":"warning"}},[_vm._v("\n        De momento não há nada a apresentar! :(\n    ")])],1)],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1324:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Setores_vue__ = __webpack_require__(463);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bb65437_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Setores_vue__ = __webpack_require__(1325);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Setores_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bb65437_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Setores_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1325:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[_c('div',{staticClass:"elevation-3"},[_c('div',{staticClass:"noTableHeader"},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('v-btn',{staticClass:"mb-2",attrs:{"slot":"activator","color":"#f8ac4a","dark":""},slot:"activator"},[_c('v-icon',{staticClass:"buttonIconText",attrs:{"color":"white"}},[_vm._v("playlist_add")]),_vm._v(" Novo "+_vm._s(_vm.name))],1),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();}}},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Nome")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#f8ac4a","autofocus":true,"rules":_vm.defaultRules},model:{value:(_vm.editedItem.nome),callback:function ($$v) {_vm.$set(_vm.editedItem, "nome", $$v)},expression:"editedItem.nome"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":""},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":""},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Guardar")])],1)],1)],1)],1),_vm._v(" "),_c('v-text-field',{staticClass:"searchTable",attrs:{"color":"#f8ac4a","append-icon":"search","label":"Pesquisa","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"390"},model:{value:(_vm.deleteM),callback:function ($$v) {_vm.deleteM=$$v},expression:"deleteM"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline",staticStyle:{"margin-left":"0px !important"}},[_vm._v("Apagar "+_vm._s(_vm.name))]),_vm._v(" "),_c('v-card-text',[_vm._v("De certeza que quer apagar este "+_vm._s(_vm.name)+"?")]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"margin-top":"0px !important"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":"flat"},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":"flat"},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Apagar")])],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.DATA,"search":_vm.search,"loading":_vm.loading,"item-key":"id","disable-initial-sort":true,"rows-per-page-items":[10,25,50,{"text":"Todos","value":-1}],"rows-per-page-text":"Itens por página:"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"textLeft",staticStyle:{"width":"15%"},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v(_vm._s(props.item.id_setor))]),_vm._v(" "),_c('td',{staticClass:"textLeft",staticStyle:{"width":"60%"},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v(_vm._s(props.item.nome))]),_vm._v(" "),_c('td',{staticClass:" px-0 textTable textCenter"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_c('v-icon',{attrs:{"color":"light-green darken-1"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item, false)}}},[_c('v-icon',{attrs:{"color":"red lighten-1"}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{staticClass:"alertTable",slot:"no-data"},[_c('v-alert',{attrs:{"value":true,"icon":"warning"}},[_vm._v("\n        De momento não há nada a apresentar! :(\n    ")])],1)],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1326:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Propostas_vue__ = __webpack_require__(464);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_031a42b6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Propostas_vue__ = __webpack_require__(1334);
function injectStyle (ssrContext) {
  __webpack_require__(1327)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-031a42b6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Propostas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_031a42b6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Propostas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1327:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1334:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[_c('div',{staticClass:"mb-4"},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-card',{staticStyle:{"box-shadow":"none","background-color":"#f8f8f8"}},[_c('v-container',{staticStyle:{"padding":"0 !important"},attrs:{"grid-list-md":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Objetivo")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#f8ac4a","items":_vm.getObjetivos,"item-text":"nome","item-value":"id_objetivo"},model:{value:(_vm.FILTRO.id_objetivo),callback:function ($$v) {_vm.$set(_vm.FILTRO, "id_objetivo", $$v)},expression:"FILTRO.id_objetivo"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Medida")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#f8ac4a","items":_vm.getMedidasByObjetivo(_vm.FILTRO.id_objetivo),"item-text":"nome","item-value":"id_medida"},model:{value:(_vm.FILTRO.id_medida),callback:function ($$v) {_vm.$set(_vm.FILTRO, "id_medida", $$v)},expression:"FILTRO.id_medida"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Ação")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#f8ac4a","items":_vm.getAcoesByMedida(_vm.FILTRO.id_medida),"item-text":"nome","item-value":"id_acao"},model:{value:(_vm.FILTRO.id_acao),callback:function ($$v) {_vm.$set(_vm.FILTRO, "id_acao", $$v)},expression:"FILTRO.id_acao"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Ano")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#f8ac4a","items":_vm.getAnos,"item-text":"nome","item-value":"id_ano"},model:{value:(_vm.FILTRO.id_ano),callback:function ($$v) {_vm.$set(_vm.FILTRO, "id_ano", $$v)},expression:"FILTRO.id_ano"}})],1),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"flex","align-items":"center"},attrs:{"xs3":"","sm3":"","md3":""}},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"#f8ac4a","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.filtrar()}}},on),[_c('v-icon',[_vm._v("search")])],1)]}}])},[_vm._v(" "),_c('span',[_vm._v("Filtrar")])]),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"#ff4b4b","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.limpar()}}},on),[_c('v-icon',[_vm._v("clear")])],1)]}}])},[_vm._v(" "),_c('span',[_vm._v("Limpar filtros")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","width":"300"},model:{value:(_vm.generating),callback:function ($$v) {_vm.generating=$$v},expression:"generating"}},[_c('v-card',{attrs:{"color":"#f8ac4a","dark":""}},[_c('v-card-text',[_vm._v("\n        A gerar pdf. Por favor aguarde...\n        "),_c('v-progress-linear',{staticClass:"mb-0",attrs:{"indeterminate":"","color":"white"}})],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","width":"300"},model:{value:(_vm.waiting),callback:function ($$v) {_vm.waiting=$$v},expression:"waiting"}},[_c('v-card',{attrs:{"color":"#f8ac4a","dark":""}},[_c('v-card-text',[_vm._v("\n        A carregar. Por favor aguarde.\n        "),_c('v-progress-linear',{attrs:{"color":"white","height":"25"},model:{value:(_vm.exportingProgress),callback:function ($$v) {_vm.exportingProgress=$$v},expression:"exportingProgress"}},[_c('div',{staticClass:"d-flex justify-center black--text"},[_vm._v("\n            "+_vm._s(Math.ceil(_vm.exportingProgress > 100 ? 100 : _vm.exportingProgress))+"%\n          ")])])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"elevation-3"},[_c('div',{staticClass:"noTableHeader"},[_c('v-dialog',{attrs:{"max-width":"1000px","persistent":""},model:{value:(_vm.reporteM),callback:function ($$v) {_vm.reporteM=$$v},expression:"reporteM"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Reporte")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{staticStyle:{"padding":"0 !important"},attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-form',{ref:"formReporte",on:{"submit":function($event){$event.preventDefault();}}},[(_vm.reporteM)?_c('v-stepper',{staticStyle:{"box-shadow":"none"},attrs:{"vertical":""},model:{value:(_vm.stepper),callback:function ($$v) {_vm.stepper=$$v},expression:"stepper"}},[_vm._l((_vm.formulario),function(p,k){return [_c('v-stepper-step',{key:'k' + k,attrs:{"step":k + 1,"editable":"","complete":_vm.checkedPerguntaCompleted(p),"edit-icon":'done',"color":"#f8ac4a"}},[_vm._v("\n                          "+_vm._s(_vm.getDimensaoById(p.key).nome)+"\n                        ")]),_vm._v(" "),_vm._l((p.children),function(p,j){return _c('v-stepper-content',{key:'s' + j + k,staticClass:"formulario",staticStyle:{"padding-top":"5px !important"},attrs:{"step":k + 1}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{staticStyle:{"display":"grid !important"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-pergunta"},[_c('v-icon',{attrs:{"color":"#222222","size":"20"}},[_vm._v("arrow_right")]),_vm._v("\n                                  "+_vm._s(p.pergunta.nome))],1),_vm._v(" "),_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(_vm.getLegenda(p.pergunta.id_tipo))+"\n                                  "),(
                                      p.pergunta.required &&
                                        p.pergunta.id_tipo != 5
                                    )?_c('span',{staticStyle:{"color":"red !important","margin-left":"10px !important"}},[_vm._v("* Obrigatória")]):_vm._e()])])],1)],1),_vm._v(" "),(p.pergunta.children.length > 0)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[(
                                p.pergunta.id_tipo == 1 ||
                                  p.pergunta.id_tipo == 2
                              )?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},_vm._l((p.pergunta.children),function(child,i){return _c('v-flex',{key:i,attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[(p.pergunta.id_tipo == 1)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"disabled":_vm.editedItem.reporte == 1,"color":"#f8ac4a","label":child.nome},on:{"change":function($event){return _vm.changeCheck(p.pergunta, child, 1)}},model:{value:(child.checked),callback:function ($$v) {_vm.$set(child, "checked", $$v)},expression:"child.checked"}}),_vm._v(" "),(
                                            child.expansivel && child.checked
                                          )?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},_vm._l((child.children),function(cc,kk){return _c('v-flex',{key:kk,attrs:{"xs12":"","sm12":"","md12":""}},[(child.id_tipo == 1)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"disabled":_vm.editedItem.reporte == 1,"color":"#f8ac4a","label":cc.nome},on:{"change":function($event){return _vm.changeCheck(child, cc, 1)}},model:{value:(cc.checked),callback:function ($$v) {_vm.$set(cc, "checked", $$v)},expression:"cc.checked"}}),_vm._v(" "),(
                                                  cc.expansivel && cc.checked
                                                )?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},_vm._l((cc.children),function(n,k1){return _c('v-flex',{key:k1,attrs:{"xs12":"","sm12":"","md12":""}},[(cc.id_tipo == 1)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"disabled":_vm.editedItem.reporte ==
                                                          1,"color":"#f8ac4a","label":n.nome},on:{"change":function($event){return _vm.changeCheck(cc, n, 1)}},model:{value:(n.checked),callback:function ($$v) {_vm.$set(n, "checked", $$v)},expression:"n.checked"}})],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 2)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"disabled":_vm.editedItem.reporte ==
                                                          1,"color":"#f8ac4a","label":n.nome},on:{"change":function($event){return _vm.changeCheck(cc, n, 2)}},model:{value:(n.checked),callback:function ($$v) {_vm.$set(n, "checked", $$v)},expression:"n.checked"}})],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 3)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(n.nome))]),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":_vm.editedItem.reporte ==
                                                            1,"color":"#f8ac4a"},on:{"input":_vm.forceUpdate},model:{value:(n.valor),callback:function ($$v) {_vm.$set(n, "valor", $$v)},expression:"n.valor"}})],1)],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 8)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(n.nome))]),_vm._v(" "),_c('v-textarea',{attrs:{"disabled":_vm.editedItem.reporte ==
                                                            1,"color":"#f8ac4a","rows":"2","auto-grow":""},on:{"input":_vm.forceUpdate},model:{value:(n.valor),callback:function ($$v) {_vm.$set(n, "valor", $$v)},expression:"n.valor"}})],1)],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 4)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(n.nome))]),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":_vm.editedItem.reporte ==
                                                            1,"color":"#f8ac4a","mask":"################"},on:{"input":_vm.forceUpdate},model:{value:(n.valor),callback:function ($$v) {_vm.$set(n, "valor", $$v)},expression:"n.valor"}})],1)],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 6)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(n.nome))]),_vm._v(" "),_c('v-autocomplete',{attrs:{"disabled":_vm.editedItem.reporte ==
                                                            1,"color":"#f8ac4a","items":_vm.getDistritos,"item-text":"nome","item-value":"id_distrito"},on:{"input":_vm.forceUpdate},model:{value:(n.valor),callback:function ($$v) {_vm.$set(n, "valor", $$v)},expression:"n.valor"}})],1)],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 7)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(n.nome))]),_vm._v(" "),_c('v-autocomplete',{attrs:{"disabled":_vm.editedItem.reporte ==
                                                            1,"color":"#f8ac4a","items":_vm.getSetores,"item-text":"nome","item-value":"id_setor"},on:{"input":_vm.forceUpdate},model:{value:(n.valor),callback:function ($$v) {_vm.$set(n, "valor", $$v)},expression:"n.valor"}})],1)],1):_vm._e()],1)}),1):_vm._e()],1):_vm._e(),_vm._v(" "),(child.id_tipo == 2)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"disabled":_vm.editedItem.reporte == 1,"color":"#f8ac4a","label":cc.nome},on:{"change":function($event){return _vm.changeCheck(child, cc, 2)}},model:{value:(cc.checked),callback:function ($$v) {_vm.$set(cc, "checked", $$v)},expression:"cc.checked"}}),_vm._v(" "),(
                                                  cc.expansivel && cc.checked
                                                )?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},_vm._l((cc.children),function(n,k1){return _c('v-flex',{key:k1,attrs:{"xs12":"","sm12":"","md12":""}},[(cc.id_tipo == 1)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"disabled":_vm.editedItem.reporte ==
                                                          1,"color":"#f8ac4a","label":n.nome},on:{"change":function($event){return _vm.changeCheck(cc, n, 1)}},model:{value:(n.checked),callback:function ($$v) {_vm.$set(n, "checked", $$v)},expression:"n.checked"}})],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 2)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"disabled":_vm.editedItem.reporte ==
                                                          1,"color":"#f8ac4a","label":n.nome},on:{"change":function($event){return _vm.changeCheck(cc, n, 2)}},model:{value:(n.checked),callback:function ($$v) {_vm.$set(n, "checked", $$v)},expression:"n.checked"}})],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 3)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(n.nome))]),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":_vm.editedItem.reporte ==
                                                            1,"color":"#f8ac4a"},on:{"input":_vm.forceUpdate},model:{value:(n.valor),callback:function ($$v) {_vm.$set(n, "valor", $$v)},expression:"n.valor"}})],1)],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 8)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(n.nome))]),_vm._v(" "),_c('v-textarea',{attrs:{"disabled":_vm.editedItem.reporte ==
                                                            1,"color":"#f8ac4a","rows":"2","auto-grow":""},on:{"input":_vm.forceUpdate},model:{value:(n.valor),callback:function ($$v) {_vm.$set(n, "valor", $$v)},expression:"n.valor"}})],1)],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 4)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(n.nome))]),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":_vm.editedItem.reporte ==
                                                            1,"color":"#f8ac4a","mask":"################"},on:{"input":_vm.forceUpdate},model:{value:(n.valor),callback:function ($$v) {_vm.$set(n, "valor", $$v)},expression:"n.valor"}})],1)],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 6)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(n.nome))]),_vm._v(" "),_c('v-autocomplete',{attrs:{"disabled":_vm.editedItem.reporte ==
                                                            1,"color":"#f8ac4a","items":_vm.getDistritos,"item-text":"nome","item-value":"id_distrito"},on:{"input":_vm.forceUpdate},model:{value:(n.valor),callback:function ($$v) {_vm.$set(n, "valor", $$v)},expression:"n.valor"}})],1)],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 7)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(n.nome))]),_vm._v(" "),_c('v-autocomplete',{attrs:{"disabled":_vm.editedItem.reporte ==
                                                            1,"color":"#f8ac4a","items":_vm.getSetores,"item-text":"nome","item-value":"id_setor"},on:{"input":_vm.forceUpdate},model:{value:(n.valor),callback:function ($$v) {_vm.$set(n, "valor", $$v)},expression:"n.valor"}})],1)],1):_vm._e()],1)}),1):_vm._e()],1):_vm._e(),_vm._v(" "),(child.id_tipo == 3)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(cc.nome))]),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":_vm.editedItem.reporte == 1,"color":"#f8ac4a"},on:{"input":_vm.forceUpdate},model:{value:(cc.valor),callback:function ($$v) {_vm.$set(cc, "valor", $$v)},expression:"cc.valor"}})],1)],1):_vm._e(),_vm._v(" "),(child.id_tipo == 8)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(cc.nome))]),_vm._v(" "),_c('v-textarea',{attrs:{"disabled":_vm.editedItem.reporte == 1,"color":"#f8ac4a","rows":"2","auto-grow":""},on:{"input":_vm.forceUpdate},model:{value:(cc.valor),callback:function ($$v) {_vm.$set(cc, "valor", $$v)},expression:"cc.valor"}})],1)],1):_vm._e(),_vm._v(" "),(child.id_tipo == 4)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(cc.nome))]),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":_vm.editedItem.reporte == 1,"color":"#f8ac4a","mask":"################"},on:{"input":_vm.forceUpdate},model:{value:(cc.valor),callback:function ($$v) {_vm.$set(cc, "valor", $$v)},expression:"cc.valor"}})],1)],1):_vm._e(),_vm._v(" "),(child.id_tipo == 6)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(cc.nome))]),_vm._v(" "),_c('v-autocomplete',{attrs:{"disabled":_vm.editedItem.reporte == 1,"color":"#f8ac4a","items":_vm.getDistritos,"item-text":"nome","item-value":"id_distrito"},on:{"input":_vm.forceUpdate},model:{value:(cc.valor),callback:function ($$v) {_vm.$set(cc, "valor", $$v)},expression:"cc.valor"}})],1)],1):_vm._e(),_vm._v(" "),(child.id_tipo == 7)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(cc.nome))]),_vm._v(" "),_c('v-autocomplete',{attrs:{"disabled":_vm.editedItem.reporte == 1,"color":"#f8ac4a","items":_vm.getSetores,"item-text":"nome","item-value":"id_setor"},on:{"input":_vm.forceUpdate},model:{value:(cc.valor),callback:function ($$v) {_vm.$set(cc, "valor", $$v)},expression:"cc.valor"}})],1)],1):_vm._e()],1)}),1):_vm._e()],1):_vm._e(),_vm._v(" "),(p.pergunta.id_tipo == 2)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"disabled":_vm.editedItem.reporte == 1,"color":"#f8ac4a","label":child.nome},on:{"change":function($event){return _vm.changeCheck(p.pergunta, child, 2)}},model:{value:(child.checked),callback:function ($$v) {_vm.$set(child, "checked", $$v)},expression:"child.checked"}}),_vm._v(" "),(
                                            child.expansivel && child.checked
                                          )?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},_vm._l((child.children),function(cc,kk){return _c('v-flex',{key:kk,attrs:{"xs12":"","sm12":"","md12":""}},[(child.id_tipo == 1)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"disabled":_vm.editedItem.reporte == 1,"color":"#f8ac4a","label":cc.nome},on:{"change":function($event){return _vm.changeCheck(child, cc, 1)}},model:{value:(cc.checked),callback:function ($$v) {_vm.$set(cc, "checked", $$v)},expression:"cc.checked"}}),_vm._v(" "),(
                                                  cc.expansivel && cc.checked
                                                )?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},_vm._l((cc.children),function(n,k1){return _c('v-flex',{key:k1,attrs:{"xs12":"","sm12":"","md12":""}},[(cc.id_tipo == 1)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"disabled":_vm.editedItem.reporte ==
                                                          1,"color":"#f8ac4a","label":n.nome},on:{"change":function($event){return _vm.changeCheck(cc, n, 1)}},model:{value:(n.checked),callback:function ($$v) {_vm.$set(n, "checked", $$v)},expression:"n.checked"}})],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 2)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"disabled":_vm.editedItem.reporte ==
                                                          1,"color":"#f8ac4a","label":n.nome},on:{"change":function($event){return _vm.changeCheck(cc, n, 2)}},model:{value:(n.checked),callback:function ($$v) {_vm.$set(n, "checked", $$v)},expression:"n.checked"}})],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 3)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(n.nome))]),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":_vm.editedItem.reporte ==
                                                            1,"color":"#f8ac4a"},on:{"input":_vm.forceUpdate},model:{value:(n.valor),callback:function ($$v) {_vm.$set(n, "valor", $$v)},expression:"n.valor"}})],1)],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 8)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(n.nome))]),_vm._v(" "),_c('v-textarea',{attrs:{"disabled":_vm.editedItem.reporte ==
                                                            1,"color":"#f8ac4a","rows":"2","auto-grow":""},on:{"input":_vm.forceUpdate},model:{value:(n.valor),callback:function ($$v) {_vm.$set(n, "valor", $$v)},expression:"n.valor"}})],1)],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 4)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(n.nome))]),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":_vm.editedItem.reporte ==
                                                            1,"color":"#f8ac4a","mask":"################"},on:{"input":_vm.forceUpdate},model:{value:(n.valor),callback:function ($$v) {_vm.$set(n, "valor", $$v)},expression:"n.valor"}})],1)],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 6)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(n.nome))]),_vm._v(" "),_c('v-autocomplete',{attrs:{"disabled":_vm.editedItem.reporte ==
                                                            1,"color":"#f8ac4a","items":_vm.getDistritos,"item-text":"nome","item-value":"id_distrito"},on:{"input":_vm.forceUpdate},model:{value:(n.valor),callback:function ($$v) {_vm.$set(n, "valor", $$v)},expression:"n.valor"}})],1)],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 7)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(n.nome))]),_vm._v(" "),_c('v-autocomplete',{attrs:{"disabled":_vm.editedItem.reporte ==
                                                            1,"color":"#f8ac4a","items":_vm.getSetores,"item-text":"nome","item-value":"id_setor"},on:{"input":_vm.forceUpdate},model:{value:(n.valor),callback:function ($$v) {_vm.$set(n, "valor", $$v)},expression:"n.valor"}})],1)],1):_vm._e()],1)}),1):_vm._e()],1):_vm._e(),_vm._v(" "),(child.id_tipo == 2)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"disabled":_vm.editedItem.reporte == 1,"color":"#f8ac4a","label":cc.nome},on:{"change":function($event){return _vm.changeCheck(child, cc, 2)}},model:{value:(cc.checked),callback:function ($$v) {_vm.$set(cc, "checked", $$v)},expression:"cc.checked"}}),_vm._v(" "),(
                                                  cc.expansivel && cc.checked
                                                )?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},_vm._l((cc.children),function(n,k1){return _c('v-flex',{key:k1,attrs:{"xs12":"","sm12":"","md12":""}},[(cc.id_tipo == 1)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"disabled":_vm.editedItem.reporte ==
                                                          1,"color":"#f8ac4a","label":n.nome},on:{"change":function($event){return _vm.changeCheck(cc, n, 1)}},model:{value:(n.checked),callback:function ($$v) {_vm.$set(n, "checked", $$v)},expression:"n.checked"}})],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 2)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"disabled":_vm.editedItem.reporte ==
                                                          1,"color":"#f8ac4a","label":n.nome},on:{"change":function($event){return _vm.changeCheck(cc, n, 2)}},model:{value:(n.checked),callback:function ($$v) {_vm.$set(n, "checked", $$v)},expression:"n.checked"}})],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 3)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(n.nome))]),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":_vm.editedItem.reporte ==
                                                            1,"color":"#f8ac4a"},on:{"input":_vm.forceUpdate},model:{value:(n.valor),callback:function ($$v) {_vm.$set(n, "valor", $$v)},expression:"n.valor"}})],1)],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 8)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(n.nome))]),_vm._v(" "),_c('v-textarea',{attrs:{"disabled":_vm.editedItem.reporte ==
                                                            1,"color":"#f8ac4a","rows":"2","auto-grow":""},on:{"input":_vm.forceUpdate},model:{value:(n.valor),callback:function ($$v) {_vm.$set(n, "valor", $$v)},expression:"n.valor"}})],1)],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 4)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(n.nome))]),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":_vm.editedItem.reporte ==
                                                            1,"color":"#f8ac4a","mask":"################"},on:{"input":_vm.forceUpdate},model:{value:(n.valor),callback:function ($$v) {_vm.$set(n, "valor", $$v)},expression:"n.valor"}})],1)],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 6)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(n.nome))]),_vm._v(" "),_c('v-autocomplete',{attrs:{"disabled":_vm.editedItem.reporte ==
                                                            1,"color":"#f8ac4a","items":_vm.getDistritos,"item-text":"nome","item-value":"id_distrito"},on:{"input":_vm.forceUpdate},model:{value:(n.valor),callback:function ($$v) {_vm.$set(n, "valor", $$v)},expression:"n.valor"}})],1)],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 7)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(n.nome))]),_vm._v(" "),_c('v-autocomplete',{attrs:{"disabled":_vm.editedItem.reporte ==
                                                            1,"color":"#f8ac4a","items":_vm.getSetores,"item-text":"nome","item-value":"id_setor"},on:{"input":_vm.forceUpdate},model:{value:(n.valor),callback:function ($$v) {_vm.$set(n, "valor", $$v)},expression:"n.valor"}})],1)],1):_vm._e()],1)}),1):_vm._e()],1):_vm._e(),_vm._v(" "),(child.id_tipo == 3)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(cc.nome))]),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":_vm.editedItem.reporte == 1,"color":"#f8ac4a"},on:{"input":_vm.forceUpdate},model:{value:(child.valor),callback:function ($$v) {_vm.$set(child, "valor", $$v)},expression:"child.valor"}})],1)],1):_vm._e(),_vm._v(" "),(child.id_tipo == 8)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(cc.nome))]),_vm._v(" "),_c('v-textarea',{attrs:{"disabled":_vm.editedItem.reporte == 1,"color":"#f8ac4a","rows":"2","auto-grow":""},on:{"input":_vm.forceUpdate},model:{value:(child.valor),callback:function ($$v) {_vm.$set(child, "valor", $$v)},expression:"child.valor"}})],1)],1):_vm._e(),_vm._v(" "),(child.id_tipo == 4)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(cc.nome))]),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":_vm.editedItem.reporte == 1,"color":"#f8ac4a","mask":"################"},on:{"input":_vm.forceUpdate},model:{value:(child.valor),callback:function ($$v) {_vm.$set(child, "valor", $$v)},expression:"child.valor"}})],1)],1):_vm._e(),_vm._v(" "),(child.id_tipo == 6)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(cc.nome))]),_vm._v(" "),_c('v-autocomplete',{attrs:{"disabled":_vm.editedItem.reporte == 1,"color":"#f8ac4a","items":_vm.getDistritos,"item-text":"nome","item-value":"id_distrito"},on:{"input":_vm.forceUpdate},model:{value:(child.valor),callback:function ($$v) {_vm.$set(child, "valor", $$v)},expression:"child.valor"}})],1)],1):_vm._e(),_vm._v(" "),(child.id_tipo == 7)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(cc.nome))]),_vm._v(" "),_c('v-autocomplete',{attrs:{"disabled":_vm.editedItem.reporte == 1,"color":"#f8ac4a","items":_vm.getSetores,"item-text":"nome","item-value":"id_setor"},on:{"input":_vm.forceUpdate},model:{value:(child.valor),callback:function ($$v) {_vm.$set(child, "valor", $$v)},expression:"child.valor"}})],1)],1):_vm._e()],1)}),1):_vm._e()],1):_vm._e()],1)],1)],1)],1)}),1):_vm._e(),_vm._v(" "),(p.pergunta.id_tipo == 5)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},_vm._l((p.pergunta.children),function(child,i){return _c('v-flex',{key:i,attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{staticStyle:{"display":"grid !important"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"child-2 label-nivel"},[_vm._v(_vm._s(child.nome))]),_vm._v(" "),_c('label',{staticClass:"label-modal child-2"},[_vm._v(_vm._s(_vm.getLegenda(child.id_tipo))+"\n                                          "),(child.required)?_c('span',{staticStyle:{"color":"red !important","margin-left":"10px !important"}},[_vm._v("* Obrigatória")]):_vm._e()])])],1)],1),_vm._v(" "),(
                                      child.id_tipo == 1 || child.id_tipo == 2
                                    )?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},_vm._l((child.children),function(c,j){return _c('v-flex',{key:j,attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{staticClass:"child-3",attrs:{"xs8":"","sm8":"","md8":""}},[(child.id_tipo == 1)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"disabled":_vm.editedItem.reporte == 1,"color":"#f8ac4a","label":c.nome},on:{"change":function($event){return _vm.changeCheck(child, c, 1)}},model:{value:(c.checked),callback:function ($$v) {_vm.$set(c, "checked", $$v)},expression:"c.checked"}}),_vm._v(" "),(c.expansivel && c.checked)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[(
                                                  (c.id_tipo == 1) |
                                                    (c.id_tipo == 2)
                                                )?_c('v-flex',_vm._l((c.children),function(n,k){return _c('v-flex',{key:k,attrs:{"xs12":"","sm12":"","md12":""}},[(c.id_tipo == 1)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"disabled":_vm.editedItem.reporte ==
                                                          1,"color":"#f8ac4a","label":n.nome},on:{"change":function($event){return _vm.changeCheck(c, n, 1)}},model:{value:(n.checked),callback:function ($$v) {_vm.$set(n, "checked", $$v)},expression:"n.checked"}})],1):_vm._e(),_vm._v(" "),(c.id_tipo == 2)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"disabled":_vm.editedItem.reporte ==
                                                          1,"color":"#f8ac4a","label":n.nome},on:{"change":function($event){return _vm.changeCheck(c, n, 2)}},model:{value:(n.checked),callback:function ($$v) {_vm.$set(n, "checked", $$v)},expression:"n.checked"}})],1):_vm._e()],1)}),1):_vm._e(),_vm._v(" "),(c.id_tipo == 3)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"disabled":_vm.editedItem.reporte == 1,"color":"#f8ac4a"},on:{"input":_vm.forceUpdate},model:{value:(c.valor),callback:function ($$v) {_vm.$set(c, "valor", $$v)},expression:"c.valor"}})],1)],1):_vm._e(),_vm._v(" "),(c.id_tipo == 8)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(_vm.n.nome))]),_vm._v(" "),_c('v-textarea',{attrs:{"disabled":_vm.editedItem.reporte == 1,"color":"#f8ac4a","rows":"2","auto-grow":""},on:{"input":_vm.forceUpdate},model:{value:(c.valor),callback:function ($$v) {_vm.$set(c, "valor", $$v)},expression:"c.valor"}})],1)],1):_vm._e(),_vm._v(" "),(c.id_tipo == 4)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"disabled":_vm.editedItem.reporte == 1,"color":"#f8ac4a","mask":"################"},on:{"input":_vm.forceUpdate},model:{value:(c.valor),callback:function ($$v) {_vm.$set(c, "valor", $$v)},expression:"c.valor"}})],1)],1):_vm._e(),_vm._v(" "),(c.id_tipo == 6)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-autocomplete',{attrs:{"disabled":_vm.editedItem.reporte == 1,"color":"#f8ac4a","items":_vm.getDistritos,"item-text":"nome","item-value":"id_distrito"},on:{"input":_vm.forceUpdate},model:{value:(c.valor),callback:function ($$v) {_vm.$set(c, "valor", $$v)},expression:"c.valor"}})],1)],1):_vm._e(),_vm._v(" "),(c.id_tipo == 7)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-autocomplete',{attrs:{"disabled":_vm.editedItem.reporte == 1,"color":"#f8ac4a","items":_vm.getSetores,"item-text":"nome","item-value":"id_setor"},on:{"input":_vm.forceUpdate},model:{value:(c.valor),callback:function ($$v) {_vm.$set(c, "valor", $$v)},expression:"c.valor"}})],1)],1):_vm._e()],1):_vm._e()],1):_vm._e(),_vm._v(" "),(child.id_tipo == 2)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"disabled":_vm.editedItem.reporte == 1,"color":"#f8ac4a","label":c.nome},on:{"change":function($event){return _vm.changeCheck(child, c, 2)}},model:{value:(c.checked),callback:function ($$v) {_vm.$set(c, "checked", $$v)},expression:"c.checked"}}),_vm._v(" "),(c.expansivel && c.checked)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[(
                                                  (c.id_tipo == 1) |
                                                    (c.id_tipo == 2)
                                                )?_c('v-flex',_vm._l((c.children),function(n,k){return _c('v-flex',{key:k,attrs:{"xs12":"","sm12":"","md12":""}},[(c.id_tipo == 1)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"disabled":_vm.editedItem.reporte ==
                                                          1,"color":"#f8ac4a","label":n.nome},on:{"change":function($event){return _vm.changeCheck(c, n, 1)}},model:{value:(n.checked),callback:function ($$v) {_vm.$set(n, "checked", $$v)},expression:"n.checked"}})],1):_vm._e(),_vm._v(" "),(c.id_tipo == 2)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"disabled":_vm.editedItem.reporte ==
                                                          1,"color":"#f8ac4a","label":n.nome},on:{"change":function($event){return _vm.changeCheck(c, n, 2)}},model:{value:(n.checked),callback:function ($$v) {_vm.$set(n, "checked", $$v)},expression:"n.checked"}})],1):_vm._e()],1)}),1):_vm._e(),_vm._v(" "),(c.id_tipo == 3)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"disabled":_vm.editedItem.reporte == 1,"color":"#f8ac4a"},on:{"input":_vm.forceUpdate},model:{value:(c.valor),callback:function ($$v) {_vm.$set(c, "valor", $$v)},expression:"c.valor"}})],1)],1):_vm._e(),_vm._v(" "),(c.id_tipo == 8)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(_vm.n.nome))]),_vm._v(" "),_c('v-textarea',{attrs:{"disabled":_vm.editedItem.reporte == 1,"color":"#f8ac4a","rows":"2","auto-grow":""},on:{"input":_vm.forceUpdate},model:{value:(c.valor),callback:function ($$v) {_vm.$set(c, "valor", $$v)},expression:"c.valor"}})],1)],1):_vm._e(),_vm._v(" "),(c.id_tipo == 4)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"disabled":_vm.editedItem.reporte == 1,"color":"#f8ac4a","mask":"################"},on:{"input":_vm.forceUpdate},model:{value:(c.valor),callback:function ($$v) {_vm.$set(c, "valor", $$v)},expression:"c.valor"}})],1)],1):_vm._e(),_vm._v(" "),(c.id_tipo == 6)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-autocomplete',{attrs:{"disabled":_vm.editedItem.reporte == 1,"color":"#f8ac4a","items":_vm.getDistritos,"item-text":"nome","item-value":"id_distrito"},on:{"input":_vm.forceUpdate},model:{value:(c.valor),callback:function ($$v) {_vm.$set(c, "valor", $$v)},expression:"c.valor"}})],1)],1):_vm._e(),_vm._v(" "),(c.id_tipo == 7)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-autocomplete',{attrs:{"disabled":_vm.editedItem.reporte == 1,"color":"#f8ac4a","items":_vm.getSetores,"item-text":"nome","item-value":"id_setor"},on:{"input":_vm.forceUpdate},model:{value:(c.valor),callback:function ($$v) {_vm.$set(c, "valor", $$v)},expression:"c.valor"}})],1)],1):_vm._e()],1):_vm._e()],1):_vm._e()],1)],1)],1)}),1):_vm._e(),_vm._v(" "),(child.id_tipo == 3)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{staticClass:"child-3",attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"disabled":_vm.editedItem.reporte == 1,"color":"#f8ac4a"},on:{"input":_vm.forceUpdate},model:{value:(child.valor),callback:function ($$v) {_vm.$set(child, "valor", $$v)},expression:"child.valor"}})],1)],1):_vm._e(),_vm._v(" "),(child.id_tipo == 8)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-textarea',{attrs:{"disabled":_vm.editedItem.reporte == 1,"color":"#f8ac4a","rows":"2","auto-grow":""},on:{"input":_vm.forceUpdate},model:{value:(child.valor),callback:function ($$v) {_vm.$set(child, "valor", $$v)},expression:"child.valor"}})],1)],1):_vm._e(),_vm._v(" "),(child.id_tipo == 4)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{staticClass:"child-3",attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"disabled":_vm.editedItem.reporte == 1,"color":"#f8ac4a","mask":"################"},on:{"input":_vm.forceUpdate},model:{value:(child.valor),callback:function ($$v) {_vm.$set(child, "valor", $$v)},expression:"child.valor"}})],1)],1):_vm._e(),_vm._v(" "),(child.id_tipo == 6)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{staticClass:"child-3",attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-autocomplete',{attrs:{"disabled":_vm.editedItem.reporte == 1,"color":"#f8ac4a","items":_vm.getDistritos,"item-text":"nome","item-value":"id_distrito"},on:{"input":_vm.forceUpdate},model:{value:(child.valor),callback:function ($$v) {_vm.$set(child, "valor", $$v)},expression:"child.valor"}})],1)],1):_vm._e(),_vm._v(" "),(child.id_tipo == 7)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{staticClass:"child-3",attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-autocomplete',{attrs:{"disabled":_vm.editedItem.reporte == 1,"color":"#f8ac4a","items":_vm.getSetores,"item-text":"nome","item-value":"id_setor"},on:{"input":_vm.forceUpdate},model:{value:(child.valor),callback:function ($$v) {_vm.$set(child, "valor", $$v)},expression:"child.valor"}})],1)],1):_vm._e()],1)],1)}),1):_vm._e()],1):(p.pergunta.id_tipo == 3)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"disabled":_vm.editedItem.reporte == 1,"color":"#f8ac4a"},on:{"input":_vm.forceUpdate},model:{value:(p.pergunta.valor),callback:function ($$v) {_vm.$set(p.pergunta, "valor", $$v)},expression:"p.pergunta.valor"}})],1)],1):_vm._e(),_vm._v(" "),(p.pergunta.id_tipo == 8)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-textarea',{attrs:{"disabled":_vm.editedItem.reporte == 1,"color":"#f8ac4a","rows":"2","auto-grow":""},on:{"input":_vm.forceUpdate},model:{value:(p.pergunta.valor),callback:function ($$v) {_vm.$set(p.pergunta, "valor", $$v)},expression:"p.pergunta.valor"}})],1)],1):(p.pergunta.id_tipo == 4)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"disabled":_vm.editedItem.reporte == 1,"color":"#f8ac4a","mask":"################"},on:{"input":_vm.forceUpdate},model:{value:(p.pergunta.valor),callback:function ($$v) {_vm.$set(p.pergunta, "valor", $$v)},expression:"p.pergunta.valor"}})],1)],1):(p.pergunta.id_tipo == 6)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-autocomplete',{attrs:{"disabled":_vm.editedItem.reporte == 1,"color":"#f8ac4a","items":_vm.getDistritos,"item-text":"nome","item-value":"id_distrito"},on:{"input":_vm.forceUpdate},model:{value:(p.pergunta.valor),callback:function ($$v) {_vm.$set(p.pergunta, "valor", $$v)},expression:"p.pergunta.valor"}})],1)],1):(p.pergunta.id_tipo == 7)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-autocomplete',{attrs:{"disabled":_vm.editedItem.reporte == 1,"color":"#f8ac4a","items":_vm.getSetores,"item-text":"nome","item-value":"id_setor"},on:{"input":_vm.forceUpdate},model:{value:(p.pergunta.valor),callback:function ($$v) {_vm.$set(p.pergunta, "valor", $$v)},expression:"p.pergunta.valor"}})],1)],1):_vm._e()],1)})]})],2):_vm._e()],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":""},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"disabled":_vm.editedItem.reporte == 1,"color":"#f8ac4a","flat":""},nativeOn:{"click":function($event){return _vm.saveReporte(false)}}},[_vm._v("Guardar")]),_vm._v(" "),_c('v-btn',{attrs:{"disabled":_vm.editedItem.submetida == 0 ||
                  !_vm.isReporteAberta(_vm.editedItem.id_ano) ||
                  _vm.editedItem.reporte == 1 ||
                  !_vm.isFormCompleted(),"color":"success"},on:{"click":function($event){_vm.repM = true}}},[_vm._v("SUBMETER REPORTE")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"700px"},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('v-btn',{staticClass:"mb-2",attrs:{"slot":"activator","color":"#f8ac4a","dark":""},slot:"activator"},[_c('v-icon',{staticClass:"buttonIconText",attrs:{"color":"white"}},[_vm._v("playlist_add")]),_vm._v("\n          Planificação ação prevista\n        ")],1),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();}}},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-stepper',{staticStyle:{"box-shadow":"none"},model:{value:(_vm.stepper2),callback:function ($$v) {_vm.stepper2=$$v},expression:"stepper2"}},[_c('v-stepper-header',{staticStyle:{"box-shadow":"none"}},[_c('v-stepper-step',{attrs:{"color":"#f8ac4a","step":"1","edit-icon":'done',"complete":_vm.editedItem.id_objetivo > 0},on:{"click":function($event){_vm.stepper2 = 1}}},[_vm._v("Objetivo")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"color":"#f8ac4a","step":"2","edit-icon":'done',"complete":_vm.editedItem.id_medida > 0},on:{"click":function($event){_vm.stepper2 = 2}}},[_vm._v("Medida")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"color":"#f8ac4a","step":"3","edit-icon":'done',"complete":_vm.editedItem.id_acao > 0},on:{"click":function($event){_vm.stepper2 = 3}}},[_vm._v("Ação")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"color":"#f8ac4a","step":"4"},on:{"click":function($event){_vm.stepper2 = 4}}},[_vm._v("Planificação")])],1),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"1"}},[_c('v-card',{staticClass:"mb-5",staticStyle:{"box-shadow":"none"}},[_c('v-radio-group',{attrs:{"disabled":_vm.editedIndex > -1},on:{"change":_vm.changeObjetivo},model:{value:(_vm.editedItem.id_objetivo),callback:function ($$v) {_vm.$set(_vm.editedItem, "id_objetivo", $$v)},expression:"editedItem.id_objetivo"}},_vm._l((_vm.getObjetivos),function(item,o){return _c('v-radio',{key:'o-' + o,staticClass:"mb-3",attrs:{"color":"#f8ac4a","label":item.nome + ' - ' + item.descricao,"value":item.id_objetivo}})}),1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('v-card',{staticClass:"mb-5",staticStyle:{"box-shadow":"none"}},[(
                                _vm.editedItem.id_objetivo > 0 &&
                                  _vm.getMedidasByObjetivo(_vm.editedItem.id_objetivo)
                                    .length > 0
                              )?_c('v-radio-group',{attrs:{"disabled":_vm.editedIndex > -1},on:{"change":_vm.changeMedida},model:{value:(_vm.editedItem.id_medida),callback:function ($$v) {_vm.$set(_vm.editedItem, "id_medida", $$v)},expression:"editedItem.id_medida"}},_vm._l((_vm.getMedidasByObjetivo(
                                  _vm.editedItem.id_objetivo
                                )),function(item,m){return _c('v-radio',{key:'m-' + m,staticClass:"mb-3",attrs:{"color":"#f8ac4a","label":item.nome + ' - ' + item.descricao,"value":item.id_medida}})}),1):(_vm.editedItem.id_objetivo == 0)?_c('span',[_vm._v("Precisa de escolher um objetivo.")]):(
                                _vm.editedItem.id_objetivo > 0 &&
                                  _vm.getMedidasByObjetivo(_vm.editedItem.id_objetivo)
                                    .length == 0
                              )?_c('span',[_vm._v("Não existem medidas associadas a este\n                              objetivo.")]):_vm._e()],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"3"}},[_c('v-card',{staticClass:"mb-5",staticStyle:{"box-shadow":"none"}},[(
                                _vm.editedItem.id_medida > 0 &&
                                  _vm.getAcoesByMedida(_vm.editedItem.id_medida)
                                    .length > 0
                              )?_c('v-radio-group',{attrs:{"disabled":_vm.editedIndex > -1},on:{"change":_vm.changeAcao},model:{value:(_vm.editedItem.id_acao),callback:function ($$v) {_vm.$set(_vm.editedItem, "id_acao", $$v)},expression:"editedItem.id_acao"}},_vm._l((_vm.getAcoesByMedida(
                                  _vm.editedItem.id_medida
                                )),function(item,a){return _c('v-radio',{key:'m-' + a,staticClass:"mb-3",attrs:{"color":"#f8ac4a","label":item.nome + ' - ' + item.descricao,"value":item.id_acao}})}),1):(_vm.editedItem.id_medida == 0)?_c('span',[_vm._v("Precisa de escolher uma medida.")]):(
                                _vm.editedItem.id_medida > 0 &&
                                  _vm.getAcoesByMedida(_vm.editedItem.id_medida)
                                    .length == 0
                              )?_c('span',[_vm._v("Não existem ações associadas a esta\n                              medida.")]):_vm._e()],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"4"}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Tipo de ação")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"disabled":_vm.editedItem.submetida == 1,"color":"#f8ac4a","items":_vm.getTiposAcao,"item-text":"nome","item-value":"id_tipo_acao"},model:{value:(_vm.editedItem.id_tipo_acao),callback:function ($$v) {_vm.$set(_vm.editedItem, "id_tipo_acao", $$v)},expression:"editedItem.id_tipo_acao"}})],1),_vm._v(" "),(
                                _vm.editedItem.id_tipo_acao == 1 ||
                                  _vm.editedItem.id_tipo_acao == 2
                              )?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Designação do projeto")]),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":_vm.editedItem.submetida == 1,"color":"#f8ac4a"},model:{value:(_vm.editedItem.design_proj),callback:function ($$v) {_vm.$set(_vm.editedItem, "design_proj", $$v)},expression:"editedItem.design_proj"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Designação da ação")]),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":_vm.editedItem.submetida == 1,"color":"#f8ac4a","rules":_vm.defaultRules},model:{value:(_vm.editedItem.design_acao),callback:function ($$v) {_vm.$set(_vm.editedItem, "design_acao", $$v)},expression:"editedItem.design_acao"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Quando ano?")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"disabled":_vm.editedItem.submetida == 1 ||
                                    _vm.editedIndex > -1,"color":"#f8ac4a","items":_vm.getAnos,"item-text":"nome","item-value":"id_ano"},on:{"change":function($event){return _vm.changeAno()}},model:{value:(_vm.editedItem.id_ano),callback:function ($$v) {_vm.$set(_vm.editedItem, "id_ano", $$v)},expression:"editedItem.id_ano"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Quando mês?")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"disabled":_vm.editedItem.submetida == 1,"color":"#f8ac4a","items":_vm.getMeses,"item-text":"nome","item-value":"id_mes"},model:{value:(_vm.editedItem.mes),callback:function ($$v) {_vm.$set(_vm.editedItem, "mes", $$v)},expression:"editedItem.mes"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Quando dia?")]),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":_vm.editedItem.submetida == 1,"color":"#f8ac4a"},model:{value:(_vm.editedItem.dia),callback:function ($$v) {_vm.$set(_vm.editedItem, "dia", $$v)},expression:"editedItem.dia"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Onde?")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"disabled":_vm.editedItem.submetida == 1,"color":"#f8ac4a","items":_vm.getDistritos,"item-text":"nome","item-value":"id_distrito"},model:{value:(_vm.editedItem.id_distrito),callback:function ($$v) {_vm.$set(_vm.editedItem, "id_distrito", $$v)},expression:"editedItem.id_distrito"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("A quem se destina?")]),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":_vm.editedItem.submetida == 1,"color":"#f8ac4a","rules":_vm.defaultRules},model:{value:(_vm.editedItem.quem),callback:function ($$v) {_vm.$set(_vm.editedItem, "quem", $$v)},expression:"editedItem.quem"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Descrição")]),_vm._v(" "),_c('v-textarea',{attrs:{"disabled":_vm.editedItem.submetida == 1,"color":"#f8ac4a","auto-grow":"","rows":2,"counter":500,"maxlength":500},model:{value:(_vm.editedItem.descricao),callback:function ($$v) {_vm.$set(_vm.editedItem, "descricao", $$v)},expression:"editedItem.descricao"}})],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":""},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"disabled":_vm.editedItem.submetida == 1,"color":"#f8ac4a","flat":""},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Guardar")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"700px"},model:{value:(_vm.addNova),callback:function ($$v) {_vm.addNova=$$v},expression:"addNova"}},[_c('v-btn',{staticClass:"mb-2",attrs:{"slot":"activator","color":"#f8ac4a","dark":""},slot:"activator"},[_c('v-icon',{staticClass:"buttonIconText",attrs:{"color":"white"}},[_vm._v("playlist_add")]),_vm._v("\n          Adicionar ação não prevista\n        ")],1),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-form',{ref:"formNova",on:{"submit":function($event){$event.preventDefault();}}},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-stepper',{staticStyle:{"box-shadow":"none"},model:{value:(_vm.stepper3),callback:function ($$v) {_vm.stepper3=$$v},expression:"stepper3"}},[_c('v-stepper-header',{staticStyle:{"box-shadow":"none"}},[_c('v-stepper-step',{attrs:{"color":"#f8ac4a","step":"1","edit-icon":'done',"complete":_vm.NOVA.id_objetivo > 0},on:{"click":function($event){_vm.stepper3 = 1}}},[_vm._v("Objetivo")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"color":"#f8ac4a","step":"2","edit-icon":'done',"complete":_vm.NOVA.id_medida > 0},on:{"click":function($event){_vm.stepper3 = 2}}},[_vm._v("Medida")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"color":"#f8ac4a","step":"3","edit-icon":'done',"complete":_vm.NOVA.id_acao > 0},on:{"click":function($event){_vm.stepper3 = 3}}},[_vm._v("Ação")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"color":"#f8ac4a","step":"4"},on:{"click":function($event){_vm.stepper3 = 4}}},[_vm._v("Dados")])],1),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"1"}},[_c('v-card',{staticClass:"mb-5",staticStyle:{"box-shadow":"none"}},[_c('v-radio-group',{on:{"change":_vm.changeObjetivo2},model:{value:(_vm.NOVA.id_objetivo),callback:function ($$v) {_vm.$set(_vm.NOVA, "id_objetivo", $$v)},expression:"NOVA.id_objetivo"}},_vm._l((_vm.getObjetivos),function(item,o){return _c('v-radio',{key:'o-' + o,staticClass:"mb-3",attrs:{"color":"#f8ac4a","label":item.nome + ' - ' + item.descricao,"value":item.id_objetivo}})}),1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('v-card',{staticClass:"mb-5",staticStyle:{"box-shadow":"none"}},[(
                                _vm.NOVA.id_objetivo > 0 &&
                                  _vm.getMedidasByObjetivo(_vm.NOVA.id_objetivo)
                                    .length > 0
                              )?_c('v-radio-group',{on:{"change":_vm.changeMedida2},model:{value:(_vm.NOVA.id_medida),callback:function ($$v) {_vm.$set(_vm.NOVA, "id_medida", $$v)},expression:"NOVA.id_medida"}},_vm._l((_vm.getMedidasByObjetivo(
                                  _vm.NOVA.id_objetivo
                                )),function(item,m){return _c('v-radio',{key:'m-' + m,staticClass:"mb-3",attrs:{"color":"#f8ac4a","label":item.nome + ' - ' + item.descricao,"value":item.id_medida}})}),1):(_vm.NOVA.id_objetivo == 0)?_c('span',[_vm._v("Precisa de escolher um objetivo.")]):(
                                _vm.NOVA.id_objetivo > 0 &&
                                  _vm.getMedidasByObjetivo(_vm.NOVA.id_objetivo)
                                    .length == 0
                              )?_c('span',[_vm._v("Não existem medidas associadas a este\n                              objetivo.")]):_vm._e()],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"3"}},[_c('v-card',{staticClass:"mb-5",staticStyle:{"box-shadow":"none"}},[(
                                _vm.NOVA.id_medida > 0 &&
                                  _vm.getAcoesByMedida(_vm.NOVA.id_medida).length > 0
                              )?_c('v-radio-group',{on:{"change":_vm.changeAcao2},model:{value:(_vm.NOVA.id_acao),callback:function ($$v) {_vm.$set(_vm.NOVA, "id_acao", $$v)},expression:"NOVA.id_acao"}},_vm._l((_vm.getAcoesByMedida(
                                  _vm.NOVA.id_medida
                                )),function(item,a){return _c('v-radio',{key:'m-' + a,staticClass:"mb-3",attrs:{"color":"#f8ac4a","label":item.nome + ' - ' + item.descricao,"value":item.id_acao}})}),1):(_vm.NOVA.id_medida == 0)?_c('span',[_vm._v("Precisa de escolher uma medida.")]):(
                                _vm.NOVA.id_medida > 0 &&
                                  _vm.getAcoesByMedida(_vm.NOVA.id_medida).length == 0
                              )?_c('span',[_vm._v("Não existem ações associadas a esta\n                              medida.")]):_vm._e()],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"4"}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Nº ações em 2018?")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#f8ac4a"},model:{value:(_vm.NOVA.ano1),callback:function ($$v) {_vm.$set(_vm.NOVA, "ano1", $$v)},expression:"NOVA.ano1"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Nº ações em 2019?")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#f8ac4a"},model:{value:(_vm.NOVA.ano2),callback:function ($$v) {_vm.$set(_vm.NOVA, "ano2", $$v)},expression:"NOVA.ano2"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Nº ações em 2020?")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#f8ac4a"},model:{value:(_vm.NOVA.ano3),callback:function ($$v) {_vm.$set(_vm.NOVA, "ano3", $$v)},expression:"NOVA.ano3"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Nº ações em 2021?")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#f8ac4a"},model:{value:(_vm.NOVA.ano4),callback:function ($$v) {_vm.$set(_vm.NOVA, "ano4", $$v)},expression:"NOVA.ano4"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Nº ações em 2022?")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#f8ac4a"},model:{value:(_vm.NOVA.ano5),callback:function ($$v) {_vm.$set(_vm.NOVA, "ano5", $$v)},expression:"NOVA.ano5"}})],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":""},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":""},nativeOn:{"click":function($event){return _vm.addPropostas($event)}}},[_vm._v("Guardar")])],1)],1)],1)],1),_vm._v(" "),_c('v-text-field',{staticClass:"searchTable",attrs:{"color":"#f8ac4a","append-icon":"search","label":"Pesquisa","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"390"},model:{value:(_vm.deleteM),callback:function ($$v) {_vm.deleteM=$$v},expression:"deleteM"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline",staticStyle:{"margin-left":"0px !important"}},[_vm._v("Apagar "+_vm._s(_vm.name))]),_vm._v(" "),_c('v-card-text',[_vm._v("De certeza que quer apagar este "+_vm._s(_vm.name)+"?")]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"margin-top":"0px !important"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":"flat"},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":"flat"},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Apagar")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"390"},model:{value:(_vm.subM),callback:function ($$v) {_vm.subM=$$v},expression:"subM"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline",staticStyle:{"margin-left":"0px !important"}},[_vm._v("Submeter "+_vm._s(_vm.name)+"?")]),_vm._v(" "),_c('v-card-text',[_vm._v("Depois de submetida não é possível efeturar\n          alterações.")]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"margin-top":"0px !important"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":"flat"},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":"flat"},nativeOn:{"click":function($event){return _vm.submeter($event)}}},[_vm._v("Submeter")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"390"},model:{value:(_vm.repM),callback:function ($$v) {_vm.repM=$$v},expression:"repM"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline",staticStyle:{"margin-left":"0px !important"}},[_vm._v("Reporte "+_vm._s(_vm.name)+"?")]),_vm._v(" "),_c('v-card-text',[_vm._v("Depois do reporte estar submetido não é possível efeturar\n          alterações.")]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"margin-top":"0px !important"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":"flat"},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":"flat"},nativeOn:{"click":function($event){return _vm.subReporte($event)}}},[_vm._v("Submeter")])],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.DATA,"search":_vm.search,"loading":_vm.loading,"item-key":"id","disable-initial-sort":true,"rows-per-page-items":[10, 25, 50, { text: 'Todos', value: -1 }],"rows-per-page-text":"Itens por página:"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"textLeft",on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v("\n          "+_vm._s(props.item.design_acao || "-")+"\n        ")]),_vm._v(" "),_c('td',{staticClass:"textCenter",on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v("\n          "+_vm._s(_vm.getAnoById(props.item.id_ano).nome)+"\n        ")]),_vm._v(" "),_c('td',{staticClass:"textCenter"},[(props.item.submetida == 0)?_c('v-btn',{attrs:{"disabled":props.item.submetida == 1 ||
                !_vm.isPlanificacaoAberta(props.item.id_ano) ||
                !_vm.readyToSubmit(props.item.id_proposta),"color":"success"},on:{"click":function($event){return _vm.submeterPlanificacao(props.item)}}},[_vm._v("SUBMETER")]):_vm._e(),_vm._v(" "),(props.item.submetida == 1)?_c('span',{staticStyle:{"color":"green"},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v("PLANIFICAÇÂO SUBMETIDA")]):_vm._e()],1),_vm._v(" "),_c('td',{staticClass:"textCenter"},[(props.item.reporte == 1)?_c('span',{staticStyle:{"color":"green"},on:{"click":function($event){return _vm.reporte(props.item)}}},[_vm._v("REPORTE SUBMETIDO")]):_vm._e(),(props.item.reporte == 0)?_c('span',{staticStyle:{"color":"red"},on:{"click":function($event){return _vm.reporte(props.item)}}},[_vm._v("REPORTE NÂO SUBMETIDO")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"px-0 textTable textCenter"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.reporte(props.item, true)}}},[_c('v-icon',{attrs:{"color":"light-green darken-1"}},[_vm._v("picture_as_pdf")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.cloneItem(props.item, true)}}},[_c('v-icon',{attrs:{"color":"blue"}},[_vm._v("backup_table")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"disabled":props.item.submetida == 1,"icon":""},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_c('v-icon',{attrs:{"color":"amber"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"disabled":props.item.submetida == 1,"icon":""},on:{"click":function($event){return _vm.editItem(props.item, false)}}},[_c('v-icon',{attrs:{"color":"red lighten-1"}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{staticClass:"alertTable",slot:"no-data"},[(_vm.loading)?_c('v-progress-circular',{staticStyle:{"margin-left":"50% !important"},attrs:{"indeterminate":"","color":"#f8ac4a"}}):_vm._e()],1)],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1335:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Anos_vue__ = __webpack_require__(467);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59ced88d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Anos_vue__ = __webpack_require__(1336);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Anos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59ced88d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Anos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1336:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[_c('div',{staticClass:"elevation-3"},[_c('div',{staticClass:"noTableHeader"},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('v-btn',{staticClass:"mb-2",attrs:{"slot":"activator","color":"#f8ac4a","dark":""},slot:"activator"},[_c('v-icon',{staticClass:"buttonIconText",attrs:{"color":"white"}},[_vm._v("playlist_add")]),_vm._v(" Novo "+_vm._s(_vm.name))],1),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();}}},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Nome")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#f8ac4a","autofocus":true,"mask":"####","rules":_vm.yearRules},model:{value:(_vm.editedItem.nome),callback:function ($$v) {_vm.$set(_vm.editedItem, "nome", $$v)},expression:"editedItem.nome"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":""},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":""},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Guardar")])],1)],1)],1)],1),_vm._v(" "),_c('v-text-field',{staticClass:"searchTable",attrs:{"color":"#f8ac4a","append-icon":"search","label":"Pesquisa","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"390"},model:{value:(_vm.deleteM),callback:function ($$v) {_vm.deleteM=$$v},expression:"deleteM"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline",staticStyle:{"margin-left":"0px !important"}},[_vm._v("Apagar "+_vm._s(_vm.name))]),_vm._v(" "),_c('v-card-text',[_vm._v("De certeza que quer apagar este "+_vm._s(_vm.name)+"?")]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"margin-top":"0px !important"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":"flat"},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":"flat"},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Apagar")])],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.DATA,"search":_vm.search,"loading":_vm.loading,"item-key":"id","disable-initial-sort":true,"rows-per-page-items":[10,25,50,{"text":"Todos","value":-1}],"rows-per-page-text":"Itens por página:"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"textLeft",staticStyle:{"width":"15%"},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v(_vm._s(props.item.id_ano))]),_vm._v(" "),_c('td',{staticClass:"textLeft",staticStyle:{"width":"60%"},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v(_vm._s(props.item.nome))]),_vm._v(" "),_c('td',{staticClass:" px-0 textTable textCenter"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_c('v-icon',{attrs:{"color":"light-green darken-1"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item, false)}}},[_c('v-icon',{attrs:{"color":"red lighten-1"}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{staticClass:"alertTable",slot:"no-data"},[_c('v-alert',{attrs:{"value":true,"icon":"warning"}},[_vm._v("\n                    De momento não há nada a apresentar! :(\n                ")])],1)],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1337:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Fases_vue__ = __webpack_require__(468);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00d85449_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Fases_vue__ = __webpack_require__(1338);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Fases_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00d85449_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Fases_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1338:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[_c('div',{staticClass:"elevation-3"},[_c('div',{staticClass:"noTableHeader"},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('v-btn',{staticClass:"mb-2",attrs:{"slot":"activator","color":"#f8ac4a","dark":""},slot:"activator"},[_c('v-icon',{staticClass:"buttonIconText",attrs:{"color":"white"}},[_vm._v("playlist_add")]),_vm._v(" Nova "+_vm._s(_vm.name))],1),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();}}},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Data ínicio")]),_vm._v(" "),_c('v-menu',{attrs:{"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.iniMenu),callback:function ($$v) {_vm.iniMenu=$$v},expression:"iniMenu"}},[_c('v-text-field',{attrs:{"slot":"activator","rules":_vm.defaultRules,"prepend-icon":"event","color":"#f8ac4a","readonly":""},slot:"activator",model:{value:(_vm.editedItem.data_inicio),callback:function ($$v) {_vm.$set(_vm.editedItem, "data_inicio", $$v)},expression:"editedItem.data_inicio"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"pt","color":"#f8ac4a"},on:{"change":_vm.iniChange},model:{value:(_vm.editedItem.data_inicio),callback:function ($$v) {_vm.$set(_vm.editedItem, "data_inicio", $$v)},expression:"editedItem.data_inicio"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Data Fim")]),_vm._v(" "),_c('v-menu',{attrs:{"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.fimMenu),callback:function ($$v) {_vm.fimMenu=$$v},expression:"fimMenu"}},[_c('v-text-field',{attrs:{"slot":"activator","rules":_vm.defaultRules,"prepend-icon":"event","color":"#f8ac4a","readonly":""},slot:"activator",model:{value:(_vm.editedItem.data_fim),callback:function ($$v) {_vm.$set(_vm.editedItem, "data_fim", $$v)},expression:"editedItem.data_fim"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"pt","min":_vm.editedItem.data_inicio,"color":"#f8ac4a"},on:{"change":_vm.fimChange},model:{value:(_vm.editedItem.data_fim),callback:function ($$v) {_vm.$set(_vm.editedItem, "data_fim", $$v)},expression:"editedItem.data_fim"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Ano")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#f8ac4a","items":_vm.getAnos,"item-text":"nome","item-value":"id_ano","rules":_vm.defaultRules},model:{value:(_vm.editedItem.id_ano),callback:function ($$v) {_vm.$set(_vm.editedItem, "id_ano", $$v)},expression:"editedItem.id_ano"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Tipo")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#f8ac4a","items":_vm.tipos,"item-text":"nome","item-value":"tipo","rules":_vm.defaultRules},model:{value:(_vm.editedItem.tipo),callback:function ($$v) {_vm.$set(_vm.editedItem, "tipo", $$v)},expression:"editedItem.tipo"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":""},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":""},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Guardar")])],1)],1)],1)],1),_vm._v(" "),_c('v-text-field',{staticClass:"searchTable",attrs:{"color":"#f8ac4a","append-icon":"search","label":"Pesquisa","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"390"},model:{value:(_vm.deleteM),callback:function ($$v) {_vm.deleteM=$$v},expression:"deleteM"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline",staticStyle:{"margin-left":"0px !important"}},[_vm._v("Apagar "+_vm._s(_vm.name))]),_vm._v(" "),_c('v-card-text',[_vm._v("De certeza que quer apagar este "+_vm._s(_vm.name)+"?")]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"margin-top":"0px !important"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":"flat"},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":"flat"},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Apagar")])],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.DATA,"search":_vm.search,"loading":_vm.loading,"item-key":"id","disable-initial-sort":true,"rows-per-page-items":[10,25,50,{"text":"Todos","value":-1}],"rows-per-page-text":"Itens por página:"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"textLeft",staticStyle:{"width":"15%"},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v(_vm._s(props.item.id_fase))]),_vm._v(" "),_c('td',{staticClass:"textLeft",staticStyle:{"width":"30%"},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v(_vm._s(_vm.nomeFase(props.item.id_ano, props.item.tipo)))]),_vm._v(" "),_c('td',{staticClass:"textCenter",staticStyle:{"width":"30%"},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v(_vm._s(props.item.data_inicio)+" a "+_vm._s(props.item.data_fim))]),_vm._v(" "),_c('td',{staticClass:" px-0 textTable textCenter"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_c('v-icon',{attrs:{"color":"light-green darken-1"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item, false)}}},[_c('v-icon',{attrs:{"color":"red lighten-1"}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{staticClass:"alertTable",slot:"no-data"},[_c('v-alert',{attrs:{"value":true,"icon":"warning"}},[_vm._v("\n                    De momento não há nada a apresentar! :(\n                ")])],1)],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1339:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Propostas_Admin_vue__ = __webpack_require__(469);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_788fd8c8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Propostas_Admin_vue__ = __webpack_require__(1341);
function injectStyle (ssrContext) {
  __webpack_require__(1340)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-788fd8c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Propostas_Admin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_788fd8c8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Propostas_Admin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1340:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1341:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[_c('v-dialog',{attrs:{"persistent":"","width":"300"},model:{value:(_vm.generating),callback:function ($$v) {_vm.generating=$$v},expression:"generating"}},[_c('v-card',{attrs:{"color":"#f8ac4a","dark":""}},[_c('v-card-text',[_vm._v("\n        A gerar pdf. Por favor aguarde...\n        "),_c('v-progress-linear',{staticClass:"mb-0",attrs:{"indeterminate":"","color":"white"}})],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","width":"300"},model:{value:(_vm.waiting),callback:function ($$v) {_vm.waiting=$$v},expression:"waiting"}},[_c('v-card',{attrs:{"color":"#f8ac4a","dark":""}},[_c('v-card-text',[_vm._v("\n        A carregar. Por favor aguarde.\n        "),_c('v-progress-linear',{attrs:{"color":"white","height":"25"},model:{value:(_vm.exportingProgress),callback:function ($$v) {_vm.exportingProgress=$$v},expression:"exportingProgress"}},[_c('div',{staticClass:"d-flex justify-center black--text"},[_vm._v("\n            "+_vm._s(Math.ceil(_vm.exportingProgress > 100 ? 100 : _vm.exportingProgress))+"%\n          ")])])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"mb-4"},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-card',{staticStyle:{"box-shadow":"none","background-color":"#f8f8f8"}},[_c('v-container',{staticStyle:{"padding":"0 !important"},attrs:{"grid-list-md":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Objetivo")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#f8ac4a","items":_vm.getObjetivos,"item-text":"nome","item-value":"id_objetivo"},model:{value:(_vm.FILTRO.id_objetivo),callback:function ($$v) {_vm.$set(_vm.FILTRO, "id_objetivo", $$v)},expression:"FILTRO.id_objetivo"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Medida")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#f8ac4a","items":_vm.getMedidasByObjetivo(_vm.FILTRO.id_objetivo),"item-text":"nome","item-value":"id_medida"},model:{value:(_vm.FILTRO.id_medida),callback:function ($$v) {_vm.$set(_vm.FILTRO, "id_medida", $$v)},expression:"FILTRO.id_medida"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Ação")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#f8ac4a","items":_vm.getAcoesByMedida(_vm.FILTRO.id_medida),"item-text":"nome","item-value":"id_acao"},model:{value:(_vm.FILTRO.id_acao),callback:function ($$v) {_vm.$set(_vm.FILTRO, "id_acao", $$v)},expression:"FILTRO.id_acao"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Instituição")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#f8ac4a","items":_vm.getAllInstituicoes,"item-text":"nome","item-value":"id_instituicao"},model:{value:(_vm.FILTRO.id_instituicao),callback:function ($$v) {_vm.$set(_vm.FILTRO, "id_instituicao", $$v)},expression:"FILTRO.id_instituicao"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Ano")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#f8ac4a","items":_vm.getAnos,"item-text":"nome","item-value":"id_ano"},model:{value:(_vm.FILTRO.id_ano),callback:function ($$v) {_vm.$set(_vm.FILTRO, "id_ano", $$v)},expression:"FILTRO.id_ano"}})],1),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"flex","align-items":"center"},attrs:{"xs3":"","sm3":"","md3":""}},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"#f8ac4a","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.filtrar()}}},on),[_c('v-icon',[_vm._v("search")])],1)]}}])},[_vm._v(" "),_c('span',[_vm._v("Filtrar")])]),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"#ff4b4b","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.limpar()}}},on),[_c('v-icon',[_vm._v("clear")])],1)]}}])},[_vm._v(" "),_c('span',[_vm._v("Limpar filtros")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"elevation-3"},[_c('v-dialog',{attrs:{"max-width":"1000px","persistent":""},model:{value:(_vm.reporteM),callback:function ($$v) {_vm.reporteM=$$v},expression:"reporteM"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Reporte")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{staticStyle:{"padding":"0 !important"},attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-form',{ref:"formReporte",on:{"submit":function($event){$event.preventDefault();}}},[(_vm.reporteM)?_c('v-stepper',{staticStyle:{"box-shadow":"none"},attrs:{"vertical":""},model:{value:(_vm.stepper),callback:function ($$v) {_vm.stepper=$$v},expression:"stepper"}},[_vm._l((_vm.formulario),function(p,k){return [_c('v-stepper-step',{key:'k' + k,attrs:{"step":k + 1,"editable":"","complete":_vm.checkedPerguntaCompleted(p),"edit-icon":'done',"color":"#f8ac4a"}},[_vm._v("\n                        "+_vm._s(_vm.getDimensaoById(p.key).nome)+"\n                      ")]),_vm._v(" "),_vm._l((p.children),function(p,j){return _c('v-stepper-content',{key:'s' + j + k,staticClass:"formulario",staticStyle:{"padding-top":"5px !important"},attrs:{"step":k + 1}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{staticStyle:{"display":"grid !important"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-pergunta"},[_c('v-icon',{attrs:{"color":"#222222","size":"20"}},[_vm._v("arrow_right")]),_vm._v("\n                                "+_vm._s(p.pergunta.nome))],1),_vm._v(" "),_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(_vm.getLegenda(p.pergunta.id_tipo))+"\n                                "),(
                                    p.pergunta.required &&
                                      p.pergunta.id_tipo != 5
                                  )?_c('span',{staticStyle:{"color":"red !important","margin-left":"10px !important"}},[_vm._v("* Obrigatória")]):_vm._e()])])],1)],1),_vm._v(" "),(p.pergunta.children.length > 0)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[(
                              p.pergunta.id_tipo == 1 ||
                                p.pergunta.id_tipo == 2
                            )?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},_vm._l((p.pergunta.children),function(child,i){return _c('v-flex',{key:i,attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[(p.pergunta.id_tipo == 1)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"disabled":true,"color":"#f8ac4a","label":child.nome},on:{"change":function($event){return _vm.changeCheck(p.pergunta, child, 1)}},model:{value:(child.checked),callback:function ($$v) {_vm.$set(child, "checked", $$v)},expression:"child.checked"}}),_vm._v(" "),(
                                          child.expansivel && child.checked
                                        )?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},_vm._l((child.children),function(cc,kk){return _c('v-flex',{key:kk,attrs:{"xs12":"","sm12":"","md12":""}},[(child.id_tipo == 1)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"disabled":true,"color":"#f8ac4a","label":cc.nome},on:{"change":function($event){return _vm.changeCheck(child, cc, 1)}},model:{value:(cc.checked),callback:function ($$v) {_vm.$set(cc, "checked", $$v)},expression:"cc.checked"}}),_vm._v(" "),(
                                                cc.expansivel && cc.checked
                                              )?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},_vm._l((cc.children),function(n,k1){return _c('v-flex',{key:k1,attrs:{"xs12":"","sm12":"","md12":""}},[(cc.id_tipo == 1)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"disabled":true,"color":"#f8ac4a","label":n.nome},on:{"change":function($event){return _vm.changeCheck(cc, n, 1)}},model:{value:(n.checked),callback:function ($$v) {_vm.$set(n, "checked", $$v)},expression:"n.checked"}})],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 2)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"disabled":true,"color":"#f8ac4a","label":n.nome},on:{"change":function($event){return _vm.changeCheck(cc, n, 2)}},model:{value:(n.checked),callback:function ($$v) {_vm.$set(n, "checked", $$v)},expression:"n.checked"}})],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 3)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(n.nome))]),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":true,"color":"#f8ac4a"},on:{"input":_vm.forceUpdate},model:{value:(n.valor),callback:function ($$v) {_vm.$set(n, "valor", $$v)},expression:"n.valor"}})],1)],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 8)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(n.nome))]),_vm._v(" "),_c('v-textarea',{attrs:{"disabled":true,"color":"#f8ac4a","rows":"2","auto-grow":""},on:{"input":_vm.forceUpdate},model:{value:(n.valor),callback:function ($$v) {_vm.$set(n, "valor", $$v)},expression:"n.valor"}})],1)],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 4)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(n.nome))]),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":true,"color":"#f8ac4a","mask":"################"},on:{"input":_vm.forceUpdate},model:{value:(n.valor),callback:function ($$v) {_vm.$set(n, "valor", $$v)},expression:"n.valor"}})],1)],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 6)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(n.nome))]),_vm._v(" "),_c('v-autocomplete',{attrs:{"disabled":true,"color":"#f8ac4a","items":_vm.getDistritos,"item-text":"nome","item-value":"id_distrito"},on:{"input":_vm.forceUpdate},model:{value:(n.valor),callback:function ($$v) {_vm.$set(n, "valor", $$v)},expression:"n.valor"}})],1)],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 7)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(n.nome))]),_vm._v(" "),_c('v-autocomplete',{attrs:{"disabled":true,"color":"#f8ac4a","items":_vm.getSetores,"item-text":"nome","item-value":"id_setor"},on:{"input":_vm.forceUpdate},model:{value:(n.valor),callback:function ($$v) {_vm.$set(n, "valor", $$v)},expression:"n.valor"}})],1)],1):_vm._e()],1)}),1):_vm._e()],1):_vm._e(),_vm._v(" "),(child.id_tipo == 2)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"disabled":true,"color":"#f8ac4a","label":cc.nome},on:{"change":function($event){return _vm.changeCheck(child, cc, 2)}},model:{value:(cc.checked),callback:function ($$v) {_vm.$set(cc, "checked", $$v)},expression:"cc.checked"}}),_vm._v(" "),(
                                                cc.expansivel && cc.checked
                                              )?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},_vm._l((cc.children),function(n,k1){return _c('v-flex',{key:k1,attrs:{"xs12":"","sm12":"","md12":""}},[(cc.id_tipo == 1)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"disabled":true,"color":"#f8ac4a","label":n.nome},on:{"change":function($event){return _vm.changeCheck(cc, n, 1)}},model:{value:(n.checked),callback:function ($$v) {_vm.$set(n, "checked", $$v)},expression:"n.checked"}})],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 2)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"disabled":true,"color":"#f8ac4a","label":n.nome},on:{"change":function($event){return _vm.changeCheck(cc, n, 2)}},model:{value:(n.checked),callback:function ($$v) {_vm.$set(n, "checked", $$v)},expression:"n.checked"}})],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 3)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(n.nome))]),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":true,"color":"#f8ac4a"},on:{"input":_vm.forceUpdate},model:{value:(n.valor),callback:function ($$v) {_vm.$set(n, "valor", $$v)},expression:"n.valor"}})],1)],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 8)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(n.nome))]),_vm._v(" "),_c('v-textarea',{attrs:{"disabled":true,"color":"#f8ac4a","rows":"2","auto-grow":""},on:{"input":_vm.forceUpdate},model:{value:(n.valor),callback:function ($$v) {_vm.$set(n, "valor", $$v)},expression:"n.valor"}})],1)],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 4)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(n.nome))]),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":true,"color":"#f8ac4a","mask":"################"},on:{"input":_vm.forceUpdate},model:{value:(n.valor),callback:function ($$v) {_vm.$set(n, "valor", $$v)},expression:"n.valor"}})],1)],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 6)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(n.nome))]),_vm._v(" "),_c('v-autocomplete',{attrs:{"disabled":true,"color":"#f8ac4a","items":_vm.getDistritos,"item-text":"nome","item-value":"id_distrito"},on:{"input":_vm.forceUpdate},model:{value:(n.valor),callback:function ($$v) {_vm.$set(n, "valor", $$v)},expression:"n.valor"}})],1)],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 7)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(n.nome))]),_vm._v(" "),_c('v-autocomplete',{attrs:{"disabled":true,"color":"#f8ac4a","items":_vm.getSetores,"item-text":"nome","item-value":"id_setor"},on:{"input":_vm.forceUpdate},model:{value:(n.valor),callback:function ($$v) {_vm.$set(n, "valor", $$v)},expression:"n.valor"}})],1)],1):_vm._e()],1)}),1):_vm._e()],1):_vm._e(),_vm._v(" "),(child.id_tipo == 3)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(cc.nome))]),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":true,"color":"#f8ac4a"},on:{"input":_vm.forceUpdate},model:{value:(cc.valor),callback:function ($$v) {_vm.$set(cc, "valor", $$v)},expression:"cc.valor"}})],1)],1):_vm._e(),_vm._v(" "),(child.id_tipo == 8)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(cc.nome))]),_vm._v(" "),_c('v-textarea',{attrs:{"disabled":true,"color":"#f8ac4a","rows":"2","auto-grow":""},on:{"input":_vm.forceUpdate},model:{value:(cc.valor),callback:function ($$v) {_vm.$set(cc, "valor", $$v)},expression:"cc.valor"}})],1)],1):_vm._e(),_vm._v(" "),(child.id_tipo == 4)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(cc.nome))]),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":true,"color":"#f8ac4a","mask":"################"},on:{"input":_vm.forceUpdate},model:{value:(cc.valor),callback:function ($$v) {_vm.$set(cc, "valor", $$v)},expression:"cc.valor"}})],1)],1):_vm._e(),_vm._v(" "),(child.id_tipo == 6)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(cc.nome))]),_vm._v(" "),_c('v-autocomplete',{attrs:{"disabled":true,"color":"#f8ac4a","items":_vm.getDistritos,"item-text":"nome","item-value":"id_distrito"},on:{"input":_vm.forceUpdate},model:{value:(cc.valor),callback:function ($$v) {_vm.$set(cc, "valor", $$v)},expression:"cc.valor"}})],1)],1):_vm._e(),_vm._v(" "),(child.id_tipo == 7)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(cc.nome))]),_vm._v(" "),_c('v-autocomplete',{attrs:{"disabled":true,"color":"#f8ac4a","items":_vm.getSetores,"item-text":"nome","item-value":"id_setor"},on:{"input":_vm.forceUpdate},model:{value:(cc.valor),callback:function ($$v) {_vm.$set(cc, "valor", $$v)},expression:"cc.valor"}})],1)],1):_vm._e()],1)}),1):_vm._e()],1):_vm._e(),_vm._v(" "),(p.pergunta.id_tipo == 2)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"disabled":true,"color":"#f8ac4a","label":child.nome},on:{"change":function($event){return _vm.changeCheck(p.pergunta, child, 2)}},model:{value:(child.checked),callback:function ($$v) {_vm.$set(child, "checked", $$v)},expression:"child.checked"}}),_vm._v(" "),(
                                          child.expansivel && child.checked
                                        )?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},_vm._l((child.children),function(cc,kk){return _c('v-flex',{key:kk,attrs:{"xs12":"","sm12":"","md12":""}},[(child.id_tipo == 1)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"disabled":true,"color":"#f8ac4a","label":cc.nome},on:{"change":function($event){return _vm.changeCheck(child, cc, 1)}},model:{value:(cc.checked),callback:function ($$v) {_vm.$set(cc, "checked", $$v)},expression:"cc.checked"}}),_vm._v(" "),(
                                                cc.expansivel && cc.checked
                                              )?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},_vm._l((cc.children),function(n,k1){return _c('v-flex',{key:k1,attrs:{"xs12":"","sm12":"","md12":""}},[(cc.id_tipo == 1)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"disabled":true,"color":"#f8ac4a","label":n.nome},on:{"change":function($event){return _vm.changeCheck(cc, n, 1)}},model:{value:(n.checked),callback:function ($$v) {_vm.$set(n, "checked", $$v)},expression:"n.checked"}})],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 2)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"disabled":true,"color":"#f8ac4a","label":n.nome},on:{"change":function($event){return _vm.changeCheck(cc, n, 2)}},model:{value:(n.checked),callback:function ($$v) {_vm.$set(n, "checked", $$v)},expression:"n.checked"}})],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 3)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(n.nome))]),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":true,"color":"#f8ac4a"},on:{"input":_vm.forceUpdate},model:{value:(n.valor),callback:function ($$v) {_vm.$set(n, "valor", $$v)},expression:"n.valor"}})],1)],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 8)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(n.nome))]),_vm._v(" "),_c('v-textarea',{attrs:{"disabled":true,"color":"#f8ac4a","rows":"2","auto-grow":""},on:{"input":_vm.forceUpdate},model:{value:(n.valor),callback:function ($$v) {_vm.$set(n, "valor", $$v)},expression:"n.valor"}})],1)],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 4)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(n.nome))]),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":true,"color":"#f8ac4a","mask":"################"},on:{"input":_vm.forceUpdate},model:{value:(n.valor),callback:function ($$v) {_vm.$set(n, "valor", $$v)},expression:"n.valor"}})],1)],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 6)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(n.nome))]),_vm._v(" "),_c('v-autocomplete',{attrs:{"disabled":true,"color":"#f8ac4a","items":_vm.getDistritos,"item-text":"nome","item-value":"id_distrito"},on:{"input":_vm.forceUpdate},model:{value:(n.valor),callback:function ($$v) {_vm.$set(n, "valor", $$v)},expression:"n.valor"}})],1)],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 7)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(n.nome))]),_vm._v(" "),_c('v-autocomplete',{attrs:{"disabled":true,"color":"#f8ac4a","items":_vm.getSetores,"item-text":"nome","item-value":"id_setor"},on:{"input":_vm.forceUpdate},model:{value:(n.valor),callback:function ($$v) {_vm.$set(n, "valor", $$v)},expression:"n.valor"}})],1)],1):_vm._e()],1)}),1):_vm._e()],1):_vm._e(),_vm._v(" "),(child.id_tipo == 2)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"disabled":true,"color":"#f8ac4a","label":cc.nome},on:{"change":function($event){return _vm.changeCheck(child, cc, 2)}},model:{value:(cc.checked),callback:function ($$v) {_vm.$set(cc, "checked", $$v)},expression:"cc.checked"}}),_vm._v(" "),(
                                                cc.expansivel && cc.checked
                                              )?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},_vm._l((cc.children),function(n,k1){return _c('v-flex',{key:k1,attrs:{"xs12":"","sm12":"","md12":""}},[(cc.id_tipo == 1)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"disabled":true,"color":"#f8ac4a","label":n.nome},on:{"change":function($event){return _vm.changeCheck(cc, n, 1)}},model:{value:(n.checked),callback:function ($$v) {_vm.$set(n, "checked", $$v)},expression:"n.checked"}})],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 2)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"disabled":true,"color":"#f8ac4a","label":n.nome},on:{"change":function($event){return _vm.changeCheck(cc, n, 2)}},model:{value:(n.checked),callback:function ($$v) {_vm.$set(n, "checked", $$v)},expression:"n.checked"}})],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 3)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(n.nome))]),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":true,"color":"#f8ac4a"},on:{"input":_vm.forceUpdate},model:{value:(n.valor),callback:function ($$v) {_vm.$set(n, "valor", $$v)},expression:"n.valor"}})],1)],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 8)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(n.nome))]),_vm._v(" "),_c('v-textarea',{attrs:{"disabled":true,"color":"#f8ac4a","rows":"2","auto-grow":""},on:{"input":_vm.forceUpdate},model:{value:(n.valor),callback:function ($$v) {_vm.$set(n, "valor", $$v)},expression:"n.valor"}})],1)],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 4)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(n.nome))]),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":true,"color":"#f8ac4a","mask":"################"},on:{"input":_vm.forceUpdate},model:{value:(n.valor),callback:function ($$v) {_vm.$set(n, "valor", $$v)},expression:"n.valor"}})],1)],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 6)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(n.nome))]),_vm._v(" "),_c('v-autocomplete',{attrs:{"disabled":true,"color":"#f8ac4a","items":_vm.getDistritos,"item-text":"nome","item-value":"id_distrito"},on:{"input":_vm.forceUpdate},model:{value:(n.valor),callback:function ($$v) {_vm.$set(n, "valor", $$v)},expression:"n.valor"}})],1)],1):_vm._e(),_vm._v(" "),(cc.id_tipo == 7)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(n.nome))]),_vm._v(" "),_c('v-autocomplete',{attrs:{"disabled":true,"color":"#f8ac4a","items":_vm.getSetores,"item-text":"nome","item-value":"id_setor"},on:{"input":_vm.forceUpdate},model:{value:(n.valor),callback:function ($$v) {_vm.$set(n, "valor", $$v)},expression:"n.valor"}})],1)],1):_vm._e()],1)}),1):_vm._e()],1):_vm._e(),_vm._v(" "),(child.id_tipo == 3)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(cc.nome))]),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":true,"color":"#f8ac4a"},on:{"input":_vm.forceUpdate},model:{value:(child.valor),callback:function ($$v) {_vm.$set(child, "valor", $$v)},expression:"child.valor"}})],1)],1):_vm._e(),_vm._v(" "),(child.id_tipo == 8)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(cc.nome))]),_vm._v(" "),_c('v-textarea',{attrs:{"disabled":true,"color":"#f8ac4a","rows":"2","auto-grow":""},on:{"input":_vm.forceUpdate},model:{value:(cc.valor),callback:function ($$v) {_vm.$set(cc, "valor", $$v)},expression:"cc.valor"}})],1)],1):_vm._e(),_vm._v(" "),(child.id_tipo == 4)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(cc.nome))]),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":true,"color":"#f8ac4a","mask":"################"},on:{"input":_vm.forceUpdate},model:{value:(child.valor),callback:function ($$v) {_vm.$set(child, "valor", $$v)},expression:"child.valor"}})],1)],1):_vm._e(),_vm._v(" "),(child.id_tipo == 6)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(cc.nome))]),_vm._v(" "),_c('v-autocomplete',{attrs:{"disabled":true,"color":"#f8ac4a","items":_vm.getDistritos,"item-text":"nome","item-value":"id_distrito"},on:{"input":_vm.forceUpdate},model:{value:(child.valor),callback:function ($$v) {_vm.$set(child, "valor", $$v)},expression:"child.valor"}})],1)],1):_vm._e(),_vm._v(" "),(child.id_tipo == 7)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v(_vm._s(cc.nome))]),_vm._v(" "),_c('v-autocomplete',{attrs:{"disabled":true,"color":"#f8ac4a","items":_vm.getSetores,"item-text":"nome","item-value":"id_setor"},on:{"input":_vm.forceUpdate},model:{value:(child.valor),callback:function ($$v) {_vm.$set(child, "valor", $$v)},expression:"child.valor"}})],1)],1):_vm._e()],1)}),1):_vm._e()],1):_vm._e()],1)],1)],1)],1)}),1):_vm._e(),_vm._v(" "),(p.pergunta.id_tipo == 5)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},_vm._l((p.pergunta.children),function(child,i){return _c('v-flex',{key:i,attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{staticStyle:{"display":"grid !important"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"child-2 label-nivel"},[_vm._v(_vm._s(child.nome))]),_vm._v(" "),_c('label',{staticClass:"label-modal child-2"},[_vm._v(_vm._s(_vm.getLegenda(child.id_tipo))+"\n                                        "),(child.required)?_c('span',{staticStyle:{"color":"red !important","margin-left":"10px !important"}},[_vm._v("* Obrigatória")]):_vm._e()])])],1)],1),_vm._v(" "),(
                                    child.id_tipo == 1 || child.id_tipo == 2
                                  )?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},_vm._l((child.children),function(c,j){return _c('v-flex',{key:j,attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{staticClass:"child-3",attrs:{"xs8":"","sm8":"","md8":""}},[(child.id_tipo == 1)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"disabled":true,"color":"#f8ac4a","label":c.nome},on:{"change":function($event){return _vm.changeCheck(child, c, 1)}},model:{value:(c.checked),callback:function ($$v) {_vm.$set(c, "checked", $$v)},expression:"c.checked"}}),_vm._v(" "),(c.expansivel && c.checked)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[(
                                                (c.id_tipo == 1) |
                                                  (c.id_tipo == 2)
                                              )?_c('v-flex',_vm._l((c.children),function(n,k){return _c('v-flex',{key:k,attrs:{"xs12":"","sm12":"","md12":""}},[(c.id_tipo == 1)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"disabled":true,"color":"#f8ac4a","label":n.nome},on:{"change":function($event){return _vm.changeCheck(c, n, 1)}},model:{value:(n.checked),callback:function ($$v) {_vm.$set(n, "checked", $$v)},expression:"n.checked"}})],1):_vm._e(),_vm._v(" "),(c.id_tipo == 2)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"disabled":true,"color":"#f8ac4a","label":n.nome},on:{"change":function($event){return _vm.changeCheck(c, n, 2)}},model:{value:(n.checked),callback:function ($$v) {_vm.$set(n, "checked", $$v)},expression:"n.checked"}})],1):_vm._e()],1)}),1):_vm._e(),_vm._v(" "),(c.id_tipo == 3)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"disabled":true,"color":"#f8ac4a"},on:{"input":_vm.forceUpdate},model:{value:(c.valor),callback:function ($$v) {_vm.$set(c, "valor", $$v)},expression:"c.valor"}})],1)],1):_vm._e(),_vm._v(" "),(c.id_tipo == 8)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-textarea',{attrs:{"disabled":true,"color":"#f8ac4a","rows":"2","auto-grow":""},on:{"input":_vm.forceUpdate},model:{value:(c.valor),callback:function ($$v) {_vm.$set(c, "valor", $$v)},expression:"c.valor"}})],1)],1):_vm._e(),_vm._v(" "),(c.id_tipo == 4)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"disabled":true,"color":"#f8ac4a","mask":"################"},on:{"input":_vm.forceUpdate},model:{value:(c.valor),callback:function ($$v) {_vm.$set(c, "valor", $$v)},expression:"c.valor"}})],1)],1):_vm._e(),_vm._v(" "),(c.id_tipo == 6)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-autocomplete',{attrs:{"disabled":true,"color":"#f8ac4a","items":_vm.getDistritos,"item-text":"nome","item-value":"id_distrito"},on:{"input":_vm.forceUpdate},model:{value:(c.valor),callback:function ($$v) {_vm.$set(c, "valor", $$v)},expression:"c.valor"}})],1)],1):_vm._e(),_vm._v(" "),(c.id_tipo == 7)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-autocomplete',{attrs:{"disabled":true,"color":"#f8ac4a","items":_vm.getSetores,"item-text":"nome","item-value":"id_setor"},on:{"input":_vm.forceUpdate},model:{value:(c.valor),callback:function ($$v) {_vm.$set(c, "valor", $$v)},expression:"c.valor"}})],1)],1):_vm._e()],1):_vm._e()],1):_vm._e(),_vm._v(" "),(child.id_tipo == 2)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"disabled":true,"color":"#f8ac4a","label":c.nome},on:{"change":function($event){return _vm.changeCheck(child, c, 2)}},model:{value:(c.checked),callback:function ($$v) {_vm.$set(c, "checked", $$v)},expression:"c.checked"}}),_vm._v(" "),(c.expansivel && c.checked)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[(
                                                (c.id_tipo == 1) |
                                                  (c.id_tipo == 2)
                                              )?_c('v-flex',_vm._l((c.children),function(n,k){return _c('v-flex',{key:k,attrs:{"xs12":"","sm12":"","md12":""}},[(c.id_tipo == 1)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"disabled":true,"color":"#f8ac4a","label":n.nome},on:{"change":function($event){return _vm.changeCheck(c, n, 1)}},model:{value:(n.checked),callback:function ($$v) {_vm.$set(n, "checked", $$v)},expression:"n.checked"}})],1):_vm._e(),_vm._v(" "),(c.id_tipo == 2)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"disabled":true,"color":"#f8ac4a","label":n.nome},on:{"change":function($event){return _vm.changeCheck(c, n, 2)}},model:{value:(n.checked),callback:function ($$v) {_vm.$set(n, "checked", $$v)},expression:"n.checked"}})],1):_vm._e()],1)}),1):_vm._e(),_vm._v(" "),(c.id_tipo == 3)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"disabled":true,"color":"#f8ac4a"},on:{"input":_vm.forceUpdate},model:{value:(c.valor),callback:function ($$v) {_vm.$set(c, "valor", $$v)},expression:"c.valor"}})],1)],1):_vm._e(),_vm._v(" "),(c.id_tipo == 8)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-textarea',{attrs:{"disabled":true,"color":"#f8ac4a","rows":"2","auto-grow":""},on:{"input":_vm.forceUpdate},model:{value:(c.valor),callback:function ($$v) {_vm.$set(c, "valor", $$v)},expression:"c.valor"}})],1)],1):_vm._e(),_vm._v(" "),(c.id_tipo == 4)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"disabled":true,"color":"#f8ac4a","mask":"################"},on:{"input":_vm.forceUpdate},model:{value:(c.valor),callback:function ($$v) {_vm.$set(c, "valor", $$v)},expression:"c.valor"}})],1)],1):_vm._e(),_vm._v(" "),(c.id_tipo == 6)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-autocomplete',{attrs:{"disabled":true,"color":"#f8ac4a","items":_vm.getDistritos,"item-text":"nome","item-value":"id_distrito"},on:{"input":_vm.forceUpdate},model:{value:(c.valor),callback:function ($$v) {_vm.$set(c, "valor", $$v)},expression:"c.valor"}})],1)],1):_vm._e(),_vm._v(" "),(c.id_tipo == 7)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-autocomplete',{attrs:{"disabled":true,"color":"#f8ac4a","items":_vm.getSetores,"item-text":"nome","item-value":"id_setor"},on:{"input":_vm.forceUpdate},model:{value:(c.valor),callback:function ($$v) {_vm.$set(c, "valor", $$v)},expression:"c.valor"}})],1)],1):_vm._e()],1):_vm._e()],1):_vm._e()],1)],1)],1)}),1):_vm._e(),_vm._v(" "),(child.id_tipo == 3)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{staticClass:"child-3",attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"disabled":true,"color":"#f8ac4a"},on:{"input":_vm.forceUpdate},model:{value:(child.valor),callback:function ($$v) {_vm.$set(child, "valor", $$v)},expression:"child.valor"}})],1)],1):_vm._e(),_vm._v(" "),(child.id_tipo == 8)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-textarea',{attrs:{"disabled":true,"color":"#f8ac4a","rows":"2","auto-grow":""},on:{"input":_vm.forceUpdate},model:{value:(child.valor),callback:function ($$v) {_vm.$set(child, "valor", $$v)},expression:"child.valor"}})],1)],1):_vm._e(),_vm._v(" "),(child.id_tipo == 4)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{staticClass:"child-3",attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"disabled":true,"color":"#f8ac4a","mask":"################"},on:{"input":_vm.forceUpdate},model:{value:(child.valor),callback:function ($$v) {_vm.$set(child, "valor", $$v)},expression:"child.valor"}})],1)],1):_vm._e(),_vm._v(" "),(child.id_tipo == 6)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{staticClass:"child-3",attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-autocomplete',{attrs:{"disabled":true,"color":"#f8ac4a","items":_vm.getDistritos,"item-text":"nome","item-value":"id_distrito"},on:{"input":_vm.forceUpdate},model:{value:(child.valor),callback:function ($$v) {_vm.$set(child, "valor", $$v)},expression:"child.valor"}})],1)],1):_vm._e(),_vm._v(" "),(child.id_tipo == 7)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{staticClass:"child-3",attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-autocomplete',{attrs:{"disabled":true,"color":"#f8ac4a","items":_vm.getSetores,"item-text":"nome","item-value":"id_setor"},on:{"input":_vm.forceUpdate},model:{value:(child.valor),callback:function ($$v) {_vm.$set(child, "valor", $$v)},expression:"child.valor"}})],1)],1):_vm._e()],1)],1)}),1):_vm._e()],1):(p.pergunta.id_tipo == 3)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"disabled":true,"color":"#f8ac4a"},on:{"input":_vm.forceUpdate},model:{value:(p.pergunta.valor),callback:function ($$v) {_vm.$set(p.pergunta, "valor", $$v)},expression:"p.pergunta.valor"}})],1)],1):_vm._e(),_vm._v(" "),(p.pergunta.id_tipo == 8)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-textarea',{attrs:{"disabled":true,"color":"#f8ac4a","rows":"2","auto-grow":""},on:{"input":_vm.forceUpdate},model:{value:(p.pergunta.valor),callback:function ($$v) {_vm.$set(p.pergunta, "valor", $$v)},expression:"p.pergunta.valor"}})],1)],1):(p.pergunta.id_tipo == 4)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"disabled":true,"color":"#f8ac4a","mask":"################"},on:{"input":_vm.forceUpdate},model:{value:(p.pergunta.valor),callback:function ($$v) {_vm.$set(p.pergunta, "valor", $$v)},expression:"p.pergunta.valor"}})],1)],1):(p.pergunta.id_tipo == 6)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-autocomplete',{attrs:{"disabled":true,"color":"#f8ac4a","items":_vm.getDistritos,"item-text":"nome","item-value":"id_distrito"},on:{"input":_vm.forceUpdate},model:{value:(p.pergunta.valor),callback:function ($$v) {_vm.$set(p.pergunta, "valor", $$v)},expression:"p.pergunta.valor"}})],1)],1):(p.pergunta.id_tipo == 7)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-autocomplete',{attrs:{"disabled":true,"color":"#f8ac4a","items":_vm.getSetores,"item-text":"nome","item-value":"id_setor"},on:{"input":_vm.forceUpdate},model:{value:(p.pergunta.valor),callback:function ($$v) {_vm.$set(p.pergunta, "valor", $$v)},expression:"p.pergunta.valor"}})],1)],1):_vm._e()],1)})]})],2):_vm._e()],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":""},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"700px"},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[(_vm.editedIndex > -1)?_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Proposta -\n            "+_vm._s(_vm.getInstituicaoById(_vm.editedItem.id_instituicao).nome))])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Tipo de ação")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"disabled":true,"color":"#f8ac4a","items":_vm.getTiposAcao,"item-text":"nome","item-value":"id_tipo_acao","rules":_vm.defaultRules},model:{value:(_vm.editedItem.id_tipo_acao),callback:function ($$v) {_vm.$set(_vm.editedItem, "id_tipo_acao", $$v)},expression:"editedItem.id_tipo_acao"}})],1),_vm._v(" "),(
                  _vm.editedItem.id_tipo_acao == 1 || _vm.editedItem.id_tipo_acao == 2
                )?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Designação do projeto")]),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":true,"color":"#f8ac4a"},model:{value:(_vm.editedItem.design_proj),callback:function ($$v) {_vm.$set(_vm.editedItem, "design_proj", $$v)},expression:"editedItem.design_proj"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Designação da ação")]),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":true,"color":"#f8ac4a","rules":_vm.defaultRules},model:{value:(_vm.editedItem.design_acao),callback:function ($$v) {_vm.$set(_vm.editedItem, "design_acao", $$v)},expression:"editedItem.design_acao"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Objetivo")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"disabled":true,"color":"#f8ac4a","items":_vm.getObjetivos,"item-text":"nome","item-value":"id_objetivo","rules":_vm.defaultRules},model:{value:(_vm.editedItem.id_objetivo),callback:function ($$v) {_vm.$set(_vm.editedItem, "id_objetivo", $$v)},expression:"editedItem.id_objetivo"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Medida")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"disabled":true,"color":"#f8ac4a","items":_vm.getMedidasByObjetivo(_vm.editedItem.id_objetivo),"item-text":"nome","item-value":"id_medida","rules":_vm.defaultRules},model:{value:(_vm.editedItem.id_medida),callback:function ($$v) {_vm.$set(_vm.editedItem, "id_medida", $$v)},expression:"editedItem.id_medida"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Ação")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"disabled":true,"color":"#f8ac4a","items":_vm.getAcoesByMedida(_vm.editedItem.id_medida),"item-text":"nome","item-value":"id_acao","rules":_vm.defaultRules},model:{value:(_vm.editedItem.id_acao),callback:function ($$v) {_vm.$set(_vm.editedItem, "id_acao", $$v)},expression:"editedItem.id_acao"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Quando ano?")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"disabled":true,"color":"#f8ac4a","items":_vm.getAnos,"rules":_vm.defaultRules,"item-text":"nome","item-value":"id_ano"},on:{"change":function($event){return _vm.changeAno()}},model:{value:(_vm.editedItem.id_ano),callback:function ($$v) {_vm.$set(_vm.editedItem, "id_ano", $$v)},expression:"editedItem.id_ano"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Quando mês?")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"disabled":true,"color":"#f8ac4a","items":_vm.getMeses,"item-text":"nome","item-value":"id_mes"},model:{value:(_vm.editedItem.mes),callback:function ($$v) {_vm.$set(_vm.editedItem, "mes", $$v)},expression:"editedItem.mes"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Quando dia?")]),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":true,"color":"#f8ac4a"},model:{value:(_vm.editedItem.dia),callback:function ($$v) {_vm.$set(_vm.editedItem, "dia", $$v)},expression:"editedItem.dia"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Onde?")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"disabled":true,"color":"#f8ac4a","items":_vm.getDistritos,"item-text":"nome","item-value":"id_distrito"},model:{value:(_vm.editedItem.id_distrito),callback:function ($$v) {_vm.$set(_vm.editedItem, "id_distrito", $$v)},expression:"editedItem.id_distrito"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("A quem de destina?")]),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":true,"color":"#f8ac4a","rules":_vm.defaultRules},model:{value:(_vm.editedItem.quem),callback:function ($$v) {_vm.$set(_vm.editedItem, "quem", $$v)},expression:"editedItem.quem"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Descrição")]),_vm._v(" "),_c('v-textarea',{attrs:{"disabled":true,"color":"#f8ac4a","rules":_vm.defaultRules,"auto-grow":"","rows":2,"counter":500,"maxlength":500},model:{value:(_vm.editedItem.descricao),callback:function ($$v) {_vm.$set(_vm.editedItem, "descricao", $$v)},expression:"editedItem.descricao"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),(_vm.editedItem.reporte == 1)?_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){return _vm.reverterReporte()}}},[_vm._v("Reverter reporte")]):_vm._e(),_vm._v(" "),(_vm.editedItem.submetida == 1)?_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){return _vm.reverterSubmissao()}}},[_vm._v("Reverter planificacao")]):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":""},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")])],1)],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"noTableHeader"},[_c('v-dialog',{attrs:{"persistent":"","max-width":"700px"},model:{value:(_vm.addNova),callback:function ($$v) {_vm.addNova=$$v},expression:"addNova"}},[_c('v-btn',{staticClass:"mb-2",attrs:{"slot":"activator","color":"#f8ac4a","dark":""},slot:"activator"},[_c('v-icon',{staticClass:"buttonIconText",attrs:{"color":"white"}},[_vm._v("playlist_add")]),_vm._v("\n          Nova "+_vm._s(_vm.name)+"\n        ")],1),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();}}},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-stepper',{staticStyle:{"box-shadow":"none"},model:{value:(_vm.stepper2),callback:function ($$v) {_vm.stepper2=$$v},expression:"stepper2"}},[_c('v-stepper-header',{staticStyle:{"box-shadow":"none"}},[_c('v-stepper-step',{attrs:{"color":"#f8ac4a","step":"1","edit-icon":'done',"complete":_vm.NOVA.id_objetivo > 0},on:{"click":function($event){_vm.stepper2 = 1}}},[_vm._v("Objetivo")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"color":"#f8ac4a","step":"2","edit-icon":'done',"complete":_vm.NOVA.id_medida > 0},on:{"click":function($event){_vm.stepper2 = 2}}},[_vm._v("Medida")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"color":"#f8ac4a","step":"3","edit-icon":'done',"complete":_vm.NOVA.id_acao > 0},on:{"click":function($event){_vm.stepper2 = 3}}},[_vm._v("Ação")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"color":"#f8ac4a","step":"4"},on:{"click":function($event){_vm.stepper2 = 4}}},[_vm._v("Dados")])],1),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"1"}},[_c('v-card',{staticClass:"mb-5",staticStyle:{"box-shadow":"none"}},[_c('v-radio-group',{on:{"change":_vm.changeObjetivo},model:{value:(_vm.NOVA.id_objetivo),callback:function ($$v) {_vm.$set(_vm.NOVA, "id_objetivo", $$v)},expression:"NOVA.id_objetivo"}},_vm._l((_vm.getObjetivos),function(item,o){return _c('v-radio',{key:'o-' + o,staticClass:"mb-3",attrs:{"color":"#f8ac4a","label":item.nome + ' - ' + item.descricao,"value":item.id_objetivo}})}),1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('v-card',{staticClass:"mb-5",staticStyle:{"box-shadow":"none"}},[(
                                _vm.NOVA.id_objetivo > 0 &&
                                  _vm.getMedidasByObjetivo(_vm.NOVA.id_objetivo)
                                    .length > 0
                              )?_c('v-radio-group',{on:{"change":_vm.changeMedida},model:{value:(_vm.NOVA.id_medida),callback:function ($$v) {_vm.$set(_vm.NOVA, "id_medida", $$v)},expression:"NOVA.id_medida"}},_vm._l((_vm.getMedidasByObjetivo(
                                  _vm.NOVA.id_objetivo
                                )),function(item,m){return _c('v-radio',{key:'m-' + m,staticClass:"mb-3",attrs:{"color":"#f8ac4a","label":item.nome + ' - ' + item.descricao,"value":item.id_medida}})}),1):(_vm.NOVA.id_objetivo == 0)?_c('span',[_vm._v("Precisa de escolher um objetivo.")]):(
                                _vm.NOVA.id_objetivo > 0 &&
                                  _vm.getMedidasByObjetivo(_vm.NOVA.id_objetivo)
                                    .length == 0
                              )?_c('span',[_vm._v("Não existem medidas associadas a este\n                              objetivo.")]):_vm._e()],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"3"}},[_c('v-card',{staticClass:"mb-5",staticStyle:{"box-shadow":"none"}},[(
                                _vm.NOVA.id_medida > 0 &&
                                  _vm.getAcoesByMedida(_vm.NOVA.id_medida).length > 0
                              )?_c('v-radio-group',{on:{"change":_vm.changeAcao},model:{value:(_vm.NOVA.id_acao),callback:function ($$v) {_vm.$set(_vm.NOVA, "id_acao", $$v)},expression:"NOVA.id_acao"}},_vm._l((_vm.getAcoesByMedida(
                                  _vm.NOVA.id_medida
                                )),function(item,a){return _c('v-radio',{key:'m-' + a,staticClass:"mb-3",attrs:{"color":"#f8ac4a","label":item.nome + ' - ' + item.descricao,"value":item.id_acao}})}),1):(_vm.NOVA.id_medida == 0)?_c('span',[_vm._v("Precisa de escolher uma medida.")]):(
                                _vm.NOVA.id_medida > 0 &&
                                  _vm.getAcoesByMedida(_vm.NOVA.id_medida).length == 0
                              )?_c('span',[_vm._v("Não existem ações associadas a esta\n                              medida.")]):_vm._e()],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"4"}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Instituição")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#f8ac4a","items":_vm.getAllInstituicoes,"item-text":"nome","item-value":"id_instituicao","rules":_vm.defaultRules},model:{value:(_vm.NOVA.id_instituicao),callback:function ($$v) {_vm.$set(_vm.NOVA, "id_instituicao", $$v)},expression:"NOVA.id_instituicao"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Nº ações em 2018?")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#f8ac4a"},model:{value:(_vm.NOVA.ano1),callback:function ($$v) {_vm.$set(_vm.NOVA, "ano1", $$v)},expression:"NOVA.ano1"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Nº ações em 2019?")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#f8ac4a"},model:{value:(_vm.NOVA.ano2),callback:function ($$v) {_vm.$set(_vm.NOVA, "ano2", $$v)},expression:"NOVA.ano2"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Nº ações em 2020?")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#f8ac4a"},model:{value:(_vm.NOVA.ano3),callback:function ($$v) {_vm.$set(_vm.NOVA, "ano3", $$v)},expression:"NOVA.ano3"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Nº ações em 2021?")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#f8ac4a"},model:{value:(_vm.NOVA.ano4),callback:function ($$v) {_vm.$set(_vm.NOVA, "ano4", $$v)},expression:"NOVA.ano4"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Nº ações em 2022?")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#f8ac4a"},model:{value:(_vm.NOVA.ano5),callback:function ($$v) {_vm.$set(_vm.NOVA, "ano5", $$v)},expression:"NOVA.ano5"}})],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":""},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":""},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Guardar")])],1)],1)],1)],1),_vm._v(" "),_c('v-text-field',{staticClass:"searchTable",attrs:{"color":"#f8ac4a","append-icon":"search","label":"Pesquisa","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"390"},model:{value:(_vm.deleteM),callback:function ($$v) {_vm.deleteM=$$v},expression:"deleteM"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline",staticStyle:{"margin-left":"0px !important"}},[_vm._v("Apagar "+_vm._s(_vm.name))]),_vm._v(" "),_c('v-card-text',[_vm._v("De certeza que quer apagar esta "+_vm._s(_vm.name)+"?")]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"margin-top":"0px !important"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":"flat"},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":"flat"},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Apagar")])],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.DATA,"search":_vm.search,"loading":_vm.loading,"item-key":"id","disable-initial-sort":true,"rows-per-page-items":[10, 25, 50, { text: 'Todos', value: -1 }],"rows-per-page-text":"Itens por página:"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"textLeft",on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v("\n          "+_vm._s(_vm.getInstituicaoById(props.item.id_instituicao).nome)+"\n        ")]),_vm._v(" "),_c('td',{staticClass:"textCenter",on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v("\n          "+_vm._s(props.item.design_acao || "-")+"\n        ")]),_vm._v(" "),_c('td',{staticClass:"textCenter",on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v("\n          "+_vm._s(_vm.getAnoById(props.item.id_ano).nome)+"\n        ")]),_vm._v(" "),_c('td',{staticClass:"textCenter",on:{"click":function($event){return _vm.editItem(props.item, true)}}},[(props.item.submetida == 0)?_c('span',{staticStyle:{"color":"red"}},[_vm._v("PLANIFICAÇÂO NÂO SUBMETIDA")]):_vm._e(),_vm._v(" "),(props.item.submetida == 1)?_c('span',{staticStyle:{"color":"green"}},[_vm._v("PLANIFICAÇÂO SUBMETIDA")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"textCenter",on:{"click":function($event){return _vm.reporte(props.item)}}},[(props.item.reporte == 0)?_c('span',{staticStyle:{"color":"red"}},[_vm._v("REPORTE NÂO SUBMETIDO")]):_vm._e(),_vm._v(" "),(props.item.reporte == 1)?_c('span',{staticStyle:{"color":"green"}},[_vm._v("REPORTE SUBMETIDO")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"px-0 textTable textCenter"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.reporte(props.item, true)}}},[_c('v-icon',{attrs:{"color":"light-green darken-1"}},[_vm._v("picture_as_pdf")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"disabled":props.item.submetida == 1,"icon":""},on:{"click":function($event){return _vm.editItem(props.item, false)}}},[_c('v-icon',{attrs:{"color":"red lighten-1"}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{staticClass:"alertTable",slot:"no-data"},[(_vm.loading)?_c('v-progress-circular',{staticStyle:{"margin-left":"50% !important"},attrs:{"indeterminate":"","color":"#f8ac4a"}}):_vm._e()],1)],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1342:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Home_vue__ = __webpack_require__(470);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0adf568b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Home_vue__ = __webpack_require__(1344);
function injectStyle (ssrContext) {
  __webpack_require__(1343)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0adf568b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0adf568b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1343:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1344:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[(_vm.getSession.user.super == 1)?_c('div',{staticClass:"mb-2"},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-card',{staticStyle:{"box-shadow":"none","background-color":"#f8f8f8"}},[_c('v-container',{staticStyle:{"padding":"0 !important"},attrs:{"grid-list-md":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Instituição")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#f8ac4a","items":_vm.getAllInstituicoes,"item-text":"nome","item-value":"id_instituicao"},model:{value:(_vm.INSTITUICAO),callback:function ($$v) {_vm.INSTITUICAO=$$v},expression:"INSTITUICAO"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Vista tabela")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#f8ac4a","items":[
                    { tipo: 0, nome: 'Propostas obrigatórias' },
                    { tipo: 1, nome: 'Auto propostas' } ],"item-text":"nome","item-value":"tipo"},model:{value:(_vm.TIPO_TABELA),callback:function ($$v) {_vm.TIPO_TABELA=$$v},expression:"TIPO_TABELA"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"390"},model:{value:(_vm.deleteM),callback:function ($$v) {_vm.deleteM=$$v},expression:"deleteM"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline",staticStyle:{"margin-left":"0px !important"}},[_vm._v("Remover propostas")]),_vm._v(" "),_c('v-card-text',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Número de propostas a remover?")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#f8ac4a","hint":'max:' + _vm.max,"persistent-hint":"","mask":"##"},model:{value:(_vm.valor),callback:function ($$v) {_vm.valor=$$v},expression:"valor"}})],1)],1),_vm._v(" "),_c('v-card-actions',{staticStyle:{"margin-top":"0px !important"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":"flat"},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":"flat"},nativeOn:{"click":function($event){return _vm.apagar($event)}}},[_vm._v("Apagar")])],1)],1)],1)],1):_c('div',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-card',{staticStyle:{"box-shadow":"none","background-color":"#f8f8f8"}},[_c('v-container',{staticStyle:{"padding":"0 !important"},attrs:{"grid-list-md":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Vista tabela")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#f8ac4a","items":[
                    { tipo: 0, nome: 'Propostas obrigatórias' },
                    { tipo: 1, nome: 'Auto propostas' } ],"item-text":"nome","item-value":"tipo"},model:{value:(_vm.TIPO_TABELA),callback:function ($$v) {_vm.TIPO_TABELA=$$v},expression:"TIPO_TABELA"}})],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',[_c('v-flex',{attrs:{"xs12":"","md12":"","sm12":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md12":"","sm12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs7":"","md7":"","sm7":""}}),_vm._v(" "),_vm._l((_vm.getAnos),function(ano,an){return _c('v-flex',{key:an,attrs:{"d-flex":"","align-center":"","justify-center":"","xs1":"","md1":"","sm1":""}},[_vm._v("\n              "+_vm._s(ano.nome))])})],2)],1),_vm._v(" "),_vm._l((_vm.getObjetivos),function(objetivo,o){return _c('v-flex',{key:o,staticClass:"mb-5",attrs:{"xs12":"","md12":"","sm12":""}},[_c('v-layout',{staticStyle:{"background-color":"#e1e1e1","padding":"15px 0px"},attrs:{"d-flex":"","align-center":"","row":""}},[_c('v-flex',{staticClass:"child-1",attrs:{"d-flex":"","align-center":"","justify-center":"","xs7":"","md7":"","sm7":""}},[_c('p',[_c('b',[_vm._v(_vm._s(objetivo.nome))]),_vm._v(" - "+_vm._s(objetivo.descricao)+"\n              ")])]),_vm._v(" "),_vm._l((_vm.getAnos),function(ano,an1){return _c('v-flex',{key:an1,attrs:{"d-flex":"","align-center":"","justify-center":"","xs1":"","md1":"","sm1":""}})})],2),_vm._v(" "),_vm._l((_vm.getMedidasByObjetivo(objetivo.id_objetivo)),function(medida,m){return _c('v-flex',{key:m,staticClass:"mb-3",attrs:{"xs12":"","md12":"","sm12":""}},[_c('v-layout',{staticStyle:{"background-color":"#efefef","padding":"15px 0px"},attrs:{"d-flex":"","align-center":"","row":""}},[_c('v-flex',{staticClass:"child-2",attrs:{"d-flex":"","align-center":"","justify-center":"","xs7":"","md7":"","sm7":""}},[_c('p',[_c('b',[_vm._v(_vm._s(medida.nome))]),_vm._v(" - "+_vm._s(medida.descricao)+"\n                ")])]),_vm._v(" "),_vm._l((_vm.getAnos),function(ano,an2){return _c('v-flex',{key:an2,attrs:{"d-flex":"","align-center":"","justify-center":"","xs1":"","md1":"","sm1":""}})})],2),_vm._v(" "),_vm._l((_vm.getAcoesByMedida(medida.id_medida)),function(acao,a){return _c('v-flex',{key:a,attrs:{"xs12":"","md12":"","sm12":""}},[_c('v-layout',{staticStyle:{"padding":"15px 0px"},style:({
                  backgroundColor: a % 2 != 0 ? '#f2f2f2' : '',
                }),attrs:{"d-flex":"","align-center":"","row":""}},[_c('v-flex',{staticClass:"child-3",attrs:{"d-flex":"","align-center":"","justify-center":"","xs7":"","md7":"","sm7":""}},[_c('p',[_c('b',[_vm._v(_vm._s(acao.nome))]),_vm._v(" - "+_vm._s(acao.descricao)+"\n                  ")])]),_vm._v(" "),_vm._l((_vm.getAnos),function(ano,an3){return _c('v-flex',{key:an3,staticClass:"ano-3",attrs:{"d-flex":"","align-center":"","justify-center":"","xs1":"","md1":"","sm1":""},on:{"click":function($event){return _vm.removeProposta(_vm.INSTITUICAO, ano.id_ano, acao.id_acao)}}},[_vm._v("\n                  "+_vm._s(_vm.getAcaoAno(
                      _vm.INSTITUICAO,
                      ano.id_ano,
                      acao.id_acao,
                      _vm.TIPO_TABELA
                    ))+"\n                ")])})],2)],1)})],2)})],2)})],2)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Perfil_vue__ = __webpack_require__(471);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0db09e53_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Perfil_vue__ = __webpack_require__(1351);
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Perfil_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0db09e53_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Perfil_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1351:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticStyle:{"width":"100%"}},[_c('div',{staticClass:"w-full"},[_c('div',{staticClass:"bg-white shadow overflow-hidden sm:rounded-lg w-full"},[_c('div',{staticClass:"px-4 py-5 sm:px-6"},[_c('h3',{staticClass:"text-lg leading-6 font-medium text-gray-900"},[_vm._v("\n          O meu perfil\n        ")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Nome")]),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":"","color":"#f8ac4a"},model:{value:(_vm.getSession.user.nome),callback:function ($$v) {_vm.$set(_vm.getSession.user, "nome", $$v)},expression:"getSession.user.nome"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Username")]),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":"","color":"#f8ac4a"},model:{value:(_vm.getSession.user.username),callback:function ($$v) {_vm.$set(_vm.getSession.user, "username", $$v)},expression:"getSession.user.username"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Email")]),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":"","color":"#f8ac4a"},model:{value:(_vm.getSession.user.email),callback:function ($$v) {_vm.$set(_vm.getSession.user, "email", $$v)},expression:"getSession.user.email"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Entidade ou Associada?")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"disabled":"","color":"#f8ac4a","items":_vm.classes,"item-text":"nome","item-value":"id_classe"},model:{value:(_vm.getSession.user.associada),callback:function ($$v) {_vm.$set(_vm.getSession.user, "associada", $$v)},expression:"getSession.user.associada"}})],1),_vm._v(" "),(_vm.getSession.user.associada == 2)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Entidade associada?")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#f8ac4a","disabled":"","items":_vm.associadas,"multiple":"","item-text":"nome","item-value":"id_associada"},model:{value:(_vm.getSession.user.associadas),callback:function ($$v) {_vm.$set(_vm.getSession.user, "associadas", $$v)},expression:"getSession.user.associadas"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Estado")]),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":"","color":"#f8ac4a","value":_vm.getSession.user.ativo == 1 ? 'ATIVO' : 'INATIVO'}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Selecione o(s) setor(es) de atividade da entidade")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#f8ac4a","items":_vm.getSectores,"multiple":"","item-text":"nome","item-value":"id_setor"},model:{value:(_vm.setores),callback:function ($$v) {_vm.setores=$$v},expression:"setores"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Selecione a natureza jurídica da entidade")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#f8ac4a","items":_vm.tipos,"item-text":"nome","item-value":"id_tipo"},model:{value:(_vm.getSession.user.publico),callback:function ($$v) {_vm.$set(_vm.getSession.user, "publico", $$v)},expression:"getSession.user.publico"}})],1),_vm._v(" "),(_vm.getSession.user.publico == 1)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Setor público")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#f8ac4a","items":_vm.setores_publicos},model:{value:(_vm.getSession.user.setor_publico),callback:function ($$v) {_vm.$set(_vm.getSession.user, "setor_publico", $$v)},expression:"getSession.user.setor_publico"}})],1):_vm._e(),_vm._v(" "),(_vm.getSession.user.publico == 2)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Setor não público")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#f8ac4a","items":_vm.fins_lucrativos},model:{value:(_vm.getSession.user.fins_lucrativos),callback:function ($$v) {_vm.$set(_vm.getSession.user, "fins_lucrativos", $$v)},expression:"getSession.user.fins_lucrativos"}})],1):_vm._e(),_vm._v(" "),(_vm.getSession.user.fins_lucrativos == 'Sem fins lucrativos')?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Tipo")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#f8ac4a","items":_vm.tipos_fins_lucrativos},model:{value:(_vm.getSession.user.tipo_fins_lucrativos),callback:function ($$v) {_vm.$set(_vm.getSession.user, "tipo_fins_lucrativos", $$v)},expression:"getSession.user.tipo_fins_lucrativos"}})],1):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("A entidade trabalha formalmente em setores diretamente\n              relacionados com a educação?")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#f8ac4a","items":['Sim', 'Não']},model:{value:(_vm.getSession.user.trabalha_educacao),callback:function ($$v) {_vm.$set(_vm.getSession.user, "trabalha_educacao", $$v)},expression:"getSession.user.trabalha_educacao"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("A entidade reconhece formalmente a Educação para o\n              Desenvolvimento em documentos estratégicos e/ou\n              operacionais?")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#f8ac4a","items":['Sim', 'Não']},model:{value:(_vm.getSession.user.trabalha_estrategicos),callback:function ($$v) {_vm.$set(_vm.getSession.user, "trabalha_estrategicos", $$v)},expression:"getSession.user.trabalha_estrategicos"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Selecione o distrito onde a entidade desempenha uma intervenção\n              mais ativa")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#f8ac4a","items":_vm.listOfDistritos,"item-text":"name","item-value":"name"},model:{value:(_vm.getSession.user.distrito),callback:function ($$v) {_vm.$set(_vm.getSession.user, "distrito", $$v)},expression:"getSession.user.distrito"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#f8ac4a","flat":""},nativeOn:{"click":function($event){return _vm.submit($event)}}},[_vm._v("Guardar")])],1)],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1355:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 472,
	"./af.js": 472,
	"./ar": 473,
	"./ar-dz": 474,
	"./ar-dz.js": 474,
	"./ar-kw": 475,
	"./ar-kw.js": 475,
	"./ar-ly": 476,
	"./ar-ly.js": 476,
	"./ar-ma": 477,
	"./ar-ma.js": 477,
	"./ar-sa": 478,
	"./ar-sa.js": 478,
	"./ar-tn": 479,
	"./ar-tn.js": 479,
	"./ar.js": 473,
	"./az": 480,
	"./az.js": 480,
	"./be": 481,
	"./be.js": 481,
	"./bg": 482,
	"./bg.js": 482,
	"./bm": 483,
	"./bm.js": 483,
	"./bn": 484,
	"./bn.js": 484,
	"./bo": 485,
	"./bo.js": 485,
	"./br": 486,
	"./br.js": 486,
	"./bs": 487,
	"./bs.js": 487,
	"./ca": 488,
	"./ca.js": 488,
	"./cs": 489,
	"./cs.js": 489,
	"./cv": 490,
	"./cv.js": 490,
	"./cy": 491,
	"./cy.js": 491,
	"./da": 492,
	"./da.js": 492,
	"./de": 493,
	"./de-at": 494,
	"./de-at.js": 494,
	"./de-ch": 495,
	"./de-ch.js": 495,
	"./de.js": 493,
	"./dv": 496,
	"./dv.js": 496,
	"./el": 497,
	"./el.js": 497,
	"./en-SG": 498,
	"./en-SG.js": 498,
	"./en-au": 499,
	"./en-au.js": 499,
	"./en-ca": 500,
	"./en-ca.js": 500,
	"./en-gb": 501,
	"./en-gb.js": 501,
	"./en-ie": 502,
	"./en-ie.js": 502,
	"./en-il": 503,
	"./en-il.js": 503,
	"./en-nz": 504,
	"./en-nz.js": 504,
	"./eo": 505,
	"./eo.js": 505,
	"./es": 506,
	"./es-do": 507,
	"./es-do.js": 507,
	"./es-us": 508,
	"./es-us.js": 508,
	"./es.js": 506,
	"./et": 509,
	"./et.js": 509,
	"./eu": 510,
	"./eu.js": 510,
	"./fa": 511,
	"./fa.js": 511,
	"./fi": 512,
	"./fi.js": 512,
	"./fo": 513,
	"./fo.js": 513,
	"./fr": 514,
	"./fr-ca": 515,
	"./fr-ca.js": 515,
	"./fr-ch": 516,
	"./fr-ch.js": 516,
	"./fr.js": 514,
	"./fy": 517,
	"./fy.js": 517,
	"./ga": 518,
	"./ga.js": 518,
	"./gd": 519,
	"./gd.js": 519,
	"./gl": 520,
	"./gl.js": 520,
	"./gom-latn": 521,
	"./gom-latn.js": 521,
	"./gu": 522,
	"./gu.js": 522,
	"./he": 523,
	"./he.js": 523,
	"./hi": 524,
	"./hi.js": 524,
	"./hr": 525,
	"./hr.js": 525,
	"./hu": 526,
	"./hu.js": 526,
	"./hy-am": 527,
	"./hy-am.js": 527,
	"./id": 528,
	"./id.js": 528,
	"./is": 529,
	"./is.js": 529,
	"./it": 530,
	"./it-ch": 531,
	"./it-ch.js": 531,
	"./it.js": 530,
	"./ja": 532,
	"./ja.js": 532,
	"./jv": 533,
	"./jv.js": 533,
	"./ka": 534,
	"./ka.js": 534,
	"./kk": 535,
	"./kk.js": 535,
	"./km": 536,
	"./km.js": 536,
	"./kn": 537,
	"./kn.js": 537,
	"./ko": 538,
	"./ko.js": 538,
	"./ku": 539,
	"./ku.js": 539,
	"./ky": 540,
	"./ky.js": 540,
	"./lb": 541,
	"./lb.js": 541,
	"./lo": 542,
	"./lo.js": 542,
	"./lt": 543,
	"./lt.js": 543,
	"./lv": 544,
	"./lv.js": 544,
	"./me": 545,
	"./me.js": 545,
	"./mi": 546,
	"./mi.js": 546,
	"./mk": 547,
	"./mk.js": 547,
	"./ml": 548,
	"./ml.js": 548,
	"./mn": 549,
	"./mn.js": 549,
	"./mr": 550,
	"./mr.js": 550,
	"./ms": 551,
	"./ms-my": 552,
	"./ms-my.js": 552,
	"./ms.js": 551,
	"./mt": 553,
	"./mt.js": 553,
	"./my": 554,
	"./my.js": 554,
	"./nb": 555,
	"./nb.js": 555,
	"./ne": 556,
	"./ne.js": 556,
	"./nl": 557,
	"./nl-be": 558,
	"./nl-be.js": 558,
	"./nl.js": 557,
	"./nn": 559,
	"./nn.js": 559,
	"./pa-in": 560,
	"./pa-in.js": 560,
	"./pl": 561,
	"./pl.js": 561,
	"./pt": 562,
	"./pt-br": 563,
	"./pt-br.js": 563,
	"./pt.js": 562,
	"./ro": 564,
	"./ro.js": 564,
	"./ru": 565,
	"./ru.js": 565,
	"./sd": 566,
	"./sd.js": 566,
	"./se": 567,
	"./se.js": 567,
	"./si": 568,
	"./si.js": 568,
	"./sk": 569,
	"./sk.js": 569,
	"./sl": 570,
	"./sl.js": 570,
	"./sq": 571,
	"./sq.js": 571,
	"./sr": 572,
	"./sr-cyrl": 573,
	"./sr-cyrl.js": 573,
	"./sr.js": 572,
	"./ss": 574,
	"./ss.js": 574,
	"./sv": 575,
	"./sv.js": 575,
	"./sw": 576,
	"./sw.js": 576,
	"./ta": 577,
	"./ta.js": 577,
	"./te": 578,
	"./te.js": 578,
	"./tet": 579,
	"./tet.js": 579,
	"./tg": 580,
	"./tg.js": 580,
	"./th": 581,
	"./th.js": 581,
	"./tl-ph": 582,
	"./tl-ph.js": 582,
	"./tlh": 583,
	"./tlh.js": 583,
	"./tr": 584,
	"./tr.js": 584,
	"./tzl": 585,
	"./tzl.js": 585,
	"./tzm": 586,
	"./tzm-latn": 587,
	"./tzm-latn.js": 587,
	"./tzm.js": 586,
	"./ug-cn": 588,
	"./ug-cn.js": 588,
	"./uk": 589,
	"./uk.js": 589,
	"./ur": 590,
	"./ur.js": 590,
	"./uz": 591,
	"./uz-latn": 592,
	"./uz-latn.js": 592,
	"./uz.js": 591,
	"./vi": 593,
	"./vi.js": 593,
	"./x-pseudo": 594,
	"./x-pseudo.js": 594,
	"./yo": 595,
	"./yo.js": 595,
	"./zh-cn": 596,
	"./zh-cn.js": 596,
	"./zh-hk": 597,
	"./zh-hk.js": 597,
	"./zh-tw": 598,
	"./zh-tw.js": 598
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1355;

/***/ }),

/***/ 1356:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1357:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export strings */
var strings = {
    // PORTUGUESE LANGUAGE
    pt: {
        paths: {
            home: 'home',
            users: 'utilizadores',
            obras: 'obras',
            arquitetos: 'arquitetos',
            calendario: 'calendario'
        },
        menus: {
            home: 'Home',
            users: 'Utilizadores',
            obras: 'Obras',
            arquitetos: 'Arquitetos',
            calendario: 'Calendário'
        },
        time: {
            dia: 'Dia',
            semana: 'Semana',
            mes: 'Mês'
        },
        actions: {
            novo: 'Novo',
            nova: 'Nova',
            editar: 'Editar',
            guardar: 'Guardar',
            confirmar: 'Confirmar',
            cancelar: 'Cancelar',
            apagar: 'Apagar',
            pesquisa: 'Pesquisa',
            pagination: 'Items por página:',
            todos: 'Todos',
            next: 'Próximo',
            prev: 'Anterior',
            resetPassword: 'Repor password',
            notificar: 'Notificar'
        },
        fields: {
            actions: 'Ações',
            nome: 'Nome',
            email: 'Email',
            altPwd: 'Alterar password',
            password: 'Password',
            cPassword: 'Confirmar password',
            morada: 'Morada',
            arquiteto: 'Arquiteto',
            responsavel: 'Responsável',
            ativo: 'Ativo',
            obra: 'Obra',
            utilizador: 'Utilizador',
            tipo: 'Tipo utilizador',
            foto: 'Fotografia',
            obs: 'OBS',
            reuniao: 'Reunião',
            titulo: 'Título',
            data: 'Data',
            hora_inicio: 'Hora inicio',
            hora_fim: 'Hora fim',
            relatorio: 'Relatório',
            imagens: 'Imagens',
            ficheiros: 'Ficheiros',
            ficheiro: 'Ficheiro',
            detalhes: 'Detalhes'
        },
        messages: {
            requiredField: '* Campo obrigatório',
            invalidEmail: '* E-mail inválido',
            invalidPassword: '* Password inválida',
            wlc: 'Bem-vindo',
            loginError: 'Os dados introduzidos não são válidos!',
            delete: 'De certeza que quer apagar este elemento?',
            noData: 'De momento não há nada a apresentar!',
            addSuccess: 'Elemento adicionado com sucesso!',
            updateSuccess: 'Elemento alterado com sucesso!',
            deleteSuccess: 'Elemento removido com sucesso!',
            addError: 'Ocorreu um erro ao adicionar o elemento!',
            updateError: 'Ocorreu um erro ao alterar o elemento!',
            deleteError: 'Ocorreu um erro ao remover o elemento!',
            sucesso: 'Sucesso',
            erro: 'Erro',
            noUser: 'Sem utilizador',
            noObra: 'Sem obra',
            resetPassword: 'Pretende repor a password para este utilizador?',
            notificar: 'Pretende notificar o utilizador deste evento?',
            notiSuccess: 'Notificação enviada com sucesso',
            notiError: 'Ocorreu um erro ao enviar a notificação'
        },
        login: {
            title: 'Entrar',
            username: 'Utilizador',
            pwd: 'Password',
            button: 'Entrar'
        }
    },

    // FRENCH LANGUAGE
    fr: {
        paths: {
            home: 'home',
            users: 'utilisateurs',
            obras: 'chantier',
            arquitetos: 'architectes',
            calendario: 'calendrier'
        },
        menus: {
            home: 'Home',
            users: 'Les utilisateurs',
            obras: 'Chantier',
            arquitetos: 'Architectes',
            calendario: 'Calendrier'
        },
        time: {
            dia: 'Jour',
            semana: 'Semaine',
            mes: 'Mois'
        },
        actions: {
            novo: 'Nouveau',
            nova: 'Nouveau',
            editar: 'Éditer',
            guardar: 'Pour Sauver',
            cancelar: 'Annuler',
            confirmar: 'Confirmer',
            apagar: 'Éteindre',
            pesquisa: 'Recherche',
            pagination: 'Articles par page:',
            todos: 'Tous',
            next: 'Suivant',
            prev: 'Précédent',
            resetPassword: 'Réinitialiser le mot de passe',
            notificar: 'Notifier'
        },
        fields: {
            actions: 'Actions',
            nome: 'Nom',
            email: 'Email',
            altPwd: 'Changer le mot de passe',
            password: 'Password',
            cPassword: 'Confirmer le mot de passe',
            morada: 'Adresse',
            arquiteto: 'Architecte',
            responsavel: 'Responsable',
            ativo: 'Actif',
            obra: 'Chantier',
            utilizador: 'Utilisateur',
            tipo: "Type d'utilisateur",
            foto: 'La photographie',
            obs: 'OBS',
            reuniao: 'Réunion',
            titulo: 'Titre',
            data: 'Date',
            hora_inicio: 'Heure de début',
            hora_fim: 'Heure de fin',
            relatorio: 'Rapport',
            imagens: 'Des photos',
            ficheiros: 'Fichiers',
            ficheiro: 'Fichier',
            detalhes: 'Les détails'
        },
        messages: {
            requiredField: '* Champ obligatoire',
            invalidEmail: '* Email invalide',
            invalidPassword: '* Mot de passe invalide',
            wlc: 'Bienvenue',
            loginError: 'Les données saisies ne sont pas valides!',
            delete: 'Êtes-vous sûr de vouloir supprimer cet élément?',
            noData: "Il n'y a rien à montrer pour l'instant!",
            addSuccess: 'Élément ajouté avec succès!',
            updateSuccess: "L'élément a été modifié avec succès!",
            deleteSuccess: 'Élément supprimé avec succès!',
            addError: "Une erreur s'est produite lors de l'ajout d'un article!",
            updateError: "Une erreur s'est produite lors de la modification de l'élément!",
            deleteError: "Une erreur s'est produite lors de la suppression de l'élément!",
            sucesso: 'Réussi',
            erro: 'Erreur',
            noUser: 'Sans utilisateur',
            noObra: 'Sans chantier',
            resetPassword: 'Voulez-vous réinitialiser le mot de passe pour cet utilisateur?',
            notificar: "Voulez-vous informer l'utilisateur de cet événement?",
            notiSuccess: 'Notification envoyée avec succès',
            notiError: "Erreur d'envoi de notification"
        },
        login: {
            title: 'Se connecter',
            username: 'Utilisateur',
            pwd: 'Mot de passe',
            button: 'Se connecter'
        }
    }
};



/***/ }),

/***/ 15:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return instance; });
/* unused harmony export HOST */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var HOST = "https://teste.areareservada.ened-portugal.pt" + ":" + "443" + "/enedapi/client";
// const HOST = "https://teste.areareservada.ened-portugal.pt/enedapi/client";
var instance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: HOST
});



/***/ }),

/***/ 313:
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),

/***/ 320:
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),

/***/ 335:
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),

/***/ 430:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jsonwebtoken__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jsonwebtoken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jsonwebtoken__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      auth: -1,
      drawer: null,
      items: [{
        icon: "home",
        super: 0,
        text: "Home",
        to: "/"
      }, {
        icon: "done_all",
        super: 0,
        text: "Propostas",
        to: "/propostas"
      }, {
        icon: "account_circle",
        super: 0,
        text: "Perfil",
        to: "/perfil"
      }, {
        icon: "class",
        super: 1,
        text: "Formulários",
        to: "/formularios"
      }, {
        icon: "question_answer",
        super: 1,
        text: "Perguntas",
        to: "/perguntas"
      }, {
        icon: "view_carousel",
        super: 1,
        text: "Dimensões",
        to: "/dimensoes"
      }, {
        icon: "view_list",
        super: 1,
        text: "Objetivos",
        to: "/objetivos"
      }, {
        icon: "vertical_split",
        super: 1,
        text: "Medidas",
        to: "/medidas"
      }, {
        icon: "view_module",
        super: 1,
        text: "Ações",
        to: "/acoes"
      }, {
        icon: "list",
        super: 1,
        text: "Setores",
        to: "/setores"
      }, {
        icon: "date_range",
        super: 1,
        text: "Fases",
        to: "/anos"
      }, {
        icon: "people",
        super: 1,
        text: "Administradores",
        to: "/administradores"
      }, {
        icon: "domain",
        super: 1,
        text: "Instituições",
        to: "/instituicoes"
      }],
      altpwd: false,
      excel: false,
      ANO: null,
      INSTITUICAO: null,
      email: "",
      pwd: "",
      cpwd: "",
      defaultRules: null,
      pwdRules: null
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])({
    getSession: "session/getState",
    getAnos: "anos/getAll",
    getAllInstituicoes: "instituicoes/getAllInstituicoes"
  })),
  watch: {
    excel: function excel(val) {
      var _this = this;

      if (!val) {
        setTimeout(function () {
          _this.ANO = null;
          _this.INSTITUICAO = null;
        }, 150);
      }
    },
    altpwd: function altpwd(val) {
      this.pwd = "";
      this.cpwd = "";
    }
  },
  created: function created() {
    var _this2 = this;

    this.pwdRules = [function (v) {
      return v == _this2.pwd || "* As palavras-passe não coincidem!";
    }];

    this.ManageSession();

    this.$eventBus.$on("login", function (res) {
      if (res) {
        _this2.SessionStart();
      }
    });

    this.$eventBus.$on("logout", function () {
      _this2.logout();
    });
  },

  methods: {
    changeData: function changeData() {
      var _this3 = this;

      if (this.pwd && this.pwd == this.cpwd) this.$store.dispatch("session/update", {
        id: this.getSession.user.id_instituicao,
        password: this.pwd
      }).then(function (res) {
        if (res) {
          _this3.toast("success", "Password alterada com sucesso!");
          _this3.altpwd = false;
        } else {
          _this3.toast("error", "Ocorreu um erro ao alterar a password!");
          _this3.altpwd = false;
        }
      });
    },
    toast: function toast(type, message) {
      if (type == "success") {
        return iziToast.show({
          title: "SUCESSO",
          color: "green",
          timeout: this.$toastTimeout,
          message: message,
          position: this.$toastPosition
        });
      } else {
        return iziToast.show({
          title: "ERRO",
          color: "red",
          timeout: this.$toastTimeout,
          message: message,
          position: this.$toastPosition
        });
      }
    },
    exportar: function exportar() {
      if (this.ANO == null) return;
      if (this.getSession.user.super == 1 && this.INSTITUICAO == null) return;

      if (this.getSession.user.super == 1) {
        window.open("https://teste.areareservada.ened-portugal.pt" + ":" + "443" + "/enedapi/client/excel/" + this.ANO + "/" + this.INSTITUICAO, "_blank");
      } else {
        window.open("https://teste.areareservada.ened-portugal.pt" + ":" + "443" + "/enedapi/client/excel/" + this.ANO + "/" + this.getSession.user.id_instituicao, "_blank");
      }

      this.excel = false;
    },
    ManageSession: function ManageSession() {
      var _this4 = this;

      if (!this.$session.exists()) this.auth = 0;else {
        this.decode(this.$session.getAll().t).then(function (res) {
          _this4.$store.dispatch("session/getData", {
            username: res
          }).then(function () {
            if (_this4.getSession.session) {
              _this4.SessionStart();
            } else _this4.auth = 0;
          });
        });
      }
    },
    SessionStart: function SessionStart() {
      this.$session.start();
      this.$session.set("t", this.token(this.getSession.user.username));
      this.OpenStore();
    },
    OpenStore: function OpenStore() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this5.$store.dispatch("instituicoes/get");
                _this5.$store.dispatch("objetivos/get");
                _this5.$store.dispatch("medidas/get");
                _this5.$store.dispatch("acoes/get");
                _this5.$store.dispatch("fases/get");
                _this5.$store.dispatch("dimensoes/get");
                _this5.$store.dispatch("perguntas/get");
                _this5.$store.dispatch("formularios/get");
                _this5.$store.dispatch("setores/get");
                _this5.$store.dispatch("anos/get");
                if (_this5.getSession.user.super == 0) _this5.$store.dispatch("propostas/getByInstituicao", _this5.getSession.user.id_instituicao);
                if (_this5.getSession.user.super == 1) _this5.$store.dispatch("propostas/get");

                _this5.auth = 1;

                _this5.$eventBus.$emit("loader", false);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this5);
      }))();
    },
    logout: function logout() {
      var _this6 = this;

      this.$store.dispatch("session/setSessionData", null).then(function () {
        _this6.auth = 0;
        _this6.$session.destroy();
        setTimeout(function () {
          return location.reload(true);
        }, 600);
      });
    },
    token: function token(params) {
      return __WEBPACK_IMPORTED_MODULE_5_jsonwebtoken___default.a.sign({
        exp: Math.floor(Date.now() / 1000) + 60 * 60 * 12,
        data: params
      }, "dKx9j)9+AB?enD(:");
    },
    decode: function decode(token) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_5_jsonwebtoken___default.a.verify(token, "dKx9j)9+AB?enD(:", function (err, decoded) {
          if (err) resolve(false);else resolve(__WEBPACK_IMPORTED_MODULE_5_jsonwebtoken___default.a.decode(token).data);
        });
      });
    }
  }
});

/***/ }),

/***/ 442:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(9);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      username: "",
      password: "",
      loading: false,
      required: ""
    };
  },
  created: function created() {
    var _this = this;

    this.required = '* Campo obrigatório';

    this.$eventBus.$on("loader", function (state) {
      _this.loading = state;
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    getSession: "session/getState"
  })),
  methods: {
    toast: function toast(type, message) {
      if (type == "success") {
        return iziToast.show({
          title: 'SUCESSO',
          color: "green",
          timeout: this.$toastTimeout,
          message: message,
          position: this.$toastPosition
        });
      } else {
        return iziToast.show({
          title: 'ERRO',
          color: "red",
          timeout: this.$toastTimeout,
          message: message,
          position: this.$toastPosition
        });
      }
    },
    login: function login() {
      var _this2 = this;

      if (!this.$refs.form.validate()) return;
      this.loading = true;
      this.$store.dispatch("session/signIn", {
        username: this.username,
        password: this.password
      }).then(function (res) {
        if (res) {
          _this2.$eventBus.$emit("login", _this2.getSession.session);
        } else {
          _this2.loading = false;
          _this2.toast("error", 'Os dados introduzidos não são válidos!');
        }
      });
    }
  }
});

/***/ }),

/***/ 443:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(9);

//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    getSession: "session/getState"
  }))
});

/***/ }),

/***/ 444:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(9);

//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    getSession: "session/getState"
  }))
});

/***/ }),

/***/ 445:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(9);

//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    getSession: "session/getState"
  }))
});

/***/ }),

/***/ 446:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(9);

//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    getSession: "session/getState"
  }))
});

/***/ }),

/***/ 447:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(9);

//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    getSession: "session/getState"
  }))
});

/***/ }),

/***/ 448:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(9);

//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    getSession: "session/getState"
  }))
});

/***/ }),

/***/ 449:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(9);

//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    getSession: "session/getState"
  }))
});

/***/ }),

/***/ 450:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(9);

//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    getSession: "session/getState"
  }))
});

/***/ }),

/***/ 451:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(9);

//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    getSession: "session/getState"
  }))
});

/***/ }),

/***/ 452:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(9);

//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    getSession: "session/getState"
  }))
});

/***/ }),

/***/ 453:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(9);

//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    getSession: "session/getState"
  }))
});

/***/ }),

/***/ 454:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(9);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var cName = {
    upper: "Administrador",
    lower: "o administrador!"
};

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            table: 'instituicoes',
            name: 'administrador',
            search: "",
            searchP: "",
            modal: false,
            deleteM: false,
            loading: true,
            searchC: '',
            headers: [{
                text: "#",
                align: "left",
                sortable: true,
                value: "id_instituicao"
            }, {
                text: "Nome",
                align: "center",
                sortable: true,
                value: "nome"
            }, {
                text: "Username",
                align: "center",
                sortable: true,
                value: "username"
            }, {
                text: "E-mail",
                align: "center",
                sortable: true,
                value: "email"
            }, {
                text: "Ativo",
                align: "center",
                sortable: true,
                value: "ativo"
            }, {
                text: "Ações",
                value: "id",
                sortable: false,
                align: "center"
            }],
            DATA: [],
            editedIndex: -1,
            cpwd: null,
            editedItem: {
                id_instituicao: 0,
                nome: "",
                username: "",
                email: "",
                password: "",
                ativo: ""
            },
            defaultItem: {
                id_instituicao: 0,
                nome: "",
                username: "",
                email: "",
                password: "",
                ativo: ""
            },
            messages: {
                add: {
                    success: cName.upper + " criado com sucesso!",
                    error: "Ocorreu um erro ao criar " + cName.lower
                },
                update: {
                    success: cName.upper + " alterado com sucesso!",
                    error: "Ocorreu um erro ao alterar " + cName.lower
                },
                delete: {
                    success: cName.upper + " eliminado com sucesso!",
                    error: "Ocorreu um erro ao apagar " + cName.lower
                },
                default: {
                    sucesso: "Sucesso",
                    error: "Ocorreu um erro!"
                }
            },
            defaultRules: null,
            pwdRules: null
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
        getAll: 'instituicoes/getAllSuper'
    }), {
        formTitle: function formTitle() {
            return this.editedIndex === -1 ? "Nova " + this.name : "Editar " + this.name;
        }
    }),

    watch: {
        modal: function modal(val) {
            val || this.close();
        },
        deleteM: function deleteM(val) {
            val || this.close();
        },
        getAll: function getAll(val) {
            this.initialize();
        }
    },

    created: function created() {
        var _this = this;

        this.defaultRules = [function (v) {
            return !!v || _this.$requiredField + '';
        }];
        this.pwdRules = [function (v) {
            return v == _this.editedItem.password || '* As palavras-passe não coincidem!';
        }];
        this.initialize();
    },
    mounted: function mounted() {},

    methods: {
        toast: function toast(type, message) {
            if (type == "success") {
                return iziToast.show({
                    title: "SUCESSO",
                    color: "green",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            } else {
                return iziToast.show({
                    title: "AVISO",
                    color: "red",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            }
        },
        initialize: function initialize() {
            this.loading = true;
            this.DATA = this.getAll;
            this.loading = false;
        },
        editItem: function editItem(item, dialog) {
            this.editedIndex = this.DATA.indexOf(item);
            this.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);

            if (dialog) this.modal = true;else this.deleteM = true;
        },
        delete: function _delete() {
            var _this2 = this;

            if (!this.editedItem.id_instituicao) return;

            this.$store.dispatch(this.table + "/delete", { id: this.editedItem.id_instituicao }).then(function (res) {
                if (res) {
                    _this2.toast('success', _this2.messages.delete.success);_this2.initialize();
                } else _this2.toast('error', _this2.messages.delete.error);

                _this2.deleteM = false;
            });
        },
        close: function close() {
            var _this3 = this;

            this.modal = this.deleteM = false;
            setTimeout(function () {
                _this3.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this3.defaultItem);
                _this3.editedIndex = -1;

                _this3.$refs.form.reset();
            }, 110);
        },
        save: function save() {
            var _this4 = this;

            if (this.deleteM) {
                this.delete();return;
            }

            if (!this.$refs.form.validate()) return;

            if (this.editedIndex == -1) {
                this.$store.dispatch(this.table + "/insert", { nome: this.editedItem.nome, username: this.editedItem.username, email: this.editedItem.email, password: this.editedItem.password, super: 1 }).then(function (res) {
                    if (res) {
                        _this4.toast('success', _this4.messages.add.success);_this4.initialize();
                    } else _this4.toast('error', _this4.messages.add.error);

                    _this4.modal = false;
                });
            } else {
                this.$store.dispatch(this.table + "/update", { id: this.editedItem.id_instituicao, nome: this.editedItem.nome, username: this.editedItem.username, email: this.editedItem.email, ativo: this.editedItem.ativo ? 1 : 0 }).then(function (res) {
                    if (res) {
                        _this4.toast('success', _this4.messages.update.success);_this4.initialize();
                    } else _this4.toast('error', _this4.messages.update.error);

                    _this4.modal = false;
                });
            }
        }
    }
});

/***/ }),

/***/ 455:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_distritos_json__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_distritos_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__store_distritos_json__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var cName = {
  upper: "Instituição",
  lower: "a instituição!"
};

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tipo_fins_lucrativos: ["Associação", "Cooperativa", "Fundação"],
      fins_lucrativos: ["Sem fins lucrativos", "Com fins lucrativos"],
      setores: [],
      setores_id_instituicao: null,
      modal_setores: false,
      table: "instituicoes",
      name: "instituição",
      search: "",
      searchP: "",
      modal: false,
      deleteM: false,
      loading: true,
      show: false,
      searchC: "",
      novaPwd: false,
      headers: [{
        text: "#",
        align: "left",
        sortable: true,
        value: "id_instituicao"
      }, {
        text: "Nome",
        align: "left",
        sortable: true,
        value: "nome"
      }, {
        text: "Username",
        align: "center",
        sortable: true,
        value: "username"
      }, {
        text: "E-mail",
        align: "center",
        sortable: true,
        value: "email"
      }, {
        text: "Ativo",
        align: "center",
        sortable: true,
        value: "ativo"
      }, {
        text: "Ações",
        value: "id",
        sortable: false,
        align: "center"
      }],

      distritos: [],
      DATA: [],
      editedIndex: -1,
      cpwd: null,
      classes: [{ id_classe: 1, nome: "Entidade signatária" }, { id_classe: 2, nome: "Associada de entidade signatária" }],
      associadas: [{ id_associada: 1, nome: "PPONGD" }, { id_associada: 2, nome: "ARIPESE" }, { id_associada: 3, nome: "ANIMAR" }],
      tipos: [{ id_tipo: 1, nome: "Público" }, { id_tipo: 2, nome: "Não Público" }],
      editedItem: {
        id_instituicao: 0,
        nome: "",
        username: "",
        email: "",
        password: "",
        ativo: "",
        entidade: 0,
        associada: [],
        id_associada: 0,
        publico: 0,
        fins_lucrativos: "",
        tipo_fins_lucrativos: "",
        setor_publico: ""
      },
      defaultItem: {
        id_instituicao: 0,
        nome: "",
        username: "",
        email: "",
        password: "",
        ativo: "",
        entidade: 0,
        associada: [],
        id_associada: 0,
        publico: 0,
        fins_lucrativos: "",
        tipo_fins_lucrativos: "",
        setor_publico: ""
      },
      messages: {
        add: {
          success: cName.upper + " criada com sucesso!",
          error: "Ocorreu um erro ao criar " + cName.lower
        },
        update: {
          success: cName.upper + " alterada com sucesso!",
          error: "Ocorreu um erro ao alterar " + cName.lower
        },
        delete: {
          success: cName.upper + " eliminada com sucesso!",
          error: "Ocorreu um erro ao apagar " + cName.lower
        },
        default: {
          sucesso: "Sucesso",
          error: "Ocorreu um erro!"
        }
      },
      defaultRules: null,
      pwdRules: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
    getAll: "instituicoes/getAllInstituicoes",
    getSectores: "setores/getAll"
  }), {
    formTitle: function formTitle() {
      return this.editedIndex === -1 ? "Nova " + this.name : "Editar " + this.name;
    }
  }),

  watch: {
    modal: function modal(val) {
      val || this.close();
    },
    deleteM: function deleteM(val) {
      val || this.close();
    },
    getAll: function getAll(val) {
      this.initialize();
    },
    novaPwd: function novaPwd(val) {
      val || this.close();
    }
  },

  created: function created() {
    var _this = this;

    this.defaultRules = [function (v) {
      return !!v || _this.$requiredField + "";
    }];
    this.pwdRules = [function (v) {
      return v == _this.editedItem.password || "* As palavras-passe não coincidem!";
    }];
    this.initialize();
  },
  mounted: function mounted() {
    this.distritos = __WEBPACK_IMPORTED_MODULE_4__store_distritos_json___default.a;
  },

  methods: {
    toast: function toast(type, message) {
      if (type == "success") {
        return iziToast.show({
          title: "SUCESSO",
          color: "green",
          timeout: this.$toastTimeout,
          message: message,
          position: this.$toastPosition
        });
      } else {
        return iziToast.show({
          title: "AVISO",
          color: "red",
          timeout: this.$toastTimeout,
          message: message,
          position: this.$toastPosition
        });
      }
    },
    updatePwd: function updatePwd() {
      var _this2 = this;

      if (this.editedItem.password && this.editedItem.password == this.cpwd) this.$store.dispatch("session/update", {
        id: this.editedItem.id_instituicao,
        password: this.cpwd
      }).then(function (res) {
        if (res) {
          _this2.toast("success", "Password alterada com sucesso!");
          _this2.novaPwd = false;
        } else {
          _this2.toast("error", "Ocorreu um erro ao alterar a password!");
          _this2.novaPwd = false;
        }
      });
    },
    initialize: function initialize() {
      this.loading = true;
      this.DATA = this.getAll;
      this.loading = false;
    },
    editItem: function editItem(item, dialog) {
      this.editedIndex = this.DATA.indexOf(item);
      this.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);

      if (this.editedItem.associada == 2 && this.editedItem.id_associada) this.editedItem.associadas = this.editedItem.id_associada.split(",").map(function (el) {
        return Number(el);
      });

      if (dialog) this.modal = true;else this.deleteM = true;
    },
    viewSetores: function viewSetores(item, dialog) {
      var _this3 = this;

      var payload = {
        id_instituicao: item.id_instituicao
      };
      this.setores_id_instituicao = item.id_instituicao;
      __WEBPACK_IMPORTED_MODULE_3__store_axios__["a" /* instance */].post("/user/setores/", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, payload)).then(function (res) {
        console.log(res);
        if (res.data.data != "Sem resultados") {
          _this3.setores = res.data.data;
        } else {
          _this3.setores = [];
        }
      });
      this.modal_setores = true;
    },
    saveSetores: function saveSetores() {
      var _this4 = this;

      var payload = {
        id_instituicao: this.setores_id_instituicao,
        setores: this.setores
      };

      __WEBPACK_IMPORTED_MODULE_3__store_axios__["a" /* instance */].put("/user/update-setores/", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, payload)).then(function (res) {
        _this4.toast("success", "dados alterados com sucesso!");
        _this4.modal_setores = false;
      });
    },
    nPwd: function nPwd(item) {
      this.$refs.formPwd.reset();

      this.editedIndex = this.DATA.indexOf(item);
      this.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);

      this.novaPwd = true;
    },
    delete: function _delete() {
      var _this5 = this;

      if (!this.editedItem.id_instituicao) return;

      this.$store.dispatch(this.table + "/delete", {
        id: this.editedItem.id_instituicao
      }).then(function (res) {
        if (res) {
          _this5.toast("success", _this5.messages.delete.success);
          _this5.initialize();
        } else _this5.toast("error", _this5.messages.delete.error);

        _this5.deleteM = false;
      });
    },
    close: function close() {
      var _this6 = this;

      this.modal = this.deleteM = this.novaPwd = false;
      setTimeout(function () {
        _this6.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this6.defaultItem);
        _this6.editedIndex = -1;

        _this6.cpwd = null;

        _this6.$refs.form.reset();
        _this6.$refs.formPwd.reset();
      }, 110);
    },
    save: function save() {
      var _this7 = this;

      if (this.deleteM) {
        this.delete();
        return;
      }

      if (!this.$refs.form.validate()) return;

      if (this.editedItem.associada == 2 && this.editedItem.id_associada) this.editedItem.associadas = this.editedItem.associadas.join(",");

      if (this.editedIndex == -1) {
        this.$store.dispatch(this.table + "/insert", {
          nome: this.editedItem.nome,
          username: this.editedItem.username,
          email: this.editedItem.email,
          password: this.editedItem.password,
          super: 0,
          associada: this.editedItem.associada,
          id_associada: this.editedItem.associadas,
          publico: this.editedItem.publico,
          fins_lucrativos: this.editedItem.fins_lucrativos,
          tipo_fins_lucrativos: this.editedItem.tipo_fins_lucrativos,
          setor_publico: this.editedItem.setor_publico,
          trabalha_educacao: this.editedItem.trabalha_educacao,
          trabalha_estrategicos: this.editedItem.trabalha_estrategicos,
          distrito: this.editedItem.distrito
        }).then(function (res) {
          if (res) {
            _this7.toast("success", _this7.messages.add.success);
            _this7.initialize();
          } else _this7.toast("error", _this7.messages.add.error);

          _this7.modal = false;
        });
      } else {
        this.$store.dispatch(this.table + "/update", {
          id: this.editedItem.id_instituicao,
          nome: this.editedItem.nome,
          username: this.editedItem.username,
          email: this.editedItem.email,
          ativo: this.editedItem.ativo ? 1 : 0,
          associada: this.editedItem.associada,
          id_associada: this.editedItem.associadas,
          publico: this.editedItem.publico,
          fins_lucrativos: this.editedItem.fins_lucrativos,
          tipo_fins_lucrativos: this.editedItem.tipo_fins_lucrativos,
          setor_publico: this.editedItem.setor_publico,
          trabalha_educacao: this.editedItem.trabalha_educacao,
          trabalha_estrategicos: this.editedItem.trabalha_estrategicos,
          distrito: this.editedItem.distrito
        }).then(function (res) {
          if (res) {
            _this7.toast("success", _this7.messages.update.success);
            _this7.initialize();
          } else _this7.toast("error", _this7.messages.update.error);

          _this7.modal = false;
        });
      }
    },
    gerarPassword: function gerarPassword() {
      this.editedItem.password = this.generatePassword();
      this.cpwd = this.editedItem.password;
    },
    generatePassword: function generatePassword() {
      var length = 8,
          charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
          retVal = "";
      for (var i = 0, n = charset.length; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n));
      }
      return retVal;
    }
  }
});

/***/ }),

/***/ 456:
/***/ (function(module, exports) {

module.exports = [{"level":1,"code":1,"name":"Aveiro"},{"level":2,"code":101,"name":"Águeda"},{"level":3,"code":10103,"name":"Aguada de Cima"},{"level":3,"code":10109,"name":"Fermentelos"},{"level":3,"code":10112,"name":"Macinhata do Vouga"},{"level":3,"code":10119,"name":"Valongo do Vouga"},{"level":3,"code":10121,"name":"União das freguesias de Águeda e Borralha"},{"level":3,"code":10122,"name":"União das freguesias de Barrô e Aguada de Baixo"},{"level":3,"code":10123,"name":"União das freguesias de Belazaima do Chão, Castanheira do Vouga e Agadão"},{"level":3,"code":10124,"name":"União das freguesias de Recardães e Espinhel"},{"level":3,"code":10125,"name":"União das freguesias de Travassô e Óis da Ribeira"},{"level":3,"code":10126,"name":"União das freguesias de Trofa, Segadães e Lamas do Vouga"},{"level":3,"code":10127,"name":"União das freguesias do Préstimo e Macieira de Alcoba"},{"level":2,"code":102,"name":"Albergaria-a-Velha"},{"level":3,"code":10202,"name":"Alquerubim"},{"level":3,"code":10203,"name":"Angeja"},{"level":3,"code":10204,"name":"Branca"},{"level":3,"code":10206,"name":"Ribeira de Fráguas"},{"level":3,"code":10209,"name":"Albergaria-a-Velha e Valmaior"},{"level":3,"code":10210,"name":"São João de Loure e Frossos"},{"level":2,"code":103,"name":"Anadia"},{"level":3,"code":10304,"name":"Avelãs de Caminho"},{"level":3,"code":10305,"name":"Avelãs de Cima"},{"level":3,"code":10307,"name":"Moita"},{"level":3,"code":10309,"name":"Sangalhos"},{"level":3,"code":10310,"name":"São Lourenço do Bairro"},{"level":3,"code":10312,"name":"Vila Nova de Monsarros"},{"level":3,"code":10313,"name":"Vilarinho do Bairro"},{"level":3,"code":10316,"name":"União das freguesias de Amoreira da Gândara, Paredes do Bairro e Ancas"},{"level":3,"code":10317,"name":"União das freguesias de Arcos e Mogofores"},{"level":3,"code":10318,"name":"União das freguesias de Tamengos, Aguim e Óis do Bairro"},{"level":2,"code":104,"name":"Arouca"},{"level":3,"code":10402,"name":"Alvarenga"},{"level":3,"code":10407,"name":"Chave"},{"level":3,"code":10409,"name":"Escariz"},{"level":3,"code":10411,"name":"Fermedo"},{"level":3,"code":10413,"name":"Mansores"},{"level":3,"code":10414,"name":"Moldes"},{"level":3,"code":10415,"name":"Rossas"},{"level":3,"code":10416,"name":"Santa Eulália"},{"level":3,"code":10417,"name":"São Miguel do Mato"},{"level":3,"code":10418,"name":"Tropeço"},{"level":3,"code":10419,"name":"Urrô"},{"level":3,"code":10420,"name":"Várzea"},{"level":3,"code":10421,"name":"União das freguesias de Arouca e Burgo"},{"level":3,"code":10422,"name":"União das freguesias de Cabreiros e Albergaria da Serra"},{"level":3,"code":10423,"name":"União das freguesias de Canelas e Espiunca"},{"level":3,"code":10424,"name":"União das freguesias de Covelo de Paivó e Janarde"},{"level":2,"code":105,"name":"Aveiro"},{"level":3,"code":10501,"name":"Aradas"},{"level":3,"code":10502,"name":"Cacia"},{"level":3,"code":10505,"name":"Esgueira"},{"level":3,"code":10508,"name":"Oliveirinha"},{"level":3,"code":10510,"name":"São Bernardo"},{"level":3,"code":10511,"name":"São Jacinto"},{"level":3,"code":10513,"name":"Santa Joana"},{"level":3,"code":10515,"name":"Eixo e Eirol"},{"level":3,"code":10516,"name":"Requeixo, Nossa Senhora de Fátima e Nariz"},{"level":3,"code":10517,"name":"União das freguesias de Glória e Vera Cruz"},{"level":2,"code":106,"name":"Castelo de Paiva"},{"level":3,"code":10602,"name":"Fornos"},{"level":3,"code":10606,"name":"Real"},{"level":3,"code":10607,"name":"Santa Maria de Sardoura"},{"level":3,"code":10608,"name":"São Martinho de Sardoura"},{"level":3,"code":10610,"name":"União das freguesias de Raiva, Pedorido e Paraíso"},{"level":3,"code":10611,"name":"União das freguesias de Sobrado e Bairros"},{"level":2,"code":107,"name":"Espinho"},{"level":3,"code":10702,"name":"Espinho"},{"level":3,"code":10704,"name":"Paramos"},{"level":3,"code":10705,"name":"Silvalde"},{"level":3,"code":10706,"name":"União das freguesias de Anta e Guetim"},{"level":2,"code":108,"name":"Estarreja"},{"level":3,"code":10801,"name":"Avanca"},{"level":3,"code":10805,"name":"Pardilhó"},{"level":3,"code":10806,"name":"Salreu"},{"level":3,"code":10808,"name":"União das freguesias de Beduído e Veiros"},{"level":3,"code":10809,"name":"União das freguesias de Canelas e Fermelã"},{"level":2,"code":109,"name":"Santa Maria da Feira"},{"level":3,"code":10901,"name":"Argoncilhe"},{"level":3,"code":10902,"name":"Arrifana"},{"level":3,"code":10904,"name":"Escapães"},{"level":3,"code":10907,"name":"Fiães"},{"level":3,"code":10908,"name":"Fornos"},{"level":3,"code":10913,"name":"Lourosa"},{"level":3,"code":10914,"name":"Milheirós de Poiares"},{"level":3,"code":10916,"name":"Mozelos"},{"level":3,"code":10917,"name":"Nogueira da Regedoura"},{"level":3,"code":10918,"name":"São Paio de Oleiros"},{"level":3,"code":10919,"name":"Paços de Brandão"},{"level":3,"code":10921,"name":"Rio Meão"},{"level":3,"code":10922,"name":"Romariz"},{"level":3,"code":10924,"name":"Sanguedo"},{"level":3,"code":10925,"name":"Santa Maria de Lamas"},{"level":3,"code":10926,"name":"São João de Ver"},{"level":3,"code":10932,"name":"União das freguesias de Caldas de São Jorge e Pigeiros"},{"level":3,"code":10933,"name":"União das freguesias de Canedo, Vale e Vila Maior"},{"level":3,"code":10934,"name":"União das freguesias de Lobão, Gião, Louredo e Guisande"},{"level":3,"code":10935,"name":"União das freguesias de Santa Maria da Feira, Travanca, Sanfins e Espargo"},{"level":3,"code":10936,"name":"União das freguesias de São Miguel do Souto e Mosteirô"},{"level":2,"code":110,"name":"Ílhavo"},{"level":3,"code":11005,"name":"Gafanha da Encarnação"},{"level":3,"code":11006,"name":"Gafanha da Nazaré"},{"level":3,"code":11007,"name":"Gafanha do Carmo"},{"level":3,"code":11008,"name":"Ílhavo (São Salvador)"},{"level":2,"code":111,"name":"Mealhada"},{"level":3,"code":11102,"name":"Barcouço"},{"level":3,"code":11103,"name":"Casal Comba"},{"level":3,"code":11104,"name":"Luso"},{"level":3,"code":11106,"name":"Pampilhosa"},{"level":3,"code":11107,"name":"Vacariça"},{"level":3,"code":11109,"name":"União das freguesias da Mealhada, Ventosa do Bairro e Antes"},{"level":2,"code":112,"name":"Murtosa"},{"level":3,"code":11201,"name":"Bunheiro"},{"level":3,"code":11202,"name":"Monte"},{"level":3,"code":11203,"name":"Murtosa"},{"level":3,"code":11204,"name":"Torreira"},{"level":2,"code":113,"name":"Oliveira de Azeméis"},{"level":3,"code":11301,"name":"Carregosa"},{"level":3,"code":11302,"name":"Cesar"},{"level":3,"code":11303,"name":"Fajões"},{"level":3,"code":11304,"name":"Loureiro"},{"level":3,"code":11305,"name":"Macieira de Sarnes"},{"level":3,"code":11310,"name":"Ossela"},{"level":3,"code":11315,"name":"São Martinho da Gândara"},{"level":3,"code":11318,"name":"São Roque"},{"level":3,"code":11319,"name":"Vila de Cucujães"},{"level":3,"code":11320,"name":"União das freguesias de Nogueira do Cravo e Pindelo"},{"level":3,"code":11321,"name":"União das freguesias de Oliveira de Azeméis, Santiago de Riba-Ul, Ul, Macinhata da Seixa e Madail"},{"level":3,"code":11322,"name":"União das freguesias de Pinheiro da Bemposta, Travanca e Palmaz"},{"level":2,"code":114,"name":"Oliveira do Bairro"},{"level":3,"code":11403,"name":"Oiã"},{"level":3,"code":11404,"name":"Oliveira do Bairro"},{"level":3,"code":11405,"name":"Palhaça"},{"level":3,"code":11407,"name":"União das freguesias de Bustos, Troviscal e Mamarrosa"},{"level":2,"code":115,"name":"Ovar"},{"level":3,"code":11502,"name":"Cortegaça"},{"level":3,"code":11503,"name":"Esmoriz"},{"level":3,"code":11504,"name":"Maceda"},{"level":3,"code":11507,"name":"Válega"},{"level":3,"code":11509,"name":"União das freguesias de Ovar, São João, Arada e São Vicente de Pereira Jusã"},{"level":2,"code":116,"name":"São João da Madeira"},{"level":3,"code":11601,"name":"São João da Madeira"},{"level":2,"code":117,"name":"Sever do Vouga"},{"level":3,"code":11702,"name":"Couto de Esteves"},{"level":3,"code":11704,"name":"Pessegueiro do Vouga"},{"level":3,"code":11705,"name":"Rocas do Vouga"},{"level":3,"code":11706,"name":"Sever do Vouga"},{"level":3,"code":11708,"name":"Talhadas"},{"level":3,"code":11710,"name":"União das freguesias de Cedrim e Paradela"},{"level":3,"code":11711,"name":"União das freguesias de Silva Escura e Dornelas"},{"level":2,"code":118,"name":"Vagos"},{"level":3,"code":11801,"name":"Calvão"},{"level":3,"code":11804,"name":"Gafanha da Boa Hora"},{"level":3,"code":11805,"name":"Ouca"},{"level":3,"code":11807,"name":"Sosa"},{"level":3,"code":11810,"name":"Santo André de Vagos"},{"level":3,"code":11812,"name":"União das freguesias de Fonte de Angeão e Covão do Lobo"},{"level":3,"code":11813,"name":"União das freguesias de Ponte de Vagos e Santa Catarina"},{"level":3,"code":11814,"name":"União das freguesias de Vagos e Santo António"},{"level":2,"code":119,"name":"Vale de Cambra"},{"level":3,"code":11901,"name":"Arões"},{"level":3,"code":11902,"name":"São Pedro de Castelões"},{"level":3,"code":11903,"name":"Cepelos"},{"level":3,"code":11905,"name":"Junqueira"},{"level":3,"code":11906,"name":"Macieira de Cambra"},{"level":3,"code":11907,"name":"Roge"},{"level":3,"code":11910,"name":"União das freguesias de Vila Chã, Codal e Vila Cova de Perrinho"},{"level":1,"code":2,"name":"Beja"},{"level":2,"code":201,"name":"Aljustrel"},{"level":3,"code":20102,"name":"Ervidel"},{"level":3,"code":20103,"name":"Messejana"},{"level":3,"code":20104,"name":"São João de Negrilhos"},{"level":3,"code":20106,"name":"União das freguesias de Aljustrel e Rio de Moinhos"},{"level":2,"code":202,"name":"Almodôvar"},{"level":3,"code":20203,"name":"Rosário"},{"level":3,"code":20205,"name":"Santa Cruz"},{"level":3,"code":20206,"name":"São Barnabé"},{"level":3,"code":20208,"name":"Aldeia dos Fernandes"},{"level":3,"code":20209,"name":"União das freguesias de Almodôvar e Graça dos Padrões"},{"level":3,"code":20210,"name":"União das freguesias de Santa Clara-a-Nova e Gomes Aires"},{"level":2,"code":203,"name":"Alvito"},{"level":3,"code":20301,"name":"Alvito"},{"level":3,"code":20302,"name":"Vila Nova da Baronia"},{"level":2,"code":204,"name":"Barrancos"},{"level":3,"code":20401,"name":"Barrancos"},{"level":2,"code":205,"name":"Beja"},{"level":3,"code":20502,"name":"Baleizão"},{"level":3,"code":20503,"name":"Beringel"},{"level":3,"code":20504,"name":"Cabeça Gorda"},{"level":3,"code":20506,"name":"Nossa Senhora das Neves"},{"level":3,"code":20510,"name":"Santa Clara de Louredo"},{"level":3,"code":20516,"name":"São Matias"},{"level":3,"code":20519,"name":"União das freguesias de Albernoa e Trindade"},{"level":3,"code":20520,"name":"União das freguesias de Beja (Salvador e Santa Maria da Feira)"},{"level":3,"code":20521,"name":"União das freguesias de Beja (Santiago Maior e São João Baptista)"},{"level":3,"code":20522,"name":"União das freguesias de Salvada e Quintos"},{"level":3,"code":20523,"name":"União das freguesias de Santa Vitória e Mombeja"},{"level":3,"code":20524,"name":"União das freguesias de Trigaches e São Brissos"},{"level":2,"code":206,"name":"Castro Verde"},{"level":3,"code":20603,"name":"Entradas"},{"level":3,"code":20604,"name":"Santa Bárbara de Padrões"},{"level":3,"code":20605,"name":"São Marcos da Ataboeira"},{"level":3,"code":20606,"name":"União das freguesias de Castro Verde e Casével"},{"level":2,"code":207,"name":"Cuba"},{"level":3,"code":20701,"name":"Cuba"},{"level":3,"code":20702,"name":"Faro do Alentejo"},{"level":3,"code":20703,"name":"Vila Alva"},{"level":3,"code":20704,"name":"Vila Ruiva"},{"level":2,"code":208,"name":"Ferreira do Alentejo"},{"level":3,"code":20803,"name":"Figueira dos Cavaleiros"},{"level":3,"code":20804,"name":"Odivelas"},{"level":3,"code":20807,"name":"União das freguesias de Alfundão e Peroguarda"},{"level":3,"code":20808,"name":"União das freguesias de Ferreira do Alentejo e Canhestros"},{"level":2,"code":209,"name":"Mértola"},{"level":3,"code":20901,"name":"Alcaria Ruiva"},{"level":3,"code":20902,"name":"Corte do Pinto"},{"level":3,"code":20903,"name":"Espírito Santo"},{"level":3,"code":20904,"name":"Mértola"},{"level":3,"code":20905,"name":"Santana de Cambas"},{"level":3,"code":20906,"name":"São João dos Caldeireiros"},{"level":3,"code":20910,"name":"União das freguesias de São Miguel do Pinheiro, São Pedro de Solis e São Sebastião dos Carros"},{"level":2,"code":210,"name":"Moura"},{"level":3,"code":21001,"name":"Amareleja"},{"level":3,"code":21002,"name":"Póvoa de São Miguel"},{"level":3,"code":21008,"name":"Sobral da Adiça"},{"level":3,"code":21009,"name":"União das freguesias de Moura (Santo Agostinho e São João Baptista) e Santo Amador"},{"level":3,"code":21010,"name":"União das freguesias de Safara e Santo Aleixo da Restauração"},{"level":2,"code":211,"name":"Odemira"},{"level":3,"code":21102,"name":"Relíquias"},{"level":3,"code":21103,"name":"Sabóia"},{"level":3,"code":21106,"name":"São Luís"},{"level":3,"code":21107,"name":"São Martinho das Amoreiras"},{"level":3,"code":21111,"name":"Vila Nova de Milfontes"},{"level":3,"code":21115,"name":"Luzianes-Gare"},{"level":3,"code":21116,"name":"Boavista dos Pinheiros"},{"level":3,"code":21117,"name":"Longueira/Almograve"},{"level":3,"code":21118,"name":"Colos"},{"level":3,"code":21119,"name":"Santa Clara-a-Velha"},{"level":3,"code":21120,"name":"São Salvador e Santa Maria"},{"level":3,"code":21121,"name":"São Teotónio"},{"level":3,"code":21122,"name":"Vale de Santiago"},{"level":2,"code":212,"name":"Ourique"},{"level":3,"code":21203,"name":"Ourique"},{"level":3,"code":21206,"name":"Santana da Serra"},{"level":3,"code":21207,"name":"União das freguesias de Garvão e Santa Luzia"},{"level":3,"code":21208,"name":"União das freguesias de Panoias e Conceição"},{"level":2,"code":213,"name":"Serpa"},{"level":3,"code":21302,"name":"Brinches"},{"level":3,"code":21303,"name":"Pias"},{"level":3,"code":21307,"name":"Vila Verde de Ficalho"},{"level":3,"code":21308,"name":"União das freguesias de Serpa (Salvador e Santa Maria)"},{"level":3,"code":21309,"name":"União das freguesias de Vila Nova de São Bento e Vale de Vargo"},{"level":2,"code":214,"name":"Vidigueira"},{"level":3,"code":21401,"name":"Pedrógão"},{"level":3,"code":21402,"name":"Selmes"},{"level":3,"code":21403,"name":"Vidigueira"},{"level":3,"code":21404,"name":"Vila de Frades"},{"level":1,"code":3,"name":"Braga"},{"level":2,"code":301,"name":"Amares"},{"level":3,"code":30102,"name":"Barreiros"},{"level":3,"code":30104,"name":"Bico"},{"level":3,"code":30105,"name":"Caires"},{"level":3,"code":30107,"name":"Carrazedo"},{"level":3,"code":30108,"name":"Dornelas"},{"level":3,"code":30111,"name":"Fiscal"},{"level":3,"code":30112,"name":"Goães"},{"level":3,"code":30113,"name":"Lago"},{"level":3,"code":30118,"name":"Rendufe"},{"level":3,"code":30119,"name":"Bouro (Santa Maria)"},{"level":3,"code":30120,"name":"Bouro (Santa Marta)"},{"level":3,"code":30125,"name":"União das freguesias de Amares e Figueiredo"},{"level":3,"code":30126,"name":"União das freguesias de Caldelas, Sequeiros e Paranhos"},{"level":3,"code":30127,"name":"União das freguesias de Ferreiros, Prozelo e Besteiros"},{"level":3,"code":30128,"name":"União das freguesias de Torre e Portela"},{"level":3,"code":30129,"name":"União das freguesias de Vilela, Seramil e Paredes Secas"},{"level":2,"code":302,"name":"Barcelos"},{"level":3,"code":30201,"name":"Abade de Neiva"},{"level":3,"code":30202,"name":"Aborim"},{"level":3,"code":30203,"name":"Adães"},{"level":3,"code":30205,"name":"Airó"},{"level":3,"code":30206,"name":"Aldreu"},{"level":3,"code":30208,"name":"Alvelos"},{"level":3,"code":30209,"name":"Arcozelo"},{"level":3,"code":30210,"name":"Areias"},{"level":3,"code":30212,"name":"Balugães"},{"level":3,"code":30213,"name":"Barcelinhos"},{"level":3,"code":30215,"name":"Barqueiros"},{"level":3,"code":30216,"name":"Cambeses"},{"level":3,"code":30218,"name":"Carapeços"},{"level":3,"code":30220,"name":"Carvalhal"},{"level":3,"code":30221,"name":"Carvalhas"},{"level":3,"code":30224,"name":"Cossourado"},{"level":3,"code":30228,"name":"Cristelo"},{"level":3,"code":30234,"name":"Fornelos"},{"level":3,"code":30235,"name":"Fragoso"},{"level":3,"code":30237,"name":"Gilmonde"},{"level":3,"code":30242,"name":"Lama"},{"level":3,"code":30243,"name":"Lijó"},{"level":3,"code":30244,"name":"Macieira de Rates"},{"level":3,"code":30245,"name":"Manhente"},{"level":3,"code":30247,"name":"Martim"},{"level":3,"code":30252,"name":"Moure"},{"level":3,"code":30254,"name":"Oliveira"},{"level":3,"code":30255,"name":"Palme"},{"level":3,"code":30256,"name":"Panque"},{"level":3,"code":30257,"name":"Paradela"},{"level":3,"code":30259,"name":"Pereira"},{"level":3,"code":30260,"name":"Perelhal"},{"level":3,"code":30261,"name":"Pousa"},{"level":3,"code":30263,"name":"Remelhe"},{"level":3,"code":30264,"name":"Roriz"},{"level":3,"code":30265,"name":"Rio Covo (Santa Eugénia)"},{"level":3,"code":30268,"name":"Galegos (Santa Maria)"},{"level":3,"code":30272,"name":"Galegos (São Martinho)"},{"level":3,"code":30277,"name":"Tamel (São Veríssimo)"},{"level":3,"code":30279,"name":"Silva"},{"level":3,"code":30282,"name":"Ucha"},{"level":3,"code":30283,"name":"Várzea"},{"level":3,"code":30287,"name":"Vila Seca"},{"level":3,"code":30290,"name":"União das freguesias de Alheira e Igreja Nova"},{"level":3,"code":30291,"name":"União das freguesias de Alvito (São Pedro e São Martinho) e Couto"},{"level":3,"code":30292,"name":"União das freguesias de Areias de Vilar e Encourados"},{"level":3,"code":30293,"name":"União das freguesias de Barcelos, Vila Boa e Vila Frescainha (São Martinho e São Pedro)"},{"level":3,"code":30294,"name":"União das freguesias de Campo e Tamel (São Pedro Fins)"},{"level":3,"code":30295,"name":"União das freguesias de Carreira e Fonte Coberta"},{"level":3,"code":30296,"name":"União das freguesias de Chorente, Góios, Courel, Pedra Furada e Gueral"},{"level":3,"code":30297,"name":"União das freguesias de Creixomil e Mariz"},{"level":3,"code":30298,"name":"União das freguesias de Durrães e Tregosa"},{"level":3,"code":30299,"name":"União das freguesias de Gamil e Midões"},{"level":3,"code":"0302FA","name":"União das freguesias de Milhazes, Vilar de Figos e Faria"},{"level":3,"code":"0302FB","name":"União das freguesias de Negreiros e Chavão"},{"level":3,"code":"0302FC","name":"União das freguesias de Quintiães e Aguiar"},{"level":3,"code":"0302FD","name":"União das freguesias de Sequeade e Bastuço (São João e Santo Estevão)"},{"level":3,"code":"0302FE","name":"União das freguesias de Silveiros e Rio Covo (Santa Eulália)"},{"level":3,"code":"0302FF","name":"União das freguesias de Tamel (Santa Leocádia) e Vilar do Monte"},{"level":3,"code":"0302FG","name":"União das freguesias de Viatodos, Grimancelos, Minhotães e Monte de Fralães"},{"level":3,"code":"0302FH","name":"União das freguesias de Vila Cova e Feitos"},{"level":2,"code":303,"name":"Braga"},{"level":3,"code":30301,"name":"Adaúfe"},{"level":3,"code":30312,"name":"Espinho"},{"level":3,"code":30313,"name":"Esporões"},{"level":3,"code":30315,"name":"Figueiredo"},{"level":3,"code":30319,"name":"Gualtar"},{"level":3,"code":30322,"name":"Lamas"},{"level":3,"code":30325,"name":"Mire de Tibães"},{"level":3,"code":30330,"name":"Padim da Graça"},{"level":3,"code":30331,"name":"Palmeira"},{"level":3,"code":30334,"name":"Pedralva"},{"level":3,"code":30336,"name":"Priscos"},{"level":3,"code":30338,"name":"Ruilhe"},{"level":3,"code":30349,"name":"Braga (São Vicente)"},{"level":3,"code":30351,"name":"Braga (São Vítor)"},{"level":3,"code":30354,"name":"Sequeira"},{"level":3,"code":30355,"name":"Sobreposta"},{"level":3,"code":30356,"name":"Tadim"},{"level":3,"code":30357,"name":"Tebosa"},{"level":3,"code":30363,"name":"União das freguesias de Arentim e Cunha"},{"level":3,"code":30364,"name":"União das freguesias de Braga (Maximinos, Sé e Cividade)"},{"level":3,"code":30365,"name":"União das freguesias de Braga (São José de São Lázaro e São João do Souto)"},{"level":3,"code":30366,"name":"União das freguesias de Cabreiros e Passos (São Julião)"},{"level":3,"code":30367,"name":"União das freguesias de Celeirós, Aveleda e Vimieiro"},{"level":3,"code":30368,"name":"União das freguesias de Crespos e Pousada"},{"level":3,"code":30369,"name":"União das freguesias de Escudeiros e Penso (Santo Estêvão e São Vicente)"},{"level":3,"code":30370,"name":"União das freguesias de Este (São Pedro e São Mamede)"},{"level":3,"code":30371,"name":"União das freguesias de Ferreiros e Gondizalves"},{"level":3,"code":30372,"name":"União das freguesias de Guisande e Oliveira (São Pedro)"},{"level":3,"code":30373,"name":"União das freguesias de Lomar e Arcos"},{"level":3,"code":30374,"name":"União das freguesias de Merelim (São Paio), Panoias e Parada de Tibães"},{"level":3,"code":30375,"name":"União das freguesias de Merelim (São Pedro) e Frossos"},{"level":3,"code":30376,"name":"União das freguesias de Morreira e Trandeiras"},{"level":3,"code":30377,"name":"União das freguesias de Nogueira, Fraião e Lamaçães"},{"level":3,"code":30378,"name":"União das freguesias de Nogueiró e Tenões"},{"level":3,"code":30379,"name":"União das freguesias de Real, Dume e Semelhe"},{"level":3,"code":30380,"name":"União das freguesias de Santa Lucrécia de Algeriz e Navarra"},{"level":3,"code":30381,"name":"União das freguesias de Vilaça e Fradelos"},{"level":2,"code":304,"name":"Cabeceiras de Basto"},{"level":3,"code":30401,"name":"Abadim"},{"level":3,"code":30404,"name":"Basto"},{"level":3,"code":30405,"name":"Bucos"},{"level":3,"code":30406,"name":"Cabeceiras de Basto"},{"level":3,"code":30407,"name":"Cavez"},{"level":3,"code":30408,"name":"Faia"},{"level":3,"code":30413,"name":"Pedraça"},{"level":3,"code":30415,"name":"Rio Douro"},{"level":3,"code":30418,"name":"União das freguesias de Alvite e Passos"},{"level":3,"code":30419,"name":"União das freguesias de Arco de Baúlhe e Vila Nune"},{"level":3,"code":30420,"name":"União das freguesias de Gondiães e Vilar de Cunhas"},{"level":3,"code":30421,"name":"União das freguesias de Refojos de Basto, Outeiro e Painzela"},{"level":2,"code":305,"name":"Celorico de Basto"},{"level":3,"code":30501,"name":"Agilde"},{"level":3,"code":30502,"name":"Arnóia"},{"level":3,"code":30503,"name":"Borba de Montanha"},{"level":3,"code":30508,"name":"Codeçoso"},{"level":3,"code":30510,"name":"Fervença"},{"level":3,"code":30515,"name":"Moreira do Castelo"},{"level":3,"code":30517,"name":"Rego"},{"level":3,"code":30518,"name":"Ribas"},{"level":3,"code":30520,"name":"Basto (São Clemente)"},{"level":3,"code":30521,"name":"Vale de Bouro"},{"level":3,"code":30523,"name":"União das freguesias de Britelo, Gémeos e Ourilhe"},{"level":3,"code":30524,"name":"União das freguesias de Caçarilhe e Infesta"},{"level":3,"code":30525,"name":"União das freguesias de Canedo de Basto e Corgo"},{"level":3,"code":30526,"name":"União das freguesias de Carvalho e Basto (Santa Tecla)"},{"level":3,"code":30527,"name":"União das freguesias de Veade, Gagos e Molares"},{"level":2,"code":306,"name":"Esposende"},{"level":3,"code":30601,"name":"Antas"},{"level":3,"code":30608,"name":"Forjães"},{"level":3,"code":30610,"name":"Gemeses"},{"level":3,"code":30615,"name":"Vila Chã"},{"level":3,"code":30616,"name":"União das freguesias de Apúlia e Fão"},{"level":3,"code":30617,"name":"União das freguesias de Belinho e Mar"},{"level":3,"code":30618,"name":"União das freguesias de Esposende, Marinhas e Gandra"},{"level":3,"code":30619,"name":"União das freguesias de Fonte Boa e Rio Tinto"},{"level":3,"code":30620,"name":"União das freguesias de Palmeira de Faro e Curvos"},{"level":2,"code":307,"name":"Fafe"},{"level":3,"code":30705,"name":"Armil"},{"level":3,"code":30708,"name":"Estorãos"},{"level":3,"code":30709,"name":"Fafe"},{"level":3,"code":30712,"name":"Fornelos"},{"level":3,"code":30714,"name":"Golães"},{"level":3,"code":30716,"name":"Medelo"},{"level":3,"code":30719,"name":"Passos"},{"level":3,"code":30722,"name":"Quinchães"},{"level":3,"code":30723,"name":"Regadas"},{"level":3,"code":30724,"name":"Revelhe"},{"level":3,"code":30725,"name":"Ribeiros"},{"level":3,"code":30726,"name":"Arões (Santa Cristina)"},{"level":3,"code":30728,"name":"São Gens"},{"level":3,"code":30729,"name":"Silvares (São Martinho)"},{"level":3,"code":30730,"name":"Arões (São Romão)"},{"level":3,"code":30733,"name":"Travassós"},{"level":3,"code":30736,"name":"Vinhós"},{"level":3,"code":30737,"name":"União de freguesias de Aboim, Felgueiras, Gontim e Pedraído"},{"level":3,"code":30738,"name":"União de freguesias de Agrela e Serafão"},{"level":3,"code":30739,"name":"União de freguesias de Antime e Silvares (São Clemente)"},{"level":3,"code":30740,"name":"União de freguesias de Ardegão, Arnozela e Seidões"},{"level":3,"code":30741,"name":"União de freguesias de Cepães e Fareja"},{"level":3,"code":30742,"name":"União de freguesias de Freitas e Vila Cova"},{"level":3,"code":30743,"name":"União de freguesias de Monte e Queimadela"},{"level":3,"code":30744,"name":"União de freguesias de Moreira do Rei e Várzea Cova"},{"level":2,"code":308,"name":"Guimarães"},{"level":3,"code":30801,"name":"Aldão"},{"level":3,"code":30804,"name":"Azurém"},{"level":3,"code":30806,"name":"Barco"},{"level":3,"code":30807,"name":"Brito"},{"level":3,"code":30808,"name":"Caldelas"},{"level":3,"code":30812,"name":"Costa"},{"level":3,"code":30813,"name":"Creixomil"},{"level":3,"code":30815,"name":"Fermentões"},{"level":3,"code":30820,"name":"Gonça"},{"level":3,"code":30821,"name":"Gondar"},{"level":3,"code":30823,"name":"Guardizela"},{"level":3,"code":30824,"name":"Infantas"},{"level":3,"code":30827,"name":"Longos"},{"level":3,"code":30828,"name":"Lordelo"},{"level":3,"code":30830,"name":"Mesão Frio"},{"level":3,"code":30831,"name":"Moreira de Cónegos"},{"level":3,"code":30832,"name":"Nespereira"},{"level":3,"code":30835,"name":"Pencelo"},{"level":3,"code":30836,"name":"Pinheiro"},{"level":3,"code":30837,"name":"Polvoreira"},{"level":3,"code":30838,"name":"Ponte"},{"level":3,"code":30840,"name":"Ronfe"},{"level":3,"code":30842,"name":"Prazins (Santa Eufémia)"},{"level":3,"code":30850,"name":"Selho (São Cristóvão)"},{"level":3,"code":30854,"name":"Selho (São Jorge)"},{"level":3,"code":30857,"name":"Candoso (São Martinho)"},{"level":3,"code":30858,"name":"Sande (São Martinho)"},{"level":3,"code":30865,"name":"São Torcato"},{"level":3,"code":30866,"name":"Serzedelo"},{"level":3,"code":30868,"name":"Silvares"},{"level":3,"code":30871,"name":"Urgezes"},{"level":3,"code":30875,"name":"União das freguesias de Abação e Gémeos"},{"level":3,"code":30876,"name":"União das freguesias de Airão Santa Maria, Airão São João e Vermil"},{"level":3,"code":30877,"name":"União das freguesias de Arosa e Castelões"},{"level":3,"code":30878,"name":"União das freguesias de Atães e Rendufe"},{"level":3,"code":30879,"name":"União das freguesias de Briteiros Santo Estêvão e Donim"},{"level":3,"code":30880,"name":"União das freguesias de Briteiros São Salvador e Briteiros Santa Leocádia"},{"level":3,"code":30881,"name":"União das freguesias de Candoso São Tiago e Mascotelos"},{"level":3,"code":30882,"name":"União das freguesias de Conde e Gandarela"},{"level":3,"code":30883,"name":"União das freguesias de Leitões, Oleiros e Figueiredo"},{"level":3,"code":30884,"name":"União das freguesias de Oliveira, São Paio e São Sebastião"},{"level":3,"code":30885,"name":"União das freguesias de Prazins Santo Tirso e Corvite"},{"level":3,"code":30886,"name":"União das freguesias de Sande São Lourenço e Balazar"},{"level":3,"code":30887,"name":"União das freguesias de Sande Vila Nova e Sande São Clemente"},{"level":3,"code":30888,"name":"União das freguesias de Selho São Lourenço e Gominhães"},{"level":3,"code":30889,"name":"União das freguesias de Serzedo e Calvos"},{"level":3,"code":30890,"name":"União das freguesias de Souto Santa Maria, Souto São Salvador e Gondomar"},{"level":3,"code":30891,"name":"União das freguesias de Tabuadelo e São Faustino"},{"level":2,"code":309,"name":"Póvoa de Lanhoso"},{"level":3,"code":30906,"name":"Covelas"},{"level":3,"code":30908,"name":"Ferreiros"},{"level":3,"code":30912,"name":"Galegos"},{"level":3,"code":30913,"name":"Garfe"},{"level":3,"code":30914,"name":"Geraz do Minho"},{"level":3,"code":30915,"name":"Lanhoso"},{"level":3,"code":30917,"name":"Monsul"},{"level":3,"code":30919,"name":"Póvoa de Lanhoso (Nossa Senhora do Amparo)"},{"level":3,"code":30921,"name":"Rendufinho"},{"level":3,"code":30922,"name":"Santo Emilião"},{"level":3,"code":30923,"name":"São João de Rei"},{"level":3,"code":30924,"name":"Serzedelo"},{"level":3,"code":30925,"name":"Sobradelo da Goma"},{"level":3,"code":30926,"name":"Taíde"},{"level":3,"code":30927,"name":"Travassos"},{"level":3,"code":30929,"name":"Vilela"},{"level":3,"code":30930,"name":"União das freguesias de Águas Santas e Moure"},{"level":3,"code":30931,"name":"União das freguesias de Calvos e Frades"},{"level":3,"code":30932,"name":"União das freguesias de Campos e Louredo"},{"level":3,"code":30933,"name":"União das freguesias de Esperança e Brunhais"},{"level":3,"code":30934,"name":"União das freguesias de Fonte Arcada e Oliveira"},{"level":3,"code":30935,"name":"União das freguesias de Verim, Friande e Ajude"},{"level":2,"code":310,"name":"Terras de Bouro"},{"level":3,"code":31001,"name":"Balança"},{"level":3,"code":31003,"name":"Campo do Gerês"},{"level":3,"code":31004,"name":"Carvalheira"},{"level":3,"code":31008,"name":"Covide"},{"level":3,"code":31009,"name":"Gondoriz"},{"level":3,"code":31010,"name":"Moimenta"},{"level":3,"code":31012,"name":"Ribeira"},{"level":3,"code":31013,"name":"Rio Caldo"},{"level":3,"code":31014,"name":"Souto"},{"level":3,"code":31015,"name":"Valdosende"},{"level":3,"code":31017,"name":"Vilar da Veiga"},{"level":3,"code":31018,"name":"União das freguesias de Chamoim e Vilar"},{"level":3,"code":31019,"name":"União das freguesias de Chorense e Monte"},{"level":3,"code":31020,"name":"União das freguesias de Cibões e Brufe"},{"level":2,"code":311,"name":"Vieira do Minho"},{"level":3,"code":31105,"name":"Cantelães"},{"level":3,"code":31107,"name":"Eira Vedra"},{"level":3,"code":31108,"name":"Guilhofrei"},{"level":3,"code":31109,"name":"Louredo"},{"level":3,"code":31110,"name":"Mosteiro"},{"level":3,"code":31111,"name":"Parada do Bouro"},{"level":3,"code":31112,"name":"Pinheiro"},{"level":3,"code":31113,"name":"Rossas"},{"level":3,"code":31115,"name":"Salamonde"},{"level":3,"code":31118,"name":"Tabuaças"},{"level":3,"code":31120,"name":"Vieira do Minho"},{"level":3,"code":31122,"name":"União das freguesias de Anissó e Soutelo"},{"level":3,"code":31123,"name":"União das freguesias de Anjos e Vilar do Chão"},{"level":3,"code":31124,"name":"União das freguesias de Caniçada e Soengas"},{"level":3,"code":31125,"name":"União das freguesias de Ruivães e Campos"},{"level":3,"code":31126,"name":"União das freguesias de Ventosa e Cova"},{"level":2,"code":312,"name":"Vila Nova de Famalicão"},{"level":3,"code":31204,"name":"Bairro"},{"level":3,"code":31206,"name":"Brufe"},{"level":3,"code":31210,"name":"Castelões"},{"level":3,"code":31212,"name":"Cruz"},{"level":3,"code":31213,"name":"Delães"},{"level":3,"code":31215,"name":"Fradelos"},{"level":3,"code":31216,"name":"Gavião"},{"level":3,"code":31219,"name":"Joane"},{"level":3,"code":31221,"name":"Landim"},{"level":3,"code":31223,"name":"Louro"},{"level":3,"code":31224,"name":"Lousado"},{"level":3,"code":31225,"name":"Mogege"},{"level":3,"code":31227,"name":"Nine"},{"level":3,"code":31230,"name":"Pedome"},{"level":3,"code":31232,"name":"Pousada de Saramagos"},{"level":3,"code":31233,"name":"Requião"},{"level":3,"code":31234,"name":"Riba de Ave"},{"level":3,"code":31235,"name":"Ribeirão"},{"level":3,"code":31239,"name":"Oliveira (Santa Maria)"},{"level":3,"code":31241,"name":"Vale (São Martinho)"},{"level":3,"code":31242,"name":"Oliveira (São Mateus)"},{"level":3,"code":31247,"name":"Vermoim"},{"level":3,"code":31249,"name":"Vilarinho das Cambas"},{"level":3,"code":31250,"name":"União das freguesias de Antas e Abade de Vermoim"},{"level":3,"code":31251,"name":"União das freguesias de Arnoso (Santa Maria e Santa Eulália) e Sezures"},{"level":3,"code":31252,"name":"União das freguesias de Avidos e Lagoa"},{"level":3,"code":31253,"name":"União das freguesias de Carreira e Bente"},{"level":3,"code":31254,"name":"União das freguesias de Esmeriz e Cabeçudos"},{"level":3,"code":31255,"name":"União das freguesias de Gondifelos, Cavalões e Outiz"},{"level":3,"code":31256,"name":"União das freguesias de Lemenhe, Mouquim e Jesufrei"},{"level":3,"code":31257,"name":"União das freguesias de Ruivães e Novais"},{"level":3,"code":31258,"name":"União das freguesias de Seide"},{"level":3,"code":31259,"name":"União das freguesias de Vale (São Cosme), Telhado e Portela"},{"level":3,"code":31260,"name":"União das freguesias de Vila Nova de Famalicão e Calendário"},{"level":2,"code":313,"name":"Vila Verde"},{"level":3,"code":31304,"name":"Atiães"},{"level":3,"code":31308,"name":"Cabanelas"},{"level":3,"code":31309,"name":"Cervães"},{"level":3,"code":31311,"name":"Coucieiro"},{"level":3,"code":31313,"name":"Dossãos"},{"level":3,"code":31316,"name":"Freiriz"},{"level":3,"code":31317,"name":"Gême"},{"level":3,"code":31323,"name":"Lage"},{"level":3,"code":31324,"name":"Lanhas"},{"level":3,"code":31325,"name":"Loureira"},{"level":3,"code":31328,"name":"Moure"},{"level":3,"code":31330,"name":"Oleiros"},{"level":3,"code":31331,"name":"Parada de Gatim"},{"level":3,"code":31335,"name":"Pico"},{"level":3,"code":31337,"name":"Ponte"},{"level":3,"code":31340,"name":"Sabariz"},{"level":3,"code":31342,"name":"Vila de Prado"},{"level":3,"code":31350,"name":"Prado (São Miguel)"},{"level":3,"code":31352,"name":"Soutelo"},{"level":3,"code":31354,"name":"Turiz"},{"level":3,"code":31355,"name":"Valdreu"},{"level":3,"code":31359,"name":"Aboim da Nóbrega e Gondomar"},{"level":3,"code":31360,"name":"União das freguesias da Ribeira do Neiva"},{"level":3,"code":31361,"name":"União das freguesias de Carreiras (São Miguel) e Carreiras (Santiago)"},{"level":3,"code":31362,"name":"União das freguesias de Escariz (São Mamede) e Escariz (São Martinho)"},{"level":3,"code":31363,"name":"União das freguesias de Esqueiros, Nevogilde e Travassós"},{"level":3,"code":31364,"name":"União das freguesias de Marrancos e Arcozelo"},{"level":3,"code":31365,"name":"União das freguesias de Oriz (Santa Marinha) e Oriz (São Miguel)"},{"level":3,"code":31366,"name":"União das freguesias de Pico de Regalados, Gondiães e Mós"},{"level":3,"code":31367,"name":"União das freguesias de Sande, Vilarinho, Barros e Gomide"},{"level":3,"code":31368,"name":"União das freguesias de Valbom (São Pedro), Passô e Valbom (São Martinho)"},{"level":3,"code":31369,"name":"União das freguesias do Vade"},{"level":3,"code":31370,"name":"Vila Verde e Barbudo"},{"level":2,"code":314,"name":"Vizela"},{"level":3,"code":31401,"name":"Santa Eulália"},{"level":3,"code":31404,"name":"Infias"},{"level":3,"code":31406,"name":"Vizela (Santo Adrião)"},{"level":3,"code":31408,"name":"União das freguesias de Caldas de Vizela (São Miguel e São João)"},{"level":3,"code":31409,"name":"União das freguesias de Tagilde e Vizela (São Paio)"},{"level":1,"code":4,"name":"Bragança"},{"level":2,"code":401,"name":"Alfândega da Fé"},{"level":3,"code":40102,"name":"Alfândega da Fé"},{"level":3,"code":40103,"name":"Cerejais"},{"level":3,"code":40111,"name":"Sambade"},{"level":3,"code":40118,"name":"Vilar Chão"},{"level":3,"code":40119,"name":"Vilarelhos"},{"level":3,"code":40120,"name":"Vilares de Vilariça"},{"level":3,"code":40121,"name":"União das freguesias de Agrobom, Saldonha e Vale Pereiro"},{"level":3,"code":40122,"name":"União das freguesias de Eucisia, Gouveia e Valverde"},{"level":3,"code":40123,"name":"União das freguesias de Ferradosa e Sendim da Serra"},{"level":3,"code":40124,"name":"União das freguesias de Gebelim e Soeima"},{"level":3,"code":40125,"name":"União das freguesias de Parada e Sendim da Ribeira"},{"level":3,"code":40126,"name":"União das freguesias de Pombal e Vales"},{"level":2,"code":402,"name":"Bragança"},{"level":3,"code":40201,"name":"Alfaião"},{"level":3,"code":40203,"name":"Babe"},{"level":3,"code":40204,"name":"Baçal"},{"level":3,"code":40206,"name":"Carragosa"},{"level":3,"code":40209,"name":"Castro de Avelãs"},{"level":3,"code":40210,"name":"Coelhoso"},{"level":3,"code":40212,"name":"Donai"},{"level":3,"code":40213,"name":"Espinhosela"},{"level":3,"code":40215,"name":"França"},{"level":3,"code":40216,"name":"Gimonde"},{"level":3,"code":40217,"name":"Gondesende"},{"level":3,"code":40218,"name":"Gostei"},{"level":3,"code":40219,"name":"Grijó de Parada"},{"level":3,"code":40221,"name":"Macedo do Mato"},{"level":3,"code":40224,"name":"Mós"},{"level":3,"code":40225,"name":"Nogueira"},{"level":3,"code":40226,"name":"Outeiro"},{"level":3,"code":40229,"name":"Parâmio"},{"level":3,"code":40230,"name":"Pinela"},{"level":3,"code":40232,"name":"Quintanilha"},{"level":3,"code":40233,"name":"Quintela de Lampaças"},{"level":3,"code":40234,"name":"Rabal"},{"level":3,"code":40236,"name":"Rebordãos"},{"level":3,"code":40239,"name":"Salsas"},{"level":3,"code":40240,"name":"Samil"},{"level":3,"code":40241,"name":"Santa Comba de Rossas"},{"level":3,"code":40244,"name":"São Pedro de Sarracenos"},{"level":3,"code":40246,"name":"Sendas"},{"level":3,"code":40247,"name":"Serapicos"},{"level":3,"code":40248,"name":"Sortes"},{"level":3,"code":40249,"name":"Zoio"},{"level":3,"code":40250,"name":"União das freguesias de Aveleda e Rio de Onor"},{"level":3,"code":40251,"name":"União das freguesias de Castrelos e Carrazedo"},{"level":3,"code":40252,"name":"União das freguesias de Izeda, Calvelhe e Paradinha Nova"},{"level":3,"code":40253,"name":"União das freguesias de Parada e Faílde"},{"level":3,"code":40254,"name":"União das freguesias de Rebordainhos e Pombares"},{"level":3,"code":40255,"name":"União das freguesias de Rio Frio e Milhão"},{"level":3,"code":40256,"name":"União das freguesias de São Julião de Palácios e Deilão"},{"level":3,"code":40257,"name":"União das freguesias de Sé, Santa Maria e Meixedo"},{"level":2,"code":403,"name":"Carrazeda de Ansiães"},{"level":3,"code":40304,"name":"Carrazeda de Ansiães"},{"level":3,"code":40306,"name":"Fonte Longa"},{"level":3,"code":40308,"name":"Linhares"},{"level":3,"code":40309,"name":"Marzagão"},{"level":3,"code":40311,"name":"Parambos"},{"level":3,"code":40312,"name":"Pereiros"},{"level":3,"code":40313,"name":"Pinhal do Norte"},{"level":3,"code":40314,"name":"Pombal"},{"level":3,"code":40316,"name":"Seixo de Ansiães"},{"level":3,"code":40318,"name":"Vilarinho da Castanheira"},{"level":3,"code":40320,"name":"União das freguesias de Amedo e Zedes"},{"level":3,"code":40321,"name":"União das freguesias de Belver e Mogo de Malta"},{"level":3,"code":40322,"name":"União das freguesias de Castanheiro do Norte e Ribalonga"},{"level":3,"code":40323,"name":"União das freguesias de Lavandeira, Beira Grande e Selores"},{"level":2,"code":404,"name":"Freixo de Espada à Cinta"},{"level":3,"code":40404,"name":"Ligares"},{"level":3,"code":40406,"name":"Poiares"},{"level":3,"code":40407,"name":"União das freguesias de Freixo de Espada à Cinta e Mazouco"},{"level":3,"code":40408,"name":"União das freguesias de Lagoaça e Fornos"},{"level":2,"code":405,"name":"Macedo de Cavaleiros"},{"level":3,"code":40502,"name":"Amendoeira"},{"level":3,"code":40503,"name":"Arcas"},{"level":3,"code":40507,"name":"Carrapatas"},{"level":3,"code":40509,"name":"Chacim"},{"level":3,"code":40510,"name":"Cortiços"},{"level":3,"code":40511,"name":"Corujas"},{"level":3,"code":40514,"name":"Ferreira"},{"level":3,"code":40515,"name":"Grijó"},{"level":3,"code":40516,"name":"Lagoa"},{"level":3,"code":40517,"name":"Lamalonga"},{"level":3,"code":40518,"name":"Lamas"},{"level":3,"code":40519,"name":"Lombo"},{"level":3,"code":40520,"name":"Macedo de Cavaleiros"},{"level":3,"code":40521,"name":"Morais"},{"level":3,"code":40523,"name":"Olmos"},{"level":3,"code":40524,"name":"Peredo"},{"level":3,"code":40526,"name":"Salselas"},{"level":3,"code":40528,"name":"Sezulfe"},{"level":3,"code":40530,"name":"Talhas"},{"level":3,"code":40532,"name":"Vale Benfeito"},{"level":3,"code":40533,"name":"Vale da Porca"},{"level":3,"code":40534,"name":"Vale de Prados"},{"level":3,"code":40536,"name":"Vilarinho de Agrochão"},{"level":3,"code":40538,"name":"Vinhas"},{"level":3,"code":40539,"name":"União das freguesias de Ala e Vilarinho do Monte"},{"level":3,"code":40540,"name":"União das freguesias de Bornes e Burga"},{"level":3,"code":40541,"name":"União das freguesias de Castelãos e Vilar do Monte"},{"level":3,"code":40542,"name":"União das freguesias de Espadanedo, Edroso, Murçós e Soutelo Mourisco"},{"level":3,"code":40543,"name":"União das freguesias de Podence e Santa Combinha"},{"level":3,"code":40544,"name":"União das freguesias de Talhinhas e Bagueixe"},{"level":2,"code":406,"name":"Miranda do Douro"},{"level":3,"code":40604,"name":"Duas Igrejas"},{"level":3,"code":40605,"name":"Genísio"},{"level":3,"code":40607,"name":"Malhadas"},{"level":3,"code":40608,"name":"Miranda do Douro"},{"level":3,"code":40609,"name":"Palaçoulo"},{"level":3,"code":40611,"name":"Picote"},{"level":3,"code":40612,"name":"Póvoa"},{"level":3,"code":40613,"name":"São Martinho de Angueira"},{"level":3,"code":40616,"name":"Vila Chã de Braciosa"},{"level":3,"code":40618,"name":"União das freguesias de Constantim e Cicouro"},{"level":3,"code":40619,"name":"União das freguesias de Ifanes e Paradela"},{"level":3,"code":40620,"name":"União das freguesias de Sendim e Atenor"},{"level":3,"code":40621,"name":"União das freguesias de Silva e Águas Vivas"},{"level":2,"code":407,"name":"Mirandela"},{"level":3,"code":40701,"name":"Abambres"},{"level":3,"code":40702,"name":"Abreiro"},{"level":3,"code":40703,"name":"Aguieiras"},{"level":3,"code":40704,"name":"Alvites"},{"level":3,"code":40708,"name":"Bouça"},{"level":3,"code":40709,"name":"Cabanelas"},{"level":3,"code":40710,"name":"Caravelas"},{"level":3,"code":40711,"name":"Carvalhais"},{"level":3,"code":40712,"name":"Cedães"},{"level":3,"code":40713,"name":"Cobro"},{"level":3,"code":40714,"name":"Fradizela"},{"level":3,"code":40716,"name":"Frechas"},{"level":3,"code":40718,"name":"Lamas de Orelhão"},{"level":3,"code":40720,"name":"Mascarenhas"},{"level":3,"code":40721,"name":"Mirandela"},{"level":3,"code":40722,"name":"Múrias"},{"level":3,"code":40724,"name":"Passos"},{"level":3,"code":40727,"name":"São Pedro Velho"},{"level":3,"code":40728,"name":"São Salvador"},{"level":3,"code":40729,"name":"Suçães"},{"level":3,"code":40730,"name":"Torre de Dona Chama"},{"level":3,"code":40731,"name":"Vale de Asnes"},{"level":3,"code":40732,"name":"Vale de Gouvinhas"},{"level":3,"code":40733,"name":"Vale de Salgueiro"},{"level":3,"code":40734,"name":"Vale de Telhas"},{"level":3,"code":40738,"name":"União das freguesias de Avantos e Romeu"},{"level":3,"code":40739,"name":"União das Freguesias de Avidagos, Navalho e Pereira"},{"level":3,"code":40740,"name":"União das freguesias de Barcel, Marmelos e Valverde da Gestosa"},{"level":3,"code":40741,"name":"União das freguesias de Franco e Vila Boa"},{"level":3,"code":40742,"name":"União das freguesias de Freixeda e Vila Verde"},{"level":2,"code":408,"name":"Mogadouro"},{"level":3,"code":40801,"name":"Azinhoso"},{"level":3,"code":40802,"name":"Bemposta"},{"level":3,"code":40803,"name":"Bruçó"},{"level":3,"code":40804,"name":"Brunhoso"},{"level":3,"code":40807,"name":"Castelo Branco"},{"level":3,"code":40808,"name":"Castro Vicente"},{"level":3,"code":40809,"name":"Meirinhos"},{"level":3,"code":40811,"name":"Paradela"},{"level":3,"code":40812,"name":"Penas Roias"},{"level":3,"code":40813,"name":"Peredo da Bemposta"},{"level":3,"code":40815,"name":"Saldanha"},{"level":3,"code":40817,"name":"São Martinho do Peso"},{"level":3,"code":40819,"name":"Tó"},{"level":3,"code":40820,"name":"Travanca"},{"level":3,"code":40821,"name":"Urrós"},{"level":3,"code":40822,"name":"Vale da Madre"},{"level":3,"code":40826,"name":"Vila de Ala"},{"level":3,"code":40829,"name":"União das freguesias de Brunhozinho, Castanheira e Sanhoane"},{"level":3,"code":40830,"name":"União das freguesias de Mogadouro, Valverde, Vale de Porco e Vilar de Rei"},{"level":3,"code":40831,"name":"União das freguesias de Remondes e Soutelo"},{"level":3,"code":40832,"name":"União das freguesias de Vilarinho dos Galegos e Ventozelo"},{"level":2,"code":409,"name":"Torre de Moncorvo"},{"level":3,"code":40901,"name":"Açoreira"},{"level":3,"code":40903,"name":"Cabeça Boa"},{"level":3,"code":40905,"name":"Carviçais"},{"level":3,"code":40906,"name":"Castedo"},{"level":3,"code":40909,"name":"Horta da Vilariça"},{"level":3,"code":40910,"name":"Larinho"},{"level":3,"code":40911,"name":"Lousa"},{"level":3,"code":40913,"name":"Mós"},{"level":3,"code":40916,"name":"Torre de Moncorvo"},{"level":3,"code":40918,"name":"União das freguesias de Adeganha e Cardanha"},{"level":3,"code":40919,"name":"União das freguesias de Felgar e Souto da Velha"},{"level":3,"code":40920,"name":"União das freguesias de Felgueiras e Maçores"},{"level":3,"code":40921,"name":"União das freguesias de Urros e Peredo dos Castelhanos"},{"level":2,"code":410,"name":"Vila Flor"},{"level":3,"code":41002,"name":"Benlhevai"},{"level":3,"code":41005,"name":"Freixiel"},{"level":3,"code":41009,"name":"Roios"},{"level":3,"code":41010,"name":"Samões"},{"level":3,"code":41011,"name":"Sampaio"},{"level":3,"code":41012,"name":"Santa Comba de Vilariça"},{"level":3,"code":41013,"name":"Seixo de Manhoses"},{"level":3,"code":41014,"name":"Trindade"},{"level":3,"code":41015,"name":"Vale Frechoso"},{"level":3,"code":41020,"name":"União das freguesias de Assares e Lodões"},{"level":3,"code":41021,"name":"União das freguesias de Candoso e Carvalho de Egas"},{"level":3,"code":41022,"name":"União das freguesias de Valtorno e Mourão"},{"level":3,"code":41023,"name":"União das freguesias de Vila Flor e Nabo"},{"level":3,"code":41024,"name":"União das freguesias de Vilas Boas e Vilarinho das Azenhas"},{"level":2,"code":411,"name":"Vimioso"},{"level":3,"code":41103,"name":"Argozelo"},{"level":3,"code":41107,"name":"Carção"},{"level":3,"code":41108,"name":"Matela"},{"level":3,"code":41109,"name":"Pinelo"},{"level":3,"code":41110,"name":"Santulhão"},{"level":3,"code":41113,"name":"Vilar Seco"},{"level":3,"code":41114,"name":"Vimioso"},{"level":3,"code":41115,"name":"União das freguesias de Algoso, Campo de Víboras e Uva"},{"level":3,"code":41116,"name":"União das freguesias de Caçarelhos e Angueira"},{"level":3,"code":41117,"name":"União das freguesias de Vale de Frades e Avelanoso"},{"level":2,"code":412,"name":"Vinhais"},{"level":3,"code":41201,"name":"Agrochão"},{"level":3,"code":41203,"name":"Candedo"},{"level":3,"code":41204,"name":"Celas"},{"level":3,"code":41206,"name":"Edral"},{"level":3,"code":41207,"name":"Edrosa"},{"level":3,"code":41208,"name":"Ervedosa"},{"level":3,"code":41215,"name":"Paçó"},{"level":3,"code":41216,"name":"Penhas Juntas"},{"level":3,"code":41219,"name":"Rebordelo"},{"level":3,"code":41221,"name":"Santalha"},{"level":3,"code":41226,"name":"Tuizelo"},{"level":3,"code":41227,"name":"Vale das Fontes"},{"level":3,"code":41229,"name":"Vila Boa de Ousilhão"},{"level":3,"code":41230,"name":"Vila Verde"},{"level":3,"code":41232,"name":"Vilar de Ossos"},{"level":3,"code":41233,"name":"Vilar de Peregrinos"},{"level":3,"code":41234,"name":"Vilar Seco de Lomba"},{"level":3,"code":41235,"name":"Vinhais"},{"level":3,"code":41236,"name":"União das freguesias de Curopos e Vale de Janeiro"},{"level":3,"code":41237,"name":"União das freguesias de Moimenta e Montouto"},{"level":3,"code":41238,"name":"União das freguesias de Nunes e Ousilhão"},{"level":3,"code":41239,"name":"União das freguesias de Quirás e Pinheiro Novo"},{"level":3,"code":41240,"name":"União das freguesias de Sobreiro de Baixo e Alvaredos"},{"level":3,"code":41241,"name":"União das freguesias de Soeira, Fresulfe e Mofreita"},{"level":3,"code":41242,"name":"União das freguesias de Travanca e Santa Cruz"},{"level":3,"code":41243,"name":"União das freguesias de Vilar de Lomba e São Jomil"},{"level":1,"code":5,"name":"Castelo Branco"},{"level":2,"code":501,"name":"Belmonte"},{"level":3,"code":50102,"name":"Caria"},{"level":3,"code":50104,"name":"Inguias"},{"level":3,"code":50105,"name":"Maçainhas"},{"level":3,"code":50106,"name":"União das freguesias de Belmonte e Colmeal da Torre"},{"level":2,"code":502,"name":"Castelo Branco"},{"level":3,"code":50201,"name":"Alcains"},{"level":3,"code":50202,"name":"Almaceda"},{"level":3,"code":50203,"name":"Benquerenças"},{"level":3,"code":50205,"name":"Castelo Branco"},{"level":3,"code":50211,"name":"Lardosa"},{"level":3,"code":50212,"name":"Louriçal do Campo"},{"level":3,"code":50214,"name":"Malpica do Tejo"},{"level":3,"code":50216,"name":"Monforte da Beira"},{"level":3,"code":50220,"name":"Salgueiro do Campo"},{"level":3,"code":50221,"name":"Santo André das Tojeiras"},{"level":3,"code":50222,"name":"São Vicente da Beira"},{"level":3,"code":50223,"name":"Sarzedas"},{"level":3,"code":50225,"name":"Tinalhas"},{"level":3,"code":50226,"name":"União das freguesias de Cebolais de Cima e Retaxo"},{"level":3,"code":50227,"name":"União das freguesias de Escalos de Baixo e Mata"},{"level":3,"code":50228,"name":"União das freguesias de Escalos de Cima e Lousa"},{"level":3,"code":50229,"name":"União das freguesias de Freixial e Juncal do Campo"},{"level":3,"code":50230,"name":"União das freguesias de Ninho do Açor e Sobral do Campo"},{"level":3,"code":50231,"name":"União das freguesias de Póvoa de Rio de Moinhos e Cafede"},{"level":2,"code":503,"name":"Covilhã"},{"level":3,"code":50302,"name":"Aldeia de São Francisco de Assis"},{"level":3,"code":50305,"name":"Boidobra"},{"level":3,"code":50308,"name":"Cortes do Meio"},{"level":3,"code":50309,"name":"Dominguizo"},{"level":3,"code":50310,"name":"Erada"},{"level":3,"code":50311,"name":"Ferro"},{"level":3,"code":50312,"name":"Orjais"},{"level":3,"code":50314,"name":"Paul"},{"level":3,"code":50315,"name":"Peraboa"},{"level":3,"code":50318,"name":"São Jorge da Beira"},{"level":3,"code":50322,"name":"Sobral de São Miguel"},{"level":3,"code":50324,"name":"Tortosendo"},{"level":3,"code":50325,"name":"Unhais da Serra"},{"level":3,"code":50327,"name":"Verdelhos"},{"level":3,"code":50332,"name":"União das freguesias de Barco e Coutada"},{"level":3,"code":50333,"name":"União das freguesias de Cantar-Galo e Vila do Carvalho"},{"level":3,"code":50334,"name":"União das freguesias de Casegas e Ourondo"},{"level":3,"code":50335,"name":"União das freguesias de Covilhã e Canhoso"},{"level":3,"code":50336,"name":"União das freguesias de Peso e Vales do Rio"},{"level":3,"code":50337,"name":"União das freguesias de Teixoso e Sarzedo"},{"level":3,"code":50338,"name":"União das freguesias de Vale Formoso e Aldeia do Souto"},{"level":2,"code":504,"name":"Fundão"},{"level":3,"code":50401,"name":"Alcaide"},{"level":3,"code":50402,"name":"Alcaria"},{"level":3,"code":50403,"name":"Alcongosta"},{"level":3,"code":50406,"name":"Alpedrinha"},{"level":3,"code":50408,"name":"Barroca"},{"level":3,"code":50410,"name":"Bogas de Cima"},{"level":3,"code":50411,"name":"Capinha"},{"level":3,"code":50412,"name":"Castelejo"},{"level":3,"code":50413,"name":"Castelo Novo"},{"level":3,"code":50416,"name":"Fatela"},{"level":3,"code":50419,"name":"Lavacolhos"},{"level":3,"code":50420,"name":"Orca"},{"level":3,"code":50421,"name":"Pêro Viseu"},{"level":3,"code":50424,"name":"Silvares"},{"level":3,"code":50425,"name":"Soalheira"},{"level":3,"code":50426,"name":"Souto da Casa"},{"level":3,"code":50427,"name":"Telhado"},{"level":3,"code":50431,"name":"Enxames"},{"level":3,"code":50432,"name":"Três Povos"},{"level":3,"code":50433,"name":"União das freguesias de Janeiro de Cima e Bogas de Baixo"},{"level":3,"code":50434,"name":"União das freguesias de Fundão, Valverde, Donas, Aldeia de Joanes e Aldeia Nova do Cabo"},{"level":3,"code":50435,"name":"União das freguesias de Póvoa de Atalaia e Atalaia do Campo"},{"level":3,"code":50436,"name":"União das freguesias de Vale de Prazeres e Mata da Rainha"},{"level":2,"code":505,"name":"Idanha-a-Nova"},{"level":3,"code":50502,"name":"Aldeia de Santa Margarida"},{"level":3,"code":50505,"name":"Ladoeiro"},{"level":3,"code":50506,"name":"Medelim"},{"level":3,"code":50509,"name":"Oledo"},{"level":3,"code":50510,"name":"Penha Garcia"},{"level":3,"code":50511,"name":"Proença-a-Velha"},{"level":3,"code":50512,"name":"Rosmaninhal"},{"level":3,"code":50514,"name":"São Miguel de Acha"},{"level":3,"code":50516,"name":"Toulões"},{"level":3,"code":50518,"name":"União das freguesias de Idanha-a-Nova e Alcafozes"},{"level":3,"code":50519,"name":"União das freguesias de Monfortinho e Salvaterra do Extremo"},{"level":3,"code":50520,"name":"União das freguesias de Monsanto e Idanha-a-Velha"},{"level":3,"code":50521,"name":"União das freguesias de Zebreira e Segura"},{"level":2,"code":506,"name":"Oleiros"},{"level":3,"code":50601,"name":"Álvaro"},{"level":3,"code":50603,"name":"Cambas"},{"level":3,"code":50605,"name":"Isna"},{"level":3,"code":50606,"name":"Madeirã"},{"level":3,"code":50607,"name":"Mosteiro"},{"level":3,"code":50609,"name":"Orvalho"},{"level":3,"code":50610,"name":"Sarnadas de São Simão"},{"level":3,"code":50611,"name":"Sobral"},{"level":3,"code":50613,"name":"Estreito-Vilar Barroco"},{"level":3,"code":50614,"name":"Oleiros-Amieira"},{"level":2,"code":507,"name":"Penamacor"},{"level":3,"code":50704,"name":"Aranhas"},{"level":3,"code":50706,"name":"Benquerença"},{"level":3,"code":50707,"name":"Meimão"},{"level":3,"code":50708,"name":"Meimoa"},{"level":3,"code":50710,"name":"Penamacor"},{"level":3,"code":50711,"name":"Salvador"},{"level":3,"code":50712,"name":"Vale da Senhora da Póvoa"},{"level":3,"code":50713,"name":"União das freguesias de Aldeia do Bispo, Águas e Aldeia de João Pires"},{"level":3,"code":50714,"name":"União das freguesias de Pedrógão de São Pedro e Bemposta"},{"level":2,"code":508,"name":"Proença-a-Nova"},{"level":3,"code":50802,"name":"Montes da Senhora"},{"level":3,"code":50805,"name":"São Pedro do Esteval"},{"level":3,"code":50807,"name":"União das freguesias de Proença-a-Nova e Peral"},{"level":3,"code":50808,"name":"União das freguesias de Sobreira Formosa e Alvito da Beira"},{"level":2,"code":509,"name":"Sertã"},{"level":3,"code":50901,"name":"Cabeçudo"},{"level":3,"code":50902,"name":"Carvalhal"},{"level":3,"code":50903,"name":"Castelo"},{"level":3,"code":50911,"name":"Pedrógão Pequeno"},{"level":3,"code":50912,"name":"Sertã"},{"level":3,"code":50913,"name":"Troviscal"},{"level":3,"code":50914,"name":"Várzea dos Cavaleiros"},{"level":3,"code":50915,"name":"União das freguesias de Cernache do Bonjardim, Nesperal e Palhais"},{"level":3,"code":50916,"name":"União das freguesias de Cumeada e Marmeleiro"},{"level":3,"code":50917,"name":"União das freguesias de Ermida e Figueiredo"},{"level":2,"code":510,"name":"Vila de Rei"},{"level":3,"code":51001,"name":"Fundada"},{"level":3,"code":51002,"name":"São João do Peso"},{"level":3,"code":51003,"name":"Vila de Rei"},{"level":2,"code":511,"name":"Vila Velha de Ródão"},{"level":3,"code":51101,"name":"Fratel"},{"level":3,"code":51102,"name":"Perais"},{"level":3,"code":51103,"name":"Sarnadas de Ródão"},{"level":3,"code":51104,"name":"Vila Velha de Ródão"},{"level":1,"code":6,"name":"Coimbra"},{"level":2,"code":601,"name":"Arganil"},{"level":3,"code":60102,"name":"Arganil"},{"level":3,"code":60104,"name":"Benfeita"},{"level":3,"code":60105,"name":"Celavisa"},{"level":3,"code":60109,"name":"Folques"},{"level":3,"code":60111,"name":"Piódão"},{"level":3,"code":60112,"name":"Pomares"},{"level":3,"code":60113,"name":"Pombeiro da Beira"},{"level":3,"code":60114,"name":"São Martinho da Cortiça"},{"level":3,"code":60115,"name":"Sarzedo"},{"level":3,"code":60116,"name":"Secarias"},{"level":3,"code":60119,"name":"União das freguesias de Cepos e Teixeira"},{"level":3,"code":60120,"name":"União das freguesias de Cerdeira e Moura da Serra"},{"level":3,"code":60121,"name":"União das freguesias de Côja e Barril de Alva"},{"level":3,"code":60122,"name":"União das freguesias de Vila Cova de Alva e Anseriz"},{"level":2,"code":602,"name":"Cantanhede"},{"level":3,"code":60201,"name":"Ançã"},{"level":3,"code":60203,"name":"Cadima"},{"level":3,"code":60205,"name":"Cordinhã"},{"level":3,"code":60207,"name":"Febres"},{"level":3,"code":60208,"name":"Murtede"},{"level":3,"code":60209,"name":"Ourentã"},{"level":3,"code":60214,"name":"Tocha"},{"level":3,"code":60215,"name":"São Caetano"},{"level":3,"code":60218,"name":"Sanguinheira"},{"level":3,"code":60220,"name":"União das freguesias de Cantanhede e Pocariça"},{"level":3,"code":60221,"name":"União das freguesias de Covões e Camarneira"},{"level":3,"code":60222,"name":"União das freguesias de Portunhos e Outil"},{"level":3,"code":60223,"name":"União das freguesias de Sepins e Bolho"},{"level":3,"code":60224,"name":"União das freguesias de Vilamar e Corticeiro de Cima"},{"level":2,"code":603,"name":"Coimbra"},{"level":3,"code":60301,"name":"Almalaguês"},{"level":3,"code":60309,"name":"Brasfemes"},{"level":3,"code":60311,"name":"Ceira"},{"level":3,"code":60312,"name":"Cernache"},{"level":3,"code":60318,"name":"Santo António dos Olivais"},{"level":3,"code":60320,"name":"São João do Campo"},{"level":3,"code":60324,"name":"São Silvestre"},{"level":3,"code":60329,"name":"Torres do Mondego"},{"level":3,"code":60332,"name":"União das freguesias de Antuzede e Vil de Matos"},{"level":3,"code":60333,"name":"União das freguesias de Assafarge e Antanhol"},{"level":3,"code":60334,"name":"União das freguesias de Coimbra (Sé Nova, Santa Cruz, Almedina e São Bartolomeu)"},{"level":3,"code":60335,"name":"União das freguesias de Eiras e São Paulo de Frades"},{"level":3,"code":60336,"name":"União das freguesias de Santa Clara e Castelo Viegas"},{"level":3,"code":60337,"name":"União das freguesias de São Martinho de Árvore e Lamarosa"},{"level":3,"code":60338,"name":"União das freguesias de São Martinho do Bispo e Ribeira de Frades"},{"level":3,"code":60339,"name":"União das freguesias de Souselas e Botão"},{"level":3,"code":60340,"name":"União das freguesias de Taveiro, Ameal e Arzila"},{"level":3,"code":60341,"name":"União das freguesias de Trouxemil e Torre de Vilela"},{"level":2,"code":604,"name":"Condeixa-a-Nova"},{"level":3,"code":60401,"name":"Anobra"},{"level":3,"code":60406,"name":"Ega"},{"level":3,"code":60407,"name":"Furadouro"},{"level":3,"code":60410,"name":"Zambujal"},{"level":3,"code":60411,"name":"União das freguesias de Condeixa-a-Velha e Condeixa-a-Nova"},{"level":3,"code":60412,"name":"União das freguesias de Sebal e Belide"},{"level":3,"code":60413,"name":"União das freguesias de Vila Seca e Bem da Fé"},{"level":2,"code":605,"name":"Figueira da Foz"},{"level":3,"code":60502,"name":"Alqueidão"},{"level":3,"code":60507,"name":"Maiorca"},{"level":3,"code":60508,"name":"Marinha das Ondas"},{"level":3,"code":60512,"name":"Tavarede"},{"level":3,"code":60513,"name":"Vila Verde"},{"level":3,"code":60514,"name":"São Pedro"},{"level":3,"code":60515,"name":"Bom Sucesso"},{"level":3,"code":60518,"name":"Moinhos da Gândara"},{"level":3,"code":60519,"name":"Alhadas"},{"level":3,"code":60520,"name":"Buarcos e São Julião"},{"level":3,"code":60521,"name":"Ferreira-a-Nova"},{"level":3,"code":60522,"name":"Lavos"},{"level":3,"code":60523,"name":"Paião"},{"level":3,"code":60524,"name":"Quiaios"},{"level":2,"code":606,"name":"Góis"},{"level":3,"code":60601,"name":"Alvares"},{"level":3,"code":60604,"name":"Góis"},{"level":3,"code":60605,"name":"Vila Nova do Ceira"},{"level":3,"code":60606,"name":"União das freguesias de Cadafaz e Colmeal"},{"level":2,"code":607,"name":"Lousã"},{"level":3,"code":60704,"name":"Serpins"},{"level":3,"code":60706,"name":"Gândaras"},{"level":3,"code":60707,"name":"União das freguesias de Foz de Arouce e Casal de Ermio"},{"level":3,"code":60708,"name":"União das freguesias de Lousã e Vilarinho"},{"level":2,"code":608,"name":"Mira"},{"level":3,"code":60801,"name":"Mira"},{"level":3,"code":60802,"name":"Seixo"},{"level":3,"code":60803,"name":"Carapelhos"},{"level":3,"code":60804,"name":"Praia de Mira"},{"level":2,"code":609,"name":"Miranda do Corvo"},{"level":3,"code":60901,"name":"Lamas"},{"level":3,"code":60902,"name":"Miranda do Corvo"},{"level":3,"code":60905,"name":"Vila Nova"},{"level":3,"code":60906,"name":"União das freguesias de Semide e Rio Vide"},{"level":2,"code":610,"name":"Montemor-o-Velho"},{"level":3,"code":61002,"name":"Arazede"},{"level":3,"code":61003,"name":"Carapinheira"},{"level":3,"code":61005,"name":"Liceia"},{"level":3,"code":61006,"name":"Meãs do Campo"},{"level":3,"code":61008,"name":"Pereira"},{"level":3,"code":61009,"name":"Santo Varão"},{"level":3,"code":61010,"name":"Seixo de Gatões"},{"level":3,"code":61011,"name":"Tentúgal"},{"level":3,"code":61014,"name":"Ereira"},{"level":3,"code":61015,"name":"União das freguesias de Abrunheira, Verride e Vila Nova da Barca"},{"level":3,"code":61016,"name":"União das freguesias de Montemor-o-Velho e Gatões"},{"level":2,"code":611,"name":"Oliveira do Hospital"},{"level":3,"code":61101,"name":"Aldeia das Dez"},{"level":3,"code":61102,"name":"Alvoco das Várzeas"},{"level":3,"code":61103,"name":"Avô"},{"level":3,"code":61104,"name":"Bobadela"},{"level":3,"code":61106,"name":"Lagares"},{"level":3,"code":61109,"name":"Lourosa"},{"level":3,"code":61110,"name":"Meruge"},{"level":3,"code":61111,"name":"Nogueira do Cravo"},{"level":3,"code":61115,"name":"São Gião"},{"level":3,"code":61118,"name":"Seixo da Beira"},{"level":3,"code":61119,"name":"Travanca de Lagos"},{"level":3,"code":61122,"name":"União das freguesias de Ervedal e Vila Franca da Beira"},{"level":3,"code":61123,"name":"União das freguesias de Lagos da Beira e Lajeosa"},{"level":3,"code":61124,"name":"União das freguesias de Oliveira do Hospital e São Paio de Gramaços"},{"level":3,"code":61125,"name":"União das freguesias de Penalva de Alva e São Sebastião da Feira"},{"level":3,"code":61126,"name":"União das freguesias de Santa Ovaia e Vila Pouca da Beira"},{"level":2,"code":612,"name":"Pampilhosa da Serra"},{"level":3,"code":61201,"name":"Cabril"},{"level":3,"code":61202,"name":"Dornelas do Zêzere"},{"level":3,"code":61204,"name":"Janeiro de Baixo"},{"level":3,"code":61206,"name":"Pampilhosa da Serra"},{"level":3,"code":61207,"name":"Pessegueiro"},{"level":3,"code":61209,"name":"Unhais-o-Velho"},{"level":3,"code":61211,"name":"Fajão-Vidual"},{"level":3,"code":61212,"name":"Portela do Fojo-Machio"},{"level":2,"code":613,"name":"Penacova"},{"level":3,"code":61301,"name":"Carvalho"},{"level":3,"code":61302,"name":"Figueira de Lorvão"},{"level":3,"code":61304,"name":"Lorvão"},{"level":3,"code":61307,"name":"Penacova"},{"level":3,"code":61310,"name":"Sazes do Lorvão"},{"level":3,"code":61312,"name":"União das freguesias de Friúmes e Paradela"},{"level":3,"code":61313,"name":"União das freguesias de Oliveira do Mondego e Travanca do Mondego"},{"level":3,"code":61314,"name":"União das freguesias de São Pedro de Alva e São Paio de Mondego"},{"level":2,"code":614,"name":"Penela"},{"level":3,"code":61401,"name":"Cumeeira"},{"level":3,"code":61402,"name":"Espinhal"},{"level":3,"code":61403,"name":"Podentes"},{"level":3,"code":61407,"name":"União das freguesias de São Miguel, Santa Eufémia e Rabaçal"},{"level":2,"code":615,"name":"Soure"},{"level":3,"code":61501,"name":"Alfarelos"},{"level":3,"code":61504,"name":"Figueiró do Campo"},{"level":3,"code":61506,"name":"Granja do Ulmeiro"},{"level":3,"code":61508,"name":"Samuel"},{"level":3,"code":61509,"name":"Soure"},{"level":3,"code":61510,"name":"Tapéus"},{"level":3,"code":61511,"name":"Vila Nova de Anços"},{"level":3,"code":61512,"name":"Vinha da Rainha"},{"level":3,"code":61513,"name":"União das freguesias de Degracias e Pombalinho"},{"level":3,"code":61514,"name":"União das freguesias de Gesteira e Brunhós"},{"level":2,"code":616,"name":"Tábua"},{"level":3,"code":61602,"name":"Candosa"},{"level":3,"code":61603,"name":"Carapinha"},{"level":3,"code":61608,"name":"Midões"},{"level":3,"code":61609,"name":"Mouronho"},{"level":3,"code":61611,"name":"Póvoa de Midões"},{"level":3,"code":61612,"name":"São João da Boa Vista"},{"level":3,"code":61614,"name":"Tábua"},{"level":3,"code":61616,"name":"União das freguesias de Ázere e Covelo"},{"level":3,"code":61617,"name":"União das freguesias de Covas e Vila Nova de Oliveirinha"},{"level":3,"code":61618,"name":"União das freguesias de Espariz e Sinde"},{"level":3,"code":61619,"name":"União das freguesias de Pinheiro de Coja e Meda de Mouros"},{"level":2,"code":617,"name":"Vila Nova de Poiares"},{"level":3,"code":61701,"name":"Arrifana"},{"level":3,"code":61702,"name":"Lavegadas"},{"level":3,"code":61703,"name":"Poiares (Santo André)"},{"level":3,"code":61704,"name":"São Miguel de Poiares"},{"level":1,"code":7,"name":"Évora"},{"level":2,"code":701,"name":"Alandroal"},{"level":3,"code":70103,"name":"Santiago Maior"},{"level":3,"code":70104,"name":"Capelins (Santo António)"},{"level":3,"code":70105,"name":"Terena (São Pedro)"},{"level":3,"code":70107,"name":"União das freguesias de Alandroal (Nossa Senhora da Conceição), São Brás dos Matos (Mina do Bugalho) e Juromenha (Nossa Senhora do Loreto)"},{"level":2,"code":702,"name":"Arraiolos"},{"level":3,"code":70201,"name":"Arraiolos"},{"level":3,"code":70202,"name":"Igrejinha"},{"level":3,"code":70206,"name":"Vimieiro"},{"level":3,"code":70208,"name":"União das freguesias de Gafanhoeira (São Pedro) e Sabugueiro"},{"level":3,"code":70209,"name":"União das freguesias de São Gregório e Santa Justa"},{"level":2,"code":703,"name":"Borba"},{"level":3,"code":70301,"name":"Borba (Matriz)"},{"level":3,"code":70302,"name":"Orada"},{"level":3,"code":70303,"name":"Rio de Moinhos"},{"level":3,"code":70304,"name":"Borba (São Bartolomeu)"},{"level":2,"code":704,"name":"Estremoz"},{"level":3,"code":70401,"name":"Arcos"},{"level":3,"code":70402,"name":"Glória"},{"level":3,"code":70404,"name":"Évora Monte (Santa Maria)"},{"level":3,"code":70411,"name":"São Domingos de Ana Loura"},{"level":3,"code":70413,"name":"Veiros"},{"level":3,"code":70414,"name":"União das freguesias de Estremoz (Santa Maria e Santo André)"},{"level":3,"code":70415,"name":"União das freguesias de São Bento do Cortiço e Santo Estêvão"},{"level":3,"code":70416,"name":"União das freguesias de São Lourenço de Mamporcão e São Bento de Ana Loura"},{"level":3,"code":70417,"name":"União das freguesias do Ameixial (Santa Vitória e São Bento)"},{"level":2,"code":705,"name":"Évora"},{"level":3,"code":70502,"name":"Nossa Senhora da Graça do Divor"},{"level":3,"code":70503,"name":"Nossa Senhora de Machede"},{"level":3,"code":70506,"name":"São Bento do Mato"},{"level":3,"code":70509,"name":"São Miguel de Machede"},{"level":3,"code":70513,"name":"Torre de Coelheiros"},{"level":3,"code":70515,"name":"Canaviais"},{"level":3,"code":70522,"name":"União das freguesias de Bacelo e Senhora da Saúde"},{"level":3,"code":70523,"name":"União das freguesias de Évora (São Mamede, Sé, São Pedro e Santo Antão)"},{"level":3,"code":70524,"name":"União das freguesias de Malagueira e Horta das Figueiras"},{"level":3,"code":70525,"name":"União das freguesias de Nossa Senhora da Tourega e Nossa Senhora de Guadalupe"},{"level":3,"code":70526,"name":"União das freguesias de São Manços e São Vicente do Pigeiro"},{"level":3,"code":70527,"name":"União das freguesias de São Sebastião da Giesteira e Nossa Senhora da Boa Fé"},{"level":2,"code":706,"name":"Montemor-o-Novo"},{"level":3,"code":70601,"name":"Cabrela"},{"level":3,"code":70605,"name":"Santiago do Escoural"},{"level":3,"code":70606,"name":"São Cristóvão"},{"level":3,"code":70607,"name":"Ciborro"},{"level":3,"code":70610,"name":"Foros de Vale de Figueira"},{"level":3,"code":70611,"name":"União das freguesias de Cortiçadas de Lavre e Lavre"},{"level":3,"code":70612,"name":"União das freguesias de Nossa Senhora da Vila, Nossa Senhora do Bispo e Silveiras"},{"level":2,"code":707,"name":"Mora"},{"level":3,"code":70701,"name":"Brotas"},{"level":3,"code":70702,"name":"Cabeção"},{"level":3,"code":70703,"name":"Mora"},{"level":3,"code":70704,"name":"Pavia"},{"level":2,"code":708,"name":"Mourão"},{"level":3,"code":70801,"name":"Granja"},{"level":3,"code":70802,"name":"Luz"},{"level":3,"code":70803,"name":"Mourão"},{"level":2,"code":709,"name":"Portel"},{"level":3,"code":70903,"name":"Monte do Trigo"},{"level":3,"code":70905,"name":"Portel"},{"level":3,"code":70906,"name":"Santana"},{"level":3,"code":70908,"name":"Vera Cruz"},{"level":3,"code":70909,"name":"União das freguesias de Amieira e Alqueva"},{"level":3,"code":70910,"name":"União das freguesias de São Bartolomeu do Outeiro e Oriola"},{"level":2,"code":710,"name":"Redondo"},{"level":3,"code":71001,"name":"Montoito"},{"level":3,"code":71002,"name":"Redondo"},{"level":2,"code":711,"name":"Reguengos de Monsaraz"},{"level":3,"code":71102,"name":"Corval"},{"level":3,"code":71103,"name":"Monsaraz"},{"level":3,"code":71104,"name":"Reguengos de Monsaraz"},{"level":3,"code":71106,"name":"União das freguesias de Campo e Campinho"},{"level":2,"code":712,"name":"Vendas Novas"},{"level":3,"code":71201,"name":"Vendas Novas"},{"level":3,"code":71202,"name":"Landeira"},{"level":2,"code":713,"name":"Viana do Alentejo"},{"level":3,"code":71301,"name":"Alcáçovas"},{"level":3,"code":71302,"name":"Viana do Alentejo"},{"level":3,"code":71303,"name":"Aguiar"},{"level":2,"code":714,"name":"Vila Viçosa"},{"level":3,"code":71401,"name":"Bencatel"},{"level":3,"code":71402,"name":"Ciladas"},{"level":3,"code":71404,"name":"Pardais"},{"level":3,"code":71406,"name":"Nossa Senhora da Conceição e São Bartolomeu"},{"level":1,"code":8,"name":"Faro"},{"level":2,"code":801,"name":"Albufeira"},{"level":3,"code":80102,"name":"Guia"},{"level":3,"code":80103,"name":"Paderne"},{"level":3,"code":80104,"name":"Ferreiras"},{"level":3,"code":80106,"name":"Albufeira e Olhos de Água"},{"level":2,"code":802,"name":"Alcoutim"},{"level":3,"code":80202,"name":"Giões"},{"level":3,"code":80203,"name":"Martim Longo"},{"level":3,"code":80205,"name":"Vaqueiros"},{"level":3,"code":80206,"name":"União das freguesias de Alcoutim e Pereiro"},{"level":2,"code":803,"name":"Aljezur"},{"level":3,"code":80301,"name":"Aljezur"},{"level":3,"code":80302,"name":"Bordeira"},{"level":3,"code":80303,"name":"Odeceixe"},{"level":3,"code":80304,"name":"Rogil"},{"level":2,"code":804,"name":"Castro Marim"},{"level":3,"code":80401,"name":"Azinhal"},{"level":3,"code":80402,"name":"Castro Marim"},{"level":3,"code":80403,"name":"Odeleite"},{"level":3,"code":80404,"name":"Altura"},{"level":2,"code":805,"name":"Faro"},{"level":3,"code":80503,"name":"Santa Bárbara de Nexe"},{"level":3,"code":80506,"name":"Montenegro"},{"level":3,"code":80507,"name":"União das freguesias de Conceição e Estoi"},{"level":3,"code":80508,"name":"União das freguesias de Faro (Sé e São Pedro)"},{"level":2,"code":806,"name":"Lagoa"},{"level":3,"code":80602,"name":"Ferragudo"},{"level":3,"code":80604,"name":"Porches"},{"level":3,"code":80607,"name":"União das freguesias de Estômbar e Parchal"},{"level":3,"code":80608,"name":"União das freguesias de Lagoa e Carvoeiro"},{"level":2,"code":807,"name":"Lagos"},{"level":3,"code":80703,"name":"Luz"},{"level":3,"code":80704,"name":"Odiáxere"},{"level":3,"code":80707,"name":"União das freguesias de Bensafrim e Barão de São João"},{"level":3,"code":80708,"name":"São Gonçalo de Lagos"},{"level":2,"code":808,"name":"Loulé"},{"level":3,"code":80801,"name":"Almancil"},{"level":3,"code":80802,"name":"Alte"},{"level":3,"code":80803,"name":"Ameixial"},{"level":3,"code":80804,"name":"Boliqueime"},{"level":3,"code":80805,"name":"Quarteira"},{"level":3,"code":80807,"name":"Salir"},{"level":3,"code":80808,"name":"Loulé (São Clemente)"},{"level":3,"code":80809,"name":"Loulé (São Sebastião)"},{"level":3,"code":80812,"name":"União de freguesias de Querença, Tôr e Benafim"},{"level":2,"code":809,"name":"Monchique"},{"level":3,"code":80901,"name":"Alferce"},{"level":3,"code":80902,"name":"Marmelete"},{"level":3,"code":80903,"name":"Monchique"},{"level":2,"code":810,"name":"Olhão"},{"level":3,"code":81003,"name":"Olhão"},{"level":3,"code":81004,"name":"Pechão"},{"level":3,"code":81005,"name":"Quelfes"},{"level":3,"code":81006,"name":"União das freguesias de Moncarapacho e Fuseta"},{"level":2,"code":811,"name":"Portimão"},{"level":3,"code":81101,"name":"Alvor"},{"level":3,"code":81102,"name":"Mexilhoeira Grande"},{"level":3,"code":81103,"name":"Portimão"},{"level":2,"code":812,"name":"São Brás de Alportel"},{"level":3,"code":81201,"name":"São Brás de Alportel"},{"level":2,"code":813,"name":"Silves"},{"level":3,"code":81303,"name":"Armação de Pêra"},{"level":3,"code":81305,"name":"São Bartolomeu de Messines"},{"level":3,"code":81306,"name":"São Marcos da Serra"},{"level":3,"code":81307,"name":"Silves"},{"level":3,"code":81309,"name":"União das freguesias de Alcantarilha e Pêra"},{"level":3,"code":81310,"name":"União das freguesias de Algoz e Tunes"},{"level":2,"code":814,"name":"Tavira"},{"level":3,"code":81401,"name":"Cachopo"},{"level":3,"code":81404,"name":"Santa Catarina da Fonte do Bispo"},{"level":3,"code":81408,"name":"Santa Luzia"},{"level":3,"code":81410,"name":"União das freguesias de Conceição e Cabanas de Tavira"},{"level":3,"code":81411,"name":"União das freguesias de Luz de Tavira e Santo Estêvão"},{"level":3,"code":81412,"name":"União das freguesias de Tavira (Santa Maria e Santiago)"},{"level":2,"code":815,"name":"Vila do Bispo"},{"level":3,"code":81501,"name":"Barão de São Miguel"},{"level":3,"code":81502,"name":"Budens"},{"level":3,"code":81504,"name":"Sagres"},{"level":3,"code":81506,"name":"Vila do Bispo e Raposeira"},{"level":2,"code":816,"name":"Vila Real de Santo António"},{"level":3,"code":81601,"name":"Vila Nova de Cacela"},{"level":3,"code":81602,"name":"Vila Real de Santo António"},{"level":3,"code":81603,"name":"Monte Gordo"},{"level":1,"code":9,"name":"Guarda"},{"level":2,"code":901,"name":"Aguiar da Beira"},{"level":3,"code":90102,"name":"Carapito"},{"level":3,"code":90103,"name":"Cortiçada"},{"level":3,"code":90105,"name":"Dornelas"},{"level":3,"code":90106,"name":"Eirado"},{"level":3,"code":90107,"name":"Forninhos"},{"level":3,"code":90109,"name":"Pena Verde"},{"level":3,"code":90110,"name":"Pinheiro"},{"level":3,"code":90114,"name":"União das freguesias de Aguiar da Beira e Coruche"},{"level":3,"code":90115,"name":"União das freguesias de Sequeiros e Gradiz"},{"level":3,"code":90116,"name":"União das freguesias de Souto de Aguiar da Beira e Valverde"},{"level":2,"code":902,"name":"Almeida"},{"level":3,"code":90203,"name":"Almeida"},{"level":3,"code":90207,"name":"Castelo Bom"},{"level":3,"code":90209,"name":"Freineda"},{"level":3,"code":90210,"name":"Freixo"},{"level":3,"code":90213,"name":"Malhada Sorda"},{"level":3,"code":90219,"name":"Nave de Haver"},{"level":3,"code":90224,"name":"São Pedro de Rio Seco"},{"level":3,"code":90227,"name":"Vale da Mula"},{"level":3,"code":90229,"name":"Vilar Formoso"},{"level":3,"code":90230,"name":"União das freguesias de Amoreira, Parada e Cabreira"},{"level":3,"code":90231,"name":"União das freguesias de Azinhal, Peva e Valverde"},{"level":3,"code":90232,"name":"União das freguesias de Castelo Mendo, Ade, Monteperobolso e Mesquitela"},{"level":3,"code":90233,"name":"União das freguesias de Junça e Naves"},{"level":3,"code":90234,"name":"União das freguesias de Leomil, Mido, Senouras e Aldeia Nova"},{"level":3,"code":90235,"name":"União das freguesias de Malpartida e Vale de Coelha"},{"level":3,"code":90236,"name":"União das freguesias de Miuzela e Porto de Ovelha"},{"level":2,"code":903,"name":"Celorico da Beira"},{"level":3,"code":90302,"name":"Baraçal"},{"level":3,"code":90304,"name":"Carrapichana"},{"level":3,"code":90306,"name":"Forno Telheiro"},{"level":3,"code":90307,"name":"Lajeosa do Mondego"},{"level":3,"code":90308,"name":"Linhares"},{"level":3,"code":90309,"name":"Maçal do Chão"},{"level":3,"code":90310,"name":"Mesquitela"},{"level":3,"code":90311,"name":"Minhocal"},{"level":3,"code":90312,"name":"Prados"},{"level":3,"code":90314,"name":"Ratoeira"},{"level":3,"code":90318,"name":"Vale de Azares"},{"level":3,"code":90322,"name":"Casas do Soeiro"},{"level":3,"code":90323,"name":"União das freguesias de Açores e Velosa"},{"level":3,"code":90324,"name":"União das freguesias de Celorico (São Pedro e Santa Maria) e Vila Boa do Mondego"},{"level":3,"code":90325,"name":"União das freguesias de Cortiçô da Serra, Vide entre Vinhas e Salgueirais"},{"level":3,"code":90326,"name":"União das freguesias de Rapa e Cadafaz"},{"level":2,"code":904,"name":"Figueira de Castelo Rodrigo"},{"level":3,"code":90403,"name":"Castelo Rodrigo"},{"level":3,"code":90406,"name":"Escalhão"},{"level":3,"code":90408,"name":"Figueira de Castelo Rodrigo"},{"level":3,"code":90410,"name":"Mata de Lobos"},{"level":3,"code":90415,"name":"Vermiosa"},{"level":3,"code":90418,"name":"União das freguesias de Algodres, Vale de Afonsinho e Vilar de Amargo"},{"level":3,"code":90419,"name":"União das freguesias de Almofala e Escarigo"},{"level":3,"code":90420,"name":"União das freguesias de Cinco Vilas e Reigada"},{"level":3,"code":90421,"name":"União das freguesias de Freixeda do Torrão, Quintã de Pêro Martins e Penha de Águia"},{"level":3,"code":90422,"name":"União das freguesias do Colmeal e Vilar Torpim"},{"level":2,"code":905,"name":"Fornos de Algodres"},{"level":3,"code":90501,"name":"Algodres"},{"level":3,"code":90502,"name":"Casal Vasco"},{"level":3,"code":90504,"name":"Figueiró da Granja"},{"level":3,"code":90505,"name":"Fornos de Algodres"},{"level":3,"code":90507,"name":"Infias"},{"level":3,"code":90509,"name":"Maceira"},{"level":3,"code":90510,"name":"Matança"},{"level":3,"code":90511,"name":"Muxagata"},{"level":3,"code":90512,"name":"Queiriz"},{"level":3,"code":90517,"name":"União das freguesias de Cortiçô e Vila Chã"},{"level":3,"code":90518,"name":"União das freguesias de Juncais, Vila Ruiva e Vila Soeiro do Chão"},{"level":3,"code":90519,"name":"União das freguesias de Sobral Pichorro e Fuinhas"},{"level":2,"code":906,"name":"Gouveia"},{"level":3,"code":90602,"name":"Arcozelo"},{"level":3,"code":90603,"name":"Cativelos"},{"level":3,"code":90605,"name":"Folgosinho"},{"level":3,"code":90612,"name":"Nespereira"},{"level":3,"code":90613,"name":"Paços da Serra"},{"level":3,"code":90614,"name":"Ribamondego"},{"level":3,"code":90617,"name":"São Paio"},{"level":3,"code":90619,"name":"Vila Cortês da Serra"},{"level":3,"code":90620,"name":"Vila Franca da Serra"},{"level":3,"code":90621,"name":"Vila Nova de Tazem"},{"level":3,"code":90623,"name":"União das freguesias de Aldeias e Mangualde da Serra"},{"level":3,"code":90624,"name":"União das freguesias de Figueiró da Serra e Freixo da Serra"},{"level":3,"code":90625,"name":"Gouveia"},{"level":3,"code":90626,"name":"União das freguesias de Melo e Nabais"},{"level":3,"code":90627,"name":"União das freguesias de Moimenta da Serra e Vinhó"},{"level":3,"code":90628,"name":"União das freguesias de Rio Torto e Lagarinhos"},{"level":2,"code":907,"name":"Guarda"},{"level":3,"code":90703,"name":"Aldeia do Bispo"},{"level":3,"code":90704,"name":"Aldeia Viçosa"},{"level":3,"code":90705,"name":"Alvendre"},{"level":3,"code":90706,"name":"Arrifana"},{"level":3,"code":90708,"name":"Avelãs da Ribeira"},{"level":3,"code":90709,"name":"Benespera"},{"level":3,"code":90711,"name":"Casal de Cinza"},{"level":3,"code":90712,"name":"Castanheira"},{"level":3,"code":90713,"name":"Cavadoude"},{"level":3,"code":90714,"name":"Codesseiro"},{"level":3,"code":90716,"name":"Faia"},{"level":3,"code":90717,"name":"Famalicão"},{"level":3,"code":90718,"name":"Fernão Joanes"},{"level":3,"code":90721,"name":"Gonçalo Bocas"},{"level":3,"code":90722,"name":"João Antão"},{"level":3,"code":90723,"name":"Maçainhas"},{"level":3,"code":90724,"name":"Marmeleiro"},{"level":3,"code":90725,"name":"Meios"},{"level":3,"code":90728,"name":"Panoias de Cima"},{"level":3,"code":90729,"name":"Pega"},{"level":3,"code":90730,"name":"Pêra do Moço"},{"level":3,"code":90732,"name":"Porto da Carne"},{"level":3,"code":90734,"name":"Ramela"},{"level":3,"code":90738,"name":"Santana da Azinha"},{"level":3,"code":90744,"name":"Sobral da Serra"},{"level":3,"code":90746,"name":"Vale de Estrela"},{"level":3,"code":90747,"name":"Valhelhas"},{"level":3,"code":90748,"name":"Vela"},{"level":3,"code":90749,"name":"Videmonte"},{"level":3,"code":90750,"name":"Vila Cortês do Mondego"},{"level":3,"code":90751,"name":"Vila Fernando"},{"level":3,"code":90752,"name":"Vila Franca do Deão"},{"level":3,"code":90753,"name":"Vila Garcia"},{"level":3,"code":90757,"name":"Gonçalo"},{"level":3,"code":90758,"name":"Guarda"},{"level":3,"code":90759,"name":"Jarmelo São Miguel"},{"level":3,"code":90760,"name":"Jarmelo São Pedro"},{"level":3,"code":90761,"name":"União de freguesias de Avelãs de Ambom e Rocamondo"},{"level":3,"code":90762,"name":"União de freguesias de Corujeira e Trinta"},{"level":3,"code":90763,"name":"União de freguesias de Mizarela, Pêro Soares e Vila Soeiro"},{"level":3,"code":90764,"name":"União de freguesias de Pousade e Albardo"},{"level":3,"code":90765,"name":"União de freguesias de Rochoso e Monte Margarida"},{"level":3,"code":90766,"name":"Adão"},{"level":2,"code":908,"name":"Manteigas"},{"level":3,"code":90801,"name":"Sameiro"},{"level":3,"code":90802,"name":"Manteigas (Santa Maria)"},{"level":3,"code":90803,"name":"Manteigas (São Pedro)"},{"level":3,"code":90804,"name":"Vale de Amoreira"},{"level":2,"code":909,"name":"Mêda"},{"level":3,"code":90901,"name":"Aveloso"},{"level":3,"code":90902,"name":"Barreira"},{"level":3,"code":90905,"name":"Coriscada"},{"level":3,"code":90907,"name":"Longroiva"},{"level":3,"code":90908,"name":"Marialva"},{"level":3,"code":90912,"name":"Poço do Canto"},{"level":3,"code":90914,"name":"Rabaçal"},{"level":3,"code":90915,"name":"Ranhados"},{"level":3,"code":90917,"name":"Mêda, Outeiro de Gatos e Fonte Longa"},{"level":3,"code":90918,"name":"Prova e Casteição"},{"level":3,"code":90919,"name":"União das freguesias de Vale Flor, Carvalhal e Pai Penela"},{"level":2,"code":910,"name":"Pinhel"},{"level":3,"code":91009,"name":"Ervedosa"},{"level":3,"code":91010,"name":"Freixedas"},{"level":3,"code":91012,"name":"Lamegal"},{"level":3,"code":91013,"name":"Lameiras"},{"level":3,"code":91014,"name":"Manigoto"},{"level":3,"code":91015,"name":"Pala"},{"level":3,"code":91017,"name":"Pinhel"},{"level":3,"code":91018,"name":"Pínzio"},{"level":3,"code":91024,"name":"Souro Pires"},{"level":3,"code":91027,"name":"Vascoveiro"},{"level":3,"code":91028,"name":"Agregação das freguesias Sul de Pinhel"},{"level":3,"code":91032,"name":"Alto do Palurdo"},{"level":3,"code":91029,"name":"Alverca da Beira/Bouça Cova"},{"level":3,"code":91030,"name":"Terras de Massueime"},{"level":3,"code":91035,"name":"União das freguesias de Atalaia e Safurdão"},{"level":3,"code":91031,"name":"Valbom/Bogalhal"},{"level":3,"code":91033,"name":"Vale do Côa"},{"level":3,"code":91034,"name":"Vale do Massueime"},{"level":2,"code":911,"name":"Sabugal"},{"level":3,"code":91101,"name":"Águas Belas"},{"level":3,"code":91102,"name":"Aldeia do Bispo"},{"level":3,"code":91103,"name":"Aldeia da Ponte"},{"level":3,"code":91106,"name":"Aldeia Velha"},{"level":3,"code":91107,"name":"Alfaiates"},{"level":3,"code":91109,"name":"Baraçal"},{"level":3,"code":91110,"name":"Bendada"},{"level":3,"code":91111,"name":"Bismula"},{"level":3,"code":91112,"name":"Casteleiro"},{"level":3,"code":91113,"name":"Cerdeira"},{"level":3,"code":91114,"name":"Fóios"},{"level":3,"code":91118,"name":"Malcata"},{"level":3,"code":91120,"name":"Nave"},{"level":3,"code":91123,"name":"Quadrazais"},{"level":3,"code":91124,"name":"Quintas de São Bartolomeu"},{"level":3,"code":91125,"name":"Rapoula do Côa"},{"level":3,"code":91126,"name":"Rebolosa"},{"level":3,"code":91127,"name":"Rendo"},{"level":3,"code":91133,"name":"Sortelha"},{"level":3,"code":91134,"name":"Souto"},{"level":3,"code":91136,"name":"Vale de Espinho"},{"level":3,"code":91138,"name":"Vila Boa"},{"level":3,"code":91139,"name":"Vila do Touro"},{"level":3,"code":91141,"name":"União das freguesias de Aldeia da Ribeira, Vilar Maior e Badamalos"},{"level":3,"code":91142,"name":"União das freguesias de Lajeosa e Forcalhos"},{"level":3,"code":91143,"name":"União das freguesias de Pousafoles do Bispo, Pena Lobo e Lomba"},{"level":3,"code":91144,"name":"União das freguesias de Ruvina, Ruivós e Vale das Éguas"},{"level":3,"code":91145,"name":"União das freguesias do Sabugal e Aldeia de Santo António"},{"level":3,"code":91146,"name":"União das freguesias de Santo Estêvão e Moita"},{"level":3,"code":91147,"name":"União das freguesias de Seixo do Côa e Vale Longo"},{"level":2,"code":912,"name":"Seia"},{"level":3,"code":91201,"name":"Alvoco da Serra"},{"level":3,"code":91205,"name":"Girabolhos"},{"level":3,"code":91207,"name":"Loriga"},{"level":3,"code":91208,"name":"Paranhos"},{"level":3,"code":91209,"name":"Pinhanços"},{"level":3,"code":91210,"name":"Sabugueiro"},{"level":3,"code":91212,"name":"Sandomil"},{"level":3,"code":91213,"name":"Santa Comba"},{"level":3,"code":91216,"name":"Santiago"},{"level":3,"code":91219,"name":"Sazes da Beira"},{"level":3,"code":91221,"name":"Teixeira"},{"level":3,"code":91224,"name":"Travancinha"},{"level":3,"code":91225,"name":"Valezim"},{"level":3,"code":91228,"name":"Vila Cova à Coelheira"},{"level":3,"code":91230,"name":"União das freguesias de Carragozela e Várzea de Meruge"},{"level":3,"code":91231,"name":"União das freguesias de Sameice e Santa Eulália"},{"level":3,"code":91232,"name":"União das freguesias de Santa Marinha e São Martinho"},{"level":3,"code":91233,"name":"União das freguesias de Seia, São Romão e Lapa dos Dinheiros"},{"level":3,"code":91234,"name":"União das freguesias de Torrozelo e Folhadosa"},{"level":3,"code":91235,"name":"União das freguesias de Tourais e Lajes"},{"level":3,"code":91236,"name":"União das freguesias de Vide e Cabeça"},{"level":2,"code":913,"name":"Trancoso"},{"level":3,"code":91301,"name":"Aldeia Nova"},{"level":3,"code":91303,"name":"Castanheira"},{"level":3,"code":91304,"name":"Cogula"},{"level":3,"code":91305,"name":"Cótimos"},{"level":3,"code":91307,"name":"Fiães"},{"level":3,"code":91309,"name":"Granja"},{"level":3,"code":91310,"name":"Guilheiro"},{"level":3,"code":91311,"name":"Moimentinha"},{"level":3,"code":91312,"name":"Moreira de Rei"},{"level":3,"code":91313,"name":"Palhais"},{"level":3,"code":91314,"name":"Póvoa do Concelho"},{"level":3,"code":91315,"name":"Reboleiro"},{"level":3,"code":91316,"name":"Rio de Mel"},{"level":3,"code":91321,"name":"Tamanhos"},{"level":3,"code":91325,"name":"Valdujo"},{"level":3,"code":91330,"name":"União das freguesias de Freches e Torres"},{"level":3,"code":91331,"name":"União das freguesias de Torre do Terrenho, Sebadelhe da Serra e Terrenho"},{"level":3,"code":91332,"name":"União das freguesias de Trancoso (São Pedro e Santa Maria) e Souto Maior"},{"level":3,"code":91333,"name":"União das freguesias de Vale do Seixo e Vila Garcia"},{"level":3,"code":91334,"name":"União das freguesias de Vila Franca das Naves e Feital"},{"level":3,"code":91335,"name":"União das freguesias de Vilares e Carnicães"},{"level":2,"code":914,"name":"Vila Nova de Foz Côa"},{"level":3,"code":91401,"name":"Almendra"},{"level":3,"code":91402,"name":"Castelo Melhor"},{"level":3,"code":91403,"name":"Cedovim"},{"level":3,"code":91404,"name":"Chãs"},{"level":3,"code":91405,"name":"Custóias"},{"level":3,"code":91407,"name":"Horta"},{"level":3,"code":91410,"name":"Muxagata"},{"level":3,"code":91411,"name":"Numão"},{"level":3,"code":91412,"name":"Santa Comba"},{"level":3,"code":91414,"name":"Sebadelhe"},{"level":3,"code":91415,"name":"Seixas"},{"level":3,"code":91416,"name":"Touça"},{"level":3,"code":91418,"name":"Freixo de Numão"},{"level":3,"code":91419,"name":"Vila Nova de Foz Côa"},{"level":1,"code":10,"name":"Leiria"},{"level":2,"code":1001,"name":"Alcobaça"},{"level":3,"code":100102,"name":"Alfeizerão"},{"level":3,"code":100104,"name":"Bárrio"},{"level":3,"code":100105,"name":"Benedita"},{"level":3,"code":100106,"name":"Cela"},{"level":3,"code":100108,"name":"Évora de Alcobaça"},{"level":3,"code":100109,"name":"Maiorga"},{"level":3,"code":100112,"name":"São Martinho do Porto"},{"level":3,"code":100114,"name":"Turquel"},{"level":3,"code":100116,"name":"Vimeiro"},{"level":3,"code":100120,"name":"Aljubarrota"},{"level":3,"code":100121,"name":"União das freguesias de Alcobaça e Vestiaria"},{"level":3,"code":100122,"name":"União das freguesias de Coz, Alpedriz e Montes"},{"level":3,"code":100123,"name":"União das freguesias de Pataias e Martingança"},{"level":2,"code":1002,"name":"Alvaiázere"},{"level":3,"code":100201,"name":"Almoster"},{"level":3,"code":100204,"name":"Maçãs de Dona Maria"},{"level":3,"code":100205,"name":"Pelmá"},{"level":3,"code":100208,"name":"Alvaiázere"},{"level":3,"code":100209,"name":"Pussos São Pedro"},{"level":2,"code":1003,"name":"Ansião"},{"level":3,"code":100301,"name":"Alvorge"},{"level":3,"code":100303,"name":"Avelar"},{"level":3,"code":100304,"name":"Chão de Couce"},{"level":3,"code":100306,"name":"Pousaflores"},{"level":3,"code":100307,"name":"Santiago da Guarda"},{"level":3,"code":100309,"name":"Ansião"},{"level":2,"code":1004,"name":"Batalha"},{"level":3,"code":100401,"name":"Batalha"},{"level":3,"code":100402,"name":"Reguengo do Fetal"},{"level":3,"code":100403,"name":"São Mamede"},{"level":3,"code":100404,"name":"Golpilheira"},{"level":2,"code":1005,"name":"Bombarral"},{"level":3,"code":100502,"name":"Carvalhal"},{"level":3,"code":100503,"name":"Roliça"},{"level":3,"code":100505,"name":"Pó"},{"level":3,"code":100506,"name":"União das freguesias do Bombarral e Vale Covo"},{"level":2,"code":1006,"name":"Caldas da Rainha"},{"level":3,"code":100601,"name":"A dos Francos"},{"level":3,"code":100602,"name":"Alvorninha"},{"level":3,"code":100604,"name":"Carvalhal Benfeito"},{"level":3,"code":100606,"name":"Foz do Arelho"},{"level":3,"code":100607,"name":"Landal"},{"level":3,"code":100608,"name":"Nadadouro"},{"level":3,"code":100609,"name":"Salir de Matos"},{"level":3,"code":100611,"name":"Santa Catarina"},{"level":3,"code":100615,"name":"Vidais"},{"level":3,"code":100617,"name":"União das freguesias de Caldas da Rainha - Nossa Senhora do Pópulo, Coto e São Gregório"},{"level":3,"code":100618,"name":"União das freguesias de Caldas da Rainha - Santo Onofre e Serra do Bouro"},{"level":3,"code":100619,"name":"União das freguesias de Tornada e Salir do Porto"},{"level":2,"code":1007,"name":"Castanheira de Pêra"},{"level":3,"code":100703,"name":"União das freguesias de Castanheira de Pêra e Coentral"},{"level":2,"code":1008,"name":"Figueiró dos Vinhos"},{"level":3,"code":100801,"name":"Aguda"},{"level":3,"code":100802,"name":"Arega"},{"level":3,"code":100803,"name":"Campelo"},{"level":3,"code":100806,"name":"União das freguesias de Figueiró dos Vinhos e Bairradas"},{"level":2,"code":1009,"name":"Leiria"},{"level":3,"code":100901,"name":"Amor"},{"level":3,"code":100902,"name":"Arrabal"},{"level":3,"code":100907,"name":"Caranguejeira"},{"level":3,"code":100909,"name":"Coimbrão"},{"level":3,"code":100913,"name":"Maceira"},{"level":3,"code":100915,"name":"Milagres"},{"level":3,"code":100921,"name":"Regueira de Pontes"},{"level":3,"code":100925,"name":"Bajouca"},{"level":3,"code":100926,"name":"Bidoeira de Cima"},{"level":3,"code":100932,"name":"União das freguesias de Colmeias e Memória"},{"level":3,"code":100933,"name":"União das freguesias de Leiria, Pousos, Barreira e Cortes"},{"level":3,"code":100934,"name":"União das freguesias de Marrazes e Barosa"},{"level":3,"code":100935,"name":"União das freguesias de Monte Real e Carvide"},{"level":3,"code":100936,"name":"União das freguesias de Monte Redondo e Carreira"},{"level":3,"code":100937,"name":"União das freguesias de Parceiros e Azoia"},{"level":3,"code":100938,"name":"União das freguesias de Santa Catarina da Serra e Chainça"},{"level":3,"code":100939,"name":"União das freguesias de Santa Eufémia e Boa Vista"},{"level":3,"code":100940,"name":"União das freguesias de Souto da Carpalhosa e Ortigosa"},{"level":2,"code":1010,"name":"Marinha Grande"},{"level":3,"code":101001,"name":"Marinha Grande"},{"level":3,"code":101002,"name":"Vieira de Leiria"},{"level":3,"code":101003,"name":"Moita"},{"level":2,"code":1011,"name":"Nazaré"},{"level":3,"code":101101,"name":"Famalicão"},{"level":3,"code":101102,"name":"Nazaré"},{"level":3,"code":101103,"name":"Valado dos Frades"},{"level":2,"code":1012,"name":"Óbidos"},{"level":3,"code":101201,"name":"A dos Negros"},{"level":3,"code":101202,"name":"Amoreira"},{"level":3,"code":101203,"name":"Olho Marinho"},{"level":3,"code":101207,"name":"Vau"},{"level":3,"code":101208,"name":"Gaeiras"},{"level":3,"code":101209,"name":"Usseira"},{"level":3,"code":101210,"name":"Santa Maria, São Pedro e Sobral da Lagoa"},{"level":2,"code":1013,"name":"Pedrógão Grande"},{"level":3,"code":101301,"name":"Graça"},{"level":3,"code":101302,"name":"Pedrógão Grande"},{"level":3,"code":101303,"name":"Vila Facaia"},{"level":2,"code":1014,"name":"Peniche"},{"level":3,"code":101402,"name":"Atouguia da Baleia"},{"level":3,"code":101405,"name":"Serra d'El-Rei"},{"level":3,"code":101406,"name":"Ferrel"},{"level":3,"code":101407,"name":"Peniche"},{"level":2,"code":1015,"name":"Pombal"},{"level":3,"code":101501,"name":"Abiul"},{"level":3,"code":101503,"name":"Almagreira"},{"level":3,"code":101504,"name":"Carnide"},{"level":3,"code":101505,"name":"Carriço"},{"level":3,"code":101506,"name":"Louriçal"},{"level":3,"code":101508,"name":"Pelariga"},{"level":3,"code":101509,"name":"Pombal"},{"level":3,"code":101510,"name":"Redinha"},{"level":3,"code":101513,"name":"Vermoil"},{"level":3,"code":101514,"name":"Vila Cã"},{"level":3,"code":101515,"name":"Meirinhas"},{"level":3,"code":101518,"name":"União das freguesias de Guia, Ilha e Mata Mourisca"},{"level":3,"code":101519,"name":"União das freguesias de Santiago e São Simão de Litém e Albergaria dos Doze"},{"level":2,"code":1016,"name":"Porto de Mós"},{"level":3,"code":101602,"name":"Alqueidão da Serra"},{"level":3,"code":101605,"name":"Calvaria de Cima"},{"level":3,"code":101606,"name":"Juncal"},{"level":3,"code":101608,"name":"Mira de Aire"},{"level":3,"code":101609,"name":"Pedreiras"},{"level":3,"code":101610,"name":"São Bento"},{"level":3,"code":101613,"name":"Serro Ventoso"},{"level":3,"code":101614,"name":"Porto de Mós - São João Baptista e São Pedro"},{"level":3,"code":101615,"name":"União das freguesias de Alvados e Alcaria"},{"level":3,"code":101616,"name":"União das freguesias de Arrimal e Mendiga"},{"level":1,"code":11,"name":"Lisboa"},{"level":2,"code":1101,"name":"Alenquer"},{"level":3,"code":110106,"name":"Carnota"},{"level":3,"code":110107,"name":"Meca"},{"level":3,"code":110108,"name":"Olhalvo"},{"level":3,"code":110109,"name":"Ota"},{"level":3,"code":110113,"name":"Ventosa"},{"level":3,"code":110114,"name":"Vila Verde dos Francos"},{"level":3,"code":110117,"name":"União das freguesias de Abrigada e Cabanas de Torres"},{"level":3,"code":110118,"name":"União das freguesias de Aldeia Galega da Merceana e Aldeia Gavinha"},{"level":3,"code":110119,"name":"União das freguesias de Alenquer (Santo Estêvão e Triana)"},{"level":3,"code":110120,"name":"União das freguesias de Carregado e Cadafais"},{"level":3,"code":110121,"name":"União das freguesias de Ribafria e Pereiro de Palhacana"},{"level":2,"code":1102,"name":"Arruda dos Vinhos"},{"level":3,"code":110201,"name":"Arranhó"},{"level":3,"code":110202,"name":"Arruda dos Vinhos"},{"level":3,"code":110203,"name":"Cardosas"},{"level":3,"code":110204,"name":"Santiago dos Velhos"},{"level":2,"code":1103,"name":"Azambuja"},{"level":3,"code":110301,"name":"Alcoentre"},{"level":3,"code":110302,"name":"Aveiras de Baixo"},{"level":3,"code":110303,"name":"Aveiras de Cima"},{"level":3,"code":110304,"name":"Azambuja"},{"level":3,"code":110306,"name":"Vale do Paraíso"},{"level":3,"code":110307,"name":"Vila Nova da Rainha"},{"level":3,"code":110310,"name":"União das freguesias de Manique do Intendente, Vila Nova de São Pedro e Maçussa"},{"level":2,"code":1104,"name":"Cadaval"},{"level":3,"code":110401,"name":"Alguber"},{"level":3,"code":110407,"name":"Peral"},{"level":3,"code":110409,"name":"Vermelha"},{"level":3,"code":110410,"name":"Vilar"},{"level":3,"code":110411,"name":"União das freguesias do Cadaval e Pêro Moniz"},{"level":3,"code":110412,"name":"União das freguesias de Lamas e Cercal"},{"level":3,"code":110413,"name":"União das freguesias de Painho e Figueiros"},{"level":2,"code":1105,"name":"Cascais"},{"level":3,"code":110501,"name":"Alcabideche"},{"level":3,"code":110506,"name":"São Domingos de Rana"},{"level":3,"code":110507,"name":"União das freguesias de Carcavelos e Parede"},{"level":3,"code":110508,"name":"União das freguesias de Cascais e Estoril"},{"level":2,"code":1106,"name":"Lisboa"},{"level":3,"code":110601,"name":"Ajuda"},{"level":3,"code":110602,"name":"Alcântara"},{"level":3,"code":110607,"name":"Beato"},{"level":3,"code":110608,"name":"Benfica"},{"level":3,"code":110610,"name":"Campolide"},{"level":3,"code":110611,"name":"Carnide"},{"level":3,"code":110618,"name":"Lumiar"},{"level":3,"code":110621,"name":"Marvila"},{"level":3,"code":110633,"name":"Olivais"},{"level":3,"code":110639,"name":"São Domingos de Benfica"},{"level":3,"code":110654,"name":"Alvalade"},{"level":3,"code":110655,"name":"Areeiro"},{"level":3,"code":110656,"name":"Arroios"},{"level":3,"code":110657,"name":"Avenidas Novas"},{"level":3,"code":110658,"name":"Belém"},{"level":3,"code":110659,"name":"Campo de Ourique"},{"level":3,"code":110660,"name":"Estrela"},{"level":3,"code":110661,"name":"Misericórdia"},{"level":3,"code":110662,"name":"Parque das Nações"},{"level":3,"code":110663,"name":"Penha de França"},{"level":3,"code":110664,"name":"Santa Clara"},{"level":3,"code":110665,"name":"Santa Maria Maior"},{"level":3,"code":110666,"name":"Santo António"},{"level":3,"code":110667,"name":"São Vicente"},{"level":2,"code":1107,"name":"Loures"},{"level":3,"code":110702,"name":"Bucelas"},{"level":3,"code":110705,"name":"Fanhões"},{"level":3,"code":110707,"name":"Loures"},{"level":3,"code":110708,"name":"Lousa"},{"level":3,"code":110726,"name":"União das freguesias de Moscavide e Portela"},{"level":3,"code":110727,"name":"União das freguesias de Sacavém e Prior Velho"},{"level":3,"code":110728,"name":"União das freguesias de Santa Iria de Azoia, São João da Talha e Bobadela"},{"level":3,"code":110729,"name":"União das freguesias de Santo Antão e São Julião do Tojal"},{"level":3,"code":110730,"name":"União das freguesias de Santo António dos Cavaleiros e Frielas"},{"level":3,"code":110731,"name":"União das freguesias de Camarate, Unhos e Apelação"},{"level":2,"code":1108,"name":"Lourinhã"},{"level":3,"code":110803,"name":"Moita dos Ferreiros"},{"level":3,"code":110805,"name":"Reguengo Grande"},{"level":3,"code":110806,"name":"Santa Bárbara"},{"level":3,"code":110808,"name":"Vimeiro"},{"level":3,"code":110810,"name":"Ribamar"},{"level":3,"code":110812,"name":"União das freguesias de Lourinhã e Atalaia"},{"level":3,"code":110813,"name":"União das freguesias de Miragaia e Marteleira"},{"level":3,"code":110814,"name":"União das freguesias de São Bartolomeu dos Galegos e Moledo"},{"level":2,"code":1109,"name":"Mafra"},{"level":3,"code":110902,"name":"Carvoeira"},{"level":3,"code":110904,"name":"Encarnação"},{"level":3,"code":110906,"name":"Ericeira"},{"level":3,"code":110909,"name":"Mafra"},{"level":3,"code":110911,"name":"Milharado"},{"level":3,"code":110913,"name":"Santo Isidoro"},{"level":3,"code":110918,"name":"União das freguesias de Azueira e Sobral da Abelheira"},{"level":3,"code":110919,"name":"União das freguesias de Enxara do Bispo, Gradil e Vila Franca do Rosário"},{"level":3,"code":110920,"name":"União das freguesias de Igreja Nova e Cheleiros"},{"level":3,"code":110921,"name":"União das freguesias de Malveira e São Miguel de Alcainça"},{"level":3,"code":110922,"name":"União das freguesias de Venda do Pinheiro e Santo Estêvão das Galés"},{"level":2,"code":1110,"name":"Oeiras"},{"level":3,"code":111002,"name":"Barcarena"},{"level":3,"code":111009,"name":"Porto Salvo"},{"level":3,"code":111012,"name":"União das freguesias de Algés, Linda-a-Velha e Cruz Quebrada-Dafundo"},{"level":3,"code":111013,"name":"União das freguesias de Carnaxide e Queijas"},{"level":3,"code":111014,"name":"União das freguesias de Oeiras e São Julião da Barra, Paço de Arcos e Caxias"},{"level":2,"code":1111,"name":"Sintra"},{"level":3,"code":111102,"name":"Algueirão-Mem Martins"},{"level":3,"code":111105,"name":"Colares"},{"level":3,"code":111108,"name":"Rio de Mouro"},{"level":3,"code":111115,"name":"Casal de Cambra"},{"level":3,"code":111122,"name":"União das freguesias de Agualva e Mira-Sintra"},{"level":3,"code":111123,"name":"União das freguesias de Almargem do Bispo, Pêro Pinheiro e Montelavar"},{"level":3,"code":111124,"name":"União das freguesias do Cacém e São Marcos"},{"level":3,"code":111125,"name":"União das freguesias de Massamá e Monte Abraão"},{"level":3,"code":111126,"name":"União das freguesias de Queluz e Belas"},{"level":3,"code":111127,"name":"União das freguesias de São João das Lampas e Terrugem"},{"level":3,"code":111128,"name":"União das freguesias de Sintra (Santa Maria e São Miguel, São Martinho e São Pedro de Penaferrim)"},{"level":2,"code":1112,"name":"Sobral de Monte Agraço"},{"level":3,"code":111201,"name":"Santo Quintino"},{"level":3,"code":111202,"name":"Sapataria"},{"level":3,"code":111203,"name":"Sobral de Monte Agraço"},{"level":2,"code":1113,"name":"Torres Vedras"},{"level":3,"code":111306,"name":"Freiria"},{"level":3,"code":111310,"name":"Ponte do Rol"},{"level":3,"code":111311,"name":"Ramalhal"},{"level":3,"code":111314,"name":"São Pedro da Cadeira"},{"level":3,"code":111316,"name":"Silveira"},{"level":3,"code":111317,"name":"Turcifal"},{"level":3,"code":111318,"name":"Ventosa"},{"level":3,"code":111321,"name":"União das freguesias de A dos Cunhados e Maceira"},{"level":3,"code":111322,"name":"União das freguesias de Campelos e Outeiro da Cabeça"},{"level":3,"code":111323,"name":"União das freguesias de Carvoeira e Carmões"},{"level":3,"code":111324,"name":"União das freguesias de Dois Portos e Runa"},{"level":3,"code":111325,"name":"União das freguesias de Maxial e Monte Redondo"},{"level":3,"code":111326,"name":"Santa Maria, São Pedro e Matacães"},{"level":2,"code":1114,"name":"Vila Franca de Xira"},{"level":3,"code":111408,"name":"Vialonga"},{"level":3,"code":111409,"name":"Vila Franca de Xira"},{"level":3,"code":111412,"name":"União das freguesias de Alhandra, São João dos Montes e Calhandriz"},{"level":3,"code":111413,"name":"União das freguesias de Alverca do Ribatejo e Sobralinho"},{"level":3,"code":111414,"name":"União das freguesias de Castanheira do Ribatejo e Cachoeiras"},{"level":3,"code":111415,"name":"União das freguesias de Póvoa de Santa Iria e Forte da Casa"},{"level":2,"code":1115,"name":"Amadora"},{"level":3,"code":111512,"name":"Alfragide"},{"level":3,"code":111513,"name":"Águas Livres"},{"level":3,"code":111514,"name":"Encosta do Sol"},{"level":3,"code":111515,"name":"Falagueira-Venda Nova"},{"level":3,"code":111516,"name":"Mina de Água"},{"level":3,"code":111517,"name":"Venteira"},{"level":2,"code":1116,"name":"Odivelas"},{"level":3,"code":111603,"name":"Odivelas"},{"level":3,"code":111608,"name":"União das freguesias de Pontinha e Famões"},{"level":3,"code":111609,"name":"União das freguesias de Póvoa de Santo Adrião e Olival Basto"},{"level":3,"code":111610,"name":"União das freguesias de Ramada e Caneças"},{"level":1,"code":12,"name":"Portalegre"},{"level":2,"code":1201,"name":"Alter do Chão"},{"level":3,"code":120101,"name":"Alter do Chão"},{"level":3,"code":120102,"name":"Chancelaria"},{"level":3,"code":120103,"name":"Seda"},{"level":3,"code":120104,"name":"Cunheira"},{"level":2,"code":1202,"name":"Arronches"},{"level":3,"code":120201,"name":"Assunção"},{"level":3,"code":120202,"name":"Esperança"},{"level":3,"code":120203,"name":"Mosteiros"},{"level":2,"code":1203,"name":"Avis"},{"level":3,"code":120302,"name":"Aldeia Velha"},{"level":3,"code":120303,"name":"Avis"},{"level":3,"code":120305,"name":"Ervedal"},{"level":3,"code":120306,"name":"Figueira e Barros"},{"level":3,"code":120309,"name":"União das freguesias de Alcórrego e Maranhão"},{"level":3,"code":120310,"name":"União das freguesias de Benavila e Valongo"},{"level":2,"code":1204,"name":"Campo Maior"},{"level":3,"code":120401,"name":"Nossa Senhora da Expectação"},{"level":3,"code":120402,"name":"Nossa Senhora da Graça dos Degolados"},{"level":3,"code":120403,"name":"São João Baptista"},{"level":2,"code":1205,"name":"Castelo de Vide"},{"level":3,"code":120501,"name":"Nossa Senhora da Graça de Póvoa e Meadas"},{"level":3,"code":120502,"name":"Santa Maria da Devesa"},{"level":3,"code":120503,"name":"Santiago Maior"},{"level":3,"code":120504,"name":"São João Baptista"},{"level":2,"code":1206,"name":"Crato"},{"level":3,"code":120601,"name":"Aldeia da Mata"},{"level":3,"code":120604,"name":"Gáfete"},{"level":3,"code":120605,"name":"Monte da Pedra"},{"level":3,"code":120607,"name":"União das freguesias de Crato e Mártires, Flor da Rosa e Vale do Peso"},{"level":2,"code":1207,"name":"Elvas"},{"level":3,"code":120706,"name":"Santa Eulália"},{"level":3,"code":120707,"name":"São Brás e São Lourenço"},{"level":3,"code":120708,"name":"São Vicente e Ventosa"},{"level":3,"code":120712,"name":"Assunção, Ajuda, Salvador e Santo Ildefonso"},{"level":3,"code":120713,"name":"Caia, São Pedro e Alcáçova"},{"level":3,"code":120714,"name":"União das freguesias de Barbacena e Vila Fernando"},{"level":3,"code":120715,"name":"União das freguesias de Terrugem e Vila Boim"},{"level":2,"code":1208,"name":"Fronteira"},{"level":3,"code":120801,"name":"Cabeço de Vide"},{"level":3,"code":120802,"name":"Fronteira"},{"level":3,"code":120803,"name":"São Saturnino"},{"level":2,"code":1209,"name":"Gavião"},{"level":3,"code":120902,"name":"Belver"},{"level":3,"code":120903,"name":"Comenda"},{"level":3,"code":120905,"name":"Margem"},{"level":3,"code":120906,"name":"União das freguesias de Gavião e Atalaia"},{"level":2,"code":1210,"name":"Marvão"},{"level":3,"code":121001,"name":"Beirã"},{"level":3,"code":121002,"name":"Santa Maria de Marvão"},{"level":3,"code":121003,"name":"Santo António das Areias"},{"level":3,"code":121004,"name":"São Salvador da Aramenha"},{"level":2,"code":1211,"name":"Monforte"},{"level":3,"code":121101,"name":"Assumar"},{"level":3,"code":121102,"name":"Monforte"},{"level":3,"code":121103,"name":"Santo Aleixo"},{"level":3,"code":121104,"name":"Vaiamonte"},{"level":2,"code":1212,"name":"Nisa"},{"level":3,"code":121201,"name":"Alpalhão"},{"level":3,"code":121205,"name":"Montalvão"},{"level":3,"code":121207,"name":"Santana"},{"level":3,"code":121208,"name":"São Matias"},{"level":3,"code":121210,"name":"Tolosa"},{"level":3,"code":121211,"name":"União das freguesias de Arez e Amieira do Tejo"},{"level":3,"code":121212,"name":"União das freguesias de Espírito Santo, Nossa Senhora da Graça e São Simão"},{"level":2,"code":1213,"name":"Ponte de Sor"},{"level":3,"code":121301,"name":"Galveias"},{"level":3,"code":121302,"name":"Montargil"},{"level":3,"code":121304,"name":"Foros de Arrão"},{"level":3,"code":121305,"name":"Longomel"},{"level":3,"code":121308,"name":"União das freguesias de Ponte de Sor, Tramaga e Vale de Açor"},{"level":2,"code":1214,"name":"Portalegre"},{"level":3,"code":121401,"name":"Alagoa"},{"level":3,"code":121402,"name":"Alegrete"},{"level":3,"code":121404,"name":"Fortios"},{"level":3,"code":121410,"name":"Urra"},{"level":3,"code":121411,"name":"União das freguesias da Sé e São Lourenço"},{"level":3,"code":121412,"name":"União das freguesias de Reguengo e São Julião"},{"level":3,"code":121413,"name":"União das freguesias de Ribeira de Nisa e Carreiras"},{"level":2,"code":1215,"name":"Sousel"},{"level":3,"code":121501,"name":"Cano"},{"level":3,"code":121502,"name":"Casa Branca"},{"level":3,"code":121503,"name":"Santo Amaro"},{"level":3,"code":121504,"name":"Sousel"},{"level":1,"code":13,"name":"Porto"},{"level":2,"code":1301,"name":"Amarante"},{"level":3,"code":130103,"name":"Ansiães"},{"level":3,"code":130107,"name":"Candemil"},{"level":3,"code":130112,"name":"Fregim"},{"level":3,"code":130115,"name":"Fridão"},{"level":3,"code":130117,"name":"Gondar"},{"level":3,"code":130118,"name":"Jazente"},{"level":3,"code":130119,"name":"Lomba"},{"level":3,"code":130120,"name":"Louredo"},{"level":3,"code":130121,"name":"Lufrei"},{"level":3,"code":130123,"name":"Mancelos"},{"level":3,"code":130126,"name":"Padronelo"},{"level":3,"code":130128,"name":"Rebordelo"},{"level":3,"code":130129,"name":"Salvador do Monte"},{"level":3,"code":130134,"name":"Gouveia (São Simão)"},{"level":3,"code":130135,"name":"Telões"},{"level":3,"code":130136,"name":"Travanca"},{"level":3,"code":130138,"name":"Vila Caiz"},{"level":3,"code":130139,"name":"Vila Chã do Marão"},{"level":3,"code":130141,"name":"União das freguesias de Aboadela, Sanche e Várzea"},{"level":3,"code":130142,"name":"União das freguesias de Amarante (São Gonçalo), Madalena, Cepelos e Gatão"},{"level":3,"code":130143,"name":"União das freguesias de Bustelo, Carneiro e Carvalho de Rei"},{"level":3,"code":130144,"name":"União das freguesias de Figueiró (Santiago e Santa Cristina)"},{"level":3,"code":130145,"name":"União das freguesias de Freixo de Cima e de Baixo"},{"level":3,"code":130146,"name":"União das freguesias de Olo e Canadelo"},{"level":3,"code":130147,"name":"Vila Meã"},{"level":3,"code":130148,"name":"União das freguesias de Vila Garcia, Aboim e Chapa"},{"level":2,"code":1302,"name":"Baião"},{"level":3,"code":130204,"name":"Frende"},{"level":3,"code":130205,"name":"Gestaçô"},{"level":3,"code":130206,"name":"Gove"},{"level":3,"code":130207,"name":"Grilo"},{"level":3,"code":130208,"name":"Loivos do Monte"},{"level":3,"code":130215,"name":"Santa Marinha do Zêzere"},{"level":3,"code":130219,"name":"Valadares"},{"level":3,"code":130220,"name":"Viariz"},{"level":3,"code":130221,"name":"União das freguesias de Ancede e Ribadouro"},{"level":3,"code":130222,"name":"União das freguesias de Baião (Santa Leocádia) e Mesquinhata"},{"level":3,"code":130223,"name":"União das freguesias de Campelo e Ovil"},{"level":3,"code":130224,"name":"União das freguesias de Loivos da Ribeira e Tresouras"},{"level":3,"code":130225,"name":"União das freguesias de Santa Cruz do Douro e São Tomé de Covelas"},{"level":3,"code":130226,"name":"União das freguesias de Teixeira e Teixeiró"},{"level":2,"code":1303,"name":"Felgueiras"},{"level":3,"code":130301,"name":"Aião"},{"level":3,"code":130302,"name":"Airães"},{"level":3,"code":130305,"name":"Friande"},{"level":3,"code":130306,"name":"Idães"},{"level":3,"code":130307,"name":"Jugueiros"},{"level":3,"code":130313,"name":"Penacova"},{"level":3,"code":130314,"name":"Pinheiro"},{"level":3,"code":130315,"name":"Pombeiro de Ribavizela"},{"level":3,"code":130317,"name":"Refontoura"},{"level":3,"code":130318,"name":"Regilde"},{"level":3,"code":130319,"name":"Revinhade"},{"level":3,"code":130324,"name":"Sendim"},{"level":3,"code":130334,"name":"União das freguesias de Macieira da Lixa e Caramos"},{"level":3,"code":130335,"name":"União das freguesias de Margaride (Santa Eulália), Várzea, Lagares, Varziela e Moure"},{"level":3,"code":130336,"name":"União das freguesias de Pedreira, Rande e Sernande"},{"level":3,"code":130337,"name":"União das freguesias de Torrados e Sousa"},{"level":3,"code":130338,"name":"União das freguesias de Unhão e Lordelo"},{"level":3,"code":130339,"name":"União das freguesias de Vila Cova da Lixa e Borba de Godim"},{"level":3,"code":130340,"name":"União das freguesias de Vila Fria e Vizela (São Jorge)"},{"level":3,"code":130341,"name":"União das freguesias de Vila Verde e Santão"},{"level":2,"code":1304,"name":"Gondomar"},{"level":3,"code":130405,"name":"Lomba"},{"level":3,"code":130408,"name":"Rio Tinto"},{"level":3,"code":130412,"name":"Baguim do Monte (Rio Tinto)"},{"level":3,"code":130413,"name":"União das freguesias de Fânzeres e São Pedro da Cova"},{"level":3,"code":130414,"name":"União das freguesias de Foz do Sousa e Covelo"},{"level":3,"code":130415,"name":"União das freguesias de Gondomar (São Cosme), Valbom e Jovim"},{"level":3,"code":130416,"name":"União das freguesias de Melres e Medas"},{"level":2,"code":1305,"name":"Lousada"},{"level":3,"code":130502,"name":"Aveleda"},{"level":3,"code":130504,"name":"Caíde de Rei"},{"level":3,"code":130510,"name":"Lodares"},{"level":3,"code":130512,"name":"Macieira"},{"level":3,"code":130513,"name":"Meinedo"},{"level":3,"code":130515,"name":"Nevogilde"},{"level":3,"code":130524,"name":"Sousela"},{"level":3,"code":130525,"name":"Torno"},{"level":3,"code":130526,"name":"Vilar do Torno e Alentém"},{"level":3,"code":130527,"name":"União das freguesias de Cernadelo e Lousada (São Miguel e Santa Margarida)"},{"level":3,"code":130528,"name":"União das freguesias de Cristelos, Boim e Ordem"},{"level":3,"code":130529,"name":"União das freguesias de Figueiras e Covas"},{"level":3,"code":130530,"name":"União das freguesias de Lustosa e Barrosas (Santo Estêvão)"},{"level":3,"code":130531,"name":"União das freguesias de Nespereira e Casais"},{"level":3,"code":130532,"name":"União das freguesias de Silvares, Pias, Nogueira e Alvarenga"},{"level":2,"code":1306,"name":"Maia"},{"level":3,"code":130601,"name":"Águas Santas"},{"level":3,"code":130603,"name":"Folgosa"},{"level":3,"code":130608,"name":"Milheirós"},{"level":3,"code":130609,"name":"Moreira"},{"level":3,"code":130613,"name":"São Pedro Fins"},{"level":3,"code":130616,"name":"Vila Nova da Telha"},{"level":3,"code":130617,"name":"Pedrouços"},{"level":3,"code":130618,"name":"Castêlo da Maia"},{"level":3,"code":130619,"name":"Cidade da Maia"},{"level":3,"code":130620,"name":"Nogueira e Silva Escura"},{"level":2,"code":1307,"name":"Marco de Canaveses"},{"level":3,"code":130704,"name":"Banho e Carvalhosa"},{"level":3,"code":130705,"name":"Constance"},{"level":3,"code":130722,"name":"Soalhães"},{"level":3,"code":130723,"name":"Sobretâmega"},{"level":3,"code":130724,"name":"Tabuado"},{"level":3,"code":130730,"name":"Vila Boa do Bispo"},{"level":3,"code":130732,"name":"Alpendorada, Várzea e Torrão"},{"level":3,"code":130733,"name":"Avessadas e Rosém"},{"level":3,"code":130734,"name":"Bem Viver"},{"level":3,"code":130735,"name":"Santo Isidoro e Livração"},{"level":3,"code":130736,"name":"Marco"},{"level":3,"code":130737,"name":"Paredes de Viadores e Manhuncelos"},{"level":3,"code":130738,"name":"Penhalonga e Paços de Gaiolo"},{"level":3,"code":130739,"name":"Sande e São Lourenço do Douro"},{"level":3,"code":130740,"name":"Várzea, Aliviada e Folhada"},{"level":3,"code":130741,"name":"Vila Boa de Quires e Maureles"},{"level":2,"code":1308,"name":"Matosinhos"},{"level":3,"code":130811,"name":"União das freguesias de Custóias, Leça do Balio e Guifões"},{"level":3,"code":130812,"name":"União das freguesias de Matosinhos e Leça da Palmeira"},{"level":3,"code":130813,"name":"União das freguesias de Perafita, Lavra e Santa Cruz do Bispo"},{"level":3,"code":130814,"name":"União das freguesias de São Mamede de Infesta e Senhora da Hora"},{"level":2,"code":1309,"name":"Paços de Ferreira"},{"level":3,"code":130902,"name":"Carvalhosa"},{"level":3,"code":130904,"name":"Eiriz"},{"level":3,"code":130905,"name":"Ferreira"},{"level":3,"code":130906,"name":"Figueiró"},{"level":3,"code":130908,"name":"Freamunde"},{"level":3,"code":130910,"name":"Meixomil"},{"level":3,"code":130913,"name":"Penamaior"},{"level":3,"code":130914,"name":"Raimonda"},{"level":3,"code":130916,"name":"Seroa"},{"level":3,"code":130917,"name":"Frazão Arreigada"},{"level":3,"code":130918,"name":"Paços de Ferreira"},{"level":3,"code":130919,"name":"Sanfins Lamoso Codessos"},{"level":2,"code":1310,"name":"Paredes"},{"level":3,"code":131001,"name":"Aguiar de Sousa"},{"level":3,"code":131002,"name":"Astromil"},{"level":3,"code":131003,"name":"Baltar"},{"level":3,"code":131004,"name":"Beire"},{"level":3,"code":131008,"name":"Cete"},{"level":3,"code":131009,"name":"Cristelo"},{"level":3,"code":131010,"name":"Duas Igrejas"},{"level":3,"code":131011,"name":"Gandra"},{"level":3,"code":131013,"name":"Lordelo"},{"level":3,"code":131014,"name":"Louredo"},{"level":3,"code":131017,"name":"Parada de Todeia"},{"level":3,"code":131018,"name":"Rebordosa"},{"level":3,"code":131019,"name":"Recarei"},{"level":3,"code":131020,"name":"Sobreira"},{"level":3,"code":131021,"name":"Sobrosa"},{"level":3,"code":131022,"name":"Vandoma"},{"level":3,"code":131024,"name":"Vilela"},{"level":3,"code":131025,"name":"Paredes"},{"level":2,"code":1311,"name":"Penafiel"},{"level":3,"code":131101,"name":"Abragão"},{"level":3,"code":131102,"name":"Boelhe"},{"level":3,"code":131103,"name":"Bustelo"},{"level":3,"code":131104,"name":"Cabeça Santa"},{"level":3,"code":131105,"name":"Canelas"},{"level":3,"code":131106,"name":"Capela"},{"level":3,"code":131107,"name":"Castelões"},{"level":3,"code":131108,"name":"Croca"},{"level":3,"code":131109,"name":"Duas Igrejas"},{"level":3,"code":131110,"name":"Eja"},{"level":3,"code":131112,"name":"Fonte Arcada"},{"level":3,"code":131113,"name":"Galegos"},{"level":3,"code":131115,"name":"Irivo"},{"level":3,"code":131121,"name":"Oldrões"},{"level":3,"code":131122,"name":"Paço de Sousa"},{"level":3,"code":131125,"name":"Perozelo"},{"level":3,"code":131128,"name":"Rans"},{"level":3,"code":131129,"name":"Rio de Moinhos"},{"level":3,"code":131132,"name":"Recezinhos (São Mamede)"},{"level":3,"code":131133,"name":"Recezinhos (São Martinho)"},{"level":3,"code":131134,"name":"Sebolido"},{"level":3,"code":131136,"name":"Valpedre"},{"level":3,"code":131138,"name":"Rio Mau"},{"level":3,"code":131139,"name":"Penafiel"},{"level":3,"code":131140,"name":"Luzim e Vila Cova"},{"level":3,"code":131141,"name":"Guilhufe e Urrô"},{"level":3,"code":131142,"name":"Lagares e Figueira"},{"level":3,"code":131143,"name":"Termas de São Vicente"},{"level":2,"code":1312,"name":"Porto"},{"level":3,"code":131202,"name":"Bonfim"},{"level":3,"code":131203,"name":"Campanhã"},{"level":3,"code":131210,"name":"Paranhos"},{"level":3,"code":131211,"name":"Ramalde"},{"level":3,"code":131216,"name":"União das freguesias de Aldoar, Foz do Douro e Nevogilde"},{"level":3,"code":131217,"name":"União das freguesias de Cedofeita, Santo Ildefonso, Sé, Miragaia, São Nicolau e Vitória"},{"level":3,"code":131218,"name":"União das freguesias de Lordelo do Ouro e Massarelos"},{"level":2,"code":1313,"name":"Póvoa de Varzim"},{"level":3,"code":131305,"name":"Balazar"},{"level":3,"code":131307,"name":"Estela"},{"level":3,"code":131308,"name":"Laundos"},{"level":3,"code":131311,"name":"Rates"},{"level":3,"code":131313,"name":"União das freguesias de Aver-o-Mar, Amorim e Terroso"},{"level":3,"code":131314,"name":"União das freguesias de Aguçadoura e Navais"},{"level":3,"code":131315,"name":"União das freguesias da Póvoa de Varzim, Beiriz e Argivai"},{"level":2,"code":1314,"name":"Santo Tirso"},{"level":3,"code":131401,"name":"Agrela"},{"level":3,"code":131402,"name":"Água Longa"},{"level":3,"code":131405,"name":"Aves"},{"level":3,"code":131413,"name":"Monte Córdova"},{"level":3,"code":131416,"name":"Rebordões"},{"level":3,"code":131418,"name":"Reguenga"},{"level":3,"code":131419,"name":"Roriz"},{"level":3,"code":131430,"name":"Negrelos (São Tomé)"},{"level":3,"code":131432,"name":"Vilarinho"},{"level":3,"code":131433,"name":"União das freguesias de Areias, Sequeiró, Lama e Palmeira"},{"level":3,"code":131434,"name":"Vila Nova do Campo"},{"level":3,"code":131435,"name":"União das freguesias de Carreira e Refojos de Riba de Ave"},{"level":3,"code":131436,"name":"União das freguesias de Lamelas e Guimarei"},{"level":3,"code":131437,"name":"União das freguesias de Santo Tirso, Couto (Santa Cristina e São Miguel) e Burgães"},{"level":2,"code":1315,"name":"Valongo"},{"level":3,"code":131501,"name":"Alfena"},{"level":3,"code":131503,"name":"Ermesinde"},{"level":3,"code":131505,"name":"Valongo"},{"level":3,"code":131506,"name":"União das freguesias de Campo e Sobrado"},{"level":2,"code":1316,"name":"Vila do Conde"},{"level":3,"code":131602,"name":"Árvore"},{"level":3,"code":131603,"name":"Aveleda"},{"level":3,"code":131604,"name":"Azurara"},{"level":3,"code":131607,"name":"Fajozes"},{"level":3,"code":131610,"name":"Gião"},{"level":3,"code":131611,"name":"Guilhabreu"},{"level":3,"code":131612,"name":"Junqueira"},{"level":3,"code":131613,"name":"Labruge"},{"level":3,"code":131614,"name":"Macieira da Maia"},{"level":3,"code":131616,"name":"Mindelo"},{"level":3,"code":131617,"name":"Modivas"},{"level":3,"code":131627,"name":"Vila Chã"},{"level":3,"code":131628,"name":"Vila do Conde"},{"level":3,"code":131630,"name":"Vilar de Pinheiro"},{"level":3,"code":131631,"name":"União das freguesias de Bagunte, Ferreiró, Outeiro Maior e Parada"},{"level":3,"code":131632,"name":"União das freguesias de Fornelo e Vairão"},{"level":3,"code":131633,"name":"União das freguesias de Malta e Canidelo"},{"level":3,"code":131634,"name":"União das freguesias de Retorta e Tougues"},{"level":3,"code":131635,"name":"União das freguesias de Rio Mau e Arcos"},{"level":3,"code":131636,"name":"União das freguesias de Touguinha e Touguinhó"},{"level":3,"code":131637,"name":"União das freguesias de Vilar e Mosteiró"},{"level":2,"code":1317,"name":"Vila Nova de Gaia"},{"level":3,"code":131701,"name":"Arcozelo"},{"level":3,"code":131702,"name":"Avintes"},{"level":3,"code":131703,"name":"Canelas"},{"level":3,"code":131704,"name":"Canidelo"},{"level":3,"code":131709,"name":"Madalena"},{"level":3,"code":131712,"name":"Oliveira do Douro"},{"level":3,"code":131717,"name":"São Félix da Marinha"},{"level":3,"code":131723,"name":"Vilar de Andorinho"},{"level":3,"code":131725,"name":"União das freguesias de Grijó e Sermonde"},{"level":3,"code":131726,"name":"União das freguesias de Gulpilhares e Valadares"},{"level":3,"code":131727,"name":"União das freguesias de Mafamude e Vilar do Paraíso"},{"level":3,"code":131728,"name":"União das freguesias de Pedroso e Seixezelo"},{"level":3,"code":131729,"name":"União das freguesias de Sandim, Olival, Lever e Crestuma"},{"level":3,"code":131730,"name":"União das freguesias de Santa Marinha e São Pedro da Afurada"},{"level":3,"code":131731,"name":"União das freguesias de Serzedo e Perosinho"},{"level":2,"code":1318,"name":"Trofa"},{"level":3,"code":131806,"name":"Covelas"},{"level":3,"code":131808,"name":"Muro"},{"level":3,"code":131809,"name":"União das freguesias de Alvarelhos e Guidões"},{"level":3,"code":131810,"name":"União das freguesias de Bougado (São Martinho e Santiago)"},{"level":3,"code":131811,"name":"União das freguesias de Coronado (São Romão e São Mamede)"},{"level":1,"code":14,"name":"Santarém"},{"level":2,"code":1401,"name":"Abrantes"},{"level":3,"code":140104,"name":"Bemposta"},{"level":3,"code":140105,"name":"Martinchel"},{"level":3,"code":140106,"name":"Mouriscas"},{"level":3,"code":140107,"name":"Pego"},{"level":3,"code":140108,"name":"Rio de Moinhos"},{"level":3,"code":140115,"name":"Tramagal"},{"level":3,"code":140118,"name":"Fontes"},{"level":3,"code":140119,"name":"Carvalhal"},{"level":3,"code":140120,"name":"União das freguesias de Abrantes (São Vicente e São João) e Alferrarede"},{"level":3,"code":140121,"name":"União das freguesias de Aldeia do Mato e Souto"},{"level":3,"code":140122,"name":"União das freguesias de Alvega e Concavada"},{"level":3,"code":140123,"name":"União das freguesias de São Facundo e Vale das Mós"},{"level":3,"code":140124,"name":"União das freguesias de São Miguel do Rio Torto e Rossio ao Sul do Tejo"},{"level":2,"code":1402,"name":"Alcanena"},{"level":3,"code":140202,"name":"Bugalhos"},{"level":3,"code":140206,"name":"Minde"},{"level":3,"code":140207,"name":"Moitas Venda"},{"level":3,"code":140208,"name":"Monsanto"},{"level":3,"code":140209,"name":"Serra de Santo António"},{"level":3,"code":140211,"name":"União das freguesias de Alcanena e Vila Moreira"},{"level":3,"code":140212,"name":"União das freguesias de Malhou, Louriceira e Espinheiro"},{"level":2,"code":1403,"name":"Almeirim"},{"level":3,"code":140301,"name":"Almeirim"},{"level":3,"code":140302,"name":"Benfica do Ribatejo"},{"level":3,"code":140303,"name":"Fazendas de Almeirim"},{"level":3,"code":140304,"name":"Raposa"},{"level":2,"code":1404,"name":"Alpiarça"},{"level":3,"code":140401,"name":"Alpiarça"},{"level":2,"code":1405,"name":"Benavente"},{"level":3,"code":140501,"name":"Benavente"},{"level":3,"code":140502,"name":"Samora Correia"},{"level":3,"code":140503,"name":"Santo Estêvão"},{"level":3,"code":140504,"name":"Barrosa"},{"level":2,"code":1406,"name":"Cartaxo"},{"level":3,"code":140604,"name":"Pontével"},{"level":3,"code":140605,"name":"Valada"},{"level":3,"code":140607,"name":"Vila Chã de Ourique"},{"level":3,"code":140608,"name":"Vale da Pedra"},{"level":3,"code":140609,"name":"União das freguesias do Cartaxo e Vale da Pinta"},{"level":3,"code":140610,"name":"União das freguesias de Ereira e Lapa"},{"level":2,"code":1407,"name":"Chamusca"},{"level":3,"code":140704,"name":"Ulme"},{"level":3,"code":140705,"name":"Vale de Cavalos"},{"level":3,"code":140707,"name":"Carregueira"},{"level":3,"code":140708,"name":"União das freguesias da Chamusca e Pinheiro Grande"},{"level":3,"code":140709,"name":"União das freguesias de Parreira e Chouto"},{"level":2,"code":1408,"name":"Constância"},{"level":3,"code":140801,"name":"Constância"},{"level":3,"code":140802,"name":"Montalvo"},{"level":3,"code":140803,"name":"Santa Margarida da Coutada"},{"level":2,"code":1409,"name":"Coruche"},{"level":3,"code":140902,"name":"Couço"},{"level":3,"code":140903,"name":"São José da Lamarosa"},{"level":3,"code":140905,"name":"Branca"},{"level":3,"code":140907,"name":"Biscainho"},{"level":3,"code":140908,"name":"Santana do Mato"},{"level":3,"code":140909,"name":"União das freguesias de Coruche, Fajarda e Erra"},{"level":2,"code":1410,"name":"Entroncamento"},{"level":3,"code":141001,"name":"São João Baptista"},{"level":3,"code":141002,"name":"Nossa Senhora de Fátima"},{"level":2,"code":1411,"name":"Ferreira do Zêzere"},{"level":3,"code":141101,"name":"Águas Belas"},{"level":3,"code":141103,"name":"Beco"},{"level":3,"code":141104,"name":"Chãos"},{"level":3,"code":141106,"name":"Ferreira do Zêzere"},{"level":3,"code":141107,"name":"Igreja Nova do Sobral"},{"level":3,"code":141110,"name":"Nossa Senhora do Pranto"},{"level":3,"code":141111,"name":"União das freguesias de Areias e Pias"},{"level":2,"code":1412,"name":"Golegã"},{"level":3,"code":141201,"name":"Azinhaga"},{"level":3,"code":141202,"name":"Golegã"},{"level":3,"code":141203,"name":"Pombalinho"},{"level":2,"code":1413,"name":"Mação"},{"level":3,"code":141302,"name":"Amêndoa"},{"level":3,"code":141303,"name":"Cardigos"},{"level":3,"code":141304,"name":"Carvoeiro"},{"level":3,"code":141305,"name":"Envendos"},{"level":3,"code":141307,"name":"Ortiga"},{"level":3,"code":141309,"name":"União das freguesias de Mação, Penhascoso e Aboboreira"},{"level":2,"code":1414,"name":"Rio Maior"},{"level":3,"code":141401,"name":"Alcobertas"},{"level":3,"code":141402,"name":"Arrouquelas"},{"level":3,"code":141405,"name":"Fráguas"},{"level":3,"code":141408,"name":"Rio Maior"},{"level":3,"code":141410,"name":"Asseiceira"},{"level":3,"code":141411,"name":"São Sebastião"},{"level":3,"code":141415,"name":"União das freguesias de Azambujeira e Malaqueijo"},{"level":3,"code":141416,"name":"União das freguesias de Marmeleira e Assentiz"},{"level":3,"code":141417,"name":"União das freguesias de Outeiro da Cortiçada e Arruda dos Pisões"},{"level":3,"code":141418,"name":"União das freguesias de São João da Ribeira e Ribeira de São João"},{"level":2,"code":1415,"name":"Salvaterra de Magos"},{"level":3,"code":141502,"name":"Marinhais"},{"level":3,"code":141503,"name":"Muge"},{"level":3,"code":141507,"name":"União das freguesias de Glória do Ribatejo e Granho"},{"level":3,"code":141508,"name":"União das freguesias de Salvaterra de Magos e Foros de Salvaterra"},{"level":2,"code":1416,"name":"Santarém"},{"level":3,"code":141601,"name":"Abitureiras"},{"level":3,"code":141602,"name":"Abrã"},{"level":3,"code":141604,"name":"Alcanede"},{"level":3,"code":141605,"name":"Alcanhões"},{"level":3,"code":141606,"name":"Almoster"},{"level":3,"code":141607,"name":"Amiais de Baixo"},{"level":3,"code":141608,"name":"Arneiro das Milhariças"},{"level":3,"code":141613,"name":"Moçarria"},{"level":3,"code":141614,"name":"Pernes"},{"level":3,"code":141616,"name":"Póvoa da Isenta"},{"level":3,"code":141625,"name":"Vale de Santarém"},{"level":3,"code":141628,"name":"Gançaria"},{"level":3,"code":141629,"name":"União das freguesias de Achete, Azoia de Baixo e Póvoa de Santarém"},{"level":3,"code":141630,"name":"União das freguesias de Azoia de Cima e Tremês"},{"level":3,"code":141631,"name":"União das freguesias de Casével e Vaqueiros"},{"level":3,"code":141632,"name":"União das freguesias de Romeira e Várzea"},{"level":3,"code":141633,"name":"União das freguesias de Santarém (Marvila), Santa Iria da Ribeira de Santarém, Santarém (São Salvador) e Santarém (São Nicolau)"},{"level":3,"code":141634,"name":"União das freguesias de São Vicente do Paul e Vale de Figueira"},{"level":2,"code":1417,"name":"Sardoal"},{"level":3,"code":141701,"name":"Alcaravela"},{"level":3,"code":141702,"name":"Santiago de Montalegre"},{"level":3,"code":141703,"name":"Sardoal"},{"level":3,"code":141704,"name":"Valhascos"},{"level":2,"code":1418,"name":"Tomar"},{"level":3,"code":141802,"name":"Asseiceira"},{"level":3,"code":141804,"name":"Carregueiros"},{"level":3,"code":141808,"name":"Olalhas"},{"level":3,"code":141809,"name":"Paialvo"},{"level":3,"code":141813,"name":"São Pedro de Tomar"},{"level":3,"code":141814,"name":"Sabacheira"},{"level":3,"code":141817,"name":"União das freguesias de Além da Ribeira e Pedreira"},{"level":3,"code":141818,"name":"União das freguesias de Casais e Alviobeira"},{"level":3,"code":141819,"name":"União das freguesias de Madalena e Beselga"},{"level":3,"code":141820,"name":"União das freguesias de Serra e Junceira"},{"level":3,"code":141821,"name":"União das freguesias de Tomar (São João Baptista) e Santa Maria dos Olivais"},{"level":2,"code":1419,"name":"Torres Novas"},{"level":3,"code":141902,"name":"Assentiz"},{"level":3,"code":141904,"name":"Chancelaria"},{"level":3,"code":141909,"name":"Pedrógão"},{"level":3,"code":141910,"name":"Riachos"},{"level":3,"code":141916,"name":"Zibreira"},{"level":3,"code":141917,"name":"Meia Via"},{"level":3,"code":141918,"name":"União das freguesias de Brogueira, Parceiros de Igreja e Alcorochel"},{"level":3,"code":141919,"name":"União das freguesias de Olaia e Paço"},{"level":3,"code":141920,"name":"União das freguesias de Torres Novas (Santa Maria, Salvador e Santiago)"},{"level":3,"code":141921,"name":"União das freguesias de Torres Novas (São Pedro), Lapas e Ribeira Branca"},{"level":2,"code":1420,"name":"Vila Nova da Barquinha"},{"level":3,"code":142001,"name":"Atalaia"},{"level":3,"code":142002,"name":"Praia do Ribatejo"},{"level":3,"code":142003,"name":"Tancos"},{"level":3,"code":142006,"name":"Vila Nova da Barquinha"},{"level":2,"code":1421,"name":"Ourém"},{"level":3,"code":142101,"name":"Alburitel"},{"level":3,"code":142102,"name":"Atouguia"},{"level":3,"code":142104,"name":"Caxarias"},{"level":3,"code":142105,"name":"Espite"},{"level":3,"code":142106,"name":"Fátima"},{"level":3,"code":142111,"name":"Nossa Senhora das Misericórdias"},{"level":3,"code":142113,"name":"Seiça"},{"level":3,"code":142114,"name":"Urqueira"},{"level":3,"code":142115,"name":"Nossa Senhora da Piedade"},{"level":3,"code":142119,"name":"União das freguesias de Freixianda, Ribeira do Fárrio e Formigais"},{"level":3,"code":142120,"name":"União das freguesias de Gondemaria e Olival"},{"level":3,"code":142121,"name":"União das freguesias de Matas e Cercal"},{"level":3,"code":142122,"name":"União das freguesias de Rio de Couros e Casal dos Bernardos"},{"level":1,"code":15,"name":"Setúbal"},{"level":2,"code":1501,"name":"Alcácer do Sal"},{"level":3,"code":150104,"name":"Torrão"},{"level":3,"code":150105,"name":"São Martinho"},{"level":3,"code":150106,"name":"Comporta"},{"level":3,"code":150107,"name":"União das freguesias de Alcácer do Sal (Santa Maria do Castelo e Santiago) e Santa Susana"},{"level":2,"code":1502,"name":"Alcochete"},{"level":3,"code":150201,"name":"Alcochete"},{"level":3,"code":150202,"name":"Samouco"},{"level":3,"code":150203,"name":"São Francisco"},{"level":2,"code":1503,"name":"Almada"},{"level":3,"code":150303,"name":"Costa da Caparica"},{"level":3,"code":150312,"name":"União das freguesias de Almada, Cova da Piedade, Pragal e Cacilhas"},{"level":3,"code":150313,"name":"União das freguesias de Caparica e Trafaria"},{"level":3,"code":150314,"name":"União das freguesias de Charneca de Caparica e Sobreda"},{"level":3,"code":150315,"name":"União das freguesias de Laranjeiro e Feijó"},{"level":2,"code":1504,"name":"Barreiro"},{"level":3,"code":150407,"name":"Santo António da Charneca"},{"level":3,"code":150409,"name":"União das freguesias de Alto do Seixalinho, Santo André e Verderena"},{"level":3,"code":150410,"name":"União das freguesias de Barreiro e Lavradio"},{"level":3,"code":150411,"name":"União das freguesias de Palhais e Coina"},{"level":2,"code":1505,"name":"Grândola"},{"level":3,"code":150501,"name":"Azinheira dos Barros e São Mamede do Sádão"},{"level":3,"code":150503,"name":"Melides"},{"level":3,"code":150505,"name":"Carvalhal"},{"level":3,"code":150506,"name":"União das freguesias de Grândola e Santa Margarida da Serra"},{"level":2,"code":1506,"name":"Moita"},{"level":3,"code":150601,"name":"Alhos Vedros"},{"level":3,"code":150603,"name":"Moita"},{"level":3,"code":150607,"name":"União das freguesias de Baixa da Banheira e Vale da Amoreira"},{"level":3,"code":150608,"name":"União das freguesias de Gaio-Rosário e Sarilhos Pequenos"},{"level":2,"code":1507,"name":"Montijo"},{"level":3,"code":150701,"name":"Canha"},{"level":3,"code":150704,"name":"Sarilhos Grandes"},{"level":3,"code":150709,"name":"União das freguesias de Atalaia e Alto Estanqueiro-Jardia"},{"level":3,"code":150710,"name":"União das freguesias de Montijo e Afonsoeiro"},{"level":3,"code":150711,"name":"União das freguesias de Pegões"},{"level":2,"code":1508,"name":"Palmela"},{"level":3,"code":150802,"name":"Palmela"},{"level":3,"code":150803,"name":"Pinhal Novo"},{"level":3,"code":150804,"name":"Quinta do Anjo"},{"level":3,"code":150806,"name":"União das freguesias de Poceirão e Marateca"},{"level":2,"code":1509,"name":"Santiago do Cacém"},{"level":3,"code":150901,"name":"Abela"},{"level":3,"code":150902,"name":"Alvalade"},{"level":3,"code":150903,"name":"Cercal"},{"level":3,"code":150904,"name":"Ermidas-Sado"},{"level":3,"code":150907,"name":"Santo André"},{"level":3,"code":150910,"name":"São Francisco da Serra"},{"level":3,"code":150912,"name":"União das freguesias de Santiago do Cacém, Santa Cruz e São Bartolomeu da Serra"},{"level":3,"code":150913,"name":"União das freguesias de São Domingos e Vale de Água"},{"level":2,"code":1510,"name":"Seixal"},{"level":3,"code":151002,"name":"Amora"},{"level":3,"code":151005,"name":"Corroios"},{"level":3,"code":151006,"name":"Fernão Ferro"},{"level":3,"code":151007,"name":"União das freguesias do Seixal, Arrentela e Aldeia de Paio Pires"},{"level":2,"code":1511,"name":"Sesimbra"},{"level":3,"code":151101,"name":"Sesimbra (Castelo)"},{"level":3,"code":151102,"name":"Sesimbra (Santiago)"},{"level":3,"code":151103,"name":"Quinta do Conde"},{"level":2,"code":1512,"name":"Setúbal"},{"level":3,"code":151205,"name":"Setúbal (São Sebastião)"},{"level":3,"code":151207,"name":"Gâmbia-Pontes-Alto da Guerra"},{"level":3,"code":151208,"name":"Sado"},{"level":3,"code":151209,"name":"União das freguesias de Azeitão (São Lourenço e São Simão)"},{"level":3,"code":151210,"name":"União das freguesias de Setúbal (São Julião, Nossa Senhora da Anunciada e Santa Maria da Graça)"},{"level":2,"code":1513,"name":"Sines"},{"level":3,"code":151301,"name":"Sines"},{"level":3,"code":151302,"name":"Porto Covo"},{"level":1,"code":16,"name":"Viana do Castelo"},{"level":2,"code":1601,"name":"Arcos de Valdevez"},{"level":3,"code":160101,"name":"Aboim das Choças"},{"level":3,"code":160102,"name":"Aguiã"},{"level":3,"code":160104,"name":"Ázere"},{"level":3,"code":160105,"name":"Cabana Maior"},{"level":3,"code":160106,"name":"Cabreiro"},{"level":3,"code":160108,"name":"Cendufe"},{"level":3,"code":160109,"name":"Couto"},{"level":3,"code":160113,"name":"Gavieira"},{"level":3,"code":160115,"name":"Gondoriz"},{"level":3,"code":160121,"name":"Miranda"},{"level":3,"code":160122,"name":"Monte Redondo"},{"level":3,"code":160123,"name":"Oliveira"},{"level":3,"code":160124,"name":"Paçô"},{"level":3,"code":160125,"name":"Padroso"},{"level":3,"code":160128,"name":"Prozelo"},{"level":3,"code":160130,"name":"Rio Frio"},{"level":3,"code":160131,"name":"Rio de Moinhos"},{"level":3,"code":160133,"name":"Sabadim"},{"level":3,"code":160142,"name":"Jolda (São Paio)"},{"level":3,"code":160144,"name":"Senharei"},{"level":3,"code":160145,"name":"Sistelo"},{"level":3,"code":160146,"name":"Soajo"},{"level":3,"code":160149,"name":"Vale"},{"level":3,"code":160152,"name":"União das freguesias de Alvora e Loureda"},{"level":3,"code":160153,"name":"União das freguesias de Arcos de Valdevez (São Paio) e Giela"},{"level":3,"code":160154,"name":"União das freguesias de Arcos de Valdevez (Salvador), Vila Fonche e Parada"},{"level":3,"code":160155,"name":"União das freguesias de Eiras e Mei"},{"level":3,"code":160156,"name":"União das freguesias de Grade e Carralcova"},{"level":3,"code":160157,"name":"União das freguesias de Guilhadeses e Santar"},{"level":3,"code":160158,"name":"União das freguesias de Jolda (Madalena) e Rio Cabrão"},{"level":3,"code":160159,"name":"União das freguesias de Padreiro (Salvador e Santa Cristina)"},{"level":3,"code":160160,"name":"União das freguesias de Portela e Extremo"},{"level":3,"code":160161,"name":"União das freguesias de São Jorge e Ermelo"},{"level":3,"code":160162,"name":"União das freguesias de Souto e Tabaçô"},{"level":3,"code":160163,"name":"União das freguesias de Távora (Santa Maria e São Vicente)"},{"level":3,"code":160164,"name":"União das freguesias de Vilela, São Cosme e São Damião e Sá"},{"level":2,"code":1602,"name":"Caminha"},{"level":3,"code":160201,"name":"Âncora"},{"level":3,"code":160205,"name":"Argela"},{"level":3,"code":160209,"name":"Dem"},{"level":3,"code":160211,"name":"Lanhelas"},{"level":3,"code":160214,"name":"Riba de Âncora"},{"level":3,"code":160215,"name":"Seixas"},{"level":3,"code":160217,"name":"Vila Praia de Âncora"},{"level":3,"code":160218,"name":"Vilar de Mouros"},{"level":3,"code":160220,"name":"Vile"},{"level":3,"code":160221,"name":"União das freguesias de Arga (Baixo, Cima e São João)"},{"level":3,"code":160222,"name":"União das freguesias de Caminha (Matriz) e Vilarelho"},{"level":3,"code":160223,"name":"União das freguesias de Gondar e Orbacém"},{"level":3,"code":160224,"name":"União das freguesias de Moledo e Cristelo"},{"level":3,"code":160225,"name":"União das freguesias de Venade e Azevedo"},{"level":2,"code":1603,"name":"Melgaço"},{"level":3,"code":160301,"name":"Alvaredo"},{"level":3,"code":160304,"name":"Cousso"},{"level":3,"code":160305,"name":"Cristoval"},{"level":3,"code":160307,"name":"Fiães"},{"level":3,"code":160308,"name":"Gave"},{"level":3,"code":160311,"name":"Paderne"},{"level":3,"code":160313,"name":"Penso"},{"level":3,"code":160317,"name":"São Paio"},{"level":3,"code":160319,"name":"União das freguesias de Castro Laboreiro e Lamas de Mouro"},{"level":3,"code":160320,"name":"União das freguesias de Chaviães e Paços"},{"level":3,"code":160321,"name":"União das freguesias de Parada do Monte e Cubalhão"},{"level":3,"code":160322,"name":"União das freguesias de Prado e Remoães"},{"level":3,"code":160323,"name":"União das freguesias de Vila e Roussas"},{"level":2,"code":1604,"name":"Monção"},{"level":3,"code":160401,"name":"Abedim"},{"level":3,"code":160404,"name":"Barbeita"},{"level":3,"code":160405,"name":"Barroças e Taias"},{"level":3,"code":160406,"name":"Bela"},{"level":3,"code":160407,"name":"Cambeses"},{"level":3,"code":160410,"name":"Lara"},{"level":3,"code":160411,"name":"Longos Vales"},{"level":3,"code":160415,"name":"Merufe"},{"level":3,"code":160418,"name":"Moreira"},{"level":3,"code":160420,"name":"Pias"},{"level":3,"code":160421,"name":"Pinheiros"},{"level":3,"code":160422,"name":"Podame"},{"level":3,"code":160423,"name":"Portela"},{"level":3,"code":160424,"name":"Riba de Mouro"},{"level":3,"code":160427,"name":"Segude"},{"level":3,"code":160428,"name":"Tangil"},{"level":3,"code":160431,"name":"Trute"},{"level":3,"code":160434,"name":"União das freguesias de Anhões e Luzio"},{"level":3,"code":160435,"name":"União das freguesias de Ceivães e Badim"},{"level":3,"code":160436,"name":"União das freguesias de Mazedo e Cortes"},{"level":3,"code":160437,"name":"União das freguesias de Messegães, Valadares e Sá"},{"level":3,"code":160438,"name":"União das freguesias de Monção e Troviscoso"},{"level":3,"code":160439,"name":"União das freguesias de Sago, Lordelo e Parada"},{"level":3,"code":160440,"name":"União das freguesias de Troporiz e Lapela"},{"level":2,"code":1605,"name":"Paredes de Coura"},{"level":3,"code":160501,"name":"Agualonga"},{"level":3,"code":160503,"name":"Castanheira"},{"level":3,"code":160505,"name":"Coura"},{"level":3,"code":160507,"name":"Cunha"},{"level":3,"code":160510,"name":"Infesta"},{"level":3,"code":160513,"name":"Mozelos"},{"level":3,"code":160514,"name":"Padornelo"},{"level":3,"code":160515,"name":"Parada"},{"level":3,"code":160519,"name":"Romarigães"},{"level":3,"code":160520,"name":"Rubiães"},{"level":3,"code":160521,"name":"Vascões"},{"level":3,"code":160522,"name":"União das freguesias de Bico e Cristelo"},{"level":3,"code":160523,"name":"União das freguesias de Cossourado e Linhares"},{"level":3,"code":160524,"name":"União das freguesias de Formariz e Ferreira"},{"level":3,"code":160525,"name":"União das freguesias de Insalde e Porreiras"},{"level":3,"code":160526,"name":"União das freguesias de Paredes de Coura e Resende"},{"level":2,"code":1606,"name":"Ponte da Barca"},{"level":3,"code":160601,"name":"Azias"},{"level":3,"code":160602,"name":"Boivães"},{"level":3,"code":160603,"name":"Bravães"},{"level":3,"code":160604,"name":"Britelo"},{"level":3,"code":160606,"name":"Cuide de Vila Verde"},{"level":3,"code":160611,"name":"Lavradas"},{"level":3,"code":160612,"name":"Lindoso"},{"level":3,"code":160613,"name":"Nogueira"},{"level":3,"code":160614,"name":"Oleiros"},{"level":3,"code":160619,"name":"Sampriz"},{"level":3,"code":160623,"name":"Vade (São Pedro)"},{"level":3,"code":160624,"name":"Vade (São Tomé)"},{"level":3,"code":160626,"name":"União das freguesias de Crasto, Ruivos e Grovelas"},{"level":3,"code":160627,"name":"União das freguesias de Entre Ambos-os-Rios, Ermida e Germil"},{"level":3,"code":160628,"name":"União das freguesias de Ponte da Barca, Vila Nova de Muía e Paço Vedro de Magalhães"},{"level":3,"code":160629,"name":"União das freguesias de Touvedo (São Lourenço e Salvador)"},{"level":3,"code":160630,"name":"União das freguesias de Vila Chã (São João Baptista e Santiago)"},{"level":2,"code":1607,"name":"Ponte de Lima"},{"level":3,"code":160701,"name":"Anais"},{"level":3,"code":160703,"name":"São Pedro d'Arcos"},{"level":3,"code":160704,"name":"Arcozelo"},{"level":3,"code":160707,"name":"Beiral do Lima"},{"level":3,"code":160708,"name":"Bertiandos"},{"level":3,"code":160709,"name":"Boalhosa"},{"level":3,"code":160710,"name":"Brandara"},{"level":3,"code":160713,"name":"Calheiros"},{"level":3,"code":160714,"name":"Calvelo"},{"level":3,"code":160716,"name":"Correlhã"},{"level":3,"code":160717,"name":"Estorãos"},{"level":3,"code":160718,"name":"Facha"},{"level":3,"code":160719,"name":"Feitosa"},{"level":3,"code":160721,"name":"Fontão"},{"level":3,"code":160724,"name":"Friastelas"},{"level":3,"code":160726,"name":"Gandra"},{"level":3,"code":160727,"name":"Gemieira"},{"level":3,"code":160728,"name":"Gondufe"},{"level":3,"code":160729,"name":"Labruja"},{"level":3,"code":160734,"name":"Poiares"},{"level":3,"code":160737,"name":"Refóios do Lima"},{"level":3,"code":160739,"name":"Ribeira"},{"level":3,"code":160740,"name":"Sá"},{"level":3,"code":160742,"name":"Santa Comba"},{"level":3,"code":160743,"name":"Santa Cruz do Lima"},{"level":3,"code":160744,"name":"Rebordões (Santa Maria)"},{"level":3,"code":160745,"name":"Seara"},{"level":3,"code":160746,"name":"Serdedelo"},{"level":3,"code":160747,"name":"Rebordões (Souto)"},{"level":3,"code":160750,"name":"Vitorino das Donas"},{"level":3,"code":160752,"name":"Arca e Ponte de Lima"},{"level":3,"code":160753,"name":"Ardegão, Freixo e Mato"},{"level":3,"code":160754,"name":"Associação de freguesias do Vale do Neiva"},{"level":3,"code":160755,"name":"Bárrio e Cepões"},{"level":3,"code":160756,"name":"Cabaços e Fojo Lobal"},{"level":3,"code":160757,"name":"Cabração e Moreira do Lima"},{"level":3,"code":160758,"name":"Fornelos e Queijada"},{"level":3,"code":160759,"name":"Labrujó, Rendufe e Vilar do Monte"},{"level":3,"code":160760,"name":"Navió e Vitorino dos Piães"},{"level":2,"code":1608,"name":"Valença"},{"level":3,"code":160802,"name":"Boivão"},{"level":3,"code":160803,"name":"Cerdal"},{"level":3,"code":160805,"name":"Fontoura"},{"level":3,"code":160806,"name":"Friestas"},{"level":3,"code":160808,"name":"Ganfei"},{"level":3,"code":160812,"name":"São Pedro da Torre"},{"level":3,"code":160816,"name":"Verdoejo"},{"level":3,"code":160817,"name":"União das freguesias de Gandra e Taião"},{"level":3,"code":160818,"name":"União das freguesias de Gondomil e Sanfins"},{"level":3,"code":160819,"name":"União das freguesias de São Julião e Silva"},{"level":3,"code":160820,"name":"União das freguesias de Valença, Cristelo Covo e Arão"},{"level":2,"code":1609,"name":"Viana do Castelo"},{"level":3,"code":160901,"name":"Afife"},{"level":3,"code":160902,"name":"Alvarães"},{"level":3,"code":160903,"name":"Amonde"},{"level":3,"code":160904,"name":"Anha"},{"level":3,"code":160905,"name":"Areosa"},{"level":3,"code":160908,"name":"Carreço"},{"level":3,"code":160910,"name":"Castelo do Neiva"},{"level":3,"code":160911,"name":"Darque"},{"level":3,"code":160914,"name":"Freixieiro de Soutelo"},{"level":3,"code":160915,"name":"Lanheses"},{"level":3,"code":160920,"name":"Montaria"},{"level":3,"code":160922,"name":"Mujães"},{"level":3,"code":160923,"name":"São Romão de Neiva"},{"level":3,"code":160925,"name":"Outeiro"},{"level":3,"code":160926,"name":"Perre"},{"level":3,"code":160928,"name":"Santa Marta de Portuzelo"},{"level":3,"code":160935,"name":"Vila Franca"},{"level":3,"code":160938,"name":"Vila de Punhe"},{"level":3,"code":160940,"name":"Chafé"},{"level":3,"code":160941,"name":"União das freguesias de Barroselas e Carvoeiro"},{"level":3,"code":160942,"name":"União das freguesias de Cardielos e Serreleis"},{"level":3,"code":160943,"name":"União das freguesias de Geraz do Lima (Santa Maria, Santa Leocádia e Moreira) e Deão"},{"level":3,"code":160944,"name":"União das freguesias de Mazarefes e Vila Fria"},{"level":3,"code":160945,"name":"União das freguesias de Nogueira, Meixedo e Vilar de Murteda"},{"level":3,"code":160946,"name":"União das freguesias de Subportela, Deocriste e Portela Susã"},{"level":3,"code":160947,"name":"União das freguesias de Torre e Vila Mou"},{"level":3,"code":160948,"name":"União das freguesias de Viana do Castelo (Santa Maria Maior e Monserrate) e Meadela"},{"level":2,"code":1610,"name":"Vila Nova de Cerveira"},{"level":3,"code":161003,"name":"Cornes"},{"level":3,"code":161004,"name":"Covas"},{"level":3,"code":161006,"name":"Gondarém"},{"level":3,"code":161007,"name":"Loivo"},{"level":3,"code":161009,"name":"Mentrestido"},{"level":3,"code":161012,"name":"Sapardos"},{"level":3,"code":161013,"name":"Sopo"},{"level":3,"code":161016,"name":"União das freguesias de Campos e Vila Meã"},{"level":3,"code":161017,"name":"União das freguesias de Candemil e Gondar"},{"level":3,"code":161018,"name":"União das freguesias de Reboreda e Nogueira"},{"level":3,"code":161019,"name":"União das freguesias de Vila Nova de Cerveira e Lovelhe"},{"level":1,"code":17,"name":"Vila Real"},{"level":2,"code":1701,"name":"Alijó"},{"level":3,"code":170101,"name":"Alijó"},{"level":3,"code":170107,"name":"Favaios"},{"level":3,"code":170108,"name":"Pegarinhos"},{"level":3,"code":170109,"name":"Pinhão"},{"level":3,"code":170112,"name":"Sanfins do Douro"},{"level":3,"code":170113,"name":"Santa Eugénia"},{"level":3,"code":170114,"name":"São Mamede de Ribatua"},{"level":3,"code":170116,"name":"Vila Chã"},{"level":3,"code":170117,"name":"Vila Verde"},{"level":3,"code":170118,"name":"Vilar de Maçada"},{"level":3,"code":170120,"name":"União das freguesias de Carlão e Amieiro"},{"level":3,"code":170121,"name":"União das freguesias de Castedo e Cotas"},{"level":3,"code":170122,"name":"União das freguesias de Pópulo e Ribalonga"},{"level":3,"code":170123,"name":"União das freguesias de Vale de Mendiz, Casal de Loivos e Vilarinho de Cotas"},{"level":2,"code":1702,"name":"Boticas"},{"level":3,"code":170203,"name":"Beça"},{"level":3,"code":170208,"name":"Covas do Barroso"},{"level":3,"code":170210,"name":"Dornelas"},{"level":3,"code":170213,"name":"Pinho"},{"level":3,"code":170215,"name":"Sapiãos"},{"level":3,"code":170217,"name":"Alturas do Barroso e Cerdedo"},{"level":3,"code":170218,"name":"Ardãos e Bobadela"},{"level":3,"code":170219,"name":"Boticas e Granja"},{"level":3,"code":170220,"name":"Codessoso, Curros e Fiães do Tâmega"},{"level":3,"code":170221,"name":"Vilar e Viveiro"},{"level":2,"code":1703,"name":"Chaves"},{"level":3,"code":170301,"name":"Águas Frias"},{"level":3,"code":170302,"name":"Anelhe"},{"level":3,"code":170305,"name":"Bustelo"},{"level":3,"code":170309,"name":"Cimo de Vila da Castanheira"},{"level":3,"code":170310,"name":"Curalha"},{"level":3,"code":170312,"name":"Ervededo"},{"level":3,"code":170313,"name":"Faiões"},{"level":3,"code":170314,"name":"Lama de Arcos"},{"level":3,"code":170316,"name":"Mairos"},{"level":3,"code":170317,"name":"Moreiras"},{"level":3,"code":170318,"name":"Nogueira da Montanha"},{"level":3,"code":170320,"name":"Oura"},{"level":3,"code":170321,"name":"Outeiro Seco"},{"level":3,"code":170322,"name":"Paradela"},{"level":3,"code":170324,"name":"Redondelo"},{"level":3,"code":170327,"name":"Sanfins"},{"level":3,"code":170329,"name":"Santa Leocádia"},{"level":3,"code":170330,"name":"Santo António de Monforte"},{"level":3,"code":170331,"name":"Santo Estêvão"},{"level":3,"code":170333,"name":"São Pedro de Agostém"},{"level":3,"code":170334,"name":"São Vicente"},{"level":3,"code":170340,"name":"Tronco"},{"level":3,"code":170341,"name":"Vale de Anta"},{"level":3,"code":170343,"name":"Vila Verde da Raia"},{"level":3,"code":170344,"name":"Vilar de Nantes"},{"level":3,"code":170345,"name":"Vilarelho da Raia"},{"level":3,"code":170347,"name":"Vilas Boas"},{"level":3,"code":170348,"name":"Vilela Seca"},{"level":3,"code":170349,"name":"Vilela do Tâmega"},{"level":3,"code":170350,"name":"Santa Maria Maior"},{"level":3,"code":170353,"name":"Planalto de Monforte (União das freguesias de Oucidres e Bobadela)"},{"level":3,"code":170354,"name":"União das freguesias da Madalena e Samaiões"},{"level":3,"code":170355,"name":"União das freguesias das Eiras, São Julião de Montenegro e Cela"},{"level":3,"code":170356,"name":"União das freguesias de Calvão e Soutelinho da Raia"},{"level":3,"code":170357,"name":"União das freguesias de Loivos e Póvoa de Agrações"},{"level":3,"code":170358,"name":"União das freguesias de Santa Cruz/Trindade e Sanjurge"},{"level":3,"code":170359,"name":"União das freguesias de Soutelo e Seara Velha"},{"level":3,"code":170360,"name":"União das freguesias de Travancas e Roriz"},{"level":3,"code":170361,"name":"Vidago (União das freguesias de Vidago, Arcossó, Selhariz e Vilarinho das Paranheiras)"},{"level":2,"code":1704,"name":"Mesão Frio"},{"level":3,"code":170401,"name":"Barqueiros"},{"level":3,"code":170402,"name":"Cidadelhe"},{"level":3,"code":170403,"name":"Oliveira"},{"level":3,"code":170407,"name":"Vila Marim"},{"level":3,"code":170408,"name":"Mesão Frio (Santo André)"},{"level":2,"code":1705,"name":"Mondim de Basto"},{"level":3,"code":170501,"name":"Atei"},{"level":3,"code":170502,"name":"Bilhó"},{"level":3,"code":170505,"name":"São Cristóvão de Mondim de Basto"},{"level":3,"code":170508,"name":"Vilar de Ferreiros"},{"level":3,"code":170509,"name":"União das freguesias de Campanhó e Paradança"},{"level":3,"code":170510,"name":"União das freguesias de Ermelo e Pardelhas"},{"level":2,"code":1706,"name":"Montalegre"},{"level":3,"code":170601,"name":"Cabril"},{"level":3,"code":170603,"name":"Cervos"},{"level":3,"code":170604,"name":"Chã"},{"level":3,"code":170607,"name":"Covelo do Gerês"},{"level":3,"code":170609,"name":"Ferral"},{"level":3,"code":170612,"name":"Gralhas"},{"level":3,"code":170616,"name":"Morgade"},{"level":3,"code":170618,"name":"Negrões"},{"level":3,"code":170619,"name":"Outeiro"},{"level":3,"code":170623,"name":"Pitões das Junias"},{"level":3,"code":170625,"name":"Reigoso"},{"level":3,"code":170626,"name":"Salto"},{"level":3,"code":170627,"name":"Santo André"},{"level":3,"code":170629,"name":"Sarraquinhos"},{"level":3,"code":170631,"name":"Solveira"},{"level":3,"code":170632,"name":"Tourém"},{"level":3,"code":170635,"name":"Vila da Ponte"},{"level":3,"code":170636,"name":"União das freguesias de Cambeses do Rio, Donões e Mourilhe"},{"level":3,"code":170637,"name":"União das freguesias de Meixedo e Padornelos"},{"level":3,"code":170638,"name":"União das freguesias de Montalegre e Padroso"},{"level":3,"code":170639,"name":"União das freguesias de Paradela, Contim e Fiães"},{"level":3,"code":170640,"name":"União das freguesias de Sezelhe e Covelães"},{"level":3,"code":170641,"name":"União das freguesias de Venda Nova e Pondras"},{"level":3,"code":170642,"name":"União das freguesias de Viade de Baixo e Fervidelas"},{"level":3,"code":170643,"name":"União das freguesias de Vilar de Perdizes e Meixide"},{"level":2,"code":1707,"name":"Murça"},{"level":3,"code":170701,"name":"Candedo"},{"level":3,"code":170703,"name":"Fiolhoso"},{"level":3,"code":170704,"name":"Jou"},{"level":3,"code":170705,"name":"Murça"},{"level":3,"code":170708,"name":"Valongo de Milhais"},{"level":3,"code":170710,"name":"União das freguesias de Carva e Vilares"},{"level":3,"code":170711,"name":"União das freguesias de Noura e Palheiros"},{"level":2,"code":1708,"name":"Peso da Régua"},{"level":3,"code":170802,"name":"Fontelas"},{"level":3,"code":170805,"name":"Loureiro"},{"level":3,"code":170809,"name":"Sedielos"},{"level":3,"code":170810,"name":"Vilarinho dos Freires"},{"level":3,"code":170813,"name":"União das freguesias de Galafura e Covelinhas"},{"level":3,"code":170814,"name":"União das freguesias de Moura Morta e Vinhós"},{"level":3,"code":170815,"name":"União das freguesias de Peso da Régua e Godim"},{"level":3,"code":170816,"name":"União das freguesias de Poiares e Canelas"},{"level":2,"code":1709,"name":"Ribeira de Pena"},{"level":3,"code":170901,"name":"Alvadia"},{"level":3,"code":170902,"name":"Canedo"},{"level":3,"code":170906,"name":"Santa Marinha"},{"level":3,"code":170908,"name":"União das freguesias de Cerva e Limões"},{"level":3,"code":170909,"name":"União das freguesias de Ribeira de Pena (Salvador) e Santo Aleixo de Além-Tâmega"},{"level":2,"code":1710,"name":"Sabrosa"},{"level":3,"code":171001,"name":"Celeirós"},{"level":3,"code":171002,"name":"Covas do Douro"},{"level":3,"code":171004,"name":"Gouvinhas"},{"level":3,"code":171005,"name":"Parada de Pinhão"},{"level":3,"code":171007,"name":"Paços"},{"level":3,"code":171009,"name":"Sabrosa"},{"level":3,"code":171011,"name":"São Lourenço de Ribapinhão"},{"level":3,"code":171013,"name":"Souto Maior"},{"level":3,"code":171014,"name":"Torre do Pinhão"},{"level":3,"code":171015,"name":"Vilarinho de São Romão"},{"level":3,"code":171016,"name":"União das freguesias de Provesende, Gouvães do Douro e São Cristóvão do Douro"},{"level":3,"code":171017,"name":"União das freguesias de São Martinho de Antas e Paradela de Guiães"},{"level":2,"code":1711,"name":"Santa Marta de Penaguião"},{"level":3,"code":171101,"name":"Alvações do Corgo"},{"level":3,"code":171102,"name":"Cumieira"},{"level":3,"code":171103,"name":"Fontes"},{"level":3,"code":171106,"name":"Medrões"},{"level":3,"code":171110,"name":"Sever"},{"level":3,"code":171111,"name":"União das freguesias de Lobrigos (São Miguel e São João Baptista) e Sanhoane"},{"level":3,"code":171112,"name":"União das freguesias de Louredo e Fornelos"},{"level":2,"code":1712,"name":"Valpaços"},{"level":3,"code":171201,"name":"Água Revés e Crasto"},{"level":3,"code":171203,"name":"Algeriz"},{"level":3,"code":171205,"name":"Bouçoães"},{"level":3,"code":171206,"name":"Canaveses"},{"level":3,"code":171209,"name":"Ervões"},{"level":3,"code":171211,"name":"Fornos do Pinhal"},{"level":3,"code":171212,"name":"Friões"},{"level":3,"code":171215,"name":"Padrela e Tazem"},{"level":3,"code":171216,"name":"Possacos"},{"level":3,"code":171217,"name":"Rio Torto"},{"level":3,"code":171219,"name":"Santa Maria de Emeres"},{"level":3,"code":171220,"name":"Santa Valha"},{"level":3,"code":171221,"name":"Santiago da Ribeira de Alhariz"},{"level":3,"code":171222,"name":"São João da Corveira"},{"level":3,"code":171223,"name":"São Pedro de Veiga de Lila"},{"level":3,"code":171224,"name":"Serapicos"},{"level":3,"code":171227,"name":"Vales"},{"level":3,"code":171229,"name":"Vassal"},{"level":3,"code":171230,"name":"Veiga de Lila"},{"level":3,"code":171231,"name":"Vilarandelo"},{"level":3,"code":171232,"name":"Carrazedo de Montenegro e Curros"},{"level":3,"code":171233,"name":"Lebução, Fiães e Nozelos"},{"level":3,"code":171234,"name":"Sonim e Barreiros"},{"level":3,"code":171235,"name":"Tinhela e Alvarelhos"},{"level":3,"code":171236,"name":"Valpaços e Sanfins"},{"level":2,"code":1713,"name":"Vila Pouca de Aguiar"},{"level":3,"code":171302,"name":"Alfarela de Jales"},{"level":3,"code":171303,"name":"Bornes de Aguiar"},{"level":3,"code":171304,"name":"Bragado"},{"level":3,"code":171305,"name":"Capeludos"},{"level":3,"code":171310,"name":"Soutelo de Aguiar"},{"level":3,"code":171311,"name":"Telões"},{"level":3,"code":171312,"name":"Tresminas"},{"level":3,"code":171313,"name":"Valoura"},{"level":3,"code":171314,"name":"Vila Pouca de Aguiar"},{"level":3,"code":171315,"name":"Vreia de Bornes"},{"level":3,"code":171316,"name":"Vreia de Jales"},{"level":3,"code":171317,"name":"Sabroso de Aguiar"},{"level":3,"code":171319,"name":"Alvão"},{"level":3,"code":171320,"name":"União das freguesias de Pensalvos e Parada de Monteiros"},{"level":2,"code":1714,"name":"Vila Real"},{"level":3,"code":171401,"name":"Abaças"},{"level":3,"code":171403,"name":"Andrães"},{"level":3,"code":171404,"name":"Arroios"},{"level":3,"code":171406,"name":"Campeã"},{"level":3,"code":171409,"name":"Folhadela"},{"level":3,"code":171410,"name":"Guiães"},{"level":3,"code":171414,"name":"Lordelo"},{"level":3,"code":171415,"name":"Mateus"},{"level":3,"code":171416,"name":"Mondrões"},{"level":3,"code":171420,"name":"Parada de Cunhos"},{"level":3,"code":171426,"name":"Torgueda"},{"level":3,"code":171429,"name":"Vila Marim"},{"level":3,"code":171431,"name":"União das freguesias de Adoufe e Vilarinho de Samardã"},{"level":3,"code":171432,"name":"União das freguesias de Borbela e Lamas de Olo"},{"level":3,"code":171433,"name":"União das freguesias de Constantim e Vale de Nogueiras"},{"level":3,"code":171434,"name":"União das freguesias de Mouçós e Lamares"},{"level":3,"code":171435,"name":"União das freguesias de Nogueira e Ermida"},{"level":3,"code":171436,"name":"União das freguesias de Pena, Quintã e Vila Cova"},{"level":3,"code":171437,"name":"União das freguesias de São Tomé do Castelo e Justes"},{"level":3,"code":171438,"name":"Vila Real"},{"level":1,"code":18,"name":"Viseu"},{"level":2,"code":1801,"name":"Armamar"},{"level":3,"code":180101,"name":"Aldeias"},{"level":3,"code":180104,"name":"Cimbres"},{"level":3,"code":180106,"name":"Folgosa"},{"level":3,"code":180107,"name":"Fontelo"},{"level":3,"code":180109,"name":"Queimada"},{"level":3,"code":180110,"name":"Queimadela"},{"level":3,"code":180111,"name":"Santa Cruz"},{"level":3,"code":180114,"name":"São Cosmado"},{"level":3,"code":180115,"name":"São Martinho das Chãs"},{"level":3,"code":180118,"name":"Vacalar"},{"level":3,"code":180120,"name":"Armamar"},{"level":3,"code":180121,"name":"União das freguesias de Aricera e Goujoim"},{"level":3,"code":180122,"name":"União das freguesias de São Romão e Santiago"},{"level":3,"code":180123,"name":"União das freguesias de Vila Seca e Santo Adrião"},{"level":2,"code":1802,"name":"Carregal do Sal"},{"level":3,"code":180201,"name":"Beijós"},{"level":3,"code":180202,"name":"Cabanas de Viriato"},{"level":3,"code":180204,"name":"Oliveira do Conde"},{"level":3,"code":180206,"name":"Parada"},{"level":3,"code":180208,"name":"Carregal do Sal"},{"level":2,"code":1803,"name":"Castro Daire"},{"level":3,"code":180301,"name":"Almofala"},{"level":3,"code":180303,"name":"Cabril"},{"level":3,"code":180304,"name":"Castro Daire"},{"level":3,"code":180305,"name":"Cujó"},{"level":3,"code":180309,"name":"Gosende"},{"level":3,"code":180312,"name":"Mões"},{"level":3,"code":180313,"name":"Moledo"},{"level":3,"code":180314,"name":"Monteiras"},{"level":3,"code":180317,"name":"Pepim"},{"level":3,"code":180319,"name":"Pinheiro"},{"level":3,"code":180322,"name":"São Joaninho"},{"level":3,"code":180323,"name":"União das freguesias de Mamouros, Alva e Ribolhos"},{"level":3,"code":180324,"name":"União das freguesias de Mezio e Moura Morta"},{"level":3,"code":180325,"name":"União das freguesias de Parada de Ester e Ester"},{"level":3,"code":180326,"name":"União das freguesias de Picão e Ermida"},{"level":3,"code":180327,"name":"União das freguesias de Reriz e Gafanhão"},{"level":2,"code":1804,"name":"Cinfães"},{"level":3,"code":180403,"name":"Cinfães"},{"level":3,"code":180404,"name":"Espadanedo"},{"level":3,"code":180405,"name":"Ferreiros de Tendais"},{"level":3,"code":180406,"name":"Fornelos"},{"level":3,"code":180408,"name":"Moimenta"},{"level":3,"code":180409,"name":"Nespereira"},{"level":3,"code":180410,"name":"Oliveira do Douro"},{"level":3,"code":180412,"name":"Santiago de Piães"},{"level":3,"code":180413,"name":"São Cristóvão de Nogueira"},{"level":3,"code":180414,"name":"Souselo"},{"level":3,"code":180415,"name":"Tarouquela"},{"level":3,"code":180416,"name":"Tendais"},{"level":3,"code":180417,"name":"Travanca"},{"level":3,"code":180418,"name":"União das freguesias de Alhões, Bustelo, Gralheira e Ramires"},{"level":2,"code":1805,"name":"Lamego"},{"level":3,"code":180502,"name":"Avões"},{"level":3,"code":180504,"name":"Britiande"},{"level":3,"code":180505,"name":"Cambres"},{"level":3,"code":180507,"name":"Ferreirim"},{"level":3,"code":180508,"name":"Ferreiros de Avões"},{"level":3,"code":180509,"name":"Figueira"},{"level":3,"code":180510,"name":"Lalim"},{"level":3,"code":180511,"name":"Lazarim"},{"level":3,"code":180516,"name":"Penajóia"},{"level":3,"code":180517,"name":"Penude"},{"level":3,"code":180519,"name":"Samodães"},{"level":3,"code":180520,"name":"Sande"},{"level":3,"code":180523,"name":"Várzea de Abrunhais"},{"level":3,"code":180524,"name":"Vila Nova de Souto d'El-Rei"},{"level":3,"code":180525,"name":"Lamego (Almacave e Sé)"},{"level":3,"code":180526,"name":"União das freguesias de Bigorne, Magueija e Pretarouca"},{"level":3,"code":180527,"name":"União das freguesias de Cepões, Meijinhos e Melcões"},{"level":3,"code":180528,"name":"União das freguesias de Parada do Bispo e Valdigem"},{"level":2,"code":1806,"name":"Mangualde"},{"level":3,"code":180601,"name":"Abrunhosa-a-Velha"},{"level":3,"code":180602,"name":"Alcafache"},{"level":3,"code":180605,"name":"Cunha Baixa"},{"level":3,"code":180606,"name":"Espinho"},{"level":3,"code":180607,"name":"Fornos de Maceira Dão"},{"level":3,"code":180608,"name":"Freixiosa"},{"level":3,"code":180614,"name":"Quintela de Azurara"},{"level":3,"code":180616,"name":"São João da Fresta"},{"level":3,"code":180619,"name":"União das freguesias de Mangualde, Mesquitela e Cunha Alta"},{"level":3,"code":180620,"name":"União das freguesias de Moimenta de Maceira Dão e Lobelhe do Mato"},{"level":3,"code":180621,"name":"União das freguesias de Santiago de Cassurrães e Póvoa de Cervães"},{"level":3,"code":180622,"name":"União das freguesias de Tavares (Chãs, Várzea e Travanca)"},{"level":2,"code":1807,"name":"Moimenta da Beira"},{"level":3,"code":180702,"name":"Alvite"},{"level":3,"code":180703,"name":"Arcozelos"},{"level":3,"code":180705,"name":"Baldos"},{"level":3,"code":180706,"name":"Cabaços"},{"level":3,"code":180707,"name":"Caria"},{"level":3,"code":180708,"name":"Castelo"},{"level":3,"code":180709,"name":"Leomil"},{"level":3,"code":180710,"name":"Moimenta da Beira"},{"level":3,"code":180713,"name":"Passô"},{"level":3,"code":180716,"name":"Rua"},{"level":3,"code":180717,"name":"Sarzedo"},{"level":3,"code":180719,"name":"Sever"},{"level":3,"code":180720,"name":"Vilar"},{"level":3,"code":180721,"name":"União das freguesias de Paradinha e Nagosa"},{"level":3,"code":180722,"name":"União das freguesias de Pêra Velha, Aldeia de Nacomba e Ariz"},{"level":3,"code":180723,"name":"União das freguesias de Peva e Segões"},{"level":2,"code":1808,"name":"Mortágua"},{"level":3,"code":180802,"name":"Cercosa"},{"level":3,"code":180804,"name":"Espinho"},{"level":3,"code":180805,"name":"Marmeleira"},{"level":3,"code":180807,"name":"Pala"},{"level":3,"code":180808,"name":"Sobral"},{"level":3,"code":180809,"name":"Trezói"},{"level":3,"code":180811,"name":"União das freguesias de Mortágua, Vale de Remígio, Cortegaça e Almaça"},{"level":2,"code":1809,"name":"Nelas"},{"level":3,"code":180901,"name":"Canas de Senhorim"},{"level":3,"code":180903,"name":"Nelas"},{"level":3,"code":180905,"name":"Senhorim"},{"level":3,"code":180906,"name":"Vilar Seco"},{"level":3,"code":180908,"name":"Lapa do Lobo"},{"level":3,"code":180910,"name":"União das freguesias de Carvalhal Redondo e Aguieira"},{"level":3,"code":180911,"name":"União das freguesias de Santar e Moreira"},{"level":2,"code":1810,"name":"Oliveira de Frades"},{"level":3,"code":181002,"name":"Arcozelo das Maias"},{"level":3,"code":181005,"name":"Pinheiro"},{"level":3,"code":181007,"name":"Ribeiradio"},{"level":3,"code":181008,"name":"São João da Serra"},{"level":3,"code":181009,"name":"São Vicente de Lafões"},{"level":3,"code":181013,"name":"União das freguesias de Arca e Varzielas"},{"level":3,"code":181014,"name":"União das freguesias de Destriz e Reigoso"},{"level":3,"code":181015,"name":"União das freguesias de Oliveira de Frades, Souto de Lafões e Sejães"},{"level":2,"code":1811,"name":"Penalva do Castelo"},{"level":3,"code":181102,"name":"Castelo de Penalva"},{"level":3,"code":181103,"name":"Esmolfe"},{"level":3,"code":181104,"name":"Germil"},{"level":3,"code":181105,"name":"Ínsua"},{"level":3,"code":181106,"name":"Lusinde"},{"level":3,"code":181109,"name":"Pindo"},{"level":3,"code":181110,"name":"Real"},{"level":3,"code":181111,"name":"Sezures"},{"level":3,"code":181112,"name":"Trancozelos"},{"level":3,"code":181114,"name":"União das freguesias de Antas e Matela"},{"level":3,"code":181115,"name":"União das freguesias de Vila Cova do Covelo/Mareco"},{"level":2,"code":1812,"name":"Penedono"},{"level":3,"code":181202,"name":"Beselga"},{"level":3,"code":181203,"name":"Castainço"},{"level":3,"code":181207,"name":"Penela da Beira"},{"level":3,"code":181208,"name":"Póvoa de Penela"},{"level":3,"code":181209,"name":"Souto"},{"level":3,"code":181210,"name":"União das freguesias de Antas e Ourozinho"},{"level":3,"code":181211,"name":"União das freguesias de Penedono e Granja"},{"level":2,"code":1813,"name":"Resende"},{"level":3,"code":181302,"name":"Barrô"},{"level":3,"code":181303,"name":"Cárquere"},{"level":3,"code":181310,"name":"Paus"},{"level":3,"code":181311,"name":"Resende"},{"level":3,"code":181312,"name":"São Cipriano"},{"level":3,"code":181313,"name":"São João de Fontoura"},{"level":3,"code":181314,"name":"São Martinho de Mouros"},{"level":3,"code":181316,"name":"União das freguesias de Anreade e São Romão de Aregos"},{"level":3,"code":181317,"name":"União das freguesias de Felgueiras e Feirão"},{"level":3,"code":181318,"name":"União das freguesias de Freigil e Miomães"},{"level":3,"code":181319,"name":"União das freguesias de Ovadas e Panchorra"},{"level":2,"code":1814,"name":"Santa Comba Dão"},{"level":3,"code":181403,"name":"Pinheiro de Ázere"},{"level":3,"code":181405,"name":"São Joaninho"},{"level":3,"code":181406,"name":"São João de Areias"},{"level":3,"code":181410,"name":"União das freguesias de Ovoa e Vimieiro"},{"level":3,"code":181411,"name":"União das freguesias de Santa Comba Dão e Couto do Mosteiro"},{"level":3,"code":181412,"name":"União das freguesias de Treixedo e Nagozela"},{"level":2,"code":1815,"name":"São João da Pesqueira"},{"level":3,"code":181501,"name":"Castanheiro do Sul"},{"level":3,"code":181502,"name":"Ervedosa do Douro"},{"level":3,"code":181504,"name":"Nagozelo do Douro"},{"level":3,"code":181505,"name":"Paredes da Beira"},{"level":3,"code":181507,"name":"Riodades"},{"level":3,"code":181509,"name":"Soutelo do Douro"},{"level":3,"code":181511,"name":"Vale de Figueira"},{"level":3,"code":181512,"name":"Valongo dos Azeites"},{"level":3,"code":181515,"name":"União das freguesias de São João da Pesqueira e Várzea de Trevões"},{"level":3,"code":181516,"name":"União das freguesias de Trevões e Espinhosa"},{"level":3,"code":181517,"name":"União das freguesias de Vilarouco e Pereiros"},{"level":2,"code":1816,"name":"São Pedro do Sul"},{"level":3,"code":181602,"name":"Bordonhos"},{"level":3,"code":181606,"name":"Figueiredo de Alva"},{"level":3,"code":181607,"name":"Manhouce"},{"level":3,"code":181608,"name":"Pindelo dos Milagres"},{"level":3,"code":181609,"name":"Pinho"},{"level":3,"code":181612,"name":"São Félix"},{"level":3,"code":181615,"name":"Serrazes"},{"level":3,"code":181616,"name":"Sul"},{"level":3,"code":181617,"name":"Valadares"},{"level":3,"code":181619,"name":"Vila Maior"},{"level":3,"code":181620,"name":"União das freguesias de Carvalhais e Candal"},{"level":3,"code":181621,"name":"União das freguesias de Santa Cruz da Trapa e São Cristóvão de Lafões"},{"level":3,"code":181622,"name":"União das freguesias de São Martinho das Moitas e Covas do Rio"},{"level":3,"code":181623,"name":"União das freguesias de São Pedro do Sul, Várzea e Baiões"},{"level":2,"code":1817,"name":"Sátão"},{"level":3,"code":181702,"name":"Avelal"},{"level":3,"code":181704,"name":"Ferreira de Aves"},{"level":3,"code":181706,"name":"Mioma"},{"level":3,"code":181707,"name":"Rio de Moinhos"},{"level":3,"code":181709,"name":"São Miguel de Vila Boa"},{"level":3,"code":181710,"name":"Sátão"},{"level":3,"code":181711,"name":"Silvã de Cima"},{"level":3,"code":181713,"name":"União das freguesias de Águas Boas e Forles"},{"level":3,"code":181714,"name":"União das freguesias de Romãs, Decermilo e Vila Longa"},{"level":2,"code":1818,"name":"Sernancelhe"},{"level":3,"code":181801,"name":"Arnas"},{"level":3,"code":181802,"name":"Carregal"},{"level":3,"code":181803,"name":"Chosendo"},{"level":3,"code":181804,"name":"Cunha"},{"level":3,"code":181806,"name":"Faia"},{"level":3,"code":181810,"name":"Granjal"},{"level":3,"code":181811,"name":"Lamosa"},{"level":3,"code":181814,"name":"Quintela"},{"level":3,"code":181817,"name":"Vila da Ponte"},{"level":3,"code":181818,"name":"União das freguesias de Ferreirim e Macieira"},{"level":3,"code":181819,"name":"União das freguesias de Fonte Arcada e Escurquela"},{"level":3,"code":181820,"name":"União das freguesias de Penso e Freixinho"},{"level":3,"code":181821,"name":"União das freguesias de Sernancelhe e Sarzeda"},{"level":2,"code":1819,"name":"Tabuaço"},{"level":3,"code":181901,"name":"Adorigo"},{"level":3,"code":181902,"name":"Arcos"},{"level":3,"code":181904,"name":"Chavães"},{"level":3,"code":181905,"name":"Desejosa"},{"level":3,"code":181906,"name":"Granja do Tedo"},{"level":3,"code":181908,"name":"Longa"},{"level":3,"code":181913,"name":"Sendim"},{"level":3,"code":181914,"name":"Tabuaço"},{"level":3,"code":181917,"name":"Valença do Douro"},{"level":3,"code":181918,"name":"União das freguesias de Barcos e Santa Leocádia"},{"level":3,"code":181919,"name":"União das freguesias de Paradela e Granjinha"},{"level":3,"code":181920,"name":"União das freguesias de Pinheiros e Vale de Figueira"},{"level":3,"code":181921,"name":"União das freguesias de Távora e Pereiro"},{"level":2,"code":1820,"name":"Tarouca"},{"level":3,"code":182004,"name":"Mondim da Beira"},{"level":3,"code":182005,"name":"Salzedas"},{"level":3,"code":182006,"name":"São João de Tarouca"},{"level":3,"code":182009,"name":"Várzea da Serra"},{"level":3,"code":182011,"name":"União das freguesias de Gouviães e Ucanha"},{"level":3,"code":182012,"name":"União das freguesias de Granja Nova e Vila Chã da Beira"},{"level":3,"code":182013,"name":"União das freguesias de Tarouca e Dálvares"},{"level":2,"code":1821,"name":"Tondela"},{"level":3,"code":182102,"name":"Campo de Besteiros"},{"level":3,"code":182103,"name":"Canas de Santa Maria"},{"level":3,"code":182105,"name":"Castelões"},{"level":3,"code":182106,"name":"Dardavaz"},{"level":3,"code":182107,"name":"Ferreirós do Dão"},{"level":3,"code":182108,"name":"Guardão"},{"level":3,"code":182109,"name":"Lajeosa do Dão"},{"level":3,"code":182110,"name":"Lobão da Beira"},{"level":3,"code":182111,"name":"Molelos"},{"level":3,"code":182116,"name":"Parada de Gonta"},{"level":3,"code":182118,"name":"Santiago de Besteiros"},{"level":3,"code":182122,"name":"Tonda"},{"level":3,"code":182127,"name":"União das freguesias de Barreiro de Besteiros e Tourigo"},{"level":3,"code":182128,"name":"União das freguesias de Caparrosa e Silvares"},{"level":3,"code":182129,"name":"União das freguesias de Mouraz e Vila Nova da Rainha"},{"level":3,"code":182130,"name":"União das freguesias de São João do Monte e Mosteirinho"},{"level":3,"code":182131,"name":"União das freguesias de São Miguel do Outeiro e Sabugosa"},{"level":3,"code":182132,"name":"União das freguesias de Tondela e Nandufe"},{"level":3,"code":182133,"name":"União das freguesias de Vilar de Besteiros e Mosteiro de Fráguas"},{"level":2,"code":1822,"name":"Vila Nova de Paiva"},{"level":3,"code":182203,"name":"Pendilhe"},{"level":3,"code":182204,"name":"Queiriga"},{"level":3,"code":182205,"name":"Touro"},{"level":3,"code":182206,"name":"Vila Cova à Coelheira"},{"level":3,"code":182208,"name":"União das freguesias de Vila Nova de Paiva, Alhais e Fráguas"},{"level":2,"code":1823,"name":"Viseu"},{"level":3,"code":182301,"name":"Abraveses"},{"level":3,"code":182304,"name":"Bodiosa"},{"level":3,"code":182305,"name":"Calde"},{"level":3,"code":182306,"name":"Campo"},{"level":3,"code":182307,"name":"Cavernães"},{"level":3,"code":182310,"name":"Cota"},{"level":3,"code":182315,"name":"Fragosela"},{"level":3,"code":182316,"name":"Lordosa"},{"level":3,"code":182317,"name":"Silgueiros"},{"level":3,"code":182318,"name":"Mundão"},{"level":3,"code":182319,"name":"Orgens"},{"level":3,"code":182320,"name":"Povolide"},{"level":3,"code":182321,"name":"Ranhados"},{"level":3,"code":182322,"name":"Ribafeita"},{"level":3,"code":182323,"name":"Rio de Loba"},{"level":3,"code":182325,"name":"Santos Evos"},{"level":3,"code":182327,"name":"São João de Lourosa"},{"level":3,"code":182329,"name":"São Pedro de France"},{"level":3,"code":182335,"name":"União das freguesias de Barreiros e Cepões"},{"level":3,"code":182336,"name":"União das freguesias de Boa Aldeia, Farminhão e Torredeita"},{"level":3,"code":182337,"name":"Coutos de Viseu"},{"level":3,"code":182338,"name":"União das freguesias de Faíl e Vila Chã de Sá"},{"level":3,"code":182339,"name":"Repeses e São Salvador"},{"level":3,"code":182340,"name":"São Cipriano e Vil de Souto"},{"level":3,"code":182341,"name":"Viseu"},{"level":2,"code":1824,"name":"Vouzela"},{"level":3,"code":182401,"name":"Alcofra"},{"level":3,"code":182403,"name":"Campia"},{"level":3,"code":182407,"name":"Fornelo do Monte"},{"level":3,"code":182409,"name":"Queirã"},{"level":3,"code":182410,"name":"São Miguel do Mato"},{"level":3,"code":182411,"name":"Ventosa"},{"level":3,"code":182413,"name":"União das freguesias de Cambra e Carvalhal de Vermilhas"},{"level":3,"code":182414,"name":"União das freguesias de Fataunços e Figueiredo das Donas"},{"level":3,"code":182415,"name":"União das freguesias de Vouzela e Paços de Vilharigues"},{"level":1,"code":31,"name":"Ilha da Madeira"},{"level":2,"code":3101,"name":"Calheta"},{"level":3,"code":310101,"name":"Arco da Calheta"},{"level":3,"code":310102,"name":"Calheta"},{"level":3,"code":310103,"name":"Estreito da Calheta"},{"level":3,"code":310104,"name":"Fajã da Ovelha"},{"level":3,"code":310105,"name":"Jardim do Mar"},{"level":3,"code":310106,"name":"Paul do Mar"},{"level":3,"code":310107,"name":"Ponta do Pargo"},{"level":3,"code":310108,"name":"Prazeres"},{"level":2,"code":3102,"name":"Câmara de Lobos"},{"level":3,"code":310201,"name":"Câmara de Lobos"},{"level":3,"code":310202,"name":"Curral das Freiras"},{"level":3,"code":310203,"name":"Estreito de Câmara de Lobos"},{"level":3,"code":310204,"name":"Quinta Grande"},{"level":3,"code":310205,"name":"Jardim da Serra"},{"level":2,"code":3103,"name":"Funchal"},{"level":3,"code":310301,"name":"Imaculado Coração de Maria"},{"level":3,"code":310302,"name":"Monte"},{"level":3,"code":310303,"name":"Funchal (Santa Luzia)"},{"level":3,"code":310304,"name":"Funchal (Santa Maria Maior)"},{"level":3,"code":310305,"name":"Santo António"},{"level":3,"code":310306,"name":"São Gonçalo"},{"level":3,"code":310307,"name":"São Martinho"},{"level":3,"code":310308,"name":"Funchal (São Pedro)"},{"level":3,"code":310309,"name":"São Roque"},{"level":3,"code":310310,"name":"Funchal (Sé)"},{"level":2,"code":3104,"name":"Machico"},{"level":3,"code":310401,"name":"Água de Pena"},{"level":3,"code":310402,"name":"Caniçal"},{"level":3,"code":310403,"name":"Machico"},{"level":3,"code":310404,"name":"Porto da Cruz"},{"level":3,"code":310405,"name":"Santo António da Serra"},{"level":2,"code":3105,"name":"Ponta do Sol"},{"level":3,"code":310501,"name":"Canhas"},{"level":3,"code":310502,"name":"Madalena do Mar"},{"level":3,"code":310503,"name":"Ponta do Sol"},{"level":2,"code":3106,"name":"Porto Moniz"},{"level":3,"code":310601,"name":"Achadas da Cruz"},{"level":3,"code":310602,"name":"Porto Moniz"},{"level":3,"code":310603,"name":"Ribeira da Janela"},{"level":3,"code":310604,"name":"Seixal"},{"level":2,"code":3107,"name":"Ribeira Brava"},{"level":3,"code":310701,"name":"Campanário"},{"level":3,"code":310702,"name":"Ribeira Brava"},{"level":3,"code":310703,"name":"Serra de Água"},{"level":3,"code":310704,"name":"Tábua"},{"level":2,"code":3108,"name":"Santa Cruz"},{"level":3,"code":310802,"name":"Camacha"},{"level":3,"code":310803,"name":"Caniço"},{"level":3,"code":310804,"name":"Gaula"},{"level":3,"code":310805,"name":"Santa Cruz"},{"level":3,"code":310806,"name":"Santo António da Serra"},{"level":2,"code":3109,"name":"Santana"},{"level":3,"code":310901,"name":"Arco de São Jorge"},{"level":3,"code":310902,"name":"Faial"},{"level":3,"code":310903,"name":"Santana"},{"level":3,"code":310904,"name":"São Jorge"},{"level":3,"code":310905,"name":"São Roque do Faial"},{"level":3,"code":310906,"name":"Ilha"},{"level":2,"code":3110,"name":"São Vicente"},{"level":3,"code":311001,"name":"Boa Ventura"},{"level":3,"code":311002,"name":"Ponta Delgada"},{"level":3,"code":311003,"name":"São Vicente"},{"level":1,"code":32,"name":"Ilha de Porto Santo"},{"level":2,"code":3201,"name":"Porto Santo"},{"level":3,"code":320101,"name":"Porto Santo"},{"level":1,"code":41,"name":"Ilha de Santa Maria"},{"level":2,"code":4101,"name":"Vila do Porto"},{"level":3,"code":410101,"name":"Almagreira"},{"level":3,"code":410102,"name":"Santa Bárbara"},{"level":3,"code":410103,"name":"Santo Espírito"},{"level":3,"code":410104,"name":"São Pedro"},{"level":3,"code":410105,"name":"Vila do Porto"},{"level":1,"code":42,"name":"Ilha de São Miguel"},{"level":2,"code":4201,"name":"Lagoa"},{"level":3,"code":420101,"name":"Água de Pau"},{"level":3,"code":420102,"name":"Cabouco"},{"level":3,"code":420103,"name":"Lagoa (Nossa Senhora do Rosário)"},{"level":3,"code":420104,"name":"Lagoa (Santa Cruz)"},{"level":3,"code":420105,"name":"Ribeira Chã"},{"level":2,"code":4202,"name":"Nordeste"},{"level":3,"code":420201,"name":"Achada"},{"level":3,"code":420202,"name":"Achadinha"},{"level":3,"code":420203,"name":"Lomba da Fazenda"},{"level":3,"code":420204,"name":"Nordeste"},{"level":3,"code":420206,"name":"Salga"},{"level":3,"code":420207,"name":"Santana"},{"level":3,"code":420208,"name":"Algarvia"},{"level":3,"code":420209,"name":"Santo António de Nordestinho"},{"level":3,"code":420210,"name":"São Pedro de Nordestinho"},{"level":2,"code":4203,"name":"Ponta Delgada"},{"level":3,"code":420301,"name":"Arrifes"},{"level":3,"code":420303,"name":"Candelária"},{"level":3,"code":420304,"name":"Capelas"},{"level":3,"code":420305,"name":"Covoada"},{"level":3,"code":420306,"name":"Fajã de Baixo"},{"level":3,"code":420307,"name":"Fajã de Cima"},{"level":3,"code":420308,"name":"Fenais da Luz"},{"level":3,"code":420309,"name":"Feteiras"},{"level":3,"code":420310,"name":"Ginetes"},{"level":3,"code":420311,"name":"Mosteiros"},{"level":3,"code":420312,"name":"Ponta Delgada (São Sebastião)"},{"level":3,"code":420313,"name":"Ponta Delgada (São José)"},{"level":3,"code":420314,"name":"Ponta Delgada (São Pedro)"},{"level":3,"code":420315,"name":"Relva"},{"level":3,"code":420316,"name":"Remédios"},{"level":3,"code":420317,"name":"Rosto do Cão (Livramento)"},{"level":3,"code":420318,"name":"Rosto do Cão (São Roque)"},{"level":3,"code":420319,"name":"Santa Bárbara"},{"level":3,"code":420320,"name":"Santo António"},{"level":3,"code":420321,"name":"São Vicente Ferreira"},{"level":3,"code":420322,"name":"Sete Cidades"},{"level":3,"code":420323,"name":"Ajuda da Bretanha"},{"level":3,"code":420324,"name":"Pilar da Bretanha"},{"level":3,"code":420325,"name":"Santa Clara"},{"level":2,"code":4204,"name":"Povoação"},{"level":3,"code":420401,"name":"Água Retorta"},{"level":3,"code":420402,"name":"Faial da Terra"},{"level":3,"code":420403,"name":"Furnas"},{"level":3,"code":420404,"name":"Nossa Senhora dos Remédios"},{"level":3,"code":420405,"name":"Povoação"},{"level":3,"code":420406,"name":"Ribeira Quente"},{"level":2,"code":4205,"name":"Ribeira Grande"},{"level":3,"code":420501,"name":"Calhetas"},{"level":3,"code":420502,"name":"Fenais da Ajuda"},{"level":3,"code":420503,"name":"Lomba da Maia"},{"level":3,"code":420504,"name":"Lomba de São Pedro"},{"level":3,"code":420505,"name":"Maia"},{"level":3,"code":420506,"name":"Pico da Pedra"},{"level":3,"code":420507,"name":"Porto Formoso"},{"level":3,"code":420508,"name":"Rabo de Peixe"},{"level":3,"code":420509,"name":"Ribeira Grande (Conceição)"},{"level":3,"code":420510,"name":"Ribeira Grande (Matriz)"},{"level":3,"code":420511,"name":"Ribeira Seca"},{"level":3,"code":420512,"name":"Ribeirinha"},{"level":3,"code":420513,"name":"Santa Bárbara"},{"level":3,"code":420514,"name":"São Brás"},{"level":2,"code":4206,"name":"Vila Franca do Campo"},{"level":3,"code":420601,"name":"Água de Alto"},{"level":3,"code":420602,"name":"Ponta Garça"},{"level":3,"code":420603,"name":"Ribeira das Tainhas"},{"level":3,"code":420604,"name":"Vila Franca do Campo (São Miguel)"},{"level":3,"code":420605,"name":"Vila Franca do Campo (São Pedro)"},{"level":3,"code":420606,"name":"Ribeira Seca"},{"level":1,"code":43,"name":"Ilha Terceira"},{"level":2,"code":4301,"name":"Angra do Heroísmo"},{"level":3,"code":430101,"name":"Altares"},{"level":3,"code":430102,"name":"Angra (Nossa Senhora da Conceição)"},{"level":3,"code":430103,"name":"Angra (Santa Luzia)"},{"level":3,"code":430104,"name":"Angra (São Pedro)"},{"level":3,"code":430105,"name":"Angra (Sé)"},{"level":3,"code":430106,"name":"Cinco Ribeiras"},{"level":3,"code":430107,"name":"Doze Ribeiras"},{"level":3,"code":430108,"name":"Feteira"},{"level":3,"code":430109,"name":"Porto Judeu"},{"level":3,"code":430110,"name":"Posto Santo"},{"level":3,"code":430111,"name":"Raminho"},{"level":3,"code":430112,"name":"Ribeirinha"},{"level":3,"code":430113,"name":"Santa Bárbara"},{"level":3,"code":430114,"name":"São Bartolomeu de Regatos"},{"level":3,"code":430115,"name":"São Bento"},{"level":3,"code":430116,"name":"São Mateus da Calheta"},{"level":3,"code":430117,"name":"Serreta"},{"level":3,"code":430118,"name":"Terra Chã"},{"level":3,"code":430119,"name":"Vila de São Sebastião"},{"level":2,"code":4302,"name":"Vila da Praia da Vitória"},{"level":3,"code":430201,"name":"Agualva"},{"level":3,"code":430202,"name":"Biscoitos"},{"level":3,"code":430203,"name":"Cabo da Praia"},{"level":3,"code":430204,"name":"Fonte do Bastardo"},{"level":3,"code":430205,"name":"Fontinhas"},{"level":3,"code":430206,"name":"Lajes"},{"level":3,"code":430207,"name":"Praia da Vitória (Santa Cruz)"},{"level":3,"code":430208,"name":"Quatro Ribeiras"},{"level":3,"code":430209,"name":"São Brás"},{"level":3,"code":430210,"name":"Vila Nova"},{"level":3,"code":430211,"name":"Porto Martins"},{"level":1,"code":44,"name":"Ilha Graciosa"},{"level":2,"code":4401,"name":"Santa Cruz da Graciosa"},{"level":3,"code":440101,"name":"Guadalupe"},{"level":3,"code":440102,"name":"Luz"},{"level":3,"code":440103,"name":"São Mateus"},{"level":3,"code":440104,"name":"Santa Cruz da Graciosa"},{"level":1,"code":45,"name":"Ilha de São Jorge"},{"level":2,"code":4501,"name":"Calheta"},{"level":3,"code":450101,"name":"Calheta"},{"level":3,"code":450102,"name":"Norte Pequeno"},{"level":3,"code":450103,"name":"Ribeira Seca"},{"level":3,"code":450104,"name":"Santo Antão"},{"level":3,"code":450105,"name":"Topo (Nossa Senhora do Rosário)"},{"level":2,"code":4502,"name":"Velas"},{"level":3,"code":450201,"name":"Manadas (Santa Bárbara)"},{"level":3,"code":450202,"name":"Norte Grande (Neves)"},{"level":3,"code":450203,"name":"Rosais"},{"level":3,"code":450204,"name":"Santo Amaro"},{"level":3,"code":450205,"name":"Urzelina (São Mateus)"},{"level":3,"code":450206,"name":"Velas (São Jorge)"},{"level":1,"code":46,"name":"Ilha do Pico"},{"level":2,"code":4601,"name":"Lajes do Pico"},{"level":3,"code":460101,"name":"Calheta de Nesquim"},{"level":3,"code":460102,"name":"Lajes do Pico"},{"level":3,"code":460103,"name":"Piedade"},{"level":3,"code":460104,"name":"Ribeiras"},{"level":3,"code":460105,"name":"Ribeirinha"},{"level":3,"code":460106,"name":"São João"},{"level":2,"code":4602,"name":"Madalena"},{"level":3,"code":460201,"name":"Bandeiras"},{"level":3,"code":460202,"name":"Candelária"},{"level":3,"code":460203,"name":"Criação Velha"},{"level":3,"code":460204,"name":"Madalena"},{"level":3,"code":460205,"name":"São Caetano"},{"level":3,"code":460206,"name":"São Mateus"},{"level":2,"code":4603,"name":"São Roque do Pico"},{"level":3,"code":460301,"name":"Prainha"},{"level":3,"code":460302,"name":"Santa Luzia"},{"level":3,"code":460303,"name":"Santo Amaro"},{"level":3,"code":460304,"name":"Santo António"},{"level":3,"code":460305,"name":"São Roque do Pico"},{"level":1,"code":47,"name":"Ilha do Faial"},{"level":2,"code":4701,"name":"Horta"},{"level":3,"code":470101,"name":"Capelo"},{"level":3,"code":470102,"name":"Castelo Branco"},{"level":3,"code":470103,"name":"Cedros"},{"level":3,"code":470104,"name":"Feteira"},{"level":3,"code":470105,"name":"Flamengos"},{"level":3,"code":470106,"name":"Horta (Angústias)"},{"level":3,"code":470107,"name":"Horta (Conceição)"},{"level":3,"code":470108,"name":"Horta (Matriz)"},{"level":3,"code":470109,"name":"Pedro Miguel"},{"level":3,"code":470110,"name":"Praia do Almoxarife"},{"level":3,"code":470111,"name":"Praia do Norte"},{"level":3,"code":470112,"name":"Ribeirinha"},{"level":3,"code":470113,"name":"Salão"},{"level":1,"code":48,"name":"Ilha das Flores"},{"level":2,"code":4801,"name":"Lajes das Flores"},{"level":3,"code":480101,"name":"Fajã Grande"},{"level":3,"code":480102,"name":"Fajãzinha"},{"level":3,"code":480103,"name":"Fazenda"},{"level":3,"code":480104,"name":"Lajedo"},{"level":3,"code":480105,"name":"Lajes das Flores"},{"level":3,"code":480106,"name":"Lomba"},{"level":3,"code":480107,"name":"Mosteiro"},{"level":2,"code":4802,"name":"Santa Cruz das Flores"},{"level":3,"code":480201,"name":"Caveira"},{"level":3,"code":480202,"name":"Cedros"},{"level":3,"code":480203,"name":"Ponta Delgada"},{"level":3,"code":480204,"name":"Santa Cruz das Flores"},{"level":1,"code":49,"name":"Ilha do Corvo"},{"level":2,"code":4901,"name":"Corvo"},{"level":3,"code":490101,"name":"Corvo"}]

/***/ }),

/***/ 457:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(9);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var cName = {
    upper: "Objetivo",
    lower: "o objetivo!"
};

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            table: 'objetivos',
            name: 'objetivo',
            search: "",
            modal: false,
            deleteM: false,
            loading: true,
            searchP: '',
            headers: [{
                text: "#",
                align: "left",
                sortable: true,
                value: "id_objetivo"
            }, {
                text: "Nome",
                align: "left",
                sortable: true,
                value: "nome"
            }, {
                text: "Ações",
                value: "id",
                sortable: false,
                align: "center"
            }],
            DATA: [],
            editedIndex: -1,
            editedItem: {
                id_objetivo: 0,
                nome: "",
                descricao: ""
            },
            defaultItem: {
                id_objetivo: 0,
                nome: "",
                descricao: ""
            },
            messages: {
                add: {
                    success: cName.upper + " criado com sucesso!",
                    error: "Ocorreu um erro ao criar " + cName.lower
                },
                update: {
                    success: cName.upper + " alterado com sucesso!",
                    error: "Ocorreu um erro ao alterar " + cName.lower
                },
                delete: {
                    success: cName.upper + " eliminado com sucesso!",
                    error: "Ocorreu um erro ao apagar " + cName.lower
                },
                default: {
                    sucesso: "Sucesso",
                    error: "Ocorreu um erro!"
                }
            },
            defaultRules: null
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
        getAll: 'objetivos/getAll'
    }), {
        formTitle: function formTitle() {
            return this.editedIndex === -1 ? "Novo " + this.name : "Editar " + this.name;
        }
    }),

    watch: {
        modal: function modal(val) {
            val || this.close();
        },
        deleteM: function deleteM(val) {
            val || this.close();
        },
        getAll: function getAll(val) {
            this.initialize();
        }
    },

    created: function created() {
        var _this = this;

        this.defaultRules = [function (v) {
            return !!v || _this.$requiredField + '';
        }];
        this.initialize();
    },
    mounted: function mounted() {},

    methods: {
        toast: function toast(type, message) {
            if (type == "success") {
                return iziToast.show({
                    title: "SUCESSO",
                    color: "green",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            } else {
                return iziToast.show({
                    title: "AVISO",
                    color: "red",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            }
        },
        initialize: function initialize() {
            this.loading = true;
            this.DATA = this.getAll;
            this.loading = false;
        },
        editItem: function editItem(item, dialog) {
            this.editedIndex = this.DATA.indexOf(item);
            this.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);

            if (dialog) this.modal = true;else this.deleteM = true;
        },
        delete: function _delete() {
            var _this2 = this;

            if (!this.editedItem.id_objetivo) return;

            this.$store.dispatch(this.table + "/delete", { id: this.editedItem.id_objetivo }).then(function (res) {
                if (res) {
                    _this2.toast('success', _this2.messages.delete.success);_this2.initialize();
                } else _this2.toast('error', _this2.messages.delete.error);

                _this2.deleteM = false;
            });
        },
        close: function close() {
            var _this3 = this;

            this.modal = this.deleteM = false;
            setTimeout(function () {
                _this3.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this3.defaultItem);
                _this3.editedIndex = -1;

                _this3.$refs.form.reset();
            }, 110);
        },
        save: function save() {
            var _this4 = this;

            if (this.deleteM) {
                this.delete();return;
            }

            if (!this.$refs.form.validate()) return;

            if (this.editedIndex == -1) {
                this.$store.dispatch(this.table + "/insert", { nome: this.editedItem.nome, descricao: this.editedItem.descricao }).then(function (res) {
                    if (res) {
                        _this4.toast('success', _this4.messages.add.success);_this4.initialize();
                    } else _this4.toast('error', _this4.messages.add.error);

                    _this4.modal = false;
                });
            } else {
                this.$store.dispatch(this.table + "/update", { id: this.editedItem.id_objetivo, nome: this.editedItem.nome, descricao: this.editedItem.descricao }).then(function (res) {
                    if (res) {
                        _this4.toast('success', _this4.messages.update.success);_this4.initialize();
                    } else _this4.toast('error', _this4.messages.update.error);

                    _this4.modal = false;
                });
            }
        }
    }
});

/***/ }),

/***/ 458:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(9);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var cName = {
    upper: "Medida",
    lower: "a medida!"
};

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            table: 'medidas',
            name: 'medida',
            search: "",
            modal: false,
            deleteM: false,
            loading: true,
            searchP: '',
            headers: [{
                text: "#",
                align: "left",
                sortable: true,
                value: "id_medida"
            }, {
                text: "Nome",
                align: "left",
                sortable: true,
                value: "nome"
            }, {
                text: "Objetivo",
                align: "center",
                sortable: true,
                value: "id_objetivo"
            }, {
                text: "Ações",
                value: "id",
                sortable: false,
                align: "center"
            }],
            DATA: [],
            editedIndex: -1,
            editedItem: {
                id_medida: 0,
                nome: "",
                descricao: "",
                id_objetivo: 0
            },
            defaultItem: {
                id_medida: 0,
                nome: "",
                descricao: "",
                id_objetivo: 0
            },
            messages: {
                add: {
                    success: cName.upper + " criada com sucesso!",
                    error: "Ocorreu um erro ao criar " + cName.lower
                },
                update: {
                    success: cName.upper + " alterada com sucesso!",
                    error: "Ocorreu um erro ao alterar " + cName.lower
                },
                delete: {
                    success: cName.upper + " eliminada com sucesso!",
                    error: "Ocorreu um erro ao apagar " + cName.lower
                },
                default: {
                    sucesso: "Sucesso",
                    error: "Ocorreu um erro!"
                }
            },
            defaultRules: null
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
        getAll: 'medidas/getAll',
        getObjetivos: 'objetivos/getAll',
        getObjetivoById: 'objetivos/getById'
    }), {
        formTitle: function formTitle() {
            return this.editedIndex === -1 ? "Nova " + this.name : "Editar " + this.name;
        }
    }),

    watch: {
        modal: function modal(val) {
            val || this.close();
        },
        deleteM: function deleteM(val) {
            val || this.close();
        },
        getAll: function getAll(val) {
            this.initialize();
        }
    },

    created: function created() {
        var _this = this;

        this.defaultRules = [function (v) {
            return !!v || _this.$requiredField + '';
        }];
        this.initialize();
    },
    mounted: function mounted() {},

    methods: {
        toast: function toast(type, message) {
            if (type == "success") {
                return iziToast.show({
                    title: "SUCESSO",
                    color: "green",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            } else {
                return iziToast.show({
                    title: "AVISO",
                    color: "red",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            }
        },
        initialize: function initialize() {
            this.loading = true;
            this.DATA = this.getAll;
            this.loading = false;
        },
        editItem: function editItem(item, dialog) {
            this.editedIndex = this.DATA.indexOf(item);
            this.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);

            if (dialog) this.modal = true;else this.deleteM = true;
        },
        delete: function _delete() {
            var _this2 = this;

            if (!this.editedItem.id_medida) return;

            this.$store.dispatch(this.table + "/delete", { id: this.editedItem.id_medida }).then(function (res) {
                if (res) {
                    _this2.toast('success', _this2.messages.delete.success);_this2.initialize();
                } else _this2.toast('error', _this2.messages.delete.error);

                _this2.deleteM = false;
            });
        },
        close: function close() {
            var _this3 = this;

            this.modal = this.deleteM = false;
            setTimeout(function () {
                _this3.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this3.defaultItem);
                _this3.editedIndex = -1;

                _this3.$refs.form.reset();
            }, 110);
        },
        save: function save() {
            var _this4 = this;

            if (this.deleteM) {
                this.delete();return;
            }

            if (!this.$refs.form.validate()) return;

            if (this.editedIndex == -1) {
                this.$store.dispatch(this.table + "/insert", { nome: this.editedItem.nome, id_objetivo: this.editedItem.id_objetivo, descricao: this.editedItem.descricao }).then(function (res) {
                    if (res) {
                        _this4.toast('success', _this4.messages.add.success);_this4.initialize();
                    } else _this4.toast('error', _this4.messages.add.error);

                    _this4.modal = false;
                });
            } else {
                this.$store.dispatch(this.table + "/update", { id: this.editedItem.id_medida, nome: this.editedItem.nome, id_objetivo: this.editedItem.id_objetivo, descricao: this.editedItem.descricao }).then(function (res) {
                    if (res) {
                        _this4.toast('success', _this4.messages.update.success);_this4.initialize();
                    } else _this4.toast('error', _this4.messages.update.error);

                    _this4.modal = false;
                });
            }
        }
    }
});

/***/ }),

/***/ 459:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(9);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var cName = {
    upper: "Ação",
    lower: "a ação!"
};

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            table: 'acoes',
            name: 'ação',
            search: "",
            modal: false,
            deleteM: false,
            loading: true,
            searchP: '',
            headers: [{
                text: "#",
                align: "left",
                sortable: true,
                value: "id_acao"
            }, {
                text: "Nome",
                align: "left",
                sortable: true,
                value: "nome"
            }, {
                text: "Medida",
                align: "center",
                sortable: true,
                value: "id_medida"
            }, {
                text: "Formulário",
                align: "center",
                sortable: true,
                value: "id_formulario"
            }, {
                text: "Ações",
                value: "id",
                sortable: false,
                align: "center"
            }],
            DATA: [],
            editedIndex: -1,
            editedItem: {
                id_acao: 0,
                nome: "",
                descricao: "",
                id_medida: 0,
                id_formulario: 0
            },
            defaultItem: {
                id_acao: 0,
                nome: "",
                descricao: "",
                id_medida: 0,
                id_formulario: 0
            },
            messages: {
                add: {
                    success: cName.upper + " criada com sucesso!",
                    error: "Ocorreu um erro ao criar " + cName.lower
                },
                update: {
                    success: cName.upper + " alterada com sucesso!",
                    error: "Ocorreu um erro ao alterar " + cName.lower
                },
                delete: {
                    success: cName.upper + " eliminada com sucesso!",
                    error: "Ocorreu um erro ao apagar " + cName.lower
                },
                default: {
                    sucesso: "Sucesso",
                    error: "Ocorreu um erro!"
                }
            },
            defaultRules: null
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
        getAll: 'acoes/getAll',
        getMedidas: 'medidas/getAll',
        getMedidaById: 'medidas/getById',
        getFormularios: 'formularios/getAll',
        getFormularioById: 'formularios/getById'
    }), {
        formTitle: function formTitle() {
            return this.editedIndex === -1 ? "Nova " + this.name : "Editar " + this.name;
        }
    }),

    watch: {
        modal: function modal(val) {
            val || this.close();
        },
        deleteM: function deleteM(val) {
            val || this.close();
        },
        getAll: function getAll(val) {
            this.initialize();
        }
    },

    created: function created() {
        var _this = this;

        this.defaultRules = [function (v) {
            return !!v || _this.$requiredField + '';
        }];
        this.initialize();
    },
    mounted: function mounted() {},

    methods: {
        toast: function toast(type, message) {
            if (type == "success") {
                return iziToast.show({
                    title: "SUCESSO",
                    color: "green",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            } else {
                return iziToast.show({
                    title: "AVISO",
                    color: "red",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            }
        },
        initialize: function initialize() {
            this.loading = true;
            this.DATA = this.getAll;
            this.loading = false;
        },
        editItem: function editItem(item, dialog) {
            this.editedIndex = this.DATA.indexOf(item);
            this.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);

            if (dialog) this.modal = true;else this.deleteM = true;
        },
        delete: function _delete() {
            var _this2 = this;

            if (!this.editedItem.id_acao) return;

            this.$store.dispatch(this.table + "/delete", { id: this.editedItem.id_acao }).then(function (res) {
                if (res) {
                    _this2.toast('success', _this2.messages.delete.success);_this2.initialize();
                } else _this2.toast('error', _this2.messages.delete.error);

                _this2.deleteM = false;
            });
        },
        close: function close() {
            var _this3 = this;

            this.modal = this.deleteM = false;
            setTimeout(function () {
                _this3.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this3.defaultItem);
                _this3.editedIndex = -1;

                _this3.$refs.form.reset();
            }, 110);
        },
        save: function save() {
            var _this4 = this;

            if (this.deleteM) {
                this.delete();return;
            }

            if (!this.$refs.form.validate()) return;

            if (this.editedIndex == -1) {
                this.$store.dispatch(this.table + "/insert", { nome: this.editedItem.nome, id_medida: this.editedItem.id_medida, id_formulario: this.editedItem.id_formulario, descricao: this.editedItem.descricao }).then(function (res) {
                    if (res) {
                        _this4.toast('success', _this4.messages.add.success);_this4.initialize();
                    } else _this4.toast('error', _this4.messages.add.error);

                    _this4.modal = false;
                });
            } else {
                this.$store.dispatch(this.table + "/update", { id: this.editedItem.id_acao, nome: this.editedItem.nome, id_medida: this.editedItem.id_medida, id_formulario: this.editedItem.id_formulario, descricao: this.editedItem.descricao }).then(function (res) {
                    if (res) {
                        _this4.toast('success', _this4.messages.update.success);_this4.initialize();
                    } else _this4.toast('error', _this4.messages.update.error);

                    _this4.modal = false;
                });
            }
        }
    }
});

/***/ }),

/***/ 460:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(9);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var cName = {
    upper: "Dimensão",
    lower: "a dimensão!"
};

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            table: 'dimensoes',
            name: 'dimensão',
            search: "",
            modal: false,
            deleteM: false,
            loading: true,
            searchP: '',
            sorted: [],
            headers: [{
                text: "Ordem",
                align: "left",
                sortable: false,
                value: "id_dimensao"
            }, {
                text: "Nome",
                align: "left",
                sortable: true,
                value: "nome"
            }, {
                text: "Ações",
                value: "id",
                sortable: false,
                align: "center"
            }],
            DATA: [],
            editedIndex: -1,
            editedItem: {
                id_dimensao: 0,
                nome: "",
                local: 0
            },
            defaultItem: {
                id_dimensao: 0,
                nome: "",
                local: 0
            },
            messages: {
                add: {
                    success: cName.upper + " criada com sucesso!",
                    error: "Ocorreu um erro ao criar " + cName.lower
                },
                update: {
                    success: cName.upper + " alterada com sucesso!",
                    error: "Ocorreu um erro ao alterar " + cName.lower
                },
                delete: {
                    success: cName.upper + " eliminada com sucesso!",
                    error: "Ocorreu um erro ao apagar " + cName.lower
                },
                default: {
                    sucesso: "Sucesso",
                    error: "Ocorreu um erro!"
                }
            },
            defaultRules: null
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])({
        getAll: 'dimensoes/getAll'
    }), {
        formTitle: function formTitle() {
            return this.editedIndex === -1 ? "Novo " + this.name : "Editar " + this.name;
        }
    }),

    watch: {
        modal: function modal(val) {
            val || this.close();
        },
        deleteM: function deleteM(val) {
            val || this.close();
        },
        getAll: function getAll(val) {
            this.initialize();
        }
    },

    created: function created() {
        var _this = this;

        this.defaultRules = [function (v) {
            return !!v || _this.$requiredField + '';
        }];
        this.initialize();
    },
    mounted: function mounted() {},

    methods: {
        toast: function toast(type, message) {
            if (type == "success") {
                return iziToast.show({
                    title: "SUCESSO",
                    color: "green",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            } else {
                return iziToast.show({
                    title: "AVISO",
                    color: "red",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            }
        },
        sortDimensao: function sortDimensao() {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.DATA), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var d = _step.value;

                    this.$store.dispatch(this.table + "/update", { id: d.id_dimensao, ordem: d.ordem });
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        getItems: function getItems() {
            var aux = [];
            for (var i in this.DATA) {
                aux.push({ id: Number(i) + 1, nome: Number(i) + 1, d: this.DATA[i].id_dimensao });
            }return aux;
        },
        initialize: function initialize() {
            this.loading = true;
            this.DATA = this.getAll;
            this.loading = false;
        },
        editItem: function editItem(item, dialog) {
            this.editedIndex = this.DATA.indexOf(item);
            this.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);

            if (dialog) this.modal = true;else this.deleteM = true;
        },
        delete: function _delete() {
            var _this2 = this;

            if (!this.editedItem.id_dimensao) return;

            this.$store.dispatch(this.table + "/delete", { id: this.editedItem.id_dimensao }).then(function (res) {
                if (res) {
                    _this2.toast('success', _this2.messages.delete.success);_this2.initialize();
                } else _this2.toast('error', _this2.messages.delete.error);

                _this2.deleteM = false;
            });
        },
        close: function close() {
            var _this3 = this;

            this.modal = this.deleteM = false;
            setTimeout(function () {
                _this3.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this3.defaultItem);
                _this3.editedIndex = -1;

                _this3.$refs.form.reset();
            }, 110);
        },
        save: function save() {
            var _this4 = this;

            if (this.deleteM) {
                this.delete();return;
            }

            if (!this.$refs.form.validate()) return;

            if (this.editedIndex == -1) {
                this.$store.dispatch(this.table + "/insert", { nome: this.editedItem.nome, ordem: this.DATA.length + 1 }).then(function (res) {
                    if (res) {
                        _this4.toast('success', _this4.messages.add.success);_this4.initialize();
                    } else _this4.toast('error', _this4.messages.add.error);

                    _this4.modal = false;
                });
            } else {
                this.$store.dispatch(this.table + "/update", { id: this.editedItem.id_dimensao, nome: this.editedItem.nome }).then(function (res) {
                    if (res) {
                        _this4.toast('success', _this4.messages.update.success);_this4.initialize();
                    } else _this4.toast('error', _this4.messages.update.error);

                    _this4.modal = false;
                });
            }
        }
    }
});

/***/ }),

/***/ 461:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(9);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var cName = {
    upper: "Pergunta",
    lower: "a pergunta!"
};

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            isLoading: false,
            table: 'perguntas',
            name: 'pergunta',
            search: "",
            modal: false,
            deleteM: false,
            loading: true,
            searchP: '',
            isExpansivel: [{ expansivel: 0, nome: 'Não expansível' }, { expansivel: 1, nome: 'Expansível' }],
            pergunta: {
                nome: '',
                id_dimensao: 0,
                id_tipo: 0,
                required: 1,
                children: [],
                expansivel: 0
            },
            headers: [{
                text: "#",
                align: "left",
                sortable: true,
                value: "id_pergunta"
            }, {
                text: "Nome",
                align: "left",
                sortable: true,
                value: "nome"
            }, {
                text: "Ações",
                value: "id",
                sortable: false,
                align: "center"
            }],
            DATA: [],
            editedIndex: -1,
            defaultItem: {
                nome: '',
                id_dimensao: 0,
                id_tipo: 0,
                required: 1,
                children: [],
                expansivel: 0
            },
            messages: {
                add: {
                    success: cName.upper + " criada com sucesso!",
                    error: "Ocorreu um erro ao criar " + cName.lower
                },
                update: {
                    success: cName.upper + " alterada com sucesso!",
                    error: "Ocorreu um erro ao alterar " + cName.lower
                },
                delete: {
                    success: cName.upper + " eliminada com sucesso!",
                    error: "Ocorreu um erro ao apagar " + cName.lower
                },
                default: {
                    sucesso: "Sucesso",
                    error: "Ocorreu um erro!"
                }
            },
            defaultRules: null
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])({
        getAll: 'perguntas/getAll',
        getDimensoes: 'dimensoes/getAll',
        getDimensaoById: 'dimensoes/getById',
        getTipos: 'tipos/getAll'
    }), {
        formTitle: function formTitle() {
            return this.editedIndex === -1 ? "Nova " + this.name : "Editar " + this.name;
        }
    }),

    watch: {
        modal: function modal(val) {
            val || this.close();
        },
        deleteM: function deleteM(val) {
            val || this.close();
        },
        getAll: function getAll(val) {
            this.initialize();
        }
    },

    created: function created() {
        var _this = this;

        this.defaultRules = [function (v) {
            return !!v || _this.$requiredField + '';
        }];
        this.initialize();
    },
    mounted: function mounted() {},

    methods: {
        deleteChildChild: function deleteChildChild(child, c) {
            var _this2 = this;

            if (this.editedIndex == -1) child.children.splice(child.children.findIndex(function (e) {
                return e.id_pergunta == c.id_pergunta;
            }), 1);else {
                this.$store.dispatch(this.table + "/delete", { id: c.id_pergunta }).then(function (res) {
                    if (res) {
                        _this2.toast('success', _this2.messages.delete.success);child.children.splice(child.children.findIndex(function (e) {
                            return e.id_pergunta == c.id_pergunta;
                        }), 1);
                    } else _this2.toast('error', _this2.messages.delete.error);
                });
            }
        },
        deleteChild: function deleteChild(parent, child) {
            var _this3 = this;

            if (this.editedIndex == -1) this.pergunta.children.find(function (el) {
                return el.id_pergunta == parent.id_pergunta;
            }).children.splice(this.pergunta.children.find(function (el) {
                return el.id_pergunta == parent.id_pergunta;
            }).children.findIndex(function (e) {
                return e.id_pergunta == child.id_pergunta;
            }), 1);else {
                this.$store.dispatch(this.table + "/delete", { id: child.id_pergunta }).then(function (res) {
                    if (res) {
                        _this3.toast('success', _this3.messages.delete.success);_this3.pergunta.children.find(function (el) {
                            return el.id_pergunta == parent.id_pergunta;
                        }).children.splice(_this3.pergunta.children.find(function (el) {
                            return el.id_pergunta == parent.id_pergunta;
                        }).children.findIndex(function (e) {
                            return e.id_pergunta == child.id_pergunta;
                        }), 1);
                    } else _this3.toast('error', _this3.messages.delete.error);
                });
            }
        },
        addChild: function addChild(child) {
            this.pergunta.children.find(function (el) {
                return el.id_pergunta == child.id_pergunta;
            }).children.push({ id_pergunta: child.children.length, expansivel: 0, nome: '', children: [], id_tipo: 0 });
        },
        addChildChild: function addChildChild(child, c) {
            this.pergunta.children.find(function (el) {
                return el.id_pergunta == child.id_pergunta;
            }).children.find(function (e) {
                return e.id_pergunta == c.id_pergunta;
            }).children.push({ id_pergunta: c.children.length, nome: '', id_tipo: 0, expansivel: 0 });
        },
        deleteChildren: function deleteChildren(child) {
            var _this4 = this;

            if (this.editedIndex == -1) this.pergunta.children.splice(this.pergunta.children.findIndex(function (el) {
                return el.id_pergunta == child.id_pergunta;
            }), 1);else {
                this.$store.dispatch(this.table + "/delete", { id: child.id_pergunta }).then(function (res) {
                    if (res) {
                        _this4.toast('success', _this4.messages.delete.success);_this4.pergunta.children.splice(_this4.pergunta.children.findIndex(function (el) {
                            return el.id_pergunta == child.id_pergunta;
                        }), 1);
                    } else _this4.toast('error', _this4.messages.delete.error);
                });
            }
        },
        addChildren: function addChildren() {
            //if(!this.$refs.form.validate()) return;

            this.pergunta.children.push({ id_pergunta: this.pergunta.children.length, nome: '', id_tipo: 0, expansivel: 0, children: [], required: this.pergunta.id_tipo == 5 ? 1 : 0 });
        },
        changeTipo: function changeTipo() {
            if (this.pergunta.id_tipo == 3 || this.pergunta.id_tipo == 8 || this.pergunta.id_tipo == 4 || this.pergunta.id_tipo == 6 || this.pergunta.id_tipo == 7) this.pergunta.children = [];
        },
        changeTipoChild: function changeTipoChild(child) {
            if (child.id_tipo == 3 || child.id_tipo == 8 || child.id_tipo == 4 || child.id_tipo == 6 || child.id_tipo == 7) child.children = [];
        },
        toast: function toast(type, message) {
            if (type == "success") {
                return iziToast.show({
                    title: "SUCESSO",
                    color: "green",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            } else {
                return iziToast.show({
                    title: "AVISO",
                    color: "red",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            }
        },
        initialize: function initialize() {
            this.loading = true;
            this.DATA = this.getAll;
            this.loading = false;
        },
        editItem: function editItem(item, dialog) {
            var _this5 = this;

            if (dialog) {
                this.isLoading = true;
                this.modal = true;
                __WEBPACK_IMPORTED_MODULE_5__store_axios__["a" /* instance */].get("/pergunta/" + item.id_pergunta).then(function (res) {
                    _this5.editedIndex = _this5.DATA.indexOf(item);
                    _this5.pergunta = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, res.data.data[0]);
                    _this5.isLoading = false;
                });
            } else {
                this.editedIndex = this.DATA.indexOf(item);
                this.pergunta = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, item);
                this.deleteM = true;
            }
        },
        delete: function _delete() {
            var _this6 = this;

            if (!this.pergunta.id_pergunta) return;

            this.$store.dispatch(this.table + "/delete", { id: this.pergunta.id_pergunta }).then(function (res) {
                if (res) {
                    _this6.toast('success', _this6.messages.delete.success);_this6.initialize();
                } else _this6.toast('error', _this6.messages.delete.error);

                _this6.deleteM = false;
            });
        },
        close: function close() {
            var _this7 = this;

            this.modal = this.deleteM = this.isLoading = false;
            setTimeout(function () {
                delete _this7.pergunta.children;
                _this7.editedIndex = -1;

                setTimeout(function () {
                    _this7.$refs.form.reset();
                    _this7.pergunta = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, _this7.defaultItem);
                }, 50);
            }, 110);
        },
        save: function save() {
            var _this8 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                var status, perguntas;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!_this8.deleteM) {
                                    _context.next = 3;
                                    break;
                                }

                                _this8.delete();return _context.abrupt("return");

                            case 3:
                                if (_this8.$refs.form.validate()) {
                                    _context.next = 5;
                                    break;
                                }

                                return _context.abrupt("return");

                            case 5:
                                _context.next = 7;
                                return _this8.checkForm(_this8.pergunta);

                            case 7:
                                status = _context.sent;

                                if (status) {
                                    _context.next = 11;
                                    break;
                                }

                                _this8.toast('error', 'O formulario não está preenchido corretamente!');return _context.abrupt("return");

                            case 11:
                                if (!(_this8.editedIndex == -1)) {
                                    _context.next = 16;
                                    break;
                                }

                                _this8.pergunta.required = _this8.pergunta.required ? 1 : 0;
                                _this8.$store.dispatch(_this8.table + "/insert", { pergunta: _this8.pergunta }).then(function (res) {

                                    if (res) {
                                        _this8.toast('success', _this8.messages.add.success);_this8.initialize();
                                    } else _this8.toast('error', _this8.messages.add.error);

                                    _this8.modal = false;
                                });
                                _context.next = 20;
                                break;

                            case 16:
                                _context.next = 18;
                                return _this8.prepareArray(_this8.pergunta);

                            case 18:
                                perguntas = _context.sent;


                                _this8.$store.dispatch(_this8.table + "/update", { perguntas: perguntas }).then(function (res) {
                                    if (res) {
                                        _this8.toast('success', _this8.messages.update.success);_this8.initialize();
                                    } else _this8.toast('error', _this8.messages.update.error);

                                    _this8.modal = false;
                                });

                            case 20:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this8);
            }))();
        },
        checkForm: function checkForm(pergunta) {
            var completed = [];
            var i = 0;
            if (pergunta.id_tipo == 5) {
                if (!pergunta.hasOwnProperty('children') || pergunta.hasOwnProperty('children') && pergunta.children.length == 0) completed.push(false);else {
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(pergunta.children), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var c = _step.value;

                            i++;
                            if (c.id_tipo == 1 || c.id_tipo == 2) {
                                if (c.children.length == 0) completed.push(false);else {
                                    var _iteratorNormalCompletion2 = true;
                                    var _didIteratorError2 = false;
                                    var _iteratorError2 = undefined;

                                    try {
                                        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(c.children), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                            var n = _step2.value;

                                            if (n.expansivel) {
                                                if (n.id_tipo < 5 && n.children.length == 0) completed.push(false);else completed.push(true);
                                            } else completed.push(true);
                                        }
                                    } catch (err) {
                                        _didIteratorError2 = true;
                                        _iteratorError2 = err;
                                    } finally {
                                        try {
                                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                                _iterator2.return();
                                            }
                                        } finally {
                                            if (_didIteratorError2) {
                                                throw _iteratorError2;
                                            }
                                        }
                                    }
                                }
                            } else completed.push(true);

                            if (i == pergunta.children.length) return completed.findIndex(function (el) {
                                return el == false;
                            }) == -1 ? true : false;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            } else if (pergunta.id_tipo == 1 || pergunta.id_tipo == 2) {
                if (!pergunta.hasOwnProperty('children') || pergunta.hasOwnProperty('children') && pergunta.children.length == 0) completed.push(false);else {
                    var _iteratorNormalCompletion3 = true;
                    var _didIteratorError3 = false;
                    var _iteratorError3 = undefined;

                    try {
                        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(pergunta.children), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                            var c = _step3.value;

                            i++;
                            if (c.expansivel) {
                                if (c.children.length == 0) completed.push(false);else {
                                    var _iteratorNormalCompletion4 = true;
                                    var _didIteratorError4 = false;
                                    var _iteratorError4 = undefined;

                                    try {
                                        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(c.children), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                                            var n = _step4.value;

                                            if (n.expansivel) {
                                                if (n.id_tipo < 5 && n.children.length == 0) completed.push(false);else completed.push(true);
                                            } else completed.push(true);
                                        }
                                    } catch (err) {
                                        _didIteratorError4 = true;
                                        _iteratorError4 = err;
                                    } finally {
                                        try {
                                            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                                _iterator4.return();
                                            }
                                        } finally {
                                            if (_didIteratorError4) {
                                                throw _iteratorError4;
                                            }
                                        }
                                    }
                                }
                            } else completed.push(true);

                            if (i == pergunta.children.length) return completed.findIndex(function (el) {
                                return el == false;
                            }) == -1 ? true : false;
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                _iterator3.return();
                            }
                        } finally {
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }
                }
            } else return true;
        },
        prepareArray: function prepareArray(pergunta) {
            var aux = [];

            if (pergunta.id_tipo == 5) {
                aux.push({ id: pergunta.id_pergunta, nome: pergunta.nome, required: pergunta.required ? 1 : 0, expansivel: pergunta.expansivel, id_dimensao: pergunta.id_dimensao });
                var _iteratorNormalCompletion5 = true;
                var _didIteratorError5 = false;
                var _iteratorError5 = undefined;

                try {
                    for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(pergunta.children), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                        var c = _step5.value;

                        aux.push({ id: c.id_pergunta, nome: c.nome, required: c.required ? 1 : 0, expansivel: c.expansivel, id_dimensao: c.id_dimensao });
                        if (c.children.length > 0) {
                            var _iteratorNormalCompletion6 = true;
                            var _didIteratorError6 = false;
                            var _iteratorError6 = undefined;

                            try {
                                for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(c.children), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                                    var n = _step6.value;

                                    aux.push({ id: n.id_pergunta, nome: n.nome, required: n.required ? 1 : 0, expansivel: n.expansivel, id_dimensao: n.id_dimensao });
                                    if (n.expansivel) {
                                        var _iteratorNormalCompletion7 = true;
                                        var _didIteratorError7 = false;
                                        var _iteratorError7 = undefined;

                                        try {
                                            for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(n.children), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                                                var nn = _step7.value;

                                                aux.push({ id: nn.id_pergunta, nome: nn.nome, required: nn.required ? 1 : 0, expansivel: nn.expansivel, id_dimensao: nn.id_dimensao });
                                            }
                                        } catch (err) {
                                            _didIteratorError7 = true;
                                            _iteratorError7 = err;
                                        } finally {
                                            try {
                                                if (!_iteratorNormalCompletion7 && _iterator7.return) {
                                                    _iterator7.return();
                                                }
                                            } finally {
                                                if (_didIteratorError7) {
                                                    throw _iteratorError7;
                                                }
                                            }
                                        }
                                    }
                                }
                            } catch (err) {
                                _didIteratorError6 = true;
                                _iteratorError6 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion6 && _iterator6.return) {
                                        _iterator6.return();
                                    }
                                } finally {
                                    if (_didIteratorError6) {
                                        throw _iteratorError6;
                                    }
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError5 = true;
                    _iteratorError5 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion5 && _iterator5.return) {
                            _iterator5.return();
                        }
                    } finally {
                        if (_didIteratorError5) {
                            throw _iteratorError5;
                        }
                    }
                }
            } else {
                if (pergunta.id_tipo == 1 || pergunta.id_tipo == 2) {
                    aux.push({ id: pergunta.id_pergunta, nome: pergunta.nome, required: pergunta.required ? 1 : 0, expansivel: pergunta.expansivel, id_dimensao: pergunta.id_dimensao });
                    var _iteratorNormalCompletion8 = true;
                    var _didIteratorError8 = false;
                    var _iteratorError8 = undefined;

                    try {
                        for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(pergunta.children), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                            var c = _step8.value;

                            aux.push({ id: c.id_pergunta, nome: c.nome, required: c.required ? 1 : 0, expansivel: c.expansivel, id_dimensao: c.id_dimensao });
                            if (c.children.length > 0) {
                                var _iteratorNormalCompletion9 = true;
                                var _didIteratorError9 = false;
                                var _iteratorError9 = undefined;

                                try {
                                    for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(c.children), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                                        var n = _step9.value;

                                        aux.push({ id: n.id_pergunta, nome: n.nome, required: n.required ? 1 : 0, expansivel: n.expansivel, id_dimensao: n.id_dimensao });
                                        if (n.expansivel) {
                                            var _iteratorNormalCompletion10 = true;
                                            var _didIteratorError10 = false;
                                            var _iteratorError10 = undefined;

                                            try {
                                                for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(n.children), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                                                    var nn = _step10.value;

                                                    aux.push({ id: nn.id_pergunta, nome: nn.nome, required: nn.required ? 1 : 0, expansivel: nn.expansivel, id_dimensao: nn.id_dimensao });
                                                }
                                            } catch (err) {
                                                _didIteratorError10 = true;
                                                _iteratorError10 = err;
                                            } finally {
                                                try {
                                                    if (!_iteratorNormalCompletion10 && _iterator10.return) {
                                                        _iterator10.return();
                                                    }
                                                } finally {
                                                    if (_didIteratorError10) {
                                                        throw _iteratorError10;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError9 = true;
                                    _iteratorError9 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion9 && _iterator9.return) {
                                            _iterator9.return();
                                        }
                                    } finally {
                                        if (_didIteratorError9) {
                                            throw _iteratorError9;
                                        }
                                    }
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError8 = true;
                        _iteratorError8 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion8 && _iterator8.return) {
                                _iterator8.return();
                            }
                        } finally {
                            if (_didIteratorError8) {
                                throw _iteratorError8;
                            }
                        }
                    }
                } else aux.push({ id: pergunta.id_pergunta, nome: pergunta.nome, required: pergunta.required ? 1 : 0, expansivel: pergunta.expansivel, id_dimensao: pergunta.id_dimensao });
            }

            return aux;
        }
    }
});

/***/ }),

/***/ 462:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(9);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var cName = {
    upper: "Formulário",
    lower: "o formulário!"
};

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            isLoading: false,
            table: 'formularios',
            name: 'formulário',
            search: "",
            modal: false,
            deleteM: false,
            loading: true,
            searchP: '',
            headers: [{
                text: "#",
                align: "left",
                sortable: true,
                value: "id_formulario"
            }, {
                text: "Nome",
                align: "left",
                sortable: true,
                value: "nome"
            }, {
                text: "Ações",
                value: "id",
                sortable: false,
                align: "center"
            }],
            DATA: [],
            editedIndex: -1,
            editedItem: {
                id_formulario: 0,
                nome: "",
                perguntas: []
            },
            defaultItem: {
                id_formulario: 0,
                nome: "",
                perguntas: []
            },
            messages: {
                add: {
                    success: cName.upper + " criado com sucesso!",
                    error: "Ocorreu um erro ao criar " + cName.lower
                },
                update: {
                    success: cName.upper + " alterado com sucesso!",
                    error: "Ocorreu um erro ao alterar " + cName.lower
                },
                delete: {
                    success: cName.upper + " eliminado com sucesso!",
                    error: "Ocorreu um erro ao apagar " + cName.lower
                },
                default: {
                    sucesso: "Sucesso",
                    error: "Ocorreu um erro!"
                }
            },
            defaultRules: null
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])({
        getAll: 'formularios/getAll',
        getPerguntas: 'perguntas/getAll'
    }), {
        formTitle: function formTitle() {
            return this.editedIndex === -1 ? "Novo " + this.name : "Editar " + this.name;
        }
    }),

    watch: {
        modal: function modal(val) {
            val || this.close();
        },
        deleteM: function deleteM(val) {
            val || this.close();
        },
        getAll: function getAll(val) {
            this.initialize();
        }
    },

    created: function created() {
        var _this = this;

        this.defaultRules = [function (v) {
            return !!v || _this.$requiredField + '';
        }];
        this.initialize();
    },
    mounted: function mounted() {},

    methods: {
        toast: function toast(type, message) {
            if (type == "success") {
                return iziToast.show({
                    title: "SUCESSO",
                    color: "green",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            } else {
                return iziToast.show({
                    title: "AVISO",
                    color: "red",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            }
        },
        initialize: function initialize() {
            this.loading = true;
            this.DATA = this.getAll;
            this.loading = false;
        },
        editItem: function editItem(item, dialog) {
            var _this2 = this;

            this.editedIndex = this.DATA.indexOf(item);

            if (dialog) {
                this.isLoading = true;
                this.modal = true;
                __WEBPACK_IMPORTED_MODULE_4__store_axios__["a" /* instance */].get("/formulario/" + item.id_formulario).then(function (res) {
                    _this2.editedItem = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, res.data.data[0]);
                    _this2.isLoading = false;
                });
            } else {
                this.editedItem = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, item);
                this.deleteM = true;
            }
        },
        delete: function _delete() {
            var _this3 = this;

            if (!this.editedItem.id_formulario) return;

            this.$store.dispatch(this.table + "/delete", { id: this.editedItem.id_formulario }).then(function (res) {
                if (res) {
                    _this3.toast('success', _this3.messages.delete.success);_this3.initialize();
                } else _this3.toast('error', _this3.messages.delete.error);

                _this3.deleteM = false;
            });
        },
        close: function close() {
            var _this4 = this;

            this.modal = this.deleteM = this.isLoading = false;
            setTimeout(function () {
                _this4.editedItem = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this4.defaultItem);
                _this4.editedIndex = -1;

                _this4.$refs.form.reset();
            }, 110);
        },
        save: function save() {
            var _this5 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!_this5.deleteM) {
                                    _context.next = 3;
                                    break;
                                }

                                _this5.delete();return _context.abrupt("return");

                            case 3:
                                if (_this5.$refs.form.validate()) {
                                    _context.next = 5;
                                    break;
                                }

                                return _context.abrupt("return");

                            case 5:
                                if (!(_this5.editedItem.perguntas.length == 0)) {
                                    _context.next = 8;
                                    break;
                                }

                                _this5.toast('error', 'O formulário deve ter no minimo uma pergunta associada.');return _context.abrupt("return");

                            case 8:
                                if (!(_this5.editedIndex == -1)) {
                                    _context.next = 12;
                                    break;
                                }

                                _this5.$store.dispatch(_this5.table + "/insert", { formulario: _this5.editedItem }).then(function (res) {
                                    if (res) {
                                        _this5.toast('success', _this5.messages.add.success);_this5.initialize();
                                    } else _this5.toast('error', _this5.messages.add.error);

                                    _this5.modal = false;
                                });
                                _context.next = 16;
                                break;

                            case 12:
                                _context.next = 14;
                                return _this5.formatArray();

                            case 14:
                                _this5.editedItem.perguntas = _context.sent;


                                _this5.$store.dispatch(_this5.table + "/update", { formulario: _this5.editedItem }).then(function (res) {
                                    if (res) {
                                        _this5.toast('success', _this5.messages.update.success);_this5.initialize();
                                    } else _this5.toast('error', _this5.messages.update.error);

                                    _this5.modal = false;
                                });

                            case 16:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this5);
            }))();
        },
        formatArray: function formatArray() {
            return this.editedItem.perguntas.hasOwnProperty('id_pf') ? this.editedItem.perguntas.map(function (el) {
                return el.id_pergunta;
            }) : this.editedItem.perguntas;
        }
    }
});

/***/ }),

/***/ 463:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(9);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var cName = {
    upper: "Setor",
    lower: "o setor!"
};

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            table: 'setores',
            name: 'setor',
            search: "",
            modal: false,
            deleteM: false,
            loading: true,
            searchP: '',
            headers: [{
                text: "#",
                align: "left",
                sortable: true,
                value: "id_setor"
            }, {
                text: "Nome",
                align: "left",
                sortable: true,
                value: "nome"
            }, {
                text: "Ações",
                value: "id",
                sortable: false,
                align: "center"
            }],
            DATA: [],
            editedIndex: -1,
            editedItem: {
                id_setor: 0,
                nome: ""
            },
            defaultItem: {
                id_setor: 0,
                nome: ""
            },
            messages: {
                add: {
                    success: cName.upper + " criado com sucesso!",
                    error: "Ocorreu um erro ao criar " + cName.lower
                },
                update: {
                    success: cName.upper + " alterado com sucesso!",
                    error: "Ocorreu um erro ao alterar " + cName.lower
                },
                delete: {
                    success: cName.upper + " eliminado com sucesso!",
                    error: "Ocorreu um erro ao apagar " + cName.lower
                },
                default: {
                    sucesso: "Sucesso",
                    error: "Ocorreu um erro!"
                }
            },
            defaultRules: null
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
        getAll: 'setores/getAll'
    }), {
        formTitle: function formTitle() {
            return this.editedIndex === -1 ? "Novo " + this.name : "Editar " + this.name;
        }
    }),

    watch: {
        modal: function modal(val) {
            val || this.close();
        },
        deleteM: function deleteM(val) {
            val || this.close();
        },
        getAll: function getAll(val) {
            this.initialize();
        }
    },

    created: function created() {
        var _this = this;

        this.defaultRules = [function (v) {
            return !!v || _this.$requiredField + '';
        }];
        this.initialize();
    },
    mounted: function mounted() {},

    methods: {
        toast: function toast(type, message) {
            if (type == "success") {
                return iziToast.show({
                    title: "SUCESSO",
                    color: "green",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            } else {
                return iziToast.show({
                    title: "AVISO",
                    color: "red",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            }
        },
        initialize: function initialize() {
            this.loading = true;
            this.DATA = this.getAll;
            this.loading = false;
        },
        editItem: function editItem(item, dialog) {
            this.editedIndex = this.DATA.indexOf(item);
            this.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);

            if (dialog) this.modal = true;else this.deleteM = true;
        },
        delete: function _delete() {
            var _this2 = this;

            if (!this.editedItem.id_setor) return;

            this.$store.dispatch(this.table + "/delete", { id: this.editedItem.id_setor }).then(function (res) {
                if (res) {
                    _this2.toast('success', _this2.messages.delete.success);_this2.initialize();
                } else _this2.toast('error', _this2.messages.delete.error);

                _this2.deleteM = false;
            });
        },
        close: function close() {
            var _this3 = this;

            this.modal = this.deleteM = false;
            setTimeout(function () {
                _this3.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this3.defaultItem);
                _this3.editedIndex = -1;

                _this3.$refs.form.reset();
            }, 110);
        },
        save: function save() {
            var _this4 = this;

            if (this.deleteM) {
                this.delete();return;
            }

            if (!this.$refs.form.validate()) return;

            if (this.editedIndex == -1) {
                this.$store.dispatch(this.table + "/insert", { nome: this.editedItem.nome }).then(function (res) {
                    if (res) {
                        _this4.toast('success', _this4.messages.add.success);_this4.initialize();
                    } else _this4.toast('error', _this4.messages.add.error);

                    _this4.modal = false;
                });
            } else {
                this.$store.dispatch(this.table + "/update", { id: this.editedItem.id_setor, nome: this.editedItem.nome }).then(function (res) {
                    if (res) {
                        _this4.toast('success', _this4.messages.update.success);_this4.initialize();
                    } else _this4.toast('error', _this4.messages.update.error);

                    _this4.modal = false;
                });
            }
        }
    }
});

/***/ }),

/***/ 464:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(9);








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var cName = {
  upper: "Planificação",
  lower: "a planificação!"
};

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _ref;

    return _ref = {
      table: "propostas",
      name: "planificação",
      search: "",
      generating: false,
      modal: false,
      deleteM: false,
      loading: true,
      waiting: false,
      exportingProgress: 0,
      addNova: false,
      subM: false,
      repM: false,
      reporteM: false,
      searchP: "",
      stepper: 1,
      stepper2: 1,
      stepper3: 1,
      headers: [{
        text: "Nome ação",
        align: "left",
        value: "design_acao"
      }, {
        text: "Ano",
        align: "center",
        value: "id_ano"
      }, {
        text: "Submetida?",
        align: "center",
        value: "id_proposta"
      }, {
        text: "Reporte?",
        align: "center",
        value: "id_proposta"
      }, {
        text: "Ações",
        value: "id",
        sortable: false,
        align: "center"
      }],
      DATA: [],
      FILTRO: {
        id_objetivo: 0,
        id_medida: 0,
        id_acao: 0,
        id_ano: 0,
        id_instituicao: 0
      }
    }, __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "stepper", 0), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "editedIndex", -1), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "formulario", []), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "ID", 0), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "allowed", false), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "editedItem", {
      id_proposta: 0,
      id_instituicao: 0,
      id_objetivo: 0,
      id_medida: 0,
      id_acao: 0,
      id_ano: "",
      id_distrito: "",
      quem: "",
      descricao: "",
      data_criacao: "",
      data_modificacao: "",
      submetida: 0,
      data_submetida: "",
      reporte: 0,
      data_reporte: "",
      id_tipo_acao: 0,
      design_acao: "",
      design_proj: "",
      mes: "",
      dia: ""
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "defaultItem", {
      id_proposta: 0,
      id_instituicao: 0,
      id_objetivo: 0,
      id_medida: 0,
      id_acao: 0,
      id_ano: "",
      id_distrito: "",
      quem: "",
      descricao: "",
      data_criacao: "",
      data_modificacao: "",
      submetida: 0,
      data_submetida: "",
      reporte: 0,
      data_reporte: "",
      id_tipo_acao: 0,
      design_acao: "",
      design_proj: "",
      mes: "",
      dia: ""
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "NOVA", {
      id_objetivo: 0,
      id_medida: 0,
      id_acao: 0,
      ano1: "",
      ano2: "",
      ano3: "",
      ano4: "",
      ano5: "",
      id_instituicao: 0
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "DEFAULT_NOVA", {
      id_objetivo: 0,
      id_medida: 0,
      id_acao: 0,
      ano1: "",
      ano2: "",
      ano3: "",
      ano4: "",
      ano5: "",
      id_instituicao: 0
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "messages", {
      add: {
        success: cName.upper + " criada com sucesso!",
        error: "Ocorreu um erro ao criar " + cName.lower
      },
      update: {
        success: cName.upper + " alterada com sucesso!",
        error: "Ocorreu um erro ao alterar " + cName.lower
      },
      delete: {
        success: cName.upper + " eliminada com sucesso!",
        error: "Ocorreu um erro ao apagar " + cName.lower
      },
      default: {
        sucesso: "Sucesso",
        error: "Ocorreu um erro!"
      }
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "defaultRules", null), _ref;
  },

  computed: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapGetters */])({
    getSession: "session/getState",
    getAll: "propostas/getAll",
    getObjetivos: "objetivos/getAll",
    getMedidasByObjetivo: "medidas/getMedidasByObjetivo",
    getAcoesByMedida: "acoes/getAcoesByMedida",
    getDistritos: "distritos/getAll",
    getSetores: "setores/getAll",
    getAnos: "anos/getAll",
    getMeses: "meses/getAll",
    getAnoById: "anos/getById",
    getMedidaById: "medidas/getById",
    getObjetivoById: "objetivos/getById",
    getTiposAcao: "tipos_acao/getAll",
    getAcaoById: "acoes/getById",
    isPlanificacaoAberta: "fases/isPlanificacaoAberta",
    isReporteAberta: "fases/isReporteAberta",
    getFormularioById: "formularios/getById",
    getPerguntaById: "perguntas/getById",
    getDimensaoById: "dimensoes/getById",
    getLivresAno: "propostas/getLivresAno",
    getInstituicaoById: "instituicoes/getById"
  }), {
    formTitle: function formTitle() {
      return this.editedIndex === -1 ? "Nova " + this.name : "Editar " + this.name;
    }
  }),

  watch: {
    modal: function modal(val) {
      val || this.close();
    },
    deleteM: function deleteM(val) {
      val || this.close();
    },
    getAll: function getAll(val) {
      this.initialize();
    }
  },

  created: function created() {
    var _this = this;

    this.defaultRules = [function (v) {
      return !!v || _this.$requiredField + "";
    }];
    this.initialize();
  },
  mounted: function mounted() {
    this.FILTRO.id_instituicao = this.getSession.user.id_instituicao;
  },

  methods: {
    filtrar: function filtrar() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
        var array;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                array = [].concat(_this2.getAll);

                if (!(_this2.FILTRO.id_objetivo > 0)) {
                  _context.next = 5;
                  break;
                }

                _context.next = 4;
                return _this2.filterObjetivo(array);

              case 4:
                array = _context.sent;

              case 5:
                if (!(_this2.FILTRO.id_medida > 0)) {
                  _context.next = 9;
                  break;
                }

                _context.next = 8;
                return _this2.filterMedida(array);

              case 8:
                array = _context.sent;

              case 9:
                if (!(_this2.FILTRO.id_acao > 0)) {
                  _context.next = 13;
                  break;
                }

                _context.next = 12;
                return _this2.filterAcao(array);

              case 12:
                array = _context.sent;

              case 13:
                if (!(_this2.FILTRO.id_ano > 0)) {
                  _context.next = 17;
                  break;
                }

                _context.next = 16;
                return _this2.filterAno(array);

              case 16:
                array = _context.sent;

              case 17:

                _this2.DATA = array;

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    filterObjetivo: function filterObjetivo(array) {
      var _this3 = this;

      return array.filter(function (el) {
        return el.id_objetivo == _this3.FILTRO.id_objetivo;
      });
    },
    filterMedida: function filterMedida(array) {
      var _this4 = this;

      return array.filter(function (el) {
        return el.id_medida == _this4.FILTRO.id_medida;
      });
    },
    filterAcao: function filterAcao(array) {
      var _this5 = this;

      return array.filter(function (el) {
        return el.id_acao == _this5.FILTRO.id_acao;
      });
    },
    filterInstituicao: function filterInstituicao(array) {
      var _this6 = this;

      return array.filter(function (el) {
        return el.id_instituicao == _this6.FILTRO.id_instituicao;
      });
    },
    filterAno: function filterAno(array) {
      var _this7 = this;

      return array.filter(function (el) {
        return el.id_ano == _this7.FILTRO.id_ano;
      });
    },
    limpar: function limpar() {
      this.FILTRO = {
        id_objetivo: 0,
        id_medida: 0,
        id_acao: 0,
        id_ano: 0,
        id_instituicao: this.getSession.user.id_instituicao
      };
      this.initialize();
    },
    changeAno: function changeAno() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this8.getLivresAno(_this8.editedItem.id_ano, _this8.editedItem.id_acao, _this8.getSession.user.id_instituicao);

              case 2:
                _this8.ID = _context2.sent;


                _this8.allowed = _this8.ID > 0;

                if (!_this8.allowed) _this8.toast("error", "Não é possivel criar mais planificações para o ano e ação indicados.");

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this8);
      }))();
    },
    changeObjetivo: function changeObjetivo() {
      this.editedItem.id_medida = 0;
      this.editedItem.id_acao = 0;
      this.stepper2 = 2;
    },
    changeMedida: function changeMedida() {
      this.editedItem.id_acao = 0;
      this.stepper2 = 3;
    },
    changeAcao: function changeAcao() {
      this.stepper2 = 4;
    },
    changeObjetivo2: function changeObjetivo2() {
      this.NOVA.id_medida = 0;
      this.NOVA.id_acao = 0;
      this.stepper3 = 2;
    },
    changeMedida2: function changeMedida2() {
      this.NOVA.id_acao = 0;
      this.stepper3 = 3;
    },
    changeAcao2: function changeAcao2() {
      this.stepper3 = 4;
    },
    isFormCompleted: function isFormCompleted() {
      if (this.formulario.length == 0) return;

      var completed = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.formulario), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var f = _step.value;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(f.children), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var p = _step2.value;

              completed.push(this.checkedCompleted(p.pergunta));
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return completed.findIndex(function (el) {
        return el == false;
      }) == -1 ? true : false;
    },
    forceUpdate: function forceUpdate() {
      this.$forceUpdate();
    },
    prevStep: function prevStep() {
      if (this.stepper > 1) this.stepper--;
    },
    nextStep: function nextStep() {
      if (this.stepper < this.formulario.length) this.stepper++;
    },
    changeCheck: function changeCheck(pergunta, child, type) {
      var ini = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      if (type == 1) {
        if (ini) child.checked = true;else {
          if (child.checked) {
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
              for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(pergunta.children), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var p = _step3.value;

                if (p.id_pergunta != child.id_pergunta) p.checked = false;
              }
            } catch (err) {
              _didIteratorError3 = true;
              _iteratorError3 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }
              } finally {
                if (_didIteratorError3) {
                  throw _iteratorError3;
                }
              }
            }

            pergunta.valor = child.id_pergunta;
          } else {
            child.checked = false;
            pergunta.valor = null;

            if (child.children && child.children.length) {
              var _iteratorNormalCompletion4 = true;
              var _didIteratorError4 = false;
              var _iteratorError4 = undefined;

              try {
                for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(child.children), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                  var p = _step4.value;

                  p.checked = false;
                }
              } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion4 && _iterator4.return) {
                    _iterator4.return();
                  }
                } finally {
                  if (_didIteratorError4) {
                    throw _iteratorError4;
                  }
                }
              }
            }
          }
        }
      } else if (type == 2) {
        pergunta.valor = typeof pergunta.valor == "undefined" ? [] : pergunta.valor;

        if (ini) child.checked = true;else {
          if (pergunta.valor.findIndex(function (el) {
            return el == child.id_pergunta;
          }) > -1) pergunta.valor.splice(pergunta.valor.findIndex(function (el) {
            return el == child.id_pergunta;
          }), 1);else pergunta.valor.push(child.id_pergunta);

          if (!child.checked) {
            if (child.children && child.children.length) {
              var _iteratorNormalCompletion5 = true;
              var _didIteratorError5 = false;
              var _iteratorError5 = undefined;

              try {
                for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(child.children), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                  var p = _step5.value;

                  p.checked = false;
                }
              } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion5 && _iterator5.return) {
                    _iterator5.return();
                  }
                } finally {
                  if (_didIteratorError5) {
                    throw _iteratorError5;
                  }
                }
              }
            }
          }
        }
      }

      this.forceUpdate();
    },
    checkedCompleted: function checkedCompleted(item) {
      var aux = [];

      if (typeof item != "undefined" && item.hasOwnProperty("children")) {
        if (item.id_tipo == 5) {
          var _iteratorNormalCompletion6 = true;
          var _didIteratorError6 = false;
          var _iteratorError6 = undefined;

          try {
            for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(item.children), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
              var c = _step6.value;

              if (c.required) {
                if (!c.hasOwnProperty("valor")) aux.push(false);else {
                  if (c.id_tipo == 2) aux.push(c.valor.length > 0);else if (!c.valor) aux.push(false);
                }
              }
            }
          } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
              }
            } finally {
              if (_didIteratorError6) {
                throw _iteratorError6;
              }
            }
          }
        } else {
          if (item.required) {
            if (!item.hasOwnProperty("valor")) aux.push(false);else {
              if (item.id_tipo == 2) aux.push(item.valor.length > 0);else if (!item.valor) aux.push(false);
            }
          }
        }

        return aux.findIndex(function (el) {
          return el == false;
        }) == -1 ? true : false;
      } else return false;
    },
    checkedPerguntaCompleted: function checkedPerguntaCompleted(item) {
      var aux = [];

      if (typeof item != "undefined" && item.hasOwnProperty("children")) {
        var _iteratorNormalCompletion7 = true;
        var _didIteratorError7 = false;
        var _iteratorError7 = undefined;

        try {
          for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(item.children), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
            var pergunta = _step7.value;

            if (pergunta.pergunta.id_tipo == 5) {
              var _iteratorNormalCompletion8 = true;
              var _didIteratorError8 = false;
              var _iteratorError8 = undefined;

              try {
                for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(pergunta.pergunta.children), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                  var c = _step8.value;

                  if (c.required) {
                    if (!c.hasOwnProperty("valor")) aux.push(false);else {
                      if (c.id_tipo == 2) aux.push(c.valor.length > 0);else if (!c.valor) aux.push(false);
                    }
                  }
                }
              } catch (err) {
                _didIteratorError8 = true;
                _iteratorError8 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion8 && _iterator8.return) {
                    _iterator8.return();
                  }
                } finally {
                  if (_didIteratorError8) {
                    throw _iteratorError8;
                  }
                }
              }
            } else {
              if (pergunta.pergunta.required) {
                if (!pergunta.pergunta.hasOwnProperty("valor")) aux.push(false);else {
                  if (pergunta.pergunta.id_tipo == 2) aux.push(pergunta.pergunta.valor.length > 0);else if (!pergunta.pergunta.valor) aux.push(false);
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError7 = true;
          _iteratorError7 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion7 && _iterator7.return) {
              _iterator7.return();
            }
          } finally {
            if (_didIteratorError7) {
              throw _iteratorError7;
            }
          }
        }

        return aux.findIndex(function (el) {
          return el == false;
        }) == -1 ? true : false;
      } else return false;
    },
    getLegenda: function getLegenda(tipo) {
      switch (tipo) {
        case 1:
          return "Apenas uma opção";
          break;
        case 2:
          return "Várias opções";
          break;

        case 3:
          return "Campo de texto aberto";
          break;

        case 4:
          return "Campo numérico";
          break;

        case 5:
          return "Pergunta com vários níveis";
          break;

        case 6:
          return "Seleção de distrito";
          break;

        case 7:
          return "Seleção de setor";
          break;

        case 8:
          return "Campo de texto longo";
          break;

        default:
          break;
      }
    },
    toast: function toast(type, message) {
      if (type == "success") {
        return iziToast.show({
          title: "SUCESSO",
          color: "green",
          timeout: this.$toastTimeout,
          message: message,
          position: this.$toastPosition
        });
      } else {
        return iziToast.show({
          title: "AVISO",
          color: "red",
          timeout: this.$toastTimeout,
          message: message,
          position: this.$toastPosition
        });
      }
    },
    initialize: function initialize() {
      this.loading = true;
      this.DATA = this.getAll;
      this.loading = false;
    },
    editItem: function editItem(item, dialog) {
      this.editedIndex = this.DATA.indexOf(item);
      this.editedItem = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, item);

      if (this.editedIndex > -1) this.stepper2 = 4;else this.stepper2 = 1;

      if (dialog) this.modal = true;else this.deleteM = true;
    },
    cloneItem: function cloneItem(item, dialog) {
      var _this9 = this;

      if (!confirm("Tem a certeza que deseja duplicar este item?")) {
        return false;
      }

      this.$store.dispatch(this.table + "/clonar", { id: item.id_proposta }).then(function (res) {
        _this9.toast("success", "Copiada com sucesso!");
        _this9.initialize();
      });
    },
    subReporte: function subReporte(state) {
      this.saveReporte(state);
    },
    delete: function _delete() {
      var _this10 = this;

      if (!this.editedItem.id_proposta) return;

      this.$store.dispatch(this.table + "/delete", {
        id: this.editedItem.id_proposta
      }).then(function (res) {
        if (res) {
          _this10.toast("success", _this10.messages.delete.success);
          _this10.initialize();
        } else _this10.toast("error", _this10.messages.delete.error);

        _this10.deleteM = false;
      });
    },
    close: function close() {
      var _this11 = this;

      this.modal = this.deleteM = this.subM = this.repM = this.addNova = this.reporteM = false;
      setTimeout(function () {
        _this11.editedIndex = -1;
        _this11.editedItem = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this11.defaultItem);
        _this11.NOVA = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this11.DEFAULT_NOVA);

        setTimeout(function () {
          _this11.stepper = 1;
          _this11.stepper2 = 1;
          _this11.stepper3 = 1;
          _this11.$refs.formReporte.reset();
        }, 50);

        _this11.$refs.form.reset();
      }, 110);
    },
    addPropostas: function addPropostas() {
      var _this12 = this;

      if (!this.$refs.formNova.validate()) return;

      this.NOVA.id_instituicao = this.getSession.user.id_instituicao;

      this.$store.dispatch(this.table + "/add", {
        data: this.NOVA,
        auto_proposta: 1
      }).then(function (res) {
        if (res) {
          _this12.toast("success", _this12.messages.add.success);
          _this12.initialize();
        } else _this12.toast("error", _this12.messages.add.error);

        _this12.addNova = false;
      });
    },
    prepareReporte: function prepareReporte(array) {
      var aux = [];
      var i = 0;

      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(array), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var a = _step9.value;

          i++;
          if (a.pergunta.id_tipo == 5) {
            if (a.pergunta.children.length == 0) {
              if (Array.isArray(a.pergunta.valor)) aux.push({
                pergunta: a.id_pergunta,
                valor: a.pergunta.valor.join(";")
              });else aux.push({
                pergunta: a.id_pergunta,
                valor: a.pergunta.valor
              });
            } else {
              var _iteratorNormalCompletion10 = true;
              var _didIteratorError10 = false;
              var _iteratorError10 = undefined;

              try {
                for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(a.pergunta.children), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                  var p = _step10.value;

                  if (Array.isArray(p.valor)) aux.push({
                    pergunta: p.id_pergunta,
                    valor: p.valor.join(";")
                  });else aux.push({
                    pergunta: p.id_pergunta,
                    valor: p.valor
                  });

                  if (p.children && p.children.length > 0) {
                    var _iteratorNormalCompletion11 = true;
                    var _didIteratorError11 = false;
                    var _iteratorError11 = undefined;

                    try {
                      for (var _iterator11 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(p.children), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
                        var pp = _step11.value;

                        if (Array.isArray(pp.valor)) aux.push({
                          pergunta: pp.id_pergunta,
                          valor: pp.valor.join(";")
                        });else aux.push({
                          pergunta: pp.id_pergunta,
                          valor: pp.valor
                        });
                      }
                    } catch (err) {
                      _didIteratorError11 = true;
                      _iteratorError11 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion11 && _iterator11.return) {
                          _iterator11.return();
                        }
                      } finally {
                        if (_didIteratorError11) {
                          throw _iteratorError11;
                        }
                      }
                    }
                  }
                }
              } catch (err) {
                _didIteratorError10 = true;
                _iteratorError10 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion10 && _iterator10.return) {
                    _iterator10.return();
                  }
                } finally {
                  if (_didIteratorError10) {
                    throw _iteratorError10;
                  }
                }
              }
            }
          } else {
            if (Array.isArray(a.pergunta.valor)) aux.push({
              pergunta: a.id_pergunta,
              valor: a.pergunta.valor.join(";")
            });else aux.push({
              pergunta: a.id_pergunta,
              valor: a.pergunta.valor
            });

            if (a.pergunta.children && a.pergunta.children.length > 0) {
              var _iteratorNormalCompletion12 = true;
              var _didIteratorError12 = false;
              var _iteratorError12 = undefined;

              try {
                for (var _iterator12 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(a.pergunta.children), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
                  var p = _step12.value;

                  if (Array.isArray(p.valor)) aux.push({
                    pergunta: p.id_pergunta,
                    valor: p.valor.join(";")
                  });else aux.push({
                    pergunta: p.id_pergunta,
                    valor: p.valor
                  });

                  if (p.children && p.children.length > 0) {
                    var _iteratorNormalCompletion13 = true;
                    var _didIteratorError13 = false;
                    var _iteratorError13 = undefined;

                    try {
                      for (var _iterator13 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(p.children), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
                        var pp = _step13.value;

                        if (Array.isArray(pp.valor)) aux.push({
                          pergunta: pp.id_pergunta,
                          valor: pp.valor.join(";")
                        });else aux.push({
                          pergunta: pp.id_pergunta,
                          valor: pp.valor
                        });

                        if (pp.children && pp.children.length > 0) {
                          var _iteratorNormalCompletion14 = true;
                          var _didIteratorError14 = false;
                          var _iteratorError14 = undefined;

                          try {
                            for (var _iterator14 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(pp.children), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
                              var ppp = _step14.value;

                              if (Array.isArray(ppp.valor)) aux.push({
                                pergunta: ppp.id_pergunta,
                                valor: ppp.valor.join(";")
                              });else aux.push({
                                pergunta: ppp.id_pergunta,
                                valor: ppp.valor
                              });
                            }
                          } catch (err) {
                            _didIteratorError14 = true;
                            _iteratorError14 = err;
                          } finally {
                            try {
                              if (!_iteratorNormalCompletion14 && _iterator14.return) {
                                _iterator14.return();
                              }
                            } finally {
                              if (_didIteratorError14) {
                                throw _iteratorError14;
                              }
                            }
                          }
                        }
                      }
                    } catch (err) {
                      _didIteratorError13 = true;
                      _iteratorError13 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion13 && _iterator13.return) {
                          _iterator13.return();
                        }
                      } finally {
                        if (_didIteratorError13) {
                          throw _iteratorError13;
                        }
                      }
                    }
                  }
                }
              } catch (err) {
                _didIteratorError12 = true;
                _iteratorError12 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion12 && _iterator12.return) {
                    _iterator12.return();
                  }
                } finally {
                  if (_didIteratorError12) {
                    throw _iteratorError12;
                  }
                }
              }
            }
          }

          if (i == array.length) return aux;
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }
    },
    unmountForm: function unmountForm(array) {
      var aux = [];

      var _iteratorNormalCompletion15 = true;
      var _didIteratorError15 = false;
      var _iteratorError15 = undefined;

      try {
        for (var _iterator15 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(array), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
          var a = _step15.value;
          var _iteratorNormalCompletion16 = true;
          var _didIteratorError16 = false;
          var _iteratorError16 = undefined;

          try {
            for (var _iterator16 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(a.children), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
              var p = _step16.value;

              aux.push(p);
            }
          } catch (err) {
            _didIteratorError16 = true;
            _iteratorError16 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion16 && _iterator16.return) {
                _iterator16.return();
              }
            } finally {
              if (_didIteratorError16) {
                throw _iteratorError16;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError15 = true;
        _iteratorError15 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion15 && _iterator15.return) {
            _iterator15.return();
          }
        } finally {
          if (_didIteratorError15) {
            throw _iteratorError15;
          }
        }
      }

      return aux;
    },
    saveReporte: function saveReporte() {
      var _this13 = this;

      var submeter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var obj, novo, array;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                //if(!this.isFormCompleted()) return;
                obj = [].concat(_this13.formulario);
                _context3.next = 3;
                return _this13.unmountForm(obj);

              case 3:
                novo = _context3.sent;
                _context3.next = 6;
                return _this13.prepareReporte(novo).filter(function (el) {
                  return typeof el.valor !== "undefined";
                });

              case 6:
                array = _context3.sent;


                _this13.$store.dispatch(_this13.table + "/reporte", {
                  id: _this13.editedItem.id_proposta,
                  formulario: array
                }).then(function (res) {
                  if (res) {
                    if (submeter) {
                      _this13.$store.dispatch(_this13.table + "/update", {
                        id: _this13.editedItem.id_proposta,
                        reporte: 1,
                        data_reporte: _this13.$moment().format("YYYY-MM-DD HH:mm:ss")
                      }).then(function (res) {
                        if (res) {
                          _this13.toast("success", "Reporte submetido com sucesso!");
                          _this13.initialize();
                        } else _this13.toast("error", "Ocorreu um erro ao submeter o reporte");

                        _this13.repM = false;
                        _this13.reporteM = false;
                      });
                    } else {
                      _this13.toast("success", _this13.messages.update.success);
                      _this13.initialize();
                      _this13.reporteM = false;
                    }
                  } else {
                    _this13.toast("error", _this13.messages.update.error);
                    _this13.reporteM = false;
                  }
                });

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this13);
      }))();
    },
    submeterPlanificacao: function submeterPlanificacao(item) {
      this.editedIndex = this.DATA.indexOf(item);
      this.editedItem = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, item);

      this.subM = true;
    },
    submeter: function submeter() {
      var _this14 = this;

      this.$store.dispatch(this.table + "/update", {
        id: this.editedItem.id_proposta,
        submetida: 1,
        data_submetida: this.$moment().format("YYYY-MM-DD HH:mm:ss")
      }).then(function (res) {
        if (res) {
          _this14.toast("success", "Planificação submetida com sucesso!");
          _this14.initialize();
        } else _this14.toast("error", "Ocorreu um erro ao submeter a planificação!");

        _this14.subM = false;
      });
    },
    readyToSubmit: function readyToSubmit(id) {
      var obj = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.DATA.find(function (el) {
        return el.id_proposta == id;
      }));

      return obj.design_acao && obj.quem && obj.id_ano && obj.id_tipo_acao && obj.id_distrito ? true : false;
    },
    sleep: function sleep() {
      var _this15 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this15.waiting = true;
        setTimeout(function () {
          resolve();
        }, 120);
      });
    },
    reporte: function reporte(item) {
      var _this16 = this;

      var pdf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                if (item) {
                  _context21.next = 2;
                  break;
                }

                return _context21.abrupt("return");

              case 2:
                _this16.exportingProgress = 0;

                _this16.sleep().then(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
                  var array, step, _loop, _iteratorNormalCompletion17, _didIteratorError17, _iteratorError17, _iterator17, _step17, p, aux, i, _loop2, _iteratorNormalCompletion18, _didIteratorError18, _iteratorError18, _iterator18, _step18, f, _aux, _loop3, _iteratorNormalCompletion19, _didIteratorError19, _iteratorError19, _iterator19, _step19, _f;

                  return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context20) {
                    while (1) {
                      switch (_context20.prev = _context20.next) {
                        case 0:
                          array = [];


                          _this16.editedIndex = _this16.DATA.indexOf(item);
                          _this16.editedItem = {};

                          _context20.next = 5;
                          return __WEBPACK_IMPORTED_MODULE_8__store_axios__["a" /* instance */].get("/proposta/" + item.id_proposta).then(function (res) {
                            if (res.data.results > 0) {
                              _this16.editedItem = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, res.data.data[0]);
                            }
                          });

                        case 5:
                          _context20.next = 7;
                          return __WEBPACK_IMPORTED_MODULE_8__store_axios__["a" /* instance */].get("/formulario/" + _this16.getAcaoById(item.id_acao).id_formulario).then(function (res) {
                            if (res.data.results > 0) {
                              array = res.data.data[0].perguntas || [];
                            }
                          });

                        case 7:
                          step = 100 / array.length;
                          _loop = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _loop(p) {
                            var _loop4, _iteratorNormalCompletion20, _didIteratorError20, _iteratorError20, _iterator20, _step20, c, el, valor, cc, e, _valor15, _e12, _valor16, ccc, _e13, _valor17, _e14, _valor18, _loop17, _iteratorNormalCompletion33, _didIteratorError33, _iteratorError33, _iterator33, _step33, vv, _loop18, _iteratorNormalCompletion34, _didIteratorError34, _iteratorError34, _iterator34, _step34, xy, _el10, _loop19, _iteratorNormalCompletion35, _didIteratorError35, _iteratorError35, _iterator35, _step35, _vv6, _el12, _loop22, _iteratorNormalCompletion38, _didIteratorError38, _iteratorError38, _iterator38, _step38, _xy6, _el13, _el14, _valor21, _loop23, _iteratorNormalCompletion39, _didIteratorError39, _iteratorError39, _iterator39, _step39, v, _el19;

                            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _loop$(_context19) {
                              while (1) {
                                switch (_context19.prev = _context19.next) {
                                  case 0:
                                    _context19.next = 2;
                                    return __WEBPACK_IMPORTED_MODULE_8__store_axios__["a" /* instance */].get("/pergunta/" + p.id_pergunta).then(function (res) {
                                      p.pergunta = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, res.data.data[0]);
                                    });

                                  case 2:
                                    _this16.exportingProgress += step;

                                    _context19.next = 5;
                                    return _this16.getDimensaoById(p.pergunta.id_dimensao).ordem;

                                  case 5:
                                    p.pergunta.ordem = _context19.sent;


                                    if (p.pergunta.hasOwnProperty("children") && p.pergunta.children.length > 0) p.pergunta.children = [].concat(p.pergunta.children.map(function (el) {
                                      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, el);
                                    }));

                                    if (!(p.pergunta.hasOwnProperty("children") && p.pergunta.children.length > 0 && p.pergunta.id_tipo == 5)) {
                                      _context19.next = 36;
                                      break;
                                    }

                                    _loop4 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _loop4(c) {
                                      var el, valor, cc, e, _valor, _e, _valor2, ccc, _e2, _valor3, _e3, _valor4, _loop5, _iteratorNormalCompletion21, _didIteratorError21, _iteratorError21, _iterator21, _step21, vv, _loop6, _iteratorNormalCompletion22, _didIteratorError22, _iteratorError22, _iterator22, _step22, xy, _el, _loop7, _iteratorNormalCompletion23, _didIteratorError23, _iteratorError23, _iterator23, _step23, _vv, _el2, _loop9, _iteratorNormalCompletion25, _didIteratorError25, _iteratorError25, _iterator25, _step25, _xy, _el3, _el4, _valor7, _loop10, _iteratorNormalCompletion26, _didIteratorError26, _iteratorError26, _iterator26, _step26, v, _el9, _valor14;

                                      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _loop4$(_context11) {
                                        while (1) {
                                          switch (_context11.prev = _context11.next) {
                                            case 0:
                                              if (!(c.id_tipo == 1)) {
                                                _context11.next = 148;
                                                break;
                                              }

                                              el = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                                return el.id_pergunta == c.id_pergunta;
                                              }));

                                              if (!(typeof el != "undefined" && el.valor)) {
                                                _context11.next = 146;
                                                break;
                                              }

                                              valor = el.valor;
                                              cc = c.children.find(function (el) {
                                                return el.id_pergunta == Number(valor);
                                              });
                                              _context11.next = 7;
                                              return _this16.changeCheck(c, cc, 1, true);

                                            case 7:
                                              c.valor = valor;

                                              if (!(cc.expansivel && (cc.id_tipo == 1 || cc.id_tipo == 2))) {
                                                _context11.next = 120;
                                                break;
                                              }

                                              e = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                                return el.id_pergunta == cc.id_pergunta;
                                              }));

                                              if (!(typeof e != "undefined" && e.valor)) {
                                                _context11.next = 118;
                                                break;
                                              }

                                              _valor = e.valor.split(";").map(function (e) {
                                                return Number(e);
                                              });

                                              cc.valor = _valor;

                                              if (!(cc.id_tipo == 1)) {
                                                _context11.next = 87;
                                                break;
                                              }

                                              _e = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                                return el.id_pergunta == cc.id_pergunta;
                                              }));

                                              if (!(typeof _e != "undefined" && _e.valor)) {
                                                _context11.next = 85;
                                                break;
                                              }

                                              _valor2 = _e.valor;
                                              ccc = cc.children.find(function (el) {
                                                return el.id_pergunta == Number(_valor2);
                                              });

                                              _this16.changeCheck(cc, ccc, 1, true);
                                              cc.valor = _valor2;

                                              if (!(ccc.expansivel && (ccc.id_tipo == 1 || ccc.id_tipo == 2))) {
                                                _context11.next = 59;
                                                break;
                                              }

                                              _e2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                                return el.id_pergunta == ccc.id_pergunta;
                                              }));

                                              if (!(typeof _e2 != "undefined" && _e2.valor)) {
                                                _context11.next = 57;
                                                break;
                                              }

                                              _valor3 = _e2.valor.split(";").map(function (e) {
                                                return Number(e);
                                              });

                                              ccc.valor = _valor3;

                                              if (!(ccc.id_tipo == 1)) {
                                                _context11.next = 30;
                                                break;
                                              }

                                              _e3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                                return el.id_pergunta == ccc.id_pergunta;
                                              }));

                                              if (typeof _e3 != "undefined" && _e3.valor) {
                                                _valor4 = _e3.valor;

                                                _this16.changeCheck(cc, ccc.children.find(function (el) {
                                                  return el.id_pergunta == Number(_valor4);
                                                }), 1, true);
                                                ccc.valor = _valor4;
                                              }
                                              _context11.next = 57;
                                              break;

                                            case 30:
                                              if (!(ccc.id_tipo == 2)) {
                                                _context11.next = 57;
                                                break;
                                              }

                                              _loop5 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _loop5(vv) {
                                                var ccc;
                                                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _loop5$(_context4) {
                                                  while (1) {
                                                    switch (_context4.prev = _context4.next) {
                                                      case 0:
                                                        ccc = ccc.children.find(function (el) {
                                                          return el.id_pergunta == Number(vv);
                                                        });
                                                        _context4.next = 3;
                                                        return _this16.changeCheck(cc, ccc, 2, true);

                                                      case 3:
                                                      case "end":
                                                        return _context4.stop();
                                                    }
                                                  }
                                                }, _loop5, _this16);
                                              });
                                              _iteratorNormalCompletion21 = true;
                                              _didIteratorError21 = false;
                                              _iteratorError21 = undefined;
                                              _context11.prev = 35;
                                              _iterator21 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(_valor3);

                                            case 37:
                                              if (_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done) {
                                                _context11.next = 43;
                                                break;
                                              }

                                              vv = _step21.value;
                                              return _context11.delegateYield(_loop5(vv), "t0", 40);

                                            case 40:
                                              _iteratorNormalCompletion21 = true;
                                              _context11.next = 37;
                                              break;

                                            case 43:
                                              _context11.next = 49;
                                              break;

                                            case 45:
                                              _context11.prev = 45;
                                              _context11.t1 = _context11["catch"](35);
                                              _didIteratorError21 = true;
                                              _iteratorError21 = _context11.t1;

                                            case 49:
                                              _context11.prev = 49;
                                              _context11.prev = 50;

                                              if (!_iteratorNormalCompletion21 && _iterator21.return) {
                                                _iterator21.return();
                                              }

                                            case 52:
                                              _context11.prev = 52;

                                              if (!_didIteratorError21) {
                                                _context11.next = 55;
                                                break;
                                              }

                                              throw _iteratorError21;

                                            case 55:
                                              return _context11.finish(52);

                                            case 56:
                                              return _context11.finish(49);

                                            case 57:
                                              _context11.next = 85;
                                              break;

                                            case 59:
                                              if (!(ccc.children && ccc.children.length > 0)) {
                                                _context11.next = 83;
                                                break;
                                              }

                                              ccc.children = [].concat(ccc.children.map(function (el) {
                                                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, el);
                                              }));

                                              _loop6 = function _loop6(xy) {
                                                var e = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                                  return el.id_pergunta == xy.id_pergunta;
                                                }));

                                                if (typeof e != "undefined") xy.valor = e.valor;
                                              };

                                              _iteratorNormalCompletion22 = true;
                                              _didIteratorError22 = false;
                                              _iteratorError22 = undefined;
                                              _context11.prev = 65;
                                              for (_iterator22 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(ccc.children); !(_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done); _iteratorNormalCompletion22 = true) {
                                                xy = _step22.value;

                                                _loop6(xy);
                                              }
                                              _context11.next = 73;
                                              break;

                                            case 69:
                                              _context11.prev = 69;
                                              _context11.t2 = _context11["catch"](65);
                                              _didIteratorError22 = true;
                                              _iteratorError22 = _context11.t2;

                                            case 73:
                                              _context11.prev = 73;
                                              _context11.prev = 74;

                                              if (!_iteratorNormalCompletion22 && _iterator22.return) {
                                                _iterator22.return();
                                              }

                                            case 76:
                                              _context11.prev = 76;

                                              if (!_didIteratorError22) {
                                                _context11.next = 79;
                                                break;
                                              }

                                              throw _iteratorError22;

                                            case 79:
                                              return _context11.finish(76);

                                            case 80:
                                              return _context11.finish(73);

                                            case 81:
                                              _context11.next = 85;
                                              break;

                                            case 83:
                                              _el = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                                return el.id_pergunta == ccc.id_pergunta;
                                              }));


                                              if (typeof _el != "undefined") ccc.valor = _el.valor;

                                            case 85:
                                              _context11.next = 118;
                                              break;

                                            case 87:
                                              if (!(cc.id_tipo == 2)) {
                                                _context11.next = 116;
                                                break;
                                              }

                                              _loop7 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _loop7(_vv) {
                                                var ccc, _e4, _valor5, _e5, _valor6, _loop8, _iteratorNormalCompletion24, _didIteratorError24, _iteratorError24, _iterator24, _step24, _vv2;

                                                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _loop7$(_context6) {
                                                  while (1) {
                                                    switch (_context6.prev = _context6.next) {
                                                      case 0:
                                                        ccc = cc.children.find(function (el) {
                                                          return el.id_pergunta == Number(_vv);
                                                        });
                                                        _context6.next = 3;
                                                        return _this16.changeCheck(cc, ccc, 2, true);

                                                      case 3:
                                                        if (!(ccc.expansivel && (ccc.id_tipo == 1 || ccc.id_tipo == 2))) {
                                                          _context6.next = 40;
                                                          break;
                                                        }

                                                        _e4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                                          return el.id_pergunta == ccc.id_pergunta;
                                                        }));

                                                        if (!(typeof _e4 != "undefined" && _e4.valor)) {
                                                          _context6.next = 40;
                                                          break;
                                                        }

                                                        _valor5 = _e4.valor.split(";").map(function (e) {
                                                          return Number(e);
                                                        });

                                                        ccc.valor = _valor5;

                                                        if (!(ccc.id_tipo == 1)) {
                                                          _context6.next = 13;
                                                          break;
                                                        }

                                                        _e5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                                          return el.id_pergunta == ccc.id_pergunta;
                                                        }));

                                                        if (typeof _e5 != "undefined" && _e5.valor) {
                                                          _valor6 = _e5.valor;

                                                          _this16.changeCheck(cc, ccc.children.find(function (el) {
                                                            return el.id_pergunta == Number(_valor6);
                                                          }), 1, true);
                                                          ccc.valor = _valor6;
                                                        }
                                                        _context6.next = 40;
                                                        break;

                                                      case 13:
                                                        if (!(ccc.id_tipo == 2)) {
                                                          _context6.next = 40;
                                                          break;
                                                        }

                                                        _loop8 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _loop8(_vv2) {
                                                          var ccc;
                                                          return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _loop8$(_context5) {
                                                            while (1) {
                                                              switch (_context5.prev = _context5.next) {
                                                                case 0:
                                                                  ccc = ccc.children.find(function (el) {
                                                                    return el.id_pergunta == Number(_vv2);
                                                                  });
                                                                  _context5.next = 3;
                                                                  return _this16.changeCheck(cc, ccc, 2, true);

                                                                case 3:
                                                                case "end":
                                                                  return _context5.stop();
                                                              }
                                                            }
                                                          }, _loop8, _this16);
                                                        });
                                                        _iteratorNormalCompletion24 = true;
                                                        _didIteratorError24 = false;
                                                        _iteratorError24 = undefined;
                                                        _context6.prev = 18;
                                                        _iterator24 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(_valor5);

                                                      case 20:
                                                        if (_iteratorNormalCompletion24 = (_step24 = _iterator24.next()).done) {
                                                          _context6.next = 26;
                                                          break;
                                                        }

                                                        _vv2 = _step24.value;
                                                        return _context6.delegateYield(_loop8(_vv2), "t0", 23);

                                                      case 23:
                                                        _iteratorNormalCompletion24 = true;
                                                        _context6.next = 20;
                                                        break;

                                                      case 26:
                                                        _context6.next = 32;
                                                        break;

                                                      case 28:
                                                        _context6.prev = 28;
                                                        _context6.t1 = _context6["catch"](18);
                                                        _didIteratorError24 = true;
                                                        _iteratorError24 = _context6.t1;

                                                      case 32:
                                                        _context6.prev = 32;
                                                        _context6.prev = 33;

                                                        if (!_iteratorNormalCompletion24 && _iterator24.return) {
                                                          _iterator24.return();
                                                        }

                                                      case 35:
                                                        _context6.prev = 35;

                                                        if (!_didIteratorError24) {
                                                          _context6.next = 38;
                                                          break;
                                                        }

                                                        throw _iteratorError24;

                                                      case 38:
                                                        return _context6.finish(35);

                                                      case 39:
                                                        return _context6.finish(32);

                                                      case 40:
                                                      case "end":
                                                        return _context6.stop();
                                                    }
                                                  }
                                                }, _loop7, _this16, [[18, 28, 32, 40], [33,, 35, 39]]);
                                              });
                                              _iteratorNormalCompletion23 = true;
                                              _didIteratorError23 = false;
                                              _iteratorError23 = undefined;
                                              _context11.prev = 92;
                                              _iterator23 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(_valor);

                                            case 94:
                                              if (_iteratorNormalCompletion23 = (_step23 = _iterator23.next()).done) {
                                                _context11.next = 100;
                                                break;
                                              }

                                              _vv = _step23.value;
                                              return _context11.delegateYield(_loop7(_vv), "t3", 97);

                                            case 97:
                                              _iteratorNormalCompletion23 = true;
                                              _context11.next = 94;
                                              break;

                                            case 100:
                                              _context11.next = 106;
                                              break;

                                            case 102:
                                              _context11.prev = 102;
                                              _context11.t4 = _context11["catch"](92);
                                              _didIteratorError23 = true;
                                              _iteratorError23 = _context11.t4;

                                            case 106:
                                              _context11.prev = 106;
                                              _context11.prev = 107;

                                              if (!_iteratorNormalCompletion23 && _iterator23.return) {
                                                _iterator23.return();
                                              }

                                            case 109:
                                              _context11.prev = 109;

                                              if (!_didIteratorError23) {
                                                _context11.next = 112;
                                                break;
                                              }

                                              throw _iteratorError23;

                                            case 112:
                                              return _context11.finish(109);

                                            case 113:
                                              return _context11.finish(106);

                                            case 114:
                                              _context11.next = 118;
                                              break;

                                            case 116:
                                              _el2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                                return el.id_pergunta == cc.id_pergunta;
                                              }));


                                              if (typeof _el2 != "undefined") cc.valor = _el2.valor;

                                            case 118:
                                              _context11.next = 146;
                                              break;

                                            case 120:
                                              if (!(cc.children && cc.children.length > 0)) {
                                                _context11.next = 144;
                                                break;
                                              }

                                              cc.children = [].concat(cc.children.map(function (el) {
                                                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, el);
                                              }));

                                              _loop9 = function _loop9(_xy) {
                                                var e = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                                  return el.id_pergunta == _xy.id_pergunta;
                                                }));

                                                if (typeof e != "undefined") _xy.valor = e.valor;
                                              };

                                              _iteratorNormalCompletion25 = true;
                                              _didIteratorError25 = false;
                                              _iteratorError25 = undefined;
                                              _context11.prev = 126;
                                              for (_iterator25 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(cc.children); !(_iteratorNormalCompletion25 = (_step25 = _iterator25.next()).done); _iteratorNormalCompletion25 = true) {
                                                _xy = _step25.value;

                                                _loop9(_xy);
                                              }
                                              _context11.next = 134;
                                              break;

                                            case 130:
                                              _context11.prev = 130;
                                              _context11.t5 = _context11["catch"](126);
                                              _didIteratorError25 = true;
                                              _iteratorError25 = _context11.t5;

                                            case 134:
                                              _context11.prev = 134;
                                              _context11.prev = 135;

                                              if (!_iteratorNormalCompletion25 && _iterator25.return) {
                                                _iterator25.return();
                                              }

                                            case 137:
                                              _context11.prev = 137;

                                              if (!_didIteratorError25) {
                                                _context11.next = 140;
                                                break;
                                              }

                                              throw _iteratorError25;

                                            case 140:
                                              return _context11.finish(137);

                                            case 141:
                                              return _context11.finish(134);

                                            case 142:
                                              _context11.next = 146;
                                              break;

                                            case 144:
                                              _el3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                                return el.id_pergunta == cc.id_pergunta;
                                              }));


                                              if (typeof _el3 != "undefined") cc.valor = _el3.valor;

                                            case 146:
                                              _context11.next = 183;
                                              break;

                                            case 148:
                                              if (!(c.id_tipo == 2)) {
                                                _context11.next = 181;
                                                break;
                                              }

                                              _el4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                                return el.id_pergunta == c.id_pergunta;
                                              }));

                                              if (!(typeof _el4 != "undefined" && _el4.valor)) {
                                                _context11.next = 179;
                                                break;
                                              }

                                              _valor7 = _el4.valor.split(";").map(function (el) {
                                                return Number(el);
                                              });

                                              c.valor = _valor7;

                                              _loop10 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _loop10(v) {
                                                var cc, _e6, _valor8, _e7, _valor9, _ccc, _e8, _valor10, _e9, _valor11, _loop11, _iteratorNormalCompletion27, _didIteratorError27, _iteratorError27, _iterator27, _step27, _vv3, _loop12, _iteratorNormalCompletion28, _didIteratorError28, _iteratorError28, _iterator28, _step28, _xy2, _el5, _loop13, _iteratorNormalCompletion29, _didIteratorError29, _iteratorError29, _iterator29, _step29, _vv4, _el7, _loop16, _iteratorNormalCompletion32, _didIteratorError32, _iteratorError32, _iterator32, _step32, _xy4, _el8;

                                                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _loop10$(_context10) {
                                                  while (1) {
                                                    switch (_context10.prev = _context10.next) {
                                                      case 0:
                                                        cc = c.children.find(function (el) {
                                                          return el.id_pergunta == Number(v);
                                                        });
                                                        _context10.next = 3;
                                                        return _this16.changeCheck(c, cc, 2, true);

                                                      case 3:
                                                        if (!(cc.expansivel && (cc.id_tipo == 1 || cc.id_tipo == 2))) {
                                                          _context10.next = 115;
                                                          break;
                                                        }

                                                        _e6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                                          return el.id_pergunta == cc.id_pergunta;
                                                        }));

                                                        if (!(typeof _e6 != "undefined" && _e6.valor)) {
                                                          _context10.next = 113;
                                                          break;
                                                        }

                                                        _valor8 = _e6.valor.split(";").map(function (e) {
                                                          return Number(e);
                                                        });

                                                        cc.valor = _valor8;

                                                        if (!(cc.id_tipo == 1)) {
                                                          _context10.next = 82;
                                                          break;
                                                        }

                                                        _e7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                                          return el.id_pergunta == cc.id_pergunta;
                                                        }));

                                                        if (!(typeof _e7 != "undefined" && _e7.valor)) {
                                                          _context10.next = 80;
                                                          break;
                                                        }

                                                        _valor9 = _e7.valor;
                                                        _ccc = cc.children.find(function (el) {
                                                          return el.id_pergunta == Number(_valor9);
                                                        });

                                                        _this16.changeCheck(cc, _ccc, 1, true);
                                                        cc.valor = _valor9;

                                                        if (!(_ccc.expansivel && (_ccc.id_tipo == 1 || _ccc.id_tipo == 2))) {
                                                          _context10.next = 54;
                                                          break;
                                                        }

                                                        _e8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                                          return el.id_pergunta == _ccc.id_pergunta;
                                                        }));

                                                        if (!(typeof _e8 != "undefined" && _e8.valor)) {
                                                          _context10.next = 52;
                                                          break;
                                                        }

                                                        _valor10 = _e8.valor.split(";").map(function (e) {
                                                          return Number(e);
                                                        });

                                                        _ccc.valor = _valor10;

                                                        if (!(_ccc.id_tipo == 1)) {
                                                          _context10.next = 25;
                                                          break;
                                                        }

                                                        _e9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                                          return el.id_pergunta == _ccc.id_pergunta;
                                                        }));

                                                        if (typeof _e9 != "undefined" && _e9.valor) {
                                                          _valor11 = _e9.valor;

                                                          _this16.changeCheck(cc, _ccc.children.find(function (el) {
                                                            return el.id_pergunta == Number(_valor11);
                                                          }), 1, true);
                                                          _ccc.valor = _valor11;
                                                        }
                                                        _context10.next = 52;
                                                        break;

                                                      case 25:
                                                        if (!(_ccc.id_tipo == 2)) {
                                                          _context10.next = 52;
                                                          break;
                                                        }

                                                        _loop11 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _loop11(_vv3) {
                                                          var ccc;
                                                          return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _loop11$(_context7) {
                                                            while (1) {
                                                              switch (_context7.prev = _context7.next) {
                                                                case 0:
                                                                  ccc = ccc.children.find(function (el) {
                                                                    return el.id_pergunta == Number(_vv3);
                                                                  });
                                                                  _context7.next = 3;
                                                                  return _this16.changeCheck(cc, ccc, 2, true);

                                                                case 3:
                                                                case "end":
                                                                  return _context7.stop();
                                                              }
                                                            }
                                                          }, _loop11, _this16);
                                                        });
                                                        _iteratorNormalCompletion27 = true;
                                                        _didIteratorError27 = false;
                                                        _iteratorError27 = undefined;
                                                        _context10.prev = 30;
                                                        _iterator27 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(_valor10);

                                                      case 32:
                                                        if (_iteratorNormalCompletion27 = (_step27 = _iterator27.next()).done) {
                                                          _context10.next = 38;
                                                          break;
                                                        }

                                                        _vv3 = _step27.value;
                                                        return _context10.delegateYield(_loop11(_vv3), "t0", 35);

                                                      case 35:
                                                        _iteratorNormalCompletion27 = true;
                                                        _context10.next = 32;
                                                        break;

                                                      case 38:
                                                        _context10.next = 44;
                                                        break;

                                                      case 40:
                                                        _context10.prev = 40;
                                                        _context10.t1 = _context10["catch"](30);
                                                        _didIteratorError27 = true;
                                                        _iteratorError27 = _context10.t1;

                                                      case 44:
                                                        _context10.prev = 44;
                                                        _context10.prev = 45;

                                                        if (!_iteratorNormalCompletion27 && _iterator27.return) {
                                                          _iterator27.return();
                                                        }

                                                      case 47:
                                                        _context10.prev = 47;

                                                        if (!_didIteratorError27) {
                                                          _context10.next = 50;
                                                          break;
                                                        }

                                                        throw _iteratorError27;

                                                      case 50:
                                                        return _context10.finish(47);

                                                      case 51:
                                                        return _context10.finish(44);

                                                      case 52:
                                                        _context10.next = 80;
                                                        break;

                                                      case 54:
                                                        if (!(_ccc.children && _ccc.children.length > 0)) {
                                                          _context10.next = 78;
                                                          break;
                                                        }

                                                        _ccc.children = [].concat(_ccc.children.map(function (el) {
                                                          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, el);
                                                        }));

                                                        _loop12 = function _loop12(_xy2) {
                                                          var e = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                                            return el.id_pergunta == _xy2.id_pergunta;
                                                          }));

                                                          if (typeof e != "undefined") _xy2.valor = e.valor;
                                                        };

                                                        _iteratorNormalCompletion28 = true;
                                                        _didIteratorError28 = false;
                                                        _iteratorError28 = undefined;
                                                        _context10.prev = 60;
                                                        for (_iterator28 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(_ccc.children); !(_iteratorNormalCompletion28 = (_step28 = _iterator28.next()).done); _iteratorNormalCompletion28 = true) {
                                                          _xy2 = _step28.value;

                                                          _loop12(_xy2);
                                                        }
                                                        _context10.next = 68;
                                                        break;

                                                      case 64:
                                                        _context10.prev = 64;
                                                        _context10.t2 = _context10["catch"](60);
                                                        _didIteratorError28 = true;
                                                        _iteratorError28 = _context10.t2;

                                                      case 68:
                                                        _context10.prev = 68;
                                                        _context10.prev = 69;

                                                        if (!_iteratorNormalCompletion28 && _iterator28.return) {
                                                          _iterator28.return();
                                                        }

                                                      case 71:
                                                        _context10.prev = 71;

                                                        if (!_didIteratorError28) {
                                                          _context10.next = 74;
                                                          break;
                                                        }

                                                        throw _iteratorError28;

                                                      case 74:
                                                        return _context10.finish(71);

                                                      case 75:
                                                        return _context10.finish(68);

                                                      case 76:
                                                        _context10.next = 80;
                                                        break;

                                                      case 78:
                                                        _el5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                                          return el.id_pergunta == _ccc.id_pergunta;
                                                        }));


                                                        if (typeof _el5 != "undefined") _ccc.valor = _el5.valor;

                                                      case 80:
                                                        _context10.next = 113;
                                                        break;

                                                      case 82:
                                                        if (!(cc.id_tipo == 2)) {
                                                          _context10.next = 111;
                                                          break;
                                                        }

                                                        _loop13 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _loop13(_vv4) {
                                                          var ccc, _e10, _valor12, _e11, _valor13, _loop14, _iteratorNormalCompletion30, _didIteratorError30, _iteratorError30, _iterator30, _step30, _vv5, _loop15, _iteratorNormalCompletion31, _didIteratorError31, _iteratorError31, _iterator31, _step31, _xy3, _el6;

                                                          return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _loop13$(_context9) {
                                                            while (1) {
                                                              switch (_context9.prev = _context9.next) {
                                                                case 0:
                                                                  ccc = cc.children.find(function (el) {
                                                                    return el.id_pergunta == Number(_vv4);
                                                                  });
                                                                  _context9.next = 3;
                                                                  return _this16.changeCheck(cc, ccc, 2, true);

                                                                case 3:
                                                                  if (!(ccc.expansivel && (ccc.id_tipo == 1 || ccc.id_tipo == 2))) {
                                                                    _context9.next = 42;
                                                                    break;
                                                                  }

                                                                  _e10 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                                                    return el.id_pergunta == ccc.id_pergunta;
                                                                  }));

                                                                  if (!(typeof _e10 != "undefined" && _e10.valor)) {
                                                                    _context9.next = 40;
                                                                    break;
                                                                  }

                                                                  _valor12 = _e10.valor.split(";").map(function (e) {
                                                                    return Number(e);
                                                                  });

                                                                  ccc.valor = _valor12;

                                                                  if (!(ccc.id_tipo == 1)) {
                                                                    _context9.next = 13;
                                                                    break;
                                                                  }

                                                                  _e11 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                                                    return el.id_pergunta == ccc.id_pergunta;
                                                                  }));

                                                                  if (typeof _e11 != "undefined" && _e11.valor) {
                                                                    _valor13 = _e11.valor;

                                                                    _this16.changeCheck(cc, ccc.children.find(function (el) {
                                                                      return el.id_pergunta == Number(_valor13);
                                                                    }), 1, true);
                                                                    ccc.valor = _valor13;
                                                                  }
                                                                  _context9.next = 40;
                                                                  break;

                                                                case 13:
                                                                  if (!(ccc.id_tipo == 2)) {
                                                                    _context9.next = 40;
                                                                    break;
                                                                  }

                                                                  _loop14 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _loop14(_vv5) {
                                                                    var ccc;
                                                                    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _loop14$(_context8) {
                                                                      while (1) {
                                                                        switch (_context8.prev = _context8.next) {
                                                                          case 0:
                                                                            ccc = ccc.children.find(function (el) {
                                                                              return el.id_pergunta == Number(_vv5);
                                                                            });
                                                                            _context8.next = 3;
                                                                            return _this16.changeCheck(cc, ccc, 2, true);

                                                                          case 3:
                                                                          case "end":
                                                                            return _context8.stop();
                                                                        }
                                                                      }
                                                                    }, _loop14, _this16);
                                                                  });
                                                                  _iteratorNormalCompletion30 = true;
                                                                  _didIteratorError30 = false;
                                                                  _iteratorError30 = undefined;
                                                                  _context9.prev = 18;
                                                                  _iterator30 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(_valor12);

                                                                case 20:
                                                                  if (_iteratorNormalCompletion30 = (_step30 = _iterator30.next()).done) {
                                                                    _context9.next = 26;
                                                                    break;
                                                                  }

                                                                  _vv5 = _step30.value;
                                                                  return _context9.delegateYield(_loop14(_vv5), "t0", 23);

                                                                case 23:
                                                                  _iteratorNormalCompletion30 = true;
                                                                  _context9.next = 20;
                                                                  break;

                                                                case 26:
                                                                  _context9.next = 32;
                                                                  break;

                                                                case 28:
                                                                  _context9.prev = 28;
                                                                  _context9.t1 = _context9["catch"](18);
                                                                  _didIteratorError30 = true;
                                                                  _iteratorError30 = _context9.t1;

                                                                case 32:
                                                                  _context9.prev = 32;
                                                                  _context9.prev = 33;

                                                                  if (!_iteratorNormalCompletion30 && _iterator30.return) {
                                                                    _iterator30.return();
                                                                  }

                                                                case 35:
                                                                  _context9.prev = 35;

                                                                  if (!_didIteratorError30) {
                                                                    _context9.next = 38;
                                                                    break;
                                                                  }

                                                                  throw _iteratorError30;

                                                                case 38:
                                                                  return _context9.finish(35);

                                                                case 39:
                                                                  return _context9.finish(32);

                                                                case 40:
                                                                  _context9.next = 68;
                                                                  break;

                                                                case 42:
                                                                  if (!(ccc.children && ccc.children.length > 0)) {
                                                                    _context9.next = 66;
                                                                    break;
                                                                  }

                                                                  ccc.children = [].concat(ccc.children.map(function (el) {
                                                                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, el);
                                                                  }));

                                                                  _loop15 = function _loop15(_xy3) {
                                                                    var e = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                                                      return el.id_pergunta == _xy3.id_pergunta;
                                                                    }));

                                                                    if (typeof e != "undefined") _xy3.valor = e.valor;
                                                                  };

                                                                  _iteratorNormalCompletion31 = true;
                                                                  _didIteratorError31 = false;
                                                                  _iteratorError31 = undefined;
                                                                  _context9.prev = 48;
                                                                  for (_iterator31 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(ccc.children); !(_iteratorNormalCompletion31 = (_step31 = _iterator31.next()).done); _iteratorNormalCompletion31 = true) {
                                                                    _xy3 = _step31.value;

                                                                    _loop15(_xy3);
                                                                  }
                                                                  _context9.next = 56;
                                                                  break;

                                                                case 52:
                                                                  _context9.prev = 52;
                                                                  _context9.t2 = _context9["catch"](48);
                                                                  _didIteratorError31 = true;
                                                                  _iteratorError31 = _context9.t2;

                                                                case 56:
                                                                  _context9.prev = 56;
                                                                  _context9.prev = 57;

                                                                  if (!_iteratorNormalCompletion31 && _iterator31.return) {
                                                                    _iterator31.return();
                                                                  }

                                                                case 59:
                                                                  _context9.prev = 59;

                                                                  if (!_didIteratorError31) {
                                                                    _context9.next = 62;
                                                                    break;
                                                                  }

                                                                  throw _iteratorError31;

                                                                case 62:
                                                                  return _context9.finish(59);

                                                                case 63:
                                                                  return _context9.finish(56);

                                                                case 64:
                                                                  _context9.next = 68;
                                                                  break;

                                                                case 66:
                                                                  _el6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                                                    return el.id_pergunta == ccc.id_pergunta;
                                                                  }));


                                                                  if (typeof _el6 != "undefined") ccc.valor = _el6.valor;

                                                                case 68:
                                                                case "end":
                                                                  return _context9.stop();
                                                              }
                                                            }
                                                          }, _loop13, _this16, [[18, 28, 32, 40], [33,, 35, 39], [48, 52, 56, 64], [57,, 59, 63]]);
                                                        });
                                                        _iteratorNormalCompletion29 = true;
                                                        _didIteratorError29 = false;
                                                        _iteratorError29 = undefined;
                                                        _context10.prev = 87;
                                                        _iterator29 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(_valor8);

                                                      case 89:
                                                        if (_iteratorNormalCompletion29 = (_step29 = _iterator29.next()).done) {
                                                          _context10.next = 95;
                                                          break;
                                                        }

                                                        _vv4 = _step29.value;
                                                        return _context10.delegateYield(_loop13(_vv4), "t3", 92);

                                                      case 92:
                                                        _iteratorNormalCompletion29 = true;
                                                        _context10.next = 89;
                                                        break;

                                                      case 95:
                                                        _context10.next = 101;
                                                        break;

                                                      case 97:
                                                        _context10.prev = 97;
                                                        _context10.t4 = _context10["catch"](87);
                                                        _didIteratorError29 = true;
                                                        _iteratorError29 = _context10.t4;

                                                      case 101:
                                                        _context10.prev = 101;
                                                        _context10.prev = 102;

                                                        if (!_iteratorNormalCompletion29 && _iterator29.return) {
                                                          _iterator29.return();
                                                        }

                                                      case 104:
                                                        _context10.prev = 104;

                                                        if (!_didIteratorError29) {
                                                          _context10.next = 107;
                                                          break;
                                                        }

                                                        throw _iteratorError29;

                                                      case 107:
                                                        return _context10.finish(104);

                                                      case 108:
                                                        return _context10.finish(101);

                                                      case 109:
                                                        _context10.next = 113;
                                                        break;

                                                      case 111:
                                                        _el7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                                          return el.id_pergunta == cc.id_pergunta;
                                                        }));


                                                        if (typeof _el7 != "undefined") cc.valor = _el7.valor;

                                                      case 113:
                                                        _context10.next = 141;
                                                        break;

                                                      case 115:
                                                        if (!(cc.children && cc.children.length > 0)) {
                                                          _context10.next = 139;
                                                          break;
                                                        }

                                                        cc.children = [].concat(cc.children.map(function (el) {
                                                          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, el);
                                                        }));

                                                        _loop16 = function _loop16(_xy4) {
                                                          var e = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                                            return el.id_pergunta == _xy4.id_pergunta;
                                                          }));

                                                          if (typeof e != "undefined") _xy4.valor = e.valor;
                                                        };

                                                        _iteratorNormalCompletion32 = true;
                                                        _didIteratorError32 = false;
                                                        _iteratorError32 = undefined;
                                                        _context10.prev = 121;
                                                        for (_iterator32 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(cc.children); !(_iteratorNormalCompletion32 = (_step32 = _iterator32.next()).done); _iteratorNormalCompletion32 = true) {
                                                          _xy4 = _step32.value;

                                                          _loop16(_xy4);
                                                        }
                                                        _context10.next = 129;
                                                        break;

                                                      case 125:
                                                        _context10.prev = 125;
                                                        _context10.t5 = _context10["catch"](121);
                                                        _didIteratorError32 = true;
                                                        _iteratorError32 = _context10.t5;

                                                      case 129:
                                                        _context10.prev = 129;
                                                        _context10.prev = 130;

                                                        if (!_iteratorNormalCompletion32 && _iterator32.return) {
                                                          _iterator32.return();
                                                        }

                                                      case 132:
                                                        _context10.prev = 132;

                                                        if (!_didIteratorError32) {
                                                          _context10.next = 135;
                                                          break;
                                                        }

                                                        throw _iteratorError32;

                                                      case 135:
                                                        return _context10.finish(132);

                                                      case 136:
                                                        return _context10.finish(129);

                                                      case 137:
                                                        _context10.next = 141;
                                                        break;

                                                      case 139:
                                                        _el8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                                          return el.id_pergunta == cc.id_pergunta;
                                                        }));


                                                        if (typeof _el8 != "undefined") cc.valor = _el8.valor;

                                                      case 141:
                                                      case "end":
                                                        return _context10.stop();
                                                    }
                                                  }
                                                }, _loop10, _this16, [[30, 40, 44, 52], [45,, 47, 51], [60, 64, 68, 76], [69,, 71, 75], [87, 97, 101, 109], [102,, 104, 108], [121, 125, 129, 137], [130,, 132, 136]]);
                                              });
                                              _iteratorNormalCompletion26 = true;
                                              _didIteratorError26 = false;
                                              _iteratorError26 = undefined;
                                              _context11.prev = 157;
                                              _iterator26 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(_valor7);

                                            case 159:
                                              if (_iteratorNormalCompletion26 = (_step26 = _iterator26.next()).done) {
                                                _context11.next = 165;
                                                break;
                                              }

                                              v = _step26.value;
                                              return _context11.delegateYield(_loop10(v), "t6", 162);

                                            case 162:
                                              _iteratorNormalCompletion26 = true;
                                              _context11.next = 159;
                                              break;

                                            case 165:
                                              _context11.next = 171;
                                              break;

                                            case 167:
                                              _context11.prev = 167;
                                              _context11.t7 = _context11["catch"](157);
                                              _didIteratorError26 = true;
                                              _iteratorError26 = _context11.t7;

                                            case 171:
                                              _context11.prev = 171;
                                              _context11.prev = 172;

                                              if (!_iteratorNormalCompletion26 && _iterator26.return) {
                                                _iterator26.return();
                                              }

                                            case 174:
                                              _context11.prev = 174;

                                              if (!_didIteratorError26) {
                                                _context11.next = 177;
                                                break;
                                              }

                                              throw _iteratorError26;

                                            case 177:
                                              return _context11.finish(174);

                                            case 178:
                                              return _context11.finish(171);

                                            case 179:
                                              _context11.next = 183;
                                              break;

                                            case 181:
                                              _el9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                                return el.id_pergunta == c.id_pergunta;
                                              }));

                                              if (typeof _el9 != "undefined" && _el9.valor) {
                                                _valor14 = _el9.valor;


                                                if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(Number(_valor14))) c.valor = Number(_valor14);else c.valor = _valor14;
                                              }

                                            case 183:
                                            case "end":
                                              return _context11.stop();
                                          }
                                        }
                                      }, _loop4, _this16, [[35, 45, 49, 57], [50,, 52, 56], [65, 69, 73, 81], [74,, 76, 80], [92, 102, 106, 114], [107,, 109, 113], [126, 130, 134, 142], [135,, 137, 141], [157, 167, 171, 179], [172,, 174, 178]]);
                                    });
                                    _iteratorNormalCompletion20 = true;
                                    _didIteratorError20 = false;
                                    _iteratorError20 = undefined;
                                    _context19.prev = 12;
                                    _iterator20 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(p.pergunta.children);

                                  case 14:
                                    if (_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done) {
                                      _context19.next = 20;
                                      break;
                                    }

                                    c = _step20.value;
                                    return _context19.delegateYield(_loop4(c), "t0", 17);

                                  case 17:
                                    _iteratorNormalCompletion20 = true;
                                    _context19.next = 14;
                                    break;

                                  case 20:
                                    _context19.next = 26;
                                    break;

                                  case 22:
                                    _context19.prev = 22;
                                    _context19.t1 = _context19["catch"](12);
                                    _didIteratorError20 = true;
                                    _iteratorError20 = _context19.t1;

                                  case 26:
                                    _context19.prev = 26;
                                    _context19.prev = 27;

                                    if (!_iteratorNormalCompletion20 && _iterator20.return) {
                                      _iterator20.return();
                                    }

                                  case 29:
                                    _context19.prev = 29;

                                    if (!_didIteratorError20) {
                                      _context19.next = 32;
                                      break;
                                    }

                                    throw _iteratorError20;

                                  case 32:
                                    return _context19.finish(29);

                                  case 33:
                                    return _context19.finish(26);

                                  case 34:
                                    _context19.next = 218;
                                    break;

                                  case 36:
                                    if (!(p.pergunta.id_tipo == 1)) {
                                      _context19.next = 183;
                                      break;
                                    }

                                    el = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                      return el.id_pergunta == p.pergunta.id_pergunta;
                                    }));

                                    if (!(typeof el != "undefined" && el.valor)) {
                                      _context19.next = 181;
                                      break;
                                    }

                                    valor = el.valor;
                                    cc = p.pergunta.children.find(function (el) {
                                      return el.id_pergunta == Number(valor);
                                    });


                                    _this16.changeCheck(p.pergunta, cc, 1, true);
                                    p.pergunta.valor = valor;

                                    if (!(cc.expansivel && (cc.id_tipo == 1 || cc.id_tipo == 2))) {
                                      _context19.next = 155;
                                      break;
                                    }

                                    e = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                      return el.id_pergunta == cc.id_pergunta;
                                    }));

                                    if (!(typeof e != "undefined" && e.valor)) {
                                      _context19.next = 153;
                                      break;
                                    }

                                    _valor15 = e.valor.split(";").map(function (e) {
                                      return Number(e);
                                    });

                                    cc.valor = _valor15;

                                    if (!(cc.id_tipo == 1)) {
                                      _context19.next = 122;
                                      break;
                                    }

                                    _e12 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                      return el.id_pergunta == cc.id_pergunta;
                                    }));

                                    if (!(typeof _e12 != "undefined" && _e12.valor)) {
                                      _context19.next = 120;
                                      break;
                                    }

                                    _valor16 = _e12.valor;
                                    ccc = cc.children.find(function (el) {
                                      return el.id_pergunta == Number(_valor16);
                                    });

                                    _this16.changeCheck(cc, ccc, 1, true);
                                    cc.valor = _valor16;

                                    if (!(ccc.expansivel && (ccc.id_tipo == 1 || ccc.id_tipo == 2))) {
                                      _context19.next = 94;
                                      break;
                                    }

                                    _e13 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                      return el.id_pergunta == ccc.id_pergunta;
                                    }));

                                    if (!(typeof _e13 != "undefined" && _e13.valor)) {
                                      _context19.next = 92;
                                      break;
                                    }

                                    _valor17 = _e13.valor.split(";").map(function (e) {
                                      return Number(e);
                                    });

                                    ccc.valor = _valor17;

                                    if (!(ccc.id_tipo == 1)) {
                                      _context19.next = 65;
                                      break;
                                    }

                                    _e14 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                      return el.id_pergunta == ccc.id_pergunta;
                                    }));

                                    if (typeof _e14 != "undefined" && _e14.valor) {
                                      _valor18 = _e14.valor;

                                      _this16.changeCheck(cc, ccc.children.find(function (el) {
                                        return el.id_pergunta == Number(_valor18);
                                      }), 1, true);
                                      ccc.valor = _valor18;
                                    }
                                    _context19.next = 92;
                                    break;

                                  case 65:
                                    if (!(ccc.id_tipo == 2)) {
                                      _context19.next = 92;
                                      break;
                                    }

                                    _loop17 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _loop17(vv) {
                                      var ccc;
                                      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _loop17$(_context12) {
                                        while (1) {
                                          switch (_context12.prev = _context12.next) {
                                            case 0:
                                              ccc = ccc.children.find(function (el) {
                                                return el.id_pergunta == Number(vv);
                                              });
                                              _context12.next = 3;
                                              return _this16.changeCheck(cc, ccc, 2, true);

                                            case 3:
                                            case "end":
                                              return _context12.stop();
                                          }
                                        }
                                      }, _loop17, _this16);
                                    });
                                    _iteratorNormalCompletion33 = true;
                                    _didIteratorError33 = false;
                                    _iteratorError33 = undefined;
                                    _context19.prev = 70;
                                    _iterator33 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(_valor17);

                                  case 72:
                                    if (_iteratorNormalCompletion33 = (_step33 = _iterator33.next()).done) {
                                      _context19.next = 78;
                                      break;
                                    }

                                    vv = _step33.value;
                                    return _context19.delegateYield(_loop17(vv), "t2", 75);

                                  case 75:
                                    _iteratorNormalCompletion33 = true;
                                    _context19.next = 72;
                                    break;

                                  case 78:
                                    _context19.next = 84;
                                    break;

                                  case 80:
                                    _context19.prev = 80;
                                    _context19.t3 = _context19["catch"](70);
                                    _didIteratorError33 = true;
                                    _iteratorError33 = _context19.t3;

                                  case 84:
                                    _context19.prev = 84;
                                    _context19.prev = 85;

                                    if (!_iteratorNormalCompletion33 && _iterator33.return) {
                                      _iterator33.return();
                                    }

                                  case 87:
                                    _context19.prev = 87;

                                    if (!_didIteratorError33) {
                                      _context19.next = 90;
                                      break;
                                    }

                                    throw _iteratorError33;

                                  case 90:
                                    return _context19.finish(87);

                                  case 91:
                                    return _context19.finish(84);

                                  case 92:
                                    _context19.next = 120;
                                    break;

                                  case 94:
                                    if (!(ccc.children && ccc.children.length > 0)) {
                                      _context19.next = 118;
                                      break;
                                    }

                                    ccc.children = [].concat(ccc.children.map(function (el) {
                                      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, el);
                                    }));

                                    _loop18 = function _loop18(xy) {
                                      var e = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                        return el.id_pergunta == xy.id_pergunta;
                                      }));

                                      if (typeof e != "undefined") xy.valor = e.valor;
                                    };

                                    _iteratorNormalCompletion34 = true;
                                    _didIteratorError34 = false;
                                    _iteratorError34 = undefined;
                                    _context19.prev = 100;
                                    for (_iterator34 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(ccc.children); !(_iteratorNormalCompletion34 = (_step34 = _iterator34.next()).done); _iteratorNormalCompletion34 = true) {
                                      xy = _step34.value;

                                      _loop18(xy);
                                    }
                                    _context19.next = 108;
                                    break;

                                  case 104:
                                    _context19.prev = 104;
                                    _context19.t4 = _context19["catch"](100);
                                    _didIteratorError34 = true;
                                    _iteratorError34 = _context19.t4;

                                  case 108:
                                    _context19.prev = 108;
                                    _context19.prev = 109;

                                    if (!_iteratorNormalCompletion34 && _iterator34.return) {
                                      _iterator34.return();
                                    }

                                  case 111:
                                    _context19.prev = 111;

                                    if (!_didIteratorError34) {
                                      _context19.next = 114;
                                      break;
                                    }

                                    throw _iteratorError34;

                                  case 114:
                                    return _context19.finish(111);

                                  case 115:
                                    return _context19.finish(108);

                                  case 116:
                                    _context19.next = 120;
                                    break;

                                  case 118:
                                    _el10 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                      return el.id_pergunta == ccc.id_pergunta;
                                    }));


                                    if (typeof _el10 != "undefined") ccc.valor = _el10.valor;

                                  case 120:
                                    _context19.next = 153;
                                    break;

                                  case 122:
                                    if (!(cc.id_tipo == 2)) {
                                      _context19.next = 151;
                                      break;
                                    }

                                    _loop19 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _loop19(_vv6) {
                                      var ccc, _e15, _valor19, _e16, _valor20, _loop20, _iteratorNormalCompletion36, _didIteratorError36, _iteratorError36, _iterator36, _step36, _vv7, _loop21, _iteratorNormalCompletion37, _didIteratorError37, _iteratorError37, _iterator37, _step37, _xy5, _el11;

                                      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _loop19$(_context14) {
                                        while (1) {
                                          switch (_context14.prev = _context14.next) {
                                            case 0:
                                              ccc = cc.children.find(function (el) {
                                                return el.id_pergunta == Number(_vv6);
                                              });
                                              _context14.next = 3;
                                              return _this16.changeCheck(cc, ccc, 2, true);

                                            case 3:
                                              if (!(ccc.expansivel && (ccc.id_tipo == 1 || ccc.id_tipo == 2))) {
                                                _context14.next = 42;
                                                break;
                                              }

                                              _e15 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                                return el.id_pergunta == ccc.id_pergunta;
                                              }));

                                              if (!(typeof _e15 != "undefined" && _e15.valor)) {
                                                _context14.next = 40;
                                                break;
                                              }

                                              _valor19 = _e15.valor.split(";").map(function (e) {
                                                return Number(e);
                                              });

                                              ccc.valor = _valor19;

                                              if (!(ccc.id_tipo == 1)) {
                                                _context14.next = 13;
                                                break;
                                              }

                                              _e16 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                                return el.id_pergunta == ccc.id_pergunta;
                                              }));

                                              if (typeof _e16 != "undefined" && _e16.valor) {
                                                _valor20 = _e16.valor;

                                                _this16.changeCheck(cc, ccc.children.find(function (el) {
                                                  return el.id_pergunta == Number(_valor20);
                                                }), 1, true);
                                                ccc.valor = _valor20;
                                              }
                                              _context14.next = 40;
                                              break;

                                            case 13:
                                              if (!(ccc.id_tipo == 2)) {
                                                _context14.next = 40;
                                                break;
                                              }

                                              _loop20 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _loop20(_vv7) {
                                                var ccc;
                                                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _loop20$(_context13) {
                                                  while (1) {
                                                    switch (_context13.prev = _context13.next) {
                                                      case 0:
                                                        ccc = ccc.children.find(function (el) {
                                                          return el.id_pergunta == Number(_vv7);
                                                        });
                                                        _context13.next = 3;
                                                        return _this16.changeCheck(cc, ccc, 2, true);

                                                      case 3:
                                                      case "end":
                                                        return _context13.stop();
                                                    }
                                                  }
                                                }, _loop20, _this16);
                                              });
                                              _iteratorNormalCompletion36 = true;
                                              _didIteratorError36 = false;
                                              _iteratorError36 = undefined;
                                              _context14.prev = 18;
                                              _iterator36 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(_valor19);

                                            case 20:
                                              if (_iteratorNormalCompletion36 = (_step36 = _iterator36.next()).done) {
                                                _context14.next = 26;
                                                break;
                                              }

                                              _vv7 = _step36.value;
                                              return _context14.delegateYield(_loop20(_vv7), "t0", 23);

                                            case 23:
                                              _iteratorNormalCompletion36 = true;
                                              _context14.next = 20;
                                              break;

                                            case 26:
                                              _context14.next = 32;
                                              break;

                                            case 28:
                                              _context14.prev = 28;
                                              _context14.t1 = _context14["catch"](18);
                                              _didIteratorError36 = true;
                                              _iteratorError36 = _context14.t1;

                                            case 32:
                                              _context14.prev = 32;
                                              _context14.prev = 33;

                                              if (!_iteratorNormalCompletion36 && _iterator36.return) {
                                                _iterator36.return();
                                              }

                                            case 35:
                                              _context14.prev = 35;

                                              if (!_didIteratorError36) {
                                                _context14.next = 38;
                                                break;
                                              }

                                              throw _iteratorError36;

                                            case 38:
                                              return _context14.finish(35);

                                            case 39:
                                              return _context14.finish(32);

                                            case 40:
                                              _context14.next = 68;
                                              break;

                                            case 42:
                                              if (!(ccc.children && ccc.children.length > 0)) {
                                                _context14.next = 66;
                                                break;
                                              }

                                              ccc.children = [].concat(ccc.children.map(function (el) {
                                                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, el);
                                              }));

                                              _loop21 = function _loop21(_xy5) {
                                                var e = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                                  return el.id_pergunta == _xy5.id_pergunta;
                                                }));

                                                if (typeof e != "undefined") _xy5.valor = e.valor;
                                              };

                                              _iteratorNormalCompletion37 = true;
                                              _didIteratorError37 = false;
                                              _iteratorError37 = undefined;
                                              _context14.prev = 48;
                                              for (_iterator37 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(ccc.children); !(_iteratorNormalCompletion37 = (_step37 = _iterator37.next()).done); _iteratorNormalCompletion37 = true) {
                                                _xy5 = _step37.value;

                                                _loop21(_xy5);
                                              }
                                              _context14.next = 56;
                                              break;

                                            case 52:
                                              _context14.prev = 52;
                                              _context14.t2 = _context14["catch"](48);
                                              _didIteratorError37 = true;
                                              _iteratorError37 = _context14.t2;

                                            case 56:
                                              _context14.prev = 56;
                                              _context14.prev = 57;

                                              if (!_iteratorNormalCompletion37 && _iterator37.return) {
                                                _iterator37.return();
                                              }

                                            case 59:
                                              _context14.prev = 59;

                                              if (!_didIteratorError37) {
                                                _context14.next = 62;
                                                break;
                                              }

                                              throw _iteratorError37;

                                            case 62:
                                              return _context14.finish(59);

                                            case 63:
                                              return _context14.finish(56);

                                            case 64:
                                              _context14.next = 68;
                                              break;

                                            case 66:
                                              _el11 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                                return el.id_pergunta == ccc.id_pergunta;
                                              }));


                                              if (typeof _el11 != "undefined") ccc.valor = _el11.valor;

                                            case 68:
                                            case "end":
                                              return _context14.stop();
                                          }
                                        }
                                      }, _loop19, _this16, [[18, 28, 32, 40], [33,, 35, 39], [48, 52, 56, 64], [57,, 59, 63]]);
                                    });
                                    _iteratorNormalCompletion35 = true;
                                    _didIteratorError35 = false;
                                    _iteratorError35 = undefined;
                                    _context19.prev = 127;
                                    _iterator35 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(_valor15);

                                  case 129:
                                    if (_iteratorNormalCompletion35 = (_step35 = _iterator35.next()).done) {
                                      _context19.next = 135;
                                      break;
                                    }

                                    _vv6 = _step35.value;
                                    return _context19.delegateYield(_loop19(_vv6), "t5", 132);

                                  case 132:
                                    _iteratorNormalCompletion35 = true;
                                    _context19.next = 129;
                                    break;

                                  case 135:
                                    _context19.next = 141;
                                    break;

                                  case 137:
                                    _context19.prev = 137;
                                    _context19.t6 = _context19["catch"](127);
                                    _didIteratorError35 = true;
                                    _iteratorError35 = _context19.t6;

                                  case 141:
                                    _context19.prev = 141;
                                    _context19.prev = 142;

                                    if (!_iteratorNormalCompletion35 && _iterator35.return) {
                                      _iterator35.return();
                                    }

                                  case 144:
                                    _context19.prev = 144;

                                    if (!_didIteratorError35) {
                                      _context19.next = 147;
                                      break;
                                    }

                                    throw _iteratorError35;

                                  case 147:
                                    return _context19.finish(144);

                                  case 148:
                                    return _context19.finish(141);

                                  case 149:
                                    _context19.next = 153;
                                    break;

                                  case 151:
                                    _el12 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                      return el.id_pergunta == cc.id_pergunta;
                                    }));


                                    if (typeof _el12 != "undefined") cc.valor = _el12.valor;

                                  case 153:
                                    _context19.next = 181;
                                    break;

                                  case 155:
                                    if (!(cc.children && cc.children.length > 0)) {
                                      _context19.next = 179;
                                      break;
                                    }

                                    cc.children = [].concat(cc.children.map(function (el) {
                                      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, el);
                                    }));

                                    _loop22 = function _loop22(_xy6) {
                                      var e = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                        return el.id_pergunta == _xy6.id_pergunta;
                                      }));

                                      if (typeof e != "undefined") _xy6.valor = e.valor;
                                    };

                                    _iteratorNormalCompletion38 = true;
                                    _didIteratorError38 = false;
                                    _iteratorError38 = undefined;
                                    _context19.prev = 161;
                                    for (_iterator38 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(cc.children); !(_iteratorNormalCompletion38 = (_step38 = _iterator38.next()).done); _iteratorNormalCompletion38 = true) {
                                      _xy6 = _step38.value;

                                      _loop22(_xy6);
                                    }
                                    _context19.next = 169;
                                    break;

                                  case 165:
                                    _context19.prev = 165;
                                    _context19.t7 = _context19["catch"](161);
                                    _didIteratorError38 = true;
                                    _iteratorError38 = _context19.t7;

                                  case 169:
                                    _context19.prev = 169;
                                    _context19.prev = 170;

                                    if (!_iteratorNormalCompletion38 && _iterator38.return) {
                                      _iterator38.return();
                                    }

                                  case 172:
                                    _context19.prev = 172;

                                    if (!_didIteratorError38) {
                                      _context19.next = 175;
                                      break;
                                    }

                                    throw _iteratorError38;

                                  case 175:
                                    return _context19.finish(172);

                                  case 176:
                                    return _context19.finish(169);

                                  case 177:
                                    _context19.next = 181;
                                    break;

                                  case 179:
                                    _el13 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                      return el.id_pergunta == cc.id_pergunta;
                                    }));


                                    if (typeof _el13 != "undefined") cc.valor = _el13.valor;

                                  case 181:
                                    _context19.next = 218;
                                    break;

                                  case 183:
                                    if (!(p.pergunta.id_tipo == 2)) {
                                      _context19.next = 216;
                                      break;
                                    }

                                    _el14 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                      return el.id_pergunta == p.pergunta.id_pergunta;
                                    }));

                                    if (!(typeof _el14 != "undefined" && _el14.valor)) {
                                      _context19.next = 214;
                                      break;
                                    }

                                    _valor21 = _el14.valor.split(";").map(function (el) {
                                      return Number(el);
                                    });

                                    p.pergunta.valor = _valor21;

                                    _loop23 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _loop23(v) {
                                      var cc, _e17, _valor22, _e18, _valor23, _ccc2, _e19, _valor24, _e20, _valor25, _loop24, _iteratorNormalCompletion40, _didIteratorError40, _iteratorError40, _iterator40, _step40, _vv8, _loop25, _iteratorNormalCompletion41, _didIteratorError41, _iteratorError41, _iterator41, _step41, _xy7, _el15, _loop26, _iteratorNormalCompletion42, _didIteratorError42, _iteratorError42, _iterator42, _step42, _vv9, _el17, _loop29, _iteratorNormalCompletion45, _didIteratorError45, _iteratorError45, _iterator45, _step45, _xy9, _el18;

                                      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _loop23$(_context18) {
                                        while (1) {
                                          switch (_context18.prev = _context18.next) {
                                            case 0:
                                              cc = p.pergunta.children.find(function (el) {
                                                return el.id_pergunta == Number(v);
                                              });
                                              _context18.next = 3;
                                              return _this16.changeCheck(p.pergunta, cc, 2, true);

                                            case 3:
                                              if (!(cc.expansivel && (cc.id_tipo == 1 || cc.id_tipo == 2 || cc.id_tipo == 4))) {
                                                _context18.next = 115;
                                                break;
                                              }

                                              _e17 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                                return el.id_pergunta == cc.id_pergunta;
                                              }));

                                              if (!(typeof _e17 != "undefined" && _e17.valor)) {
                                                _context18.next = 113;
                                                break;
                                              }

                                              _valor22 = _e17.valor.split(";").map(function (e) {
                                                return Number(e);
                                              });

                                              cc.valor = _valor22;

                                              if (!(cc.id_tipo == 1)) {
                                                _context18.next = 82;
                                                break;
                                              }

                                              _e18 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                                return el.id_pergunta == cc.id_pergunta;
                                              }));

                                              if (!(typeof _e18 != "undefined" && _e18.valor)) {
                                                _context18.next = 80;
                                                break;
                                              }

                                              _valor23 = _e18.valor;
                                              _ccc2 = cc.children.find(function (el) {
                                                return el.id_pergunta == Number(_valor23);
                                              });

                                              _this16.changeCheck(cc, _ccc2, 1, true);
                                              cc.valor = _valor23;

                                              if (!(_ccc2.expansivel && (_ccc2.id_tipo == 1 || _ccc2.id_tipo == 2))) {
                                                _context18.next = 54;
                                                break;
                                              }

                                              _e19 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                                return el.id_pergunta == _ccc2.id_pergunta;
                                              }));

                                              if (!(typeof _e19 != "undefined" && _e19.valor)) {
                                                _context18.next = 52;
                                                break;
                                              }

                                              _valor24 = _e19.valor.split(";").map(function (e) {
                                                return Number(e);
                                              });

                                              _ccc2.valor = _valor24;

                                              if (!(_ccc2.id_tipo == 1)) {
                                                _context18.next = 25;
                                                break;
                                              }

                                              _e20 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                                return el.id_pergunta == _ccc2.id_pergunta;
                                              }));

                                              if (typeof _e20 != "undefined" && _e20.valor) {
                                                _valor25 = _e20.valor;

                                                _this16.changeCheck(cc, _ccc2.children.find(function (el) {
                                                  return el.id_pergunta == Number(_valor25);
                                                }), 1, true);
                                                _ccc2.valor = _valor25;
                                              }
                                              _context18.next = 52;
                                              break;

                                            case 25:
                                              if (!(_ccc2.id_tipo == 2)) {
                                                _context18.next = 52;
                                                break;
                                              }

                                              _loop24 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _loop24(_vv8) {
                                                var ccc;
                                                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _loop24$(_context15) {
                                                  while (1) {
                                                    switch (_context15.prev = _context15.next) {
                                                      case 0:
                                                        ccc = ccc.children.find(function (el) {
                                                          return el.id_pergunta == Number(_vv8);
                                                        });
                                                        _context15.next = 3;
                                                        return _this16.changeCheck(cc, ccc, 2, true);

                                                      case 3:
                                                      case "end":
                                                        return _context15.stop();
                                                    }
                                                  }
                                                }, _loop24, _this16);
                                              });
                                              _iteratorNormalCompletion40 = true;
                                              _didIteratorError40 = false;
                                              _iteratorError40 = undefined;
                                              _context18.prev = 30;
                                              _iterator40 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(_valor24);

                                            case 32:
                                              if (_iteratorNormalCompletion40 = (_step40 = _iterator40.next()).done) {
                                                _context18.next = 38;
                                                break;
                                              }

                                              _vv8 = _step40.value;
                                              return _context18.delegateYield(_loop24(_vv8), "t0", 35);

                                            case 35:
                                              _iteratorNormalCompletion40 = true;
                                              _context18.next = 32;
                                              break;

                                            case 38:
                                              _context18.next = 44;
                                              break;

                                            case 40:
                                              _context18.prev = 40;
                                              _context18.t1 = _context18["catch"](30);
                                              _didIteratorError40 = true;
                                              _iteratorError40 = _context18.t1;

                                            case 44:
                                              _context18.prev = 44;
                                              _context18.prev = 45;

                                              if (!_iteratorNormalCompletion40 && _iterator40.return) {
                                                _iterator40.return();
                                              }

                                            case 47:
                                              _context18.prev = 47;

                                              if (!_didIteratorError40) {
                                                _context18.next = 50;
                                                break;
                                              }

                                              throw _iteratorError40;

                                            case 50:
                                              return _context18.finish(47);

                                            case 51:
                                              return _context18.finish(44);

                                            case 52:
                                              _context18.next = 80;
                                              break;

                                            case 54:
                                              if (!(_ccc2.children && _ccc2.children.length > 0)) {
                                                _context18.next = 78;
                                                break;
                                              }

                                              _ccc2.children = [].concat(_ccc2.children.map(function (el) {
                                                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, el);
                                              }));

                                              _loop25 = function _loop25(_xy7) {
                                                var e = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                                  return el.id_pergunta == _xy7.id_pergunta;
                                                }));

                                                if (typeof e != "undefined") _xy7.valor = e.valor;
                                              };

                                              _iteratorNormalCompletion41 = true;
                                              _didIteratorError41 = false;
                                              _iteratorError41 = undefined;
                                              _context18.prev = 60;
                                              for (_iterator41 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(_ccc2.children); !(_iteratorNormalCompletion41 = (_step41 = _iterator41.next()).done); _iteratorNormalCompletion41 = true) {
                                                _xy7 = _step41.value;

                                                _loop25(_xy7);
                                              }
                                              _context18.next = 68;
                                              break;

                                            case 64:
                                              _context18.prev = 64;
                                              _context18.t2 = _context18["catch"](60);
                                              _didIteratorError41 = true;
                                              _iteratorError41 = _context18.t2;

                                            case 68:
                                              _context18.prev = 68;
                                              _context18.prev = 69;

                                              if (!_iteratorNormalCompletion41 && _iterator41.return) {
                                                _iterator41.return();
                                              }

                                            case 71:
                                              _context18.prev = 71;

                                              if (!_didIteratorError41) {
                                                _context18.next = 74;
                                                break;
                                              }

                                              throw _iteratorError41;

                                            case 74:
                                              return _context18.finish(71);

                                            case 75:
                                              return _context18.finish(68);

                                            case 76:
                                              _context18.next = 80;
                                              break;

                                            case 78:
                                              _el15 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                                return el.id_pergunta == _ccc2.id_pergunta;
                                              }));


                                              if (typeof _el15 != "undefined") _ccc2.valor = _el15.valor;

                                            case 80:
                                              _context18.next = 113;
                                              break;

                                            case 82:
                                              if (!(cc.id_tipo == 2)) {
                                                _context18.next = 111;
                                                break;
                                              }

                                              _loop26 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _loop26(_vv9) {
                                                var ccc, _e21, _valor26, _e22, _valor27, _loop27, _iteratorNormalCompletion43, _didIteratorError43, _iteratorError43, _iterator43, _step43, _vv10, _loop28, _iteratorNormalCompletion44, _didIteratorError44, _iteratorError44, _iterator44, _step44, _xy8, _el16;

                                                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _loop26$(_context17) {
                                                  while (1) {
                                                    switch (_context17.prev = _context17.next) {
                                                      case 0:
                                                        ccc = cc.children.find(function (el) {
                                                          return el.id_pergunta == Number(_vv9);
                                                        });
                                                        _context17.next = 3;
                                                        return _this16.changeCheck(cc, ccc, 2, true);

                                                      case 3:
                                                        if (!(ccc.expansivel && (ccc.id_tipo == 1 || ccc.id_tipo == 2))) {
                                                          _context17.next = 42;
                                                          break;
                                                        }

                                                        _e21 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                                          return el.id_pergunta == ccc.id_pergunta;
                                                        }));

                                                        if (!(typeof _e21 != "undefined" && _e21.valor)) {
                                                          _context17.next = 40;
                                                          break;
                                                        }

                                                        _valor26 = _e21.valor.split(";").map(function (e) {
                                                          return Number(e);
                                                        });

                                                        ccc.valor = _valor26;

                                                        if (!(ccc.id_tipo == 1)) {
                                                          _context17.next = 13;
                                                          break;
                                                        }

                                                        _e22 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                                          return el.id_pergunta == ccc.id_pergunta;
                                                        }));

                                                        if (typeof _e22 != "undefined" && _e22.valor) {
                                                          _valor27 = _e22.valor;

                                                          _this16.changeCheck(cc, ccc.children.find(function (el) {
                                                            return el.id_pergunta == Number(_valor27);
                                                          }), 1, true);
                                                          ccc.valor = _valor27;
                                                        }
                                                        _context17.next = 40;
                                                        break;

                                                      case 13:
                                                        if (!(ccc.id_tipo == 2)) {
                                                          _context17.next = 40;
                                                          break;
                                                        }

                                                        _loop27 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _loop27(_vv10) {
                                                          var ccc;
                                                          return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _loop27$(_context16) {
                                                            while (1) {
                                                              switch (_context16.prev = _context16.next) {
                                                                case 0:
                                                                  ccc = ccc.children.find(function (el) {
                                                                    return el.id_pergunta == Number(_vv10);
                                                                  });
                                                                  _context16.next = 3;
                                                                  return _this16.changeCheck(cc, ccc, 2, true);

                                                                case 3:
                                                                case "end":
                                                                  return _context16.stop();
                                                              }
                                                            }
                                                          }, _loop27, _this16);
                                                        });
                                                        _iteratorNormalCompletion43 = true;
                                                        _didIteratorError43 = false;
                                                        _iteratorError43 = undefined;
                                                        _context17.prev = 18;
                                                        _iterator43 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(_valor26);

                                                      case 20:
                                                        if (_iteratorNormalCompletion43 = (_step43 = _iterator43.next()).done) {
                                                          _context17.next = 26;
                                                          break;
                                                        }

                                                        _vv10 = _step43.value;
                                                        return _context17.delegateYield(_loop27(_vv10), "t0", 23);

                                                      case 23:
                                                        _iteratorNormalCompletion43 = true;
                                                        _context17.next = 20;
                                                        break;

                                                      case 26:
                                                        _context17.next = 32;
                                                        break;

                                                      case 28:
                                                        _context17.prev = 28;
                                                        _context17.t1 = _context17["catch"](18);
                                                        _didIteratorError43 = true;
                                                        _iteratorError43 = _context17.t1;

                                                      case 32:
                                                        _context17.prev = 32;
                                                        _context17.prev = 33;

                                                        if (!_iteratorNormalCompletion43 && _iterator43.return) {
                                                          _iterator43.return();
                                                        }

                                                      case 35:
                                                        _context17.prev = 35;

                                                        if (!_didIteratorError43) {
                                                          _context17.next = 38;
                                                          break;
                                                        }

                                                        throw _iteratorError43;

                                                      case 38:
                                                        return _context17.finish(35);

                                                      case 39:
                                                        return _context17.finish(32);

                                                      case 40:
                                                        _context17.next = 68;
                                                        break;

                                                      case 42:
                                                        if (!(ccc.children && ccc.children.length > 0)) {
                                                          _context17.next = 66;
                                                          break;
                                                        }

                                                        ccc.children = [].concat(ccc.children.map(function (el) {
                                                          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, el);
                                                        }));

                                                        _loop28 = function _loop28(_xy8) {
                                                          var e = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                                            return el.id_pergunta == _xy8.id_pergunta;
                                                          }));

                                                          if (typeof e != "undefined") _xy8.valor = e.valor;
                                                        };

                                                        _iteratorNormalCompletion44 = true;
                                                        _didIteratorError44 = false;
                                                        _iteratorError44 = undefined;
                                                        _context17.prev = 48;
                                                        for (_iterator44 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(ccc.children); !(_iteratorNormalCompletion44 = (_step44 = _iterator44.next()).done); _iteratorNormalCompletion44 = true) {
                                                          _xy8 = _step44.value;

                                                          _loop28(_xy8);
                                                        }
                                                        _context17.next = 56;
                                                        break;

                                                      case 52:
                                                        _context17.prev = 52;
                                                        _context17.t2 = _context17["catch"](48);
                                                        _didIteratorError44 = true;
                                                        _iteratorError44 = _context17.t2;

                                                      case 56:
                                                        _context17.prev = 56;
                                                        _context17.prev = 57;

                                                        if (!_iteratorNormalCompletion44 && _iterator44.return) {
                                                          _iterator44.return();
                                                        }

                                                      case 59:
                                                        _context17.prev = 59;

                                                        if (!_didIteratorError44) {
                                                          _context17.next = 62;
                                                          break;
                                                        }

                                                        throw _iteratorError44;

                                                      case 62:
                                                        return _context17.finish(59);

                                                      case 63:
                                                        return _context17.finish(56);

                                                      case 64:
                                                        _context17.next = 68;
                                                        break;

                                                      case 66:
                                                        _el16 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                                          return el.id_pergunta == ccc.id_pergunta;
                                                        }));


                                                        if (typeof _el16 != "undefined") ccc.valor = _el16.valor;

                                                      case 68:
                                                      case "end":
                                                        return _context17.stop();
                                                    }
                                                  }
                                                }, _loop26, _this16, [[18, 28, 32, 40], [33,, 35, 39], [48, 52, 56, 64], [57,, 59, 63]]);
                                              });
                                              _iteratorNormalCompletion42 = true;
                                              _didIteratorError42 = false;
                                              _iteratorError42 = undefined;
                                              _context18.prev = 87;
                                              _iterator42 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(_valor22);

                                            case 89:
                                              if (_iteratorNormalCompletion42 = (_step42 = _iterator42.next()).done) {
                                                _context18.next = 95;
                                                break;
                                              }

                                              _vv9 = _step42.value;
                                              return _context18.delegateYield(_loop26(_vv9), "t3", 92);

                                            case 92:
                                              _iteratorNormalCompletion42 = true;
                                              _context18.next = 89;
                                              break;

                                            case 95:
                                              _context18.next = 101;
                                              break;

                                            case 97:
                                              _context18.prev = 97;
                                              _context18.t4 = _context18["catch"](87);
                                              _didIteratorError42 = true;
                                              _iteratorError42 = _context18.t4;

                                            case 101:
                                              _context18.prev = 101;
                                              _context18.prev = 102;

                                              if (!_iteratorNormalCompletion42 && _iterator42.return) {
                                                _iterator42.return();
                                              }

                                            case 104:
                                              _context18.prev = 104;

                                              if (!_didIteratorError42) {
                                                _context18.next = 107;
                                                break;
                                              }

                                              throw _iteratorError42;

                                            case 107:
                                              return _context18.finish(104);

                                            case 108:
                                              return _context18.finish(101);

                                            case 109:
                                              _context18.next = 113;
                                              break;

                                            case 111:
                                              _el17 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                                return el.id_pergunta == cc.id_pergunta;
                                              }));


                                              if (typeof _el17 != "undefined") cc.valor = _el17.valor;

                                            case 113:
                                              _context18.next = 141;
                                              break;

                                            case 115:
                                              if (!(cc.children && cc.children.length > 0)) {
                                                _context18.next = 139;
                                                break;
                                              }

                                              cc.children = [].concat(cc.children.map(function (el) {
                                                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, el);
                                              }));

                                              _loop29 = function _loop29(_xy9) {
                                                var e = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                                  return el.id_pergunta == _xy9.id_pergunta;
                                                }));

                                                if (typeof e != "undefined") _xy9.valor = e.valor;
                                              };

                                              _iteratorNormalCompletion45 = true;
                                              _didIteratorError45 = false;
                                              _iteratorError45 = undefined;
                                              _context18.prev = 121;
                                              for (_iterator45 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(cc.children); !(_iteratorNormalCompletion45 = (_step45 = _iterator45.next()).done); _iteratorNormalCompletion45 = true) {
                                                _xy9 = _step45.value;

                                                _loop29(_xy9);
                                              }
                                              _context18.next = 129;
                                              break;

                                            case 125:
                                              _context18.prev = 125;
                                              _context18.t5 = _context18["catch"](121);
                                              _didIteratorError45 = true;
                                              _iteratorError45 = _context18.t5;

                                            case 129:
                                              _context18.prev = 129;
                                              _context18.prev = 130;

                                              if (!_iteratorNormalCompletion45 && _iterator45.return) {
                                                _iterator45.return();
                                              }

                                            case 132:
                                              _context18.prev = 132;

                                              if (!_didIteratorError45) {
                                                _context18.next = 135;
                                                break;
                                              }

                                              throw _iteratorError45;

                                            case 135:
                                              return _context18.finish(132);

                                            case 136:
                                              return _context18.finish(129);

                                            case 137:
                                              _context18.next = 141;
                                              break;

                                            case 139:
                                              _el18 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                                return el.id_pergunta == cc.id_pergunta;
                                              }));


                                              if (typeof _el18 != "undefined") cc.valor = _el18.valor;

                                            case 141:
                                            case "end":
                                              return _context18.stop();
                                          }
                                        }
                                      }, _loop23, _this16, [[30, 40, 44, 52], [45,, 47, 51], [60, 64, 68, 76], [69,, 71, 75], [87, 97, 101, 109], [102,, 104, 108], [121, 125, 129, 137], [130,, 132, 136]]);
                                    });
                                    _iteratorNormalCompletion39 = true;
                                    _didIteratorError39 = false;
                                    _iteratorError39 = undefined;
                                    _context19.prev = 192;
                                    _iterator39 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(_valor21);

                                  case 194:
                                    if (_iteratorNormalCompletion39 = (_step39 = _iterator39.next()).done) {
                                      _context19.next = 200;
                                      break;
                                    }

                                    v = _step39.value;
                                    return _context19.delegateYield(_loop23(v), "t8", 197);

                                  case 197:
                                    _iteratorNormalCompletion39 = true;
                                    _context19.next = 194;
                                    break;

                                  case 200:
                                    _context19.next = 206;
                                    break;

                                  case 202:
                                    _context19.prev = 202;
                                    _context19.t9 = _context19["catch"](192);
                                    _didIteratorError39 = true;
                                    _iteratorError39 = _context19.t9;

                                  case 206:
                                    _context19.prev = 206;
                                    _context19.prev = 207;

                                    if (!_iteratorNormalCompletion39 && _iterator39.return) {
                                      _iterator39.return();
                                    }

                                  case 209:
                                    _context19.prev = 209;

                                    if (!_didIteratorError39) {
                                      _context19.next = 212;
                                      break;
                                    }

                                    throw _iteratorError39;

                                  case 212:
                                    return _context19.finish(209);

                                  case 213:
                                    return _context19.finish(206);

                                  case 214:
                                    _context19.next = 218;
                                    break;

                                  case 216:
                                    _el19 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this16.editedItem.children.find(function (el) {
                                      return el.id_pergunta == p.pergunta.id_pergunta;
                                    }));


                                    if (typeof _el19 != "undefined") p.pergunta.valor = _el19.valor;

                                  case 218:
                                  case "end":
                                    return _context19.stop();
                                }
                              }
                            }, _loop, _this16, [[12, 22, 26, 34], [27,, 29, 33], [70, 80, 84, 92], [85,, 87, 91], [100, 104, 108, 116], [109,, 111, 115], [127, 137, 141, 149], [142,, 144, 148], [161, 165, 169, 177], [170,, 172, 176], [192, 202, 206, 214], [207,, 209, 213]]);
                          });
                          _iteratorNormalCompletion17 = true;
                          _didIteratorError17 = false;
                          _iteratorError17 = undefined;
                          _context20.prev = 12;
                          _iterator17 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(array);

                        case 14:
                          if (_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done) {
                            _context20.next = 20;
                            break;
                          }

                          p = _step17.value;
                          return _context20.delegateYield(_loop(p), "t0", 17);

                        case 17:
                          _iteratorNormalCompletion17 = true;
                          _context20.next = 14;
                          break;

                        case 20:
                          _context20.next = 26;
                          break;

                        case 22:
                          _context20.prev = 22;
                          _context20.t1 = _context20["catch"](12);
                          _didIteratorError17 = true;
                          _iteratorError17 = _context20.t1;

                        case 26:
                          _context20.prev = 26;
                          _context20.prev = 27;

                          if (!_iteratorNormalCompletion17 && _iterator17.return) {
                            _iterator17.return();
                          }

                        case 29:
                          _context20.prev = 29;

                          if (!_didIteratorError17) {
                            _context20.next = 32;
                            break;
                          }

                          throw _iteratorError17;

                        case 32:
                          return _context20.finish(29);

                        case 33:
                          return _context20.finish(26);

                        case 34:
                          if (!pdf) {
                            _context20.next = 59;
                            break;
                          }

                          aux = [];
                          i = 0;

                          _loop2 = function _loop2(f) {
                            i++;

                            if (aux.findIndex(function (el) {
                              return el.key == f.pergunta.id_dimensao;
                            }) == -1) aux.push({
                              key: f.pergunta.id_dimensao,
                              name: _this16.getDimensaoById(f.pergunta.id_dimensao).nome,
                              children: [f]
                            });else __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, aux.find(function (el) {
                              return el.key == f.pergunta.id_dimensao;
                            })).children.push(f);

                            if (i == array.length) {
                              _this16.exportarPdf(aux);
                            }
                          };

                          _iteratorNormalCompletion18 = true;
                          _didIteratorError18 = false;
                          _iteratorError18 = undefined;
                          _context20.prev = 41;

                          for (_iterator18 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(array.sort(function (a, b) {
                            return a.pergunta.ordem - b.pergunta.ordem;
                          })); !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
                            f = _step18.value;

                            _loop2(f);
                          }
                          _context20.next = 49;
                          break;

                        case 45:
                          _context20.prev = 45;
                          _context20.t2 = _context20["catch"](41);
                          _didIteratorError18 = true;
                          _iteratorError18 = _context20.t2;

                        case 49:
                          _context20.prev = 49;
                          _context20.prev = 50;

                          if (!_iteratorNormalCompletion18 && _iterator18.return) {
                            _iterator18.return();
                          }

                        case 52:
                          _context20.prev = 52;

                          if (!_didIteratorError18) {
                            _context20.next = 55;
                            break;
                          }

                          throw _iteratorError18;

                        case 55:
                          return _context20.finish(52);

                        case 56:
                          return _context20.finish(49);

                        case 57:
                          _context20.next = 83;
                          break;

                        case 59:
                          _aux = [];

                          _loop3 = function _loop3(_f) {
                            if (_aux.findIndex(function (el) {
                              return el.key == _f.pergunta.id_dimensao;
                            }) == -1) _aux.push({
                              key: _f.pergunta.id_dimensao,
                              name: _this16.getDimensaoById(_f.pergunta.id_dimensao).nome,
                              children: [_f]
                            });else __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _aux.find(function (el) {
                              return el.key == _f.pergunta.id_dimensao;
                            })).children.push(_f);
                          };

                          _iteratorNormalCompletion19 = true;
                          _didIteratorError19 = false;
                          _iteratorError19 = undefined;
                          _context20.prev = 64;


                          for (_iterator19 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(array.sort(function (a, b) {
                            return a.pergunta.ordem - b.pergunta.ordem;
                          })); !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
                            _f = _step19.value;

                            _loop3(_f);
                          }

                          _context20.next = 72;
                          break;

                        case 68:
                          _context20.prev = 68;
                          _context20.t3 = _context20["catch"](64);
                          _didIteratorError19 = true;
                          _iteratorError19 = _context20.t3;

                        case 72:
                          _context20.prev = 72;
                          _context20.prev = 73;

                          if (!_iteratorNormalCompletion19 && _iterator19.return) {
                            _iterator19.return();
                          }

                        case 75:
                          _context20.prev = 75;

                          if (!_didIteratorError19) {
                            _context20.next = 78;
                            break;
                          }

                          throw _iteratorError19;

                        case 78:
                          return _context20.finish(75);

                        case 79:
                          return _context20.finish(72);

                        case 80:
                          _this16.formulario = _aux;
                          _this16.generating = false;
                          _this16.reporteM = true;

                        case 83:

                          _this16.waiting = false;

                        case 84:
                        case "end":
                          return _context20.stop();
                      }
                    }
                  }, _callee4, _this16, [[12, 22, 26, 34], [27,, 29, 33], [41, 45, 49, 57], [50,, 52, 56], [64, 68, 72, 80], [73,, 75, 79]]);
                })));

              case 4:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee5, _this16);
      }))();
    },
    exportarPdf: function exportarPdf(array) {
      var _planificacao,
          _this17 = this;

      this.generating = false;
      var nome = Date.now();

      this.$store.dispatch("propostas/export", {
        nome: nome,
        planificacao: (_planificacao = {
          instituicao: this.getInstituicaoById(this.editedItem.id_instituicao).nome,
          ano: this.getAnoById(this.editedItem.id_ano).nome,
          acao: this.getAcaoById(this.editedItem.id_acao).nome,
          medida: this.getMedidaById(this.editedItem.id_medida).nome,
          objetivo: this.getObjetivoById(this.editedItem.id_objetivo).nome,
          quem: this.editedItem.quem,
          descricao: this.editedItem.descricao,
          design_acao: this.editedItem.design_acao,
          design_proj: this.editedItem.design_proj
        }, __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_planificacao, "descricao", this.editedItem.descricao), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_planificacao, "submetida", this.editedItem.submetida ? "Sim" : "Não"), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_planificacao, "reporte", this.editedItem.reporte ? "Sim" : "Não"), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_planificacao, "data_submetida", this.editedItem.data_submetida ? this.editedItem.data_submetida : "-"), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_planificacao, "data_reporte", this.editedItem.data_reporte ? this.editedItem.data_reporte : "-"), _planificacao),
        reporte: array
      }).then(function (res) {
        if (res) {
          window.open("https://teste.areareservada.ened-portugal.pt" + "/enedapi/client/files/" + nome + ".pdf");

          _this17.generating = false;
          _this17.toast("success", "Listagem criada com sucesso");
        } else {
          _this17.generating = false;
          _this17.toast("error", "Ocorreu um erro na pesquisa.");
        }
      }).catch(function (err) {
        _this17.generating = false;
        _this17.toast("error", "Ocorreu um erro na pesquisa.");
      });
    },
    save: function save() {
      var _this18 = this;

      if (this.deleteM) {
        this.delete();
        return;
      }

      if (!this.$refs.form.validate()) return;

      if (this.editedIndex == -1) {
        if (!this.allowed) {
          this.toast("error", "Não é possivel criar mais planificações para o ano e ação indicados.");
          return;
        }

        this.$store.dispatch(this.table + "/update", {
          id: this.ID,
          id_tipo_acao: this.editedItem.id_tipo_acao,
          design_proj: this.editedItem.design_proj,
          design_acao: this.editedItem.design_acao,
          id_distrito: this.editedItem.id_distrito,
          dia: this.editedItem.dia,
          mes: this.editedItem.mes,
          quem: this.editedItem.quem,
          descricao: this.editedItem.descricao,
          data_criacao: this.$moment().format("YYYY-MM-DD HH:mm:ss")
        }).then(function (res) {
          if (res) {
            _this18.toast("success", _this18.messages.add.success);
            _this18.initialize();
          } else _this18.toast("error", _this18.messages.add.error);

          _this18.modal = false;
        });
      } else {
        this.$store.dispatch(this.table + "/update", {
          id: this.editedItem.id_proposta,
          id_tipo_acao: this.editedItem.id_tipo_acao,
          design_proj: this.editedItem.design_proj,
          design_acao: this.editedItem.design_acao,
          id_distrito: this.editedItem.id_distrito,
          dia: this.editedItem.dia,
          mes: this.editedItem.mes,
          quem: this.editedItem.quem,
          descricao: this.editedItem.descricao
        }).then(function (res) {
          if (res) {
            if (res) _this18.toast("success", _this18.messages.update.success);else _this18.initialize();
          } else _this18.toast("error", _this18.messages.update.error);

          _this18.modal = false;
        });
      }
    }
  }
});

/***/ }),

/***/ 467:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(9);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var cName = {
    upper: "Ano",
    lower: "o ano!"
};

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            table: 'anos',
            name: 'ano',
            search: "",
            modal: false,
            deleteM: false,
            loading: true,
            searchP: '',
            headers: [{
                text: "#",
                align: "left",
                sortable: true,
                value: "id_ano"
            }, {
                text: "Nome",
                align: "left",
                sortable: true,
                value: "nome"
            }, {
                text: "Ações",
                value: "id",
                sortable: false,
                align: "center"
            }],
            DATA: [],
            editedIndex: -1,
            editedItem: {
                id_ano: 0,
                nome: ""
            },
            defaultItem: {
                id_ano: 0,
                nome: ""
            },
            messages: {
                add: {
                    success: cName.upper + " criado com sucesso!",
                    error: "Ocorreu um erro ao criar " + cName.lower
                },
                update: {
                    success: cName.upper + " alterado com sucesso!",
                    error: "Ocorreu um erro ao alterar " + cName.lower
                },
                delete: {
                    success: cName.upper + " eliminado com sucesso!",
                    error: "Ocorreu um erro ao apagar " + cName.lower
                },
                default: {
                    sucesso: "Sucesso",
                    error: "Ocorreu um erro!"
                }
            },
            defaultRules: null,
            yearRules: null
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
        getAll: 'anos/getAll'
    }), {
        formTitle: function formTitle() {
            return this.editedIndex === -1 ? "Novo " + this.name : "Editar " + this.name;
        }
    }),

    watch: {
        modal: function modal(val) {
            val || this.close();
        },
        deleteM: function deleteM(val) {
            val || this.close();
        },
        getAll: function getAll(val) {
            this.initialize();
        }
    },

    created: function created() {
        var _this = this;

        this.defaultRules = [function (v) {
            return !!v || _this.$requiredField + '';
        }];
        this.yearRules = [function (v) {
            return v.length == 4 || _this.$requiredField + '';
        }];
        this.initialize();
    },
    mounted: function mounted() {},

    methods: {
        toast: function toast(type, message) {
            if (type == "success") {
                return iziToast.show({
                    title: "SUCESSO",
                    color: "green",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            } else {
                return iziToast.show({
                    title: "AVISO",
                    color: "red",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            }
        },
        initialize: function initialize() {
            this.loading = true;
            this.DATA = this.getAll;
            this.loading = false;
        },
        editItem: function editItem(item, dialog) {
            this.editedIndex = this.DATA.indexOf(item);
            this.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);

            if (dialog) this.modal = true;else this.deleteM = true;
        },
        delete: function _delete() {
            var _this2 = this;

            if (!this.editedItem.id_ano) return;

            this.$store.dispatch(this.table + "/delete", { id: this.editedItem.id_ano }).then(function (res) {
                if (res) {
                    _this2.toast('success', _this2.messages.delete.success);_this2.initialize();
                } else _this2.toast('error', _this2.messages.delete.error);

                _this2.deleteM = false;
            });
        },
        close: function close() {
            var _this3 = this;

            this.modal = this.deleteM = false;
            setTimeout(function () {
                _this3.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this3.defaultItem);
                _this3.editedIndex = -1;

                _this3.$refs.form.reset();
            }, 110);
        },
        save: function save() {
            var _this4 = this;

            if (this.deleteM) {
                this.delete();return;
            }

            if (!this.$refs.form.validate()) return;

            if (this.editedIndex == -1) {
                this.$store.dispatch(this.table + "/insert", { nome: this.editedItem.nome }).then(function (res) {
                    if (res) {
                        _this4.toast('success', _this4.messages.add.success);_this4.initialize();
                    } else _this4.toast('error', _this4.messages.add.error);

                    _this4.modal = false;
                });
            } else {
                this.$store.dispatch(this.table + "/update", { id: this.editedItem.id_ano, nome: this.editedItem.nome }).then(function (res) {
                    if (res) {
                        _this4.toast('success', _this4.messages.update.success);_this4.initialize();
                    } else _this4.toast('error', _this4.messages.update.error);

                    _this4.modal = false;
                });
            }
        }
    }
});

/***/ }),

/***/ 468:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(9);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var cName = {
    upper: "Fase",
    lower: "a fase!"
};

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            table: 'fases',
            name: 'fase',
            search: "",
            modal: false,
            deleteM: false,
            loading: true,
            searchP: '',
            headers: [{
                text: "#",
                align: "left",
                sortable: true,
                value: "id_fase"
            }, {
                text: "Nome",
                align: "left",
                sortable: true,
                value: "id_fase"
            }, {
                text: "Datas",
                align: "center",
                sortable: true,
                value: "data_inicio"
            }, {
                text: "Ações",
                value: "id",
                sortable: false,
                align: "center"
            }],
            DATA: [],
            editedIndex: -1,
            tipos: [{ tipo: 1, nome: 'Planificação' }, { tipo: 2, nome: 'Reporte' }],
            iniMenu: false,
            fimMenu: false,
            editedItem: {
                id_fase: 0,
                id_ano: 0,
                tipo: 0,
                data_inicio: '',
                data_fim: ''
            },
            defaultItem: {
                id_fase: 0,
                id_ano: 0,
                tipo: 0,
                data_inicio: '',
                data_fim: ''
            },
            messages: {
                add: {
                    success: cName.upper + " criada com sucesso!",
                    error: "Ocorreu um erro ao criar " + cName.lower
                },
                update: {
                    success: cName.upper + " alterada com sucesso!",
                    error: "Ocorreu um erro ao alterar " + cName.lower
                },
                delete: {
                    success: cName.upper + " eliminada com sucesso!",
                    error: "Ocorreu um erro ao apagar " + cName.lower
                },
                default: {
                    sucesso: "Sucesso",
                    error: "Ocorreu um erro!"
                }
            },
            defaultRules: null,
            yearRules: null
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
        getAll: 'fases/getAll',
        getAnos: 'anos/getAll',
        getAnoById: 'anos/getById'
    }), {
        formTitle: function formTitle() {
            return this.editedIndex === -1 ? "Nova " + this.name : "Editar " + this.name;
        }
    }),

    watch: {
        modal: function modal(val) {
            val || this.close();
        },
        deleteM: function deleteM(val) {
            val || this.close();
        },
        getAll: function getAll(val) {
            this.initialize();
        }
    },

    created: function created() {
        var _this = this;

        this.defaultRules = [function (v) {
            return !!v || _this.$requiredField + '';
        }];
        this.yearRules = [function (v) {
            return v.length == 4 || _this.$requiredField + '';
        }];
        this.initialize();
    },
    mounted: function mounted() {},

    methods: {
        nomeFase: function nomeFase(ano, tipo) {
            if (!ano || !tipo) return '-';

            return this.tipos.find(function (el) {
                return el.tipo == tipo;
            }).nome + ' - ' + this.getAnoById(ano).nome;
        },
        toast: function toast(type, message) {
            if (type == "success") {
                return iziToast.show({
                    title: "SUCESSO",
                    color: "green",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            } else {
                return iziToast.show({
                    title: "AVISO",
                    color: "red",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            }
        },
        initialize: function initialize() {
            this.loading = true;
            this.DATA = this.getAll;
            this.loading = false;
        },
        editItem: function editItem(item, dialog) {
            this.editedIndex = this.DATA.indexOf(item);
            this.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);

            if (dialog) this.modal = true;else this.deleteM = true;
        },
        delete: function _delete() {
            var _this2 = this;

            if (!this.editedItem.id_fase) return;

            this.$store.dispatch(this.table + "/delete", { id: this.editedItem.id_fase }).then(function (res) {
                if (res) {
                    _this2.toast('success', _this2.messages.delete.success);_this2.initialize();
                } else _this2.toast('error', _this2.messages.delete.error);

                _this2.deleteM = false;
            });
        },
        close: function close() {
            var _this3 = this;

            this.modal = this.deleteM = false;
            setTimeout(function () {
                _this3.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this3.defaultItem);
                _this3.editedIndex = -1;

                _this3.$refs.form.reset();
            }, 110);
        },
        save: function save() {
            var _this4 = this;

            if (this.deleteM) {
                this.delete();return;
            }

            if (!this.$refs.form.validate()) return;

            if (this.editedIndex == -1) {
                this.$store.dispatch(this.table + "/insert", { id_ano: this.editedItem.id_ano, tipo: this.editedItem.tipo, data_inicio: this.editedItem.data_inicio, data_fim: this.editedItem.data_fim }).then(function (res) {
                    if (res) {
                        _this4.toast('success', _this4.messages.add.success);_this4.initialize();
                    } else _this4.toast('error', _this4.messages.add.error);

                    _this4.modal = false;
                });
            } else {
                this.$store.dispatch(this.table + "/update", { id: this.editedItem.id_fase, id_ano: this.editedItem.id_ano, tipo: this.editedItem.tipo, data_inicio: this.editedItem.data_inicio, data_fim: this.editedItem.data_fim }).then(function (res) {
                    if (res) {
                        _this4.toast('success', _this4.messages.update.success);_this4.initialize();
                    } else _this4.toast('error', _this4.messages.update.error);

                    _this4.modal = false;
                });
            }
        },
        iniChange: function iniChange() {
            this.iniMenu = false, this.fimMenu = true;
        },
        fimChange: function fimChange() {
            this.fimMenu = false;
        }
    }
});

/***/ }),

/***/ 469:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(9);








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var cName = {
  upper: "Proposta",
  lower: "a proposta!"
};

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      table: "propostas",
      name: "proposta",
      search: "",
      stepper: 1,
      stepper2: 1,
      addNova: false,
      exportingProgress: 0,
      modal: false,
      waiting: false,
      deleteM: false,
      loading: true,
      reporteM: false,
      generating: false,
      FILTRO: {
        id_objetivo: 0,
        id_medida: 0,
        id_acao: 0,
        id_ano: 0,
        id_instituicao: 0
      },
      searchP: "",
      NOVA: {
        id_objetivo: 0,
        id_medida: 0,
        id_acao: 0,
        ano1: "",
        ano2: "",
        ano3: "",
        ano4: "",
        ano5: "",
        id_instituicao: 0
      },
      DEFAULT_NOVA: {
        id_objetivo: 0,
        id_medida: 0,
        id_acao: 0,
        ano1: "",
        ano2: "",
        ano3: "",
        ano4: "",
        ano5: "",
        id_instituicao: 0
      },
      headers: [{
        text: "Instituição",
        align: "left",
        value: "id_instituicao"
      }, {
        text: "Nome ação",
        align: "center",
        value: "design_acao"
      }, {
        text: "Ano",
        align: "center",
        value: "id_ano"
      }, {
        text: "Submetida?",
        align: "center",
        value: "id_proposta"
      }, {
        text: "Reporte?",
        align: "center",
        value: "id_proposta"
      }, {
        text: "Ações",
        value: "id",
        sortable: false,
        align: "center"
      }],
      DATA: [],
      editedIndex: -1,
      editedItem: {
        id_proposta: 0,
        nome: ""
      },
      defaultItem: {
        id_proposta: 0,
        nome: ""
      },
      messages: {
        add: {
          success: cName.upper + " criada com sucesso!",
          error: "Ocorreu um erro ao criar " + cName.lower
        },
        update: {
          success: cName.upper + " alterada com sucesso!",
          error: "Ocorreu um erro ao alterar " + cName.lower
        },
        delete: {
          success: cName.upper + " eliminada com sucesso!",
          error: "Ocorreu um erro ao apagar " + cName.lower
        },
        default: {
          sucesso: "Sucesso",
          error: "Ocorreu um erro!"
        }
      },
      defaultRules: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapGetters */])({
    getAll: "propostas/getAll",
    getAllInstituicoes: "instituicoes/getAllInstituicoes",
    getObjetivos: "objetivos/getAll",
    getMedidasByObjetivo: "medidas/getMedidasByObjetivo",
    getAcoesByMedida: "acoes/getAcoesByMedida",
    getDistritos: "distritos/getAll",
    getAnos: "anos/getAll",
    getAnoById: "anos/getById",
    getMedidaById: "medidas/getById",
    getObjetivoById: "objetivos/getById",
    getTiposAcao: "tipos_acao/getAll",
    getAcaoById: "acoes/getById",
    getMeses: "meses/getAll",
    isPlanificacaoAberta: "fases/isPlanificacaoAberta",
    isReporteAberta: "fases/isReporteAberta",
    getFormularioById: "formularios/getById",
    getPerguntaById: "perguntas/getById",
    getSetores: "setores/getAll",
    getDimensaoById: "dimensoes/getById",
    getInstituicaoById: "instituicoes/getById"
  }), {
    formTitle: function formTitle() {
      return this.editedIndex === -1 ? "Nova " + this.name : "Editar " + this.name;
    }
  }),

  watch: {
    addNova: function addNova(val) {
      val || this.close();
    },
    modal: function modal(val) {
      val || this.close();
    },
    deleteM: function deleteM(val) {
      val || this.close();
    },
    getAll: function getAll(val) {
      this.initialize();
    }
  },

  created: function created() {
    var _this = this;

    this.defaultRules = [function (v) {
      return !!v || _this.$requiredField + "";
    }];
    this.initialize();
  },
  mounted: function mounted() {},

  methods: {
    filtrar: function filtrar() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee() {
        var array;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                array = [].concat(_this2.getAll);

                if (!(_this2.FILTRO.id_objetivo > 0)) {
                  _context.next = 5;
                  break;
                }

                _context.next = 4;
                return _this2.filterObjetivo(array);

              case 4:
                array = _context.sent;

              case 5:
                if (!(_this2.FILTRO.id_medida > 0)) {
                  _context.next = 9;
                  break;
                }

                _context.next = 8;
                return _this2.filterMedida(array);

              case 8:
                array = _context.sent;

              case 9:
                if (!(_this2.FILTRO.id_acao > 0)) {
                  _context.next = 13;
                  break;
                }

                _context.next = 12;
                return _this2.filterAcao(array);

              case 12:
                array = _context.sent;

              case 13:
                if (!(_this2.FILTRO.id_instituicao > 0)) {
                  _context.next = 17;
                  break;
                }

                _context.next = 16;
                return _this2.filterInstituicao(array);

              case 16:
                array = _context.sent;

              case 17:
                if (!(_this2.FILTRO.id_ano > 0)) {
                  _context.next = 21;
                  break;
                }

                _context.next = 20;
                return _this2.filterAno(array);

              case 20:
                array = _context.sent;

              case 21:

                _this2.DATA = array;

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    limpar: function limpar() {
      this.FILTRO = {
        id_objetivo: 0,
        id_medida: 0,
        id_acao: 0,
        id_ano: 0,
        id_instituicao: 0
      };
      this.initialize();
    },
    filterObjetivo: function filterObjetivo(array) {
      var _this3 = this;

      return array.filter(function (el) {
        return el.id_objetivo == _this3.FILTRO.id_objetivo;
      });
    },
    filterMedida: function filterMedida(array) {
      var _this4 = this;

      return array.filter(function (el) {
        return el.id_medida == _this4.FILTRO.id_medida;
      });
    },
    filterAcao: function filterAcao(array) {
      var _this5 = this;

      return array.filter(function (el) {
        return el.id_acao == _this5.FILTRO.id_acao;
      });
    },
    filterInstituicao: function filterInstituicao(array) {
      var _this6 = this;

      return array.filter(function (el) {
        return el.id_instituicao == _this6.FILTRO.id_instituicao;
      });
    },
    filterAno: function filterAno(array) {
      var _this7 = this;

      return array.filter(function (el) {
        return el.id_ano == _this7.FILTRO.id_ano;
      });
    },
    changeObjetivo: function changeObjetivo() {
      this.NOVA.id_medida = 0;
      this.NOVA.id_acao = 0;
      this.stepper2 = 2;
    },
    changeMedida: function changeMedida() {
      this.NOVA.id_acao = 0;
      this.stepper2 = 3;
    },
    changeAcao: function changeAcao() {
      this.stepper2 = 4;
    },
    toast: function toast(type, message) {
      if (type == "success") {
        return iziToast.show({
          title: "SUCESSO",
          color: "green",
          timeout: this.$toastTimeout,
          message: message,
          position: this.$toastPosition
        });
      } else {
        return iziToast.show({
          title: "AVISO",
          color: "red",
          timeout: this.$toastTimeout,
          message: message,
          position: this.$toastPosition
        });
      }
    },
    initialize: function initialize() {
      this.loading = true;
      this.DATA = this.getAll;
      this.loading = false;
    },
    editItem: function editItem(item, dialog) {
      this.editedIndex = this.DATA.indexOf(item);
      this.editedItem = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, item);

      this.stepper2 = 4;

      if (dialog) this.modal = true;else this.deleteM = true;
    },
    reverterReporte: function reverterReporte() {
      var _this8 = this;

      if (!this.editedItem.id_proposta) return;

      this.$store.dispatch(this.table + "/reverter_reporte", {
        id: this.editedItem.id_proposta
      }).then(function (res) {
        _this8.toast("success", "Estado do reporte alterado");
        _this8.modal = false;
        _this8.initialize();
      });
    },
    reverterSubmissao: function reverterSubmissao() {
      var _this9 = this;

      if (!this.editedItem.id_proposta) return;

      this.$store.dispatch(this.table + "/reverter_submissao", {
        id: this.editedItem.id_proposta
      }).then(function (res) {
        _this9.toast("success", "Estado do reporte alterado");
        _this9.modal = false;
        _this9.initialize();
      });
    },
    delete: function _delete() {
      var _this10 = this;

      if (!this.editedItem.id_proposta) return;

      this.$store.dispatch(this.table + "/delete", {
        id: this.editedItem.id_proposta
      }).then(function (res) {
        if (res) {
          _this10.toast("success", _this10.messages.delete.success);
          _this10.initialize();
        } else _this10.toast("error", _this10.messages.delete.error);

        _this10.deleteM = false;
      });
    },
    close: function close() {
      var _this11 = this;

      this.modal = this.deleteM = this.addNova = this.reporteM = false;
      setTimeout(function () {
        _this11.editedItem = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this11.defaultItem);
        _this11.NOVA = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this11.DEFAULT_NOVA);
        _this11.editedIndex = -1;

        setTimeout(function () {
          _this11.stepper = 1;
          _this11.stepper2 = 1;
          _this11.$refs.formReporte.reset();
        }, 150);

        _this11.$refs.form.reset();
      }, 110);
    },
    save: function save() {
      var _this12 = this;

      if (this.deleteM) {
        this.delete();
        return;
      }

      if (!this.$refs.form.validate()) return;

      if (this.editedIndex == -1) {
        this.$store.dispatch(this.table + "/add", {
          data: this.NOVA,
          auto_proposta: 0
        }).then(function (res) {
          if (res) {
            _this12.toast("success", _this12.messages.add.success);
            _this12.initialize();
          } else _this12.toast("error", _this12.messages.add.error);

          _this12.addNova = false;
        });
      }
    },
    sleep: function sleep() {
      var _this13 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this13.waiting = true;
        setTimeout(function () {
          resolve();
        }, 120);
      });
    },
    reporte: function reporte(item) {
      var _this14 = this;

      var pdf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                if (item) {
                  _context19.next = 2;
                  break;
                }

                return _context19.abrupt("return");

              case 2:
                _this14.exportingProgress = 0;

                _this14.sleep().then(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee2() {
                  var array, step, _loop, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, p, aux, i, _loop2, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, f, _aux, _loop3, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _f;

                  return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context18) {
                    while (1) {
                      switch (_context18.prev = _context18.next) {
                        case 0:
                          array = [];


                          _this14.editedIndex = _this14.DATA.indexOf(item);
                          _this14.editedItem = {};

                          _context18.next = 5;
                          return __WEBPACK_IMPORTED_MODULE_8__store_axios__["a" /* instance */].get("/proposta/" + item.id_proposta).then(function (res) {
                            if (res.data.results > 0) {
                              _this14.editedItem = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, res.data.data[0]);
                            }
                          });

                        case 5:
                          _context18.next = 7;
                          return __WEBPACK_IMPORTED_MODULE_8__store_axios__["a" /* instance */].get("/formulario/" + _this14.getAcaoById(item.id_acao).id_formulario).then(function (res) {
                            if (res.data.results > 0) {
                              array = res.data.data[0].perguntas || [];
                            }
                          });

                        case 7:
                          step = 100 / array.length;
                          _loop = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _loop(p) {
                            var _loop4, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, c, el, valor, cc, e, _valor15, _e12, _valor16, ccc, _e13, _valor17, _e14, _valor18, _loop17, _iteratorNormalCompletion17, _didIteratorError17, _iteratorError17, _iterator17, _step17, vv, _loop18, _iteratorNormalCompletion18, _didIteratorError18, _iteratorError18, _iterator18, _step18, xy, _el10, _loop19, _iteratorNormalCompletion19, _didIteratorError19, _iteratorError19, _iterator19, _step19, _vv6, _el12, _loop22, _iteratorNormalCompletion22, _didIteratorError22, _iteratorError22, _iterator22, _step22, _xy6, _el13, _el14, _valor21, _loop23, _iteratorNormalCompletion23, _didIteratorError23, _iteratorError23, _iterator23, _step23, v, _el19;

                            return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _loop$(_context17) {
                              while (1) {
                                switch (_context17.prev = _context17.next) {
                                  case 0:
                                    _context17.next = 2;
                                    return __WEBPACK_IMPORTED_MODULE_8__store_axios__["a" /* instance */].get("/pergunta/" + p.id_pergunta).then(function (res) {
                                      p.pergunta = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, res.data.data[0]);
                                    });

                                  case 2:
                                    _this14.exportingProgress += step;

                                    _context17.next = 5;
                                    return _this14.getDimensaoById(p.pergunta.id_dimensao).ordem;

                                  case 5:
                                    p.pergunta.ordem = _context17.sent;


                                    if (p.pergunta.hasOwnProperty("children") && p.pergunta.children.length > 0) p.pergunta.children = [].concat(p.pergunta.children.map(function (el) {
                                      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, el);
                                    }));

                                    if (!(p.pergunta.hasOwnProperty("children") && p.pergunta.children.length > 0 && p.pergunta.id_tipo == 5)) {
                                      _context17.next = 36;
                                      break;
                                    }

                                    _loop4 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _loop4(c) {
                                      var el, valor, cc, e, _valor, _e, _valor2, ccc, _e2, _valor3, _e3, _valor4, _loop5, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, vv, _loop6, _iteratorNormalCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, xy, _el, _loop7, _iteratorNormalCompletion7, _didIteratorError7, _iteratorError7, _iterator7, _step7, _vv, _el2, _loop9, _iteratorNormalCompletion9, _didIteratorError9, _iteratorError9, _iterator9, _step9, _xy, _el3, _el4, _valor7, _loop10, _iteratorNormalCompletion10, _didIteratorError10, _iteratorError10, _iterator10, _step10, v, _el9, _valor14;

                                      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _loop4$(_context9) {
                                        while (1) {
                                          switch (_context9.prev = _context9.next) {
                                            case 0:
                                              if (!(c.id_tipo == 1)) {
                                                _context9.next = 148;
                                                break;
                                              }

                                              el = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                                return el.id_pergunta == c.id_pergunta;
                                              }));

                                              if (!(typeof el != "undefined" && el.valor)) {
                                                _context9.next = 146;
                                                break;
                                              }

                                              valor = el.valor;
                                              cc = c.children.find(function (el) {
                                                return el.id_pergunta == Number(valor);
                                              });
                                              _context9.next = 7;
                                              return _this14.changeCheck(c, cc, 1, true);

                                            case 7:
                                              c.valor = valor;

                                              if (!(cc.expansivel && (cc.id_tipo == 1 || cc.id_tipo == 2))) {
                                                _context9.next = 120;
                                                break;
                                              }

                                              e = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                                return el.id_pergunta == cc.id_pergunta;
                                              }));

                                              if (!(typeof e != "undefined" && e.valor)) {
                                                _context9.next = 118;
                                                break;
                                              }

                                              _valor = e.valor.split(";").map(function (e) {
                                                return Number(e);
                                              });

                                              cc.valor = _valor;

                                              if (!(cc.id_tipo == 1)) {
                                                _context9.next = 87;
                                                break;
                                              }

                                              _e = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                                return el.id_pergunta == cc.id_pergunta;
                                              }));

                                              if (!(typeof _e != "undefined" && _e.valor)) {
                                                _context9.next = 85;
                                                break;
                                              }

                                              _valor2 = _e.valor;
                                              ccc = cc.children.find(function (el) {
                                                return el.id_pergunta == Number(_valor2);
                                              });

                                              _this14.changeCheck(cc, ccc, 1, true);
                                              cc.valor = _valor2;

                                              if (!(ccc.expansivel && (ccc.id_tipo == 1 || ccc.id_tipo == 2))) {
                                                _context9.next = 59;
                                                break;
                                              }

                                              _e2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                                return el.id_pergunta == ccc.id_pergunta;
                                              }));

                                              if (!(typeof _e2 != "undefined" && _e2.valor)) {
                                                _context9.next = 57;
                                                break;
                                              }

                                              _valor3 = _e2.valor.split(";").map(function (e) {
                                                return Number(e);
                                              });

                                              ccc.valor = _valor3;

                                              if (!(ccc.id_tipo == 1)) {
                                                _context9.next = 30;
                                                break;
                                              }

                                              _e3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                                return el.id_pergunta == ccc.id_pergunta;
                                              }));

                                              if (typeof _e3 != "undefined" && _e3.valor) {
                                                _valor4 = _e3.valor;

                                                _this14.changeCheck(cc, ccc.children.find(function (el) {
                                                  return el.id_pergunta == Number(_valor4);
                                                }), 1, true);
                                                ccc.valor = _valor4;
                                              }
                                              _context9.next = 57;
                                              break;

                                            case 30:
                                              if (!(ccc.id_tipo == 2)) {
                                                _context9.next = 57;
                                                break;
                                              }

                                              _loop5 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _loop5(vv) {
                                                var ccc;
                                                return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _loop5$(_context2) {
                                                  while (1) {
                                                    switch (_context2.prev = _context2.next) {
                                                      case 0:
                                                        ccc = ccc.children.find(function (el) {
                                                          return el.id_pergunta == Number(vv);
                                                        });
                                                        _context2.next = 3;
                                                        return _this14.changeCheck(cc, ccc, 2, true);

                                                      case 3:
                                                      case "end":
                                                        return _context2.stop();
                                                    }
                                                  }
                                                }, _loop5, _this14);
                                              });
                                              _iteratorNormalCompletion5 = true;
                                              _didIteratorError5 = false;
                                              _iteratorError5 = undefined;
                                              _context9.prev = 35;
                                              _iterator5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_valor3);

                                            case 37:
                                              if (_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done) {
                                                _context9.next = 43;
                                                break;
                                              }

                                              vv = _step5.value;
                                              return _context9.delegateYield(_loop5(vv), "t0", 40);

                                            case 40:
                                              _iteratorNormalCompletion5 = true;
                                              _context9.next = 37;
                                              break;

                                            case 43:
                                              _context9.next = 49;
                                              break;

                                            case 45:
                                              _context9.prev = 45;
                                              _context9.t1 = _context9["catch"](35);
                                              _didIteratorError5 = true;
                                              _iteratorError5 = _context9.t1;

                                            case 49:
                                              _context9.prev = 49;
                                              _context9.prev = 50;

                                              if (!_iteratorNormalCompletion5 && _iterator5.return) {
                                                _iterator5.return();
                                              }

                                            case 52:
                                              _context9.prev = 52;

                                              if (!_didIteratorError5) {
                                                _context9.next = 55;
                                                break;
                                              }

                                              throw _iteratorError5;

                                            case 55:
                                              return _context9.finish(52);

                                            case 56:
                                              return _context9.finish(49);

                                            case 57:
                                              _context9.next = 85;
                                              break;

                                            case 59:
                                              if (!(ccc.children && ccc.children.length > 0)) {
                                                _context9.next = 83;
                                                break;
                                              }

                                              ccc.children = [].concat(ccc.children.map(function (el) {
                                                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, el);
                                              }));

                                              _loop6 = function _loop6(xy) {
                                                var e = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                                  return el.id_pergunta == xy.id_pergunta;
                                                }));

                                                if (typeof e != "undefined") xy.valor = e.valor;
                                              };

                                              _iteratorNormalCompletion6 = true;
                                              _didIteratorError6 = false;
                                              _iteratorError6 = undefined;
                                              _context9.prev = 65;
                                              for (_iterator6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(ccc.children); !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                                                xy = _step6.value;

                                                _loop6(xy);
                                              }
                                              _context9.next = 73;
                                              break;

                                            case 69:
                                              _context9.prev = 69;
                                              _context9.t2 = _context9["catch"](65);
                                              _didIteratorError6 = true;
                                              _iteratorError6 = _context9.t2;

                                            case 73:
                                              _context9.prev = 73;
                                              _context9.prev = 74;

                                              if (!_iteratorNormalCompletion6 && _iterator6.return) {
                                                _iterator6.return();
                                              }

                                            case 76:
                                              _context9.prev = 76;

                                              if (!_didIteratorError6) {
                                                _context9.next = 79;
                                                break;
                                              }

                                              throw _iteratorError6;

                                            case 79:
                                              return _context9.finish(76);

                                            case 80:
                                              return _context9.finish(73);

                                            case 81:
                                              _context9.next = 85;
                                              break;

                                            case 83:
                                              _el = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                                return el.id_pergunta == ccc.id_pergunta;
                                              }));


                                              if (typeof _el != "undefined") ccc.valor = _el.valor;

                                            case 85:
                                              _context9.next = 118;
                                              break;

                                            case 87:
                                              if (!(cc.id_tipo == 2)) {
                                                _context9.next = 116;
                                                break;
                                              }

                                              _loop7 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _loop7(_vv) {
                                                var ccc, _e4, _valor5, _e5, _valor6, _loop8, _iteratorNormalCompletion8, _didIteratorError8, _iteratorError8, _iterator8, _step8, _vv2;

                                                return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _loop7$(_context4) {
                                                  while (1) {
                                                    switch (_context4.prev = _context4.next) {
                                                      case 0:
                                                        ccc = cc.children.find(function (el) {
                                                          return el.id_pergunta == Number(_vv);
                                                        });
                                                        _context4.next = 3;
                                                        return _this14.changeCheck(cc, ccc, 2, true);

                                                      case 3:
                                                        if (!(ccc.expansivel && (ccc.id_tipo == 1 || ccc.id_tipo == 2))) {
                                                          _context4.next = 40;
                                                          break;
                                                        }

                                                        _e4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                                          return el.id_pergunta == ccc.id_pergunta;
                                                        }));

                                                        if (!(typeof _e4 != "undefined" && _e4.valor)) {
                                                          _context4.next = 40;
                                                          break;
                                                        }

                                                        _valor5 = _e4.valor.split(";").map(function (e) {
                                                          return Number(e);
                                                        });

                                                        ccc.valor = _valor5;

                                                        if (!(ccc.id_tipo == 1)) {
                                                          _context4.next = 13;
                                                          break;
                                                        }

                                                        _e5 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                                          return el.id_pergunta == ccc.id_pergunta;
                                                        }));

                                                        if (typeof _e5 != "undefined" && _e5.valor) {
                                                          _valor6 = _e5.valor;

                                                          _this14.changeCheck(cc, ccc.children.find(function (el) {
                                                            return el.id_pergunta == Number(_valor6);
                                                          }), 1, true);
                                                          ccc.valor = _valor6;
                                                        }
                                                        _context4.next = 40;
                                                        break;

                                                      case 13:
                                                        if (!(ccc.id_tipo == 2)) {
                                                          _context4.next = 40;
                                                          break;
                                                        }

                                                        _loop8 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _loop8(_vv2) {
                                                          var ccc;
                                                          return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _loop8$(_context3) {
                                                            while (1) {
                                                              switch (_context3.prev = _context3.next) {
                                                                case 0:
                                                                  ccc = ccc.children.find(function (el) {
                                                                    return el.id_pergunta == Number(_vv2);
                                                                  });
                                                                  _context3.next = 3;
                                                                  return _this14.changeCheck(cc, ccc, 2, true);

                                                                case 3:
                                                                case "end":
                                                                  return _context3.stop();
                                                              }
                                                            }
                                                          }, _loop8, _this14);
                                                        });
                                                        _iteratorNormalCompletion8 = true;
                                                        _didIteratorError8 = false;
                                                        _iteratorError8 = undefined;
                                                        _context4.prev = 18;
                                                        _iterator8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_valor5);

                                                      case 20:
                                                        if (_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done) {
                                                          _context4.next = 26;
                                                          break;
                                                        }

                                                        _vv2 = _step8.value;
                                                        return _context4.delegateYield(_loop8(_vv2), "t0", 23);

                                                      case 23:
                                                        _iteratorNormalCompletion8 = true;
                                                        _context4.next = 20;
                                                        break;

                                                      case 26:
                                                        _context4.next = 32;
                                                        break;

                                                      case 28:
                                                        _context4.prev = 28;
                                                        _context4.t1 = _context4["catch"](18);
                                                        _didIteratorError8 = true;
                                                        _iteratorError8 = _context4.t1;

                                                      case 32:
                                                        _context4.prev = 32;
                                                        _context4.prev = 33;

                                                        if (!_iteratorNormalCompletion8 && _iterator8.return) {
                                                          _iterator8.return();
                                                        }

                                                      case 35:
                                                        _context4.prev = 35;

                                                        if (!_didIteratorError8) {
                                                          _context4.next = 38;
                                                          break;
                                                        }

                                                        throw _iteratorError8;

                                                      case 38:
                                                        return _context4.finish(35);

                                                      case 39:
                                                        return _context4.finish(32);

                                                      case 40:
                                                      case "end":
                                                        return _context4.stop();
                                                    }
                                                  }
                                                }, _loop7, _this14, [[18, 28, 32, 40], [33,, 35, 39]]);
                                              });
                                              _iteratorNormalCompletion7 = true;
                                              _didIteratorError7 = false;
                                              _iteratorError7 = undefined;
                                              _context9.prev = 92;
                                              _iterator7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_valor);

                                            case 94:
                                              if (_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done) {
                                                _context9.next = 100;
                                                break;
                                              }

                                              _vv = _step7.value;
                                              return _context9.delegateYield(_loop7(_vv), "t3", 97);

                                            case 97:
                                              _iteratorNormalCompletion7 = true;
                                              _context9.next = 94;
                                              break;

                                            case 100:
                                              _context9.next = 106;
                                              break;

                                            case 102:
                                              _context9.prev = 102;
                                              _context9.t4 = _context9["catch"](92);
                                              _didIteratorError7 = true;
                                              _iteratorError7 = _context9.t4;

                                            case 106:
                                              _context9.prev = 106;
                                              _context9.prev = 107;

                                              if (!_iteratorNormalCompletion7 && _iterator7.return) {
                                                _iterator7.return();
                                              }

                                            case 109:
                                              _context9.prev = 109;

                                              if (!_didIteratorError7) {
                                                _context9.next = 112;
                                                break;
                                              }

                                              throw _iteratorError7;

                                            case 112:
                                              return _context9.finish(109);

                                            case 113:
                                              return _context9.finish(106);

                                            case 114:
                                              _context9.next = 118;
                                              break;

                                            case 116:
                                              _el2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                                return el.id_pergunta == cc.id_pergunta;
                                              }));


                                              if (typeof _el2 != "undefined") cc.valor = _el2.valor;

                                            case 118:
                                              _context9.next = 146;
                                              break;

                                            case 120:
                                              if (!(cc.children && cc.children.length > 0)) {
                                                _context9.next = 144;
                                                break;
                                              }

                                              cc.children = [].concat(cc.children.map(function (el) {
                                                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, el);
                                              }));

                                              _loop9 = function _loop9(_xy) {
                                                var e = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                                  return el.id_pergunta == _xy.id_pergunta;
                                                }));

                                                if (typeof e != "undefined") _xy.valor = e.valor;
                                              };

                                              _iteratorNormalCompletion9 = true;
                                              _didIteratorError9 = false;
                                              _iteratorError9 = undefined;
                                              _context9.prev = 126;
                                              for (_iterator9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(cc.children); !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                                                _xy = _step9.value;

                                                _loop9(_xy);
                                              }
                                              _context9.next = 134;
                                              break;

                                            case 130:
                                              _context9.prev = 130;
                                              _context9.t5 = _context9["catch"](126);
                                              _didIteratorError9 = true;
                                              _iteratorError9 = _context9.t5;

                                            case 134:
                                              _context9.prev = 134;
                                              _context9.prev = 135;

                                              if (!_iteratorNormalCompletion9 && _iterator9.return) {
                                                _iterator9.return();
                                              }

                                            case 137:
                                              _context9.prev = 137;

                                              if (!_didIteratorError9) {
                                                _context9.next = 140;
                                                break;
                                              }

                                              throw _iteratorError9;

                                            case 140:
                                              return _context9.finish(137);

                                            case 141:
                                              return _context9.finish(134);

                                            case 142:
                                              _context9.next = 146;
                                              break;

                                            case 144:
                                              _el3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                                return el.id_pergunta == cc.id_pergunta;
                                              }));


                                              if (typeof _el3 != "undefined") cc.valor = _el3.valor;

                                            case 146:
                                              _context9.next = 183;
                                              break;

                                            case 148:
                                              if (!(c.id_tipo == 2)) {
                                                _context9.next = 181;
                                                break;
                                              }

                                              _el4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                                return el.id_pergunta == c.id_pergunta;
                                              }));

                                              if (!(typeof _el4 != "undefined" && _el4.valor)) {
                                                _context9.next = 179;
                                                break;
                                              }

                                              _valor7 = _el4.valor.split(";").map(function (el) {
                                                return Number(el);
                                              });

                                              c.valor = _valor7;

                                              _loop10 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _loop10(v) {
                                                var cc, _e6, _valor8, _e7, _valor9, _ccc, _e8, _valor10, _e9, _valor11, _loop11, _iteratorNormalCompletion11, _didIteratorError11, _iteratorError11, _iterator11, _step11, _vv3, _loop12, _iteratorNormalCompletion12, _didIteratorError12, _iteratorError12, _iterator12, _step12, _xy2, _el5, _loop13, _iteratorNormalCompletion13, _didIteratorError13, _iteratorError13, _iterator13, _step13, _vv4, _el7, _loop16, _iteratorNormalCompletion16, _didIteratorError16, _iteratorError16, _iterator16, _step16, _xy4, _el8;

                                                return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _loop10$(_context8) {
                                                  while (1) {
                                                    switch (_context8.prev = _context8.next) {
                                                      case 0:
                                                        cc = c.children.find(function (el) {
                                                          return el.id_pergunta == Number(v);
                                                        });
                                                        _context8.next = 3;
                                                        return _this14.changeCheck(c, cc, 2, true);

                                                      case 3:
                                                        if (!(cc.expansivel && (cc.id_tipo == 1 || cc.id_tipo == 2))) {
                                                          _context8.next = 115;
                                                          break;
                                                        }

                                                        _e6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                                          return el.id_pergunta == cc.id_pergunta;
                                                        }));

                                                        if (!(typeof _e6 != "undefined" && _e6.valor)) {
                                                          _context8.next = 113;
                                                          break;
                                                        }

                                                        _valor8 = _e6.valor.split(";").map(function (e) {
                                                          return Number(e);
                                                        });

                                                        cc.valor = _valor8;

                                                        if (!(cc.id_tipo == 1)) {
                                                          _context8.next = 82;
                                                          break;
                                                        }

                                                        _e7 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                                          return el.id_pergunta == cc.id_pergunta;
                                                        }));

                                                        if (!(typeof _e7 != "undefined" && _e7.valor)) {
                                                          _context8.next = 80;
                                                          break;
                                                        }

                                                        _valor9 = _e7.valor;
                                                        _ccc = cc.children.find(function (el) {
                                                          return el.id_pergunta == Number(_valor9);
                                                        });

                                                        _this14.changeCheck(cc, _ccc, 1, true);
                                                        cc.valor = _valor9;

                                                        if (!(_ccc.expansivel && (_ccc.id_tipo == 1 || _ccc.id_tipo == 2))) {
                                                          _context8.next = 54;
                                                          break;
                                                        }

                                                        _e8 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                                          return el.id_pergunta == _ccc.id_pergunta;
                                                        }));

                                                        if (!(typeof _e8 != "undefined" && _e8.valor)) {
                                                          _context8.next = 52;
                                                          break;
                                                        }

                                                        _valor10 = _e8.valor.split(";").map(function (e) {
                                                          return Number(e);
                                                        });

                                                        _ccc.valor = _valor10;

                                                        if (!(_ccc.id_tipo == 1)) {
                                                          _context8.next = 25;
                                                          break;
                                                        }

                                                        _e9 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                                          return el.id_pergunta == _ccc.id_pergunta;
                                                        }));

                                                        if (typeof _e9 != "undefined" && _e9.valor) {
                                                          _valor11 = _e9.valor;

                                                          _this14.changeCheck(cc, _ccc.children.find(function (el) {
                                                            return el.id_pergunta == Number(_valor11);
                                                          }), 1, true);
                                                          _ccc.valor = _valor11;
                                                        }
                                                        _context8.next = 52;
                                                        break;

                                                      case 25:
                                                        if (!(_ccc.id_tipo == 2)) {
                                                          _context8.next = 52;
                                                          break;
                                                        }

                                                        _loop11 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _loop11(_vv3) {
                                                          var ccc;
                                                          return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _loop11$(_context5) {
                                                            while (1) {
                                                              switch (_context5.prev = _context5.next) {
                                                                case 0:
                                                                  ccc = ccc.children.find(function (el) {
                                                                    return el.id_pergunta == Number(_vv3);
                                                                  });
                                                                  _context5.next = 3;
                                                                  return _this14.changeCheck(cc, ccc, 2, true);

                                                                case 3:
                                                                case "end":
                                                                  return _context5.stop();
                                                              }
                                                            }
                                                          }, _loop11, _this14);
                                                        });
                                                        _iteratorNormalCompletion11 = true;
                                                        _didIteratorError11 = false;
                                                        _iteratorError11 = undefined;
                                                        _context8.prev = 30;
                                                        _iterator11 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_valor10);

                                                      case 32:
                                                        if (_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done) {
                                                          _context8.next = 38;
                                                          break;
                                                        }

                                                        _vv3 = _step11.value;
                                                        return _context8.delegateYield(_loop11(_vv3), "t0", 35);

                                                      case 35:
                                                        _iteratorNormalCompletion11 = true;
                                                        _context8.next = 32;
                                                        break;

                                                      case 38:
                                                        _context8.next = 44;
                                                        break;

                                                      case 40:
                                                        _context8.prev = 40;
                                                        _context8.t1 = _context8["catch"](30);
                                                        _didIteratorError11 = true;
                                                        _iteratorError11 = _context8.t1;

                                                      case 44:
                                                        _context8.prev = 44;
                                                        _context8.prev = 45;

                                                        if (!_iteratorNormalCompletion11 && _iterator11.return) {
                                                          _iterator11.return();
                                                        }

                                                      case 47:
                                                        _context8.prev = 47;

                                                        if (!_didIteratorError11) {
                                                          _context8.next = 50;
                                                          break;
                                                        }

                                                        throw _iteratorError11;

                                                      case 50:
                                                        return _context8.finish(47);

                                                      case 51:
                                                        return _context8.finish(44);

                                                      case 52:
                                                        _context8.next = 80;
                                                        break;

                                                      case 54:
                                                        if (!(_ccc.children && _ccc.children.length > 0)) {
                                                          _context8.next = 78;
                                                          break;
                                                        }

                                                        _ccc.children = [].concat(_ccc.children.map(function (el) {
                                                          return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, el);
                                                        }));

                                                        _loop12 = function _loop12(_xy2) {
                                                          var e = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                                            return el.id_pergunta == _xy2.id_pergunta;
                                                          }));

                                                          if (typeof e != "undefined") _xy2.valor = e.valor;
                                                        };

                                                        _iteratorNormalCompletion12 = true;
                                                        _didIteratorError12 = false;
                                                        _iteratorError12 = undefined;
                                                        _context8.prev = 60;
                                                        for (_iterator12 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_ccc.children); !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
                                                          _xy2 = _step12.value;

                                                          _loop12(_xy2);
                                                        }
                                                        _context8.next = 68;
                                                        break;

                                                      case 64:
                                                        _context8.prev = 64;
                                                        _context8.t2 = _context8["catch"](60);
                                                        _didIteratorError12 = true;
                                                        _iteratorError12 = _context8.t2;

                                                      case 68:
                                                        _context8.prev = 68;
                                                        _context8.prev = 69;

                                                        if (!_iteratorNormalCompletion12 && _iterator12.return) {
                                                          _iterator12.return();
                                                        }

                                                      case 71:
                                                        _context8.prev = 71;

                                                        if (!_didIteratorError12) {
                                                          _context8.next = 74;
                                                          break;
                                                        }

                                                        throw _iteratorError12;

                                                      case 74:
                                                        return _context8.finish(71);

                                                      case 75:
                                                        return _context8.finish(68);

                                                      case 76:
                                                        _context8.next = 80;
                                                        break;

                                                      case 78:
                                                        _el5 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                                          return el.id_pergunta == _ccc.id_pergunta;
                                                        }));


                                                        if (typeof _el5 != "undefined") _ccc.valor = _el5.valor;

                                                      case 80:
                                                        _context8.next = 113;
                                                        break;

                                                      case 82:
                                                        if (!(cc.id_tipo == 2)) {
                                                          _context8.next = 111;
                                                          break;
                                                        }

                                                        _loop13 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _loop13(_vv4) {
                                                          var ccc, _e10, _valor12, _e11, _valor13, _loop14, _iteratorNormalCompletion14, _didIteratorError14, _iteratorError14, _iterator14, _step14, _vv5, _loop15, _iteratorNormalCompletion15, _didIteratorError15, _iteratorError15, _iterator15, _step15, _xy3, _el6;

                                                          return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _loop13$(_context7) {
                                                            while (1) {
                                                              switch (_context7.prev = _context7.next) {
                                                                case 0:
                                                                  ccc = cc.children.find(function (el) {
                                                                    return el.id_pergunta == Number(_vv4);
                                                                  });
                                                                  _context7.next = 3;
                                                                  return _this14.changeCheck(cc, ccc, 2, true);

                                                                case 3:
                                                                  if (!(ccc.expansivel && (ccc.id_tipo == 1 || ccc.id_tipo == 2))) {
                                                                    _context7.next = 42;
                                                                    break;
                                                                  }

                                                                  _e10 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                                                    return el.id_pergunta == ccc.id_pergunta;
                                                                  }));

                                                                  if (!(typeof _e10 != "undefined" && _e10.valor)) {
                                                                    _context7.next = 40;
                                                                    break;
                                                                  }

                                                                  _valor12 = _e10.valor.split(";").map(function (e) {
                                                                    return Number(e);
                                                                  });

                                                                  ccc.valor = _valor12;

                                                                  if (!(ccc.id_tipo == 1)) {
                                                                    _context7.next = 13;
                                                                    break;
                                                                  }

                                                                  _e11 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                                                    return el.id_pergunta == ccc.id_pergunta;
                                                                  }));

                                                                  if (typeof _e11 != "undefined" && _e11.valor) {
                                                                    _valor13 = _e11.valor;

                                                                    _this14.changeCheck(cc, ccc.children.find(function (el) {
                                                                      return el.id_pergunta == Number(_valor13);
                                                                    }), 1, true);
                                                                    ccc.valor = _valor13;
                                                                  }
                                                                  _context7.next = 40;
                                                                  break;

                                                                case 13:
                                                                  if (!(ccc.id_tipo == 2)) {
                                                                    _context7.next = 40;
                                                                    break;
                                                                  }

                                                                  _loop14 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _loop14(_vv5) {
                                                                    var ccc;
                                                                    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _loop14$(_context6) {
                                                                      while (1) {
                                                                        switch (_context6.prev = _context6.next) {
                                                                          case 0:
                                                                            ccc = ccc.children.find(function (el) {
                                                                              return el.id_pergunta == Number(_vv5);
                                                                            });
                                                                            _context6.next = 3;
                                                                            return _this14.changeCheck(cc, ccc, 2, true);

                                                                          case 3:
                                                                          case "end":
                                                                            return _context6.stop();
                                                                        }
                                                                      }
                                                                    }, _loop14, _this14);
                                                                  });
                                                                  _iteratorNormalCompletion14 = true;
                                                                  _didIteratorError14 = false;
                                                                  _iteratorError14 = undefined;
                                                                  _context7.prev = 18;
                                                                  _iterator14 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_valor12);

                                                                case 20:
                                                                  if (_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done) {
                                                                    _context7.next = 26;
                                                                    break;
                                                                  }

                                                                  _vv5 = _step14.value;
                                                                  return _context7.delegateYield(_loop14(_vv5), "t0", 23);

                                                                case 23:
                                                                  _iteratorNormalCompletion14 = true;
                                                                  _context7.next = 20;
                                                                  break;

                                                                case 26:
                                                                  _context7.next = 32;
                                                                  break;

                                                                case 28:
                                                                  _context7.prev = 28;
                                                                  _context7.t1 = _context7["catch"](18);
                                                                  _didIteratorError14 = true;
                                                                  _iteratorError14 = _context7.t1;

                                                                case 32:
                                                                  _context7.prev = 32;
                                                                  _context7.prev = 33;

                                                                  if (!_iteratorNormalCompletion14 && _iterator14.return) {
                                                                    _iterator14.return();
                                                                  }

                                                                case 35:
                                                                  _context7.prev = 35;

                                                                  if (!_didIteratorError14) {
                                                                    _context7.next = 38;
                                                                    break;
                                                                  }

                                                                  throw _iteratorError14;

                                                                case 38:
                                                                  return _context7.finish(35);

                                                                case 39:
                                                                  return _context7.finish(32);

                                                                case 40:
                                                                  _context7.next = 68;
                                                                  break;

                                                                case 42:
                                                                  if (!(ccc.children && ccc.children.length > 0)) {
                                                                    _context7.next = 66;
                                                                    break;
                                                                  }

                                                                  ccc.children = [].concat(ccc.children.map(function (el) {
                                                                    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, el);
                                                                  }));

                                                                  _loop15 = function _loop15(_xy3) {
                                                                    var e = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                                                      return el.id_pergunta == _xy3.id_pergunta;
                                                                    }));

                                                                    if (typeof e != "undefined") _xy3.valor = e.valor;
                                                                  };

                                                                  _iteratorNormalCompletion15 = true;
                                                                  _didIteratorError15 = false;
                                                                  _iteratorError15 = undefined;
                                                                  _context7.prev = 48;
                                                                  for (_iterator15 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(ccc.children); !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
                                                                    _xy3 = _step15.value;

                                                                    _loop15(_xy3);
                                                                  }
                                                                  _context7.next = 56;
                                                                  break;

                                                                case 52:
                                                                  _context7.prev = 52;
                                                                  _context7.t2 = _context7["catch"](48);
                                                                  _didIteratorError15 = true;
                                                                  _iteratorError15 = _context7.t2;

                                                                case 56:
                                                                  _context7.prev = 56;
                                                                  _context7.prev = 57;

                                                                  if (!_iteratorNormalCompletion15 && _iterator15.return) {
                                                                    _iterator15.return();
                                                                  }

                                                                case 59:
                                                                  _context7.prev = 59;

                                                                  if (!_didIteratorError15) {
                                                                    _context7.next = 62;
                                                                    break;
                                                                  }

                                                                  throw _iteratorError15;

                                                                case 62:
                                                                  return _context7.finish(59);

                                                                case 63:
                                                                  return _context7.finish(56);

                                                                case 64:
                                                                  _context7.next = 68;
                                                                  break;

                                                                case 66:
                                                                  _el6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                                                    return el.id_pergunta == ccc.id_pergunta;
                                                                  }));


                                                                  if (typeof _el6 != "undefined") ccc.valor = _el6.valor;

                                                                case 68:
                                                                case "end":
                                                                  return _context7.stop();
                                                              }
                                                            }
                                                          }, _loop13, _this14, [[18, 28, 32, 40], [33,, 35, 39], [48, 52, 56, 64], [57,, 59, 63]]);
                                                        });
                                                        _iteratorNormalCompletion13 = true;
                                                        _didIteratorError13 = false;
                                                        _iteratorError13 = undefined;
                                                        _context8.prev = 87;
                                                        _iterator13 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_valor8);

                                                      case 89:
                                                        if (_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done) {
                                                          _context8.next = 95;
                                                          break;
                                                        }

                                                        _vv4 = _step13.value;
                                                        return _context8.delegateYield(_loop13(_vv4), "t3", 92);

                                                      case 92:
                                                        _iteratorNormalCompletion13 = true;
                                                        _context8.next = 89;
                                                        break;

                                                      case 95:
                                                        _context8.next = 101;
                                                        break;

                                                      case 97:
                                                        _context8.prev = 97;
                                                        _context8.t4 = _context8["catch"](87);
                                                        _didIteratorError13 = true;
                                                        _iteratorError13 = _context8.t4;

                                                      case 101:
                                                        _context8.prev = 101;
                                                        _context8.prev = 102;

                                                        if (!_iteratorNormalCompletion13 && _iterator13.return) {
                                                          _iterator13.return();
                                                        }

                                                      case 104:
                                                        _context8.prev = 104;

                                                        if (!_didIteratorError13) {
                                                          _context8.next = 107;
                                                          break;
                                                        }

                                                        throw _iteratorError13;

                                                      case 107:
                                                        return _context8.finish(104);

                                                      case 108:
                                                        return _context8.finish(101);

                                                      case 109:
                                                        _context8.next = 113;
                                                        break;

                                                      case 111:
                                                        _el7 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                                          return el.id_pergunta == cc.id_pergunta;
                                                        }));


                                                        if (typeof _el7 != "undefined") cc.valor = _el7.valor;

                                                      case 113:
                                                        _context8.next = 141;
                                                        break;

                                                      case 115:
                                                        if (!(cc.children && cc.children.length > 0)) {
                                                          _context8.next = 139;
                                                          break;
                                                        }

                                                        cc.children = [].concat(cc.children.map(function (el) {
                                                          return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, el);
                                                        }));

                                                        _loop16 = function _loop16(_xy4) {
                                                          var e = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                                            return el.id_pergunta == _xy4.id_pergunta;
                                                          }));

                                                          if (typeof e != "undefined") _xy4.valor = e.valor;
                                                        };

                                                        _iteratorNormalCompletion16 = true;
                                                        _didIteratorError16 = false;
                                                        _iteratorError16 = undefined;
                                                        _context8.prev = 121;
                                                        for (_iterator16 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(cc.children); !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
                                                          _xy4 = _step16.value;

                                                          _loop16(_xy4);
                                                        }
                                                        _context8.next = 129;
                                                        break;

                                                      case 125:
                                                        _context8.prev = 125;
                                                        _context8.t5 = _context8["catch"](121);
                                                        _didIteratorError16 = true;
                                                        _iteratorError16 = _context8.t5;

                                                      case 129:
                                                        _context8.prev = 129;
                                                        _context8.prev = 130;

                                                        if (!_iteratorNormalCompletion16 && _iterator16.return) {
                                                          _iterator16.return();
                                                        }

                                                      case 132:
                                                        _context8.prev = 132;

                                                        if (!_didIteratorError16) {
                                                          _context8.next = 135;
                                                          break;
                                                        }

                                                        throw _iteratorError16;

                                                      case 135:
                                                        return _context8.finish(132);

                                                      case 136:
                                                        return _context8.finish(129);

                                                      case 137:
                                                        _context8.next = 141;
                                                        break;

                                                      case 139:
                                                        _el8 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                                          return el.id_pergunta == cc.id_pergunta;
                                                        }));


                                                        if (typeof _el8 != "undefined") cc.valor = _el8.valor;

                                                      case 141:
                                                      case "end":
                                                        return _context8.stop();
                                                    }
                                                  }
                                                }, _loop10, _this14, [[30, 40, 44, 52], [45,, 47, 51], [60, 64, 68, 76], [69,, 71, 75], [87, 97, 101, 109], [102,, 104, 108], [121, 125, 129, 137], [130,, 132, 136]]);
                                              });
                                              _iteratorNormalCompletion10 = true;
                                              _didIteratorError10 = false;
                                              _iteratorError10 = undefined;
                                              _context9.prev = 157;
                                              _iterator10 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_valor7);

                                            case 159:
                                              if (_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done) {
                                                _context9.next = 165;
                                                break;
                                              }

                                              v = _step10.value;
                                              return _context9.delegateYield(_loop10(v), "t6", 162);

                                            case 162:
                                              _iteratorNormalCompletion10 = true;
                                              _context9.next = 159;
                                              break;

                                            case 165:
                                              _context9.next = 171;
                                              break;

                                            case 167:
                                              _context9.prev = 167;
                                              _context9.t7 = _context9["catch"](157);
                                              _didIteratorError10 = true;
                                              _iteratorError10 = _context9.t7;

                                            case 171:
                                              _context9.prev = 171;
                                              _context9.prev = 172;

                                              if (!_iteratorNormalCompletion10 && _iterator10.return) {
                                                _iterator10.return();
                                              }

                                            case 174:
                                              _context9.prev = 174;

                                              if (!_didIteratorError10) {
                                                _context9.next = 177;
                                                break;
                                              }

                                              throw _iteratorError10;

                                            case 177:
                                              return _context9.finish(174);

                                            case 178:
                                              return _context9.finish(171);

                                            case 179:
                                              _context9.next = 183;
                                              break;

                                            case 181:
                                              _el9 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                                return el.id_pergunta == c.id_pergunta;
                                              }));

                                              if (typeof _el9 != "undefined" && _el9.valor) {
                                                _valor14 = _el9.valor;


                                                if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(Number(_valor14))) c.valor = Number(_valor14);else c.valor = _valor14;
                                              }

                                            case 183:
                                            case "end":
                                              return _context9.stop();
                                          }
                                        }
                                      }, _loop4, _this14, [[35, 45, 49, 57], [50,, 52, 56], [65, 69, 73, 81], [74,, 76, 80], [92, 102, 106, 114], [107,, 109, 113], [126, 130, 134, 142], [135,, 137, 141], [157, 167, 171, 179], [172,, 174, 178]]);
                                    });
                                    _iteratorNormalCompletion4 = true;
                                    _didIteratorError4 = false;
                                    _iteratorError4 = undefined;
                                    _context17.prev = 12;
                                    _iterator4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(p.pergunta.children);

                                  case 14:
                                    if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
                                      _context17.next = 20;
                                      break;
                                    }

                                    c = _step4.value;
                                    return _context17.delegateYield(_loop4(c), "t0", 17);

                                  case 17:
                                    _iteratorNormalCompletion4 = true;
                                    _context17.next = 14;
                                    break;

                                  case 20:
                                    _context17.next = 26;
                                    break;

                                  case 22:
                                    _context17.prev = 22;
                                    _context17.t1 = _context17["catch"](12);
                                    _didIteratorError4 = true;
                                    _iteratorError4 = _context17.t1;

                                  case 26:
                                    _context17.prev = 26;
                                    _context17.prev = 27;

                                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                      _iterator4.return();
                                    }

                                  case 29:
                                    _context17.prev = 29;

                                    if (!_didIteratorError4) {
                                      _context17.next = 32;
                                      break;
                                    }

                                    throw _iteratorError4;

                                  case 32:
                                    return _context17.finish(29);

                                  case 33:
                                    return _context17.finish(26);

                                  case 34:
                                    _context17.next = 218;
                                    break;

                                  case 36:
                                    if (!(p.pergunta.id_tipo == 1)) {
                                      _context17.next = 183;
                                      break;
                                    }

                                    el = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                      return el.id_pergunta == p.pergunta.id_pergunta;
                                    }));

                                    if (!(typeof el != "undefined" && el.valor)) {
                                      _context17.next = 181;
                                      break;
                                    }

                                    valor = el.valor;
                                    cc = p.pergunta.children.find(function (el) {
                                      return el.id_pergunta == Number(valor);
                                    });


                                    _this14.changeCheck(p.pergunta, cc, 1, true);
                                    p.pergunta.valor = valor;

                                    if (!(cc.expansivel && (cc.id_tipo == 1 || cc.id_tipo == 2))) {
                                      _context17.next = 155;
                                      break;
                                    }

                                    e = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                      return el.id_pergunta == cc.id_pergunta;
                                    }));

                                    if (!(typeof e != "undefined" && e.valor)) {
                                      _context17.next = 153;
                                      break;
                                    }

                                    _valor15 = e.valor.split(";").map(function (e) {
                                      return Number(e);
                                    });

                                    cc.valor = _valor15;

                                    if (!(cc.id_tipo == 1)) {
                                      _context17.next = 122;
                                      break;
                                    }

                                    _e12 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                      return el.id_pergunta == cc.id_pergunta;
                                    }));

                                    if (!(typeof _e12 != "undefined" && _e12.valor)) {
                                      _context17.next = 120;
                                      break;
                                    }

                                    _valor16 = _e12.valor;
                                    ccc = cc.children.find(function (el) {
                                      return el.id_pergunta == Number(_valor16);
                                    });

                                    _this14.changeCheck(cc, ccc, 1, true);
                                    cc.valor = _valor16;

                                    if (!(ccc.expansivel && (ccc.id_tipo == 1 || ccc.id_tipo == 2))) {
                                      _context17.next = 94;
                                      break;
                                    }

                                    _e13 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                      return el.id_pergunta == ccc.id_pergunta;
                                    }));

                                    if (!(typeof _e13 != "undefined" && _e13.valor)) {
                                      _context17.next = 92;
                                      break;
                                    }

                                    _valor17 = _e13.valor.split(";").map(function (e) {
                                      return Number(e);
                                    });

                                    ccc.valor = _valor17;

                                    if (!(ccc.id_tipo == 1)) {
                                      _context17.next = 65;
                                      break;
                                    }

                                    _e14 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                      return el.id_pergunta == ccc.id_pergunta;
                                    }));

                                    if (typeof _e14 != "undefined" && _e14.valor) {
                                      _valor18 = _e14.valor;

                                      _this14.changeCheck(cc, ccc.children.find(function (el) {
                                        return el.id_pergunta == Number(_valor18);
                                      }), 1, true);
                                      ccc.valor = _valor18;
                                    }
                                    _context17.next = 92;
                                    break;

                                  case 65:
                                    if (!(ccc.id_tipo == 2)) {
                                      _context17.next = 92;
                                      break;
                                    }

                                    _loop17 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _loop17(vv) {
                                      var ccc;
                                      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _loop17$(_context10) {
                                        while (1) {
                                          switch (_context10.prev = _context10.next) {
                                            case 0:
                                              ccc = ccc.children.find(function (el) {
                                                return el.id_pergunta == Number(vv);
                                              });
                                              _context10.next = 3;
                                              return _this14.changeCheck(cc, ccc, 2, true);

                                            case 3:
                                            case "end":
                                              return _context10.stop();
                                          }
                                        }
                                      }, _loop17, _this14);
                                    });
                                    _iteratorNormalCompletion17 = true;
                                    _didIteratorError17 = false;
                                    _iteratorError17 = undefined;
                                    _context17.prev = 70;
                                    _iterator17 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_valor17);

                                  case 72:
                                    if (_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done) {
                                      _context17.next = 78;
                                      break;
                                    }

                                    vv = _step17.value;
                                    return _context17.delegateYield(_loop17(vv), "t2", 75);

                                  case 75:
                                    _iteratorNormalCompletion17 = true;
                                    _context17.next = 72;
                                    break;

                                  case 78:
                                    _context17.next = 84;
                                    break;

                                  case 80:
                                    _context17.prev = 80;
                                    _context17.t3 = _context17["catch"](70);
                                    _didIteratorError17 = true;
                                    _iteratorError17 = _context17.t3;

                                  case 84:
                                    _context17.prev = 84;
                                    _context17.prev = 85;

                                    if (!_iteratorNormalCompletion17 && _iterator17.return) {
                                      _iterator17.return();
                                    }

                                  case 87:
                                    _context17.prev = 87;

                                    if (!_didIteratorError17) {
                                      _context17.next = 90;
                                      break;
                                    }

                                    throw _iteratorError17;

                                  case 90:
                                    return _context17.finish(87);

                                  case 91:
                                    return _context17.finish(84);

                                  case 92:
                                    _context17.next = 120;
                                    break;

                                  case 94:
                                    if (!(ccc.children && ccc.children.length > 0)) {
                                      _context17.next = 118;
                                      break;
                                    }

                                    ccc.children = [].concat(ccc.children.map(function (el) {
                                      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, el);
                                    }));

                                    _loop18 = function _loop18(xy) {
                                      var e = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                        return el.id_pergunta == xy.id_pergunta;
                                      }));

                                      if (typeof e != "undefined") xy.valor = e.valor;
                                    };

                                    _iteratorNormalCompletion18 = true;
                                    _didIteratorError18 = false;
                                    _iteratorError18 = undefined;
                                    _context17.prev = 100;
                                    for (_iterator18 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(ccc.children); !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
                                      xy = _step18.value;

                                      _loop18(xy);
                                    }
                                    _context17.next = 108;
                                    break;

                                  case 104:
                                    _context17.prev = 104;
                                    _context17.t4 = _context17["catch"](100);
                                    _didIteratorError18 = true;
                                    _iteratorError18 = _context17.t4;

                                  case 108:
                                    _context17.prev = 108;
                                    _context17.prev = 109;

                                    if (!_iteratorNormalCompletion18 && _iterator18.return) {
                                      _iterator18.return();
                                    }

                                  case 111:
                                    _context17.prev = 111;

                                    if (!_didIteratorError18) {
                                      _context17.next = 114;
                                      break;
                                    }

                                    throw _iteratorError18;

                                  case 114:
                                    return _context17.finish(111);

                                  case 115:
                                    return _context17.finish(108);

                                  case 116:
                                    _context17.next = 120;
                                    break;

                                  case 118:
                                    _el10 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                      return el.id_pergunta == ccc.id_pergunta;
                                    }));


                                    if (typeof _el10 != "undefined") ccc.valor = _el10.valor;

                                  case 120:
                                    _context17.next = 153;
                                    break;

                                  case 122:
                                    if (!(cc.id_tipo == 2)) {
                                      _context17.next = 151;
                                      break;
                                    }

                                    _loop19 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _loop19(_vv6) {
                                      var ccc, _e15, _valor19, _e16, _valor20, _loop20, _iteratorNormalCompletion20, _didIteratorError20, _iteratorError20, _iterator20, _step20, _vv7, _loop21, _iteratorNormalCompletion21, _didIteratorError21, _iteratorError21, _iterator21, _step21, _xy5, _el11;

                                      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _loop19$(_context12) {
                                        while (1) {
                                          switch (_context12.prev = _context12.next) {
                                            case 0:
                                              ccc = cc.children.find(function (el) {
                                                return el.id_pergunta == Number(_vv6);
                                              });
                                              _context12.next = 3;
                                              return _this14.changeCheck(cc, ccc, 2, true);

                                            case 3:
                                              if (!(ccc.expansivel && (ccc.id_tipo == 1 || ccc.id_tipo == 2))) {
                                                _context12.next = 42;
                                                break;
                                              }

                                              _e15 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                                return el.id_pergunta == ccc.id_pergunta;
                                              }));

                                              if (!(typeof _e15 != "undefined" && _e15.valor)) {
                                                _context12.next = 40;
                                                break;
                                              }

                                              _valor19 = _e15.valor.split(";").map(function (e) {
                                                return Number(e);
                                              });

                                              ccc.valor = _valor19;

                                              if (!(ccc.id_tipo == 1)) {
                                                _context12.next = 13;
                                                break;
                                              }

                                              _e16 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                                return el.id_pergunta == ccc.id_pergunta;
                                              }));

                                              if (typeof _e16 != "undefined" && _e16.valor) {
                                                _valor20 = _e16.valor;

                                                _this14.changeCheck(cc, ccc.children.find(function (el) {
                                                  return el.id_pergunta == Number(_valor20);
                                                }), 1, true);
                                                ccc.valor = _valor20;
                                              }
                                              _context12.next = 40;
                                              break;

                                            case 13:
                                              if (!(ccc.id_tipo == 2)) {
                                                _context12.next = 40;
                                                break;
                                              }

                                              _loop20 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _loop20(_vv7) {
                                                var ccc;
                                                return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _loop20$(_context11) {
                                                  while (1) {
                                                    switch (_context11.prev = _context11.next) {
                                                      case 0:
                                                        ccc = ccc.children.find(function (el) {
                                                          return el.id_pergunta == Number(_vv7);
                                                        });
                                                        _context11.next = 3;
                                                        return _this14.changeCheck(cc, ccc, 2, true);

                                                      case 3:
                                                      case "end":
                                                        return _context11.stop();
                                                    }
                                                  }
                                                }, _loop20, _this14);
                                              });
                                              _iteratorNormalCompletion20 = true;
                                              _didIteratorError20 = false;
                                              _iteratorError20 = undefined;
                                              _context12.prev = 18;
                                              _iterator20 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_valor19);

                                            case 20:
                                              if (_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done) {
                                                _context12.next = 26;
                                                break;
                                              }

                                              _vv7 = _step20.value;
                                              return _context12.delegateYield(_loop20(_vv7), "t0", 23);

                                            case 23:
                                              _iteratorNormalCompletion20 = true;
                                              _context12.next = 20;
                                              break;

                                            case 26:
                                              _context12.next = 32;
                                              break;

                                            case 28:
                                              _context12.prev = 28;
                                              _context12.t1 = _context12["catch"](18);
                                              _didIteratorError20 = true;
                                              _iteratorError20 = _context12.t1;

                                            case 32:
                                              _context12.prev = 32;
                                              _context12.prev = 33;

                                              if (!_iteratorNormalCompletion20 && _iterator20.return) {
                                                _iterator20.return();
                                              }

                                            case 35:
                                              _context12.prev = 35;

                                              if (!_didIteratorError20) {
                                                _context12.next = 38;
                                                break;
                                              }

                                              throw _iteratorError20;

                                            case 38:
                                              return _context12.finish(35);

                                            case 39:
                                              return _context12.finish(32);

                                            case 40:
                                              _context12.next = 68;
                                              break;

                                            case 42:
                                              if (!(ccc.children && ccc.children.length > 0)) {
                                                _context12.next = 66;
                                                break;
                                              }

                                              ccc.children = [].concat(ccc.children.map(function (el) {
                                                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, el);
                                              }));

                                              _loop21 = function _loop21(_xy5) {
                                                var e = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                                  return el.id_pergunta == _xy5.id_pergunta;
                                                }));

                                                if (typeof e != "undefined") _xy5.valor = e.valor;
                                              };

                                              _iteratorNormalCompletion21 = true;
                                              _didIteratorError21 = false;
                                              _iteratorError21 = undefined;
                                              _context12.prev = 48;
                                              for (_iterator21 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(ccc.children); !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
                                                _xy5 = _step21.value;

                                                _loop21(_xy5);
                                              }
                                              _context12.next = 56;
                                              break;

                                            case 52:
                                              _context12.prev = 52;
                                              _context12.t2 = _context12["catch"](48);
                                              _didIteratorError21 = true;
                                              _iteratorError21 = _context12.t2;

                                            case 56:
                                              _context12.prev = 56;
                                              _context12.prev = 57;

                                              if (!_iteratorNormalCompletion21 && _iterator21.return) {
                                                _iterator21.return();
                                              }

                                            case 59:
                                              _context12.prev = 59;

                                              if (!_didIteratorError21) {
                                                _context12.next = 62;
                                                break;
                                              }

                                              throw _iteratorError21;

                                            case 62:
                                              return _context12.finish(59);

                                            case 63:
                                              return _context12.finish(56);

                                            case 64:
                                              _context12.next = 68;
                                              break;

                                            case 66:
                                              _el11 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                                return el.id_pergunta == ccc.id_pergunta;
                                              }));


                                              if (typeof _el11 != "undefined") ccc.valor = _el11.valor;

                                            case 68:
                                            case "end":
                                              return _context12.stop();
                                          }
                                        }
                                      }, _loop19, _this14, [[18, 28, 32, 40], [33,, 35, 39], [48, 52, 56, 64], [57,, 59, 63]]);
                                    });
                                    _iteratorNormalCompletion19 = true;
                                    _didIteratorError19 = false;
                                    _iteratorError19 = undefined;
                                    _context17.prev = 127;
                                    _iterator19 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_valor15);

                                  case 129:
                                    if (_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done) {
                                      _context17.next = 135;
                                      break;
                                    }

                                    _vv6 = _step19.value;
                                    return _context17.delegateYield(_loop19(_vv6), "t5", 132);

                                  case 132:
                                    _iteratorNormalCompletion19 = true;
                                    _context17.next = 129;
                                    break;

                                  case 135:
                                    _context17.next = 141;
                                    break;

                                  case 137:
                                    _context17.prev = 137;
                                    _context17.t6 = _context17["catch"](127);
                                    _didIteratorError19 = true;
                                    _iteratorError19 = _context17.t6;

                                  case 141:
                                    _context17.prev = 141;
                                    _context17.prev = 142;

                                    if (!_iteratorNormalCompletion19 && _iterator19.return) {
                                      _iterator19.return();
                                    }

                                  case 144:
                                    _context17.prev = 144;

                                    if (!_didIteratorError19) {
                                      _context17.next = 147;
                                      break;
                                    }

                                    throw _iteratorError19;

                                  case 147:
                                    return _context17.finish(144);

                                  case 148:
                                    return _context17.finish(141);

                                  case 149:
                                    _context17.next = 153;
                                    break;

                                  case 151:
                                    _el12 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                      return el.id_pergunta == cc.id_pergunta;
                                    }));


                                    if (typeof _el12 != "undefined") cc.valor = _el12.valor;

                                  case 153:
                                    _context17.next = 181;
                                    break;

                                  case 155:
                                    if (!(cc.children && cc.children.length > 0)) {
                                      _context17.next = 179;
                                      break;
                                    }

                                    cc.children = [].concat(cc.children.map(function (el) {
                                      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, el);
                                    }));

                                    _loop22 = function _loop22(_xy6) {
                                      var e = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                        return el.id_pergunta == _xy6.id_pergunta;
                                      }));

                                      if (typeof e != "undefined") _xy6.valor = e.valor;
                                    };

                                    _iteratorNormalCompletion22 = true;
                                    _didIteratorError22 = false;
                                    _iteratorError22 = undefined;
                                    _context17.prev = 161;
                                    for (_iterator22 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(cc.children); !(_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done); _iteratorNormalCompletion22 = true) {
                                      _xy6 = _step22.value;

                                      _loop22(_xy6);
                                    }
                                    _context17.next = 169;
                                    break;

                                  case 165:
                                    _context17.prev = 165;
                                    _context17.t7 = _context17["catch"](161);
                                    _didIteratorError22 = true;
                                    _iteratorError22 = _context17.t7;

                                  case 169:
                                    _context17.prev = 169;
                                    _context17.prev = 170;

                                    if (!_iteratorNormalCompletion22 && _iterator22.return) {
                                      _iterator22.return();
                                    }

                                  case 172:
                                    _context17.prev = 172;

                                    if (!_didIteratorError22) {
                                      _context17.next = 175;
                                      break;
                                    }

                                    throw _iteratorError22;

                                  case 175:
                                    return _context17.finish(172);

                                  case 176:
                                    return _context17.finish(169);

                                  case 177:
                                    _context17.next = 181;
                                    break;

                                  case 179:
                                    _el13 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                      return el.id_pergunta == cc.id_pergunta;
                                    }));


                                    if (typeof _el13 != "undefined") cc.valor = _el13.valor;

                                  case 181:
                                    _context17.next = 218;
                                    break;

                                  case 183:
                                    if (!(p.pergunta.id_tipo == 2)) {
                                      _context17.next = 216;
                                      break;
                                    }

                                    _el14 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                      return el.id_pergunta == p.pergunta.id_pergunta;
                                    }));

                                    if (!(typeof _el14 != "undefined" && _el14.valor)) {
                                      _context17.next = 214;
                                      break;
                                    }

                                    _valor21 = _el14.valor.split(";").map(function (el) {
                                      return Number(el);
                                    });

                                    p.pergunta.valor = _valor21;

                                    _loop23 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _loop23(v) {
                                      var cc, _e17, _valor22, _e18, _valor23, _ccc2, _e19, _valor24, _e20, _valor25, _loop24, _iteratorNormalCompletion24, _didIteratorError24, _iteratorError24, _iterator24, _step24, _vv8, _loop25, _iteratorNormalCompletion25, _didIteratorError25, _iteratorError25, _iterator25, _step25, _xy7, _el15, _loop26, _iteratorNormalCompletion26, _didIteratorError26, _iteratorError26, _iterator26, _step26, _vv9, _el17, _loop29, _iteratorNormalCompletion29, _didIteratorError29, _iteratorError29, _iterator29, _step29, _xy9, _el18;

                                      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _loop23$(_context16) {
                                        while (1) {
                                          switch (_context16.prev = _context16.next) {
                                            case 0:
                                              cc = p.pergunta.children.find(function (el) {
                                                return el.id_pergunta == Number(v);
                                              });
                                              _context16.next = 3;
                                              return _this14.changeCheck(p.pergunta, cc, 2, true);

                                            case 3:
                                              if (!(cc.expansivel && (cc.id_tipo == 1 || cc.id_tipo == 2 || cc.id_tipo == 4))) {
                                                _context16.next = 115;
                                                break;
                                              }

                                              _e17 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                                return el.id_pergunta == cc.id_pergunta;
                                              }));

                                              if (!(typeof _e17 != "undefined" && _e17.valor)) {
                                                _context16.next = 113;
                                                break;
                                              }

                                              _valor22 = _e17.valor.split(";").map(function (e) {
                                                return Number(e);
                                              });

                                              cc.valor = _valor22;

                                              if (!(cc.id_tipo == 1)) {
                                                _context16.next = 82;
                                                break;
                                              }

                                              _e18 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                                return el.id_pergunta == cc.id_pergunta;
                                              }));

                                              if (!(typeof _e18 != "undefined" && _e18.valor)) {
                                                _context16.next = 80;
                                                break;
                                              }

                                              _valor23 = _e18.valor;
                                              _ccc2 = cc.children.find(function (el) {
                                                return el.id_pergunta == Number(_valor23);
                                              });

                                              _this14.changeCheck(cc, _ccc2, 1, true);
                                              cc.valor = _valor23;

                                              if (!(_ccc2.expansivel && (_ccc2.id_tipo == 1 || _ccc2.id_tipo == 2))) {
                                                _context16.next = 54;
                                                break;
                                              }

                                              _e19 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                                return el.id_pergunta == _ccc2.id_pergunta;
                                              }));

                                              if (!(typeof _e19 != "undefined" && _e19.valor)) {
                                                _context16.next = 52;
                                                break;
                                              }

                                              _valor24 = _e19.valor.split(";").map(function (e) {
                                                return Number(e);
                                              });

                                              _ccc2.valor = _valor24;

                                              if (!(_ccc2.id_tipo == 1)) {
                                                _context16.next = 25;
                                                break;
                                              }

                                              _e20 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                                return el.id_pergunta == _ccc2.id_pergunta;
                                              }));

                                              if (typeof _e20 != "undefined" && _e20.valor) {
                                                _valor25 = _e20.valor;

                                                _this14.changeCheck(cc, _ccc2.children.find(function (el) {
                                                  return el.id_pergunta == Number(_valor25);
                                                }), 1, true);
                                                _ccc2.valor = _valor25;
                                              }
                                              _context16.next = 52;
                                              break;

                                            case 25:
                                              if (!(_ccc2.id_tipo == 2)) {
                                                _context16.next = 52;
                                                break;
                                              }

                                              _loop24 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _loop24(_vv8) {
                                                var ccc;
                                                return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _loop24$(_context13) {
                                                  while (1) {
                                                    switch (_context13.prev = _context13.next) {
                                                      case 0:
                                                        ccc = ccc.children.find(function (el) {
                                                          return el.id_pergunta == Number(_vv8);
                                                        });
                                                        _context13.next = 3;
                                                        return _this14.changeCheck(cc, ccc, 2, true);

                                                      case 3:
                                                      case "end":
                                                        return _context13.stop();
                                                    }
                                                  }
                                                }, _loop24, _this14);
                                              });
                                              _iteratorNormalCompletion24 = true;
                                              _didIteratorError24 = false;
                                              _iteratorError24 = undefined;
                                              _context16.prev = 30;
                                              _iterator24 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_valor24);

                                            case 32:
                                              if (_iteratorNormalCompletion24 = (_step24 = _iterator24.next()).done) {
                                                _context16.next = 38;
                                                break;
                                              }

                                              _vv8 = _step24.value;
                                              return _context16.delegateYield(_loop24(_vv8), "t0", 35);

                                            case 35:
                                              _iteratorNormalCompletion24 = true;
                                              _context16.next = 32;
                                              break;

                                            case 38:
                                              _context16.next = 44;
                                              break;

                                            case 40:
                                              _context16.prev = 40;
                                              _context16.t1 = _context16["catch"](30);
                                              _didIteratorError24 = true;
                                              _iteratorError24 = _context16.t1;

                                            case 44:
                                              _context16.prev = 44;
                                              _context16.prev = 45;

                                              if (!_iteratorNormalCompletion24 && _iterator24.return) {
                                                _iterator24.return();
                                              }

                                            case 47:
                                              _context16.prev = 47;

                                              if (!_didIteratorError24) {
                                                _context16.next = 50;
                                                break;
                                              }

                                              throw _iteratorError24;

                                            case 50:
                                              return _context16.finish(47);

                                            case 51:
                                              return _context16.finish(44);

                                            case 52:
                                              _context16.next = 80;
                                              break;

                                            case 54:
                                              if (!(_ccc2.children && _ccc2.children.length > 0)) {
                                                _context16.next = 78;
                                                break;
                                              }

                                              _ccc2.children = [].concat(_ccc2.children.map(function (el) {
                                                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, el);
                                              }));

                                              _loop25 = function _loop25(_xy7) {
                                                var e = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                                  return el.id_pergunta == _xy7.id_pergunta;
                                                }));

                                                if (typeof e != "undefined") _xy7.valor = e.valor;
                                              };

                                              _iteratorNormalCompletion25 = true;
                                              _didIteratorError25 = false;
                                              _iteratorError25 = undefined;
                                              _context16.prev = 60;
                                              for (_iterator25 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_ccc2.children); !(_iteratorNormalCompletion25 = (_step25 = _iterator25.next()).done); _iteratorNormalCompletion25 = true) {
                                                _xy7 = _step25.value;

                                                _loop25(_xy7);
                                              }
                                              _context16.next = 68;
                                              break;

                                            case 64:
                                              _context16.prev = 64;
                                              _context16.t2 = _context16["catch"](60);
                                              _didIteratorError25 = true;
                                              _iteratorError25 = _context16.t2;

                                            case 68:
                                              _context16.prev = 68;
                                              _context16.prev = 69;

                                              if (!_iteratorNormalCompletion25 && _iterator25.return) {
                                                _iterator25.return();
                                              }

                                            case 71:
                                              _context16.prev = 71;

                                              if (!_didIteratorError25) {
                                                _context16.next = 74;
                                                break;
                                              }

                                              throw _iteratorError25;

                                            case 74:
                                              return _context16.finish(71);

                                            case 75:
                                              return _context16.finish(68);

                                            case 76:
                                              _context16.next = 80;
                                              break;

                                            case 78:
                                              _el15 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                                return el.id_pergunta == _ccc2.id_pergunta;
                                              }));


                                              if (typeof _el15 != "undefined") _ccc2.valor = _el15.valor;

                                            case 80:
                                              _context16.next = 113;
                                              break;

                                            case 82:
                                              if (!(cc.id_tipo == 2)) {
                                                _context16.next = 111;
                                                break;
                                              }

                                              _loop26 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _loop26(_vv9) {
                                                var ccc, _e21, _valor26, _e22, _valor27, _loop27, _iteratorNormalCompletion27, _didIteratorError27, _iteratorError27, _iterator27, _step27, _vv10, _loop28, _iteratorNormalCompletion28, _didIteratorError28, _iteratorError28, _iterator28, _step28, _xy8, _el16;

                                                return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _loop26$(_context15) {
                                                  while (1) {
                                                    switch (_context15.prev = _context15.next) {
                                                      case 0:
                                                        ccc = cc.children.find(function (el) {
                                                          return el.id_pergunta == Number(_vv9);
                                                        });
                                                        _context15.next = 3;
                                                        return _this14.changeCheck(cc, ccc, 2, true);

                                                      case 3:
                                                        if (!(ccc.expansivel && (ccc.id_tipo == 1 || ccc.id_tipo == 2))) {
                                                          _context15.next = 42;
                                                          break;
                                                        }

                                                        _e21 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                                          return el.id_pergunta == ccc.id_pergunta;
                                                        }));

                                                        if (!(typeof _e21 != "undefined" && _e21.valor)) {
                                                          _context15.next = 40;
                                                          break;
                                                        }

                                                        _valor26 = _e21.valor.split(";").map(function (e) {
                                                          return Number(e);
                                                        });

                                                        ccc.valor = _valor26;

                                                        if (!(ccc.id_tipo == 1)) {
                                                          _context15.next = 13;
                                                          break;
                                                        }

                                                        _e22 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                                          return el.id_pergunta == ccc.id_pergunta;
                                                        }));

                                                        if (typeof _e22 != "undefined" && _e22.valor) {
                                                          _valor27 = _e22.valor;

                                                          _this14.changeCheck(cc, ccc.children.find(function (el) {
                                                            return el.id_pergunta == Number(_valor27);
                                                          }), 1, true);
                                                          ccc.valor = _valor27;
                                                        }
                                                        _context15.next = 40;
                                                        break;

                                                      case 13:
                                                        if (!(ccc.id_tipo == 2)) {
                                                          _context15.next = 40;
                                                          break;
                                                        }

                                                        _loop27 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _loop27(_vv10) {
                                                          var ccc;
                                                          return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _loop27$(_context14) {
                                                            while (1) {
                                                              switch (_context14.prev = _context14.next) {
                                                                case 0:
                                                                  ccc = ccc.children.find(function (el) {
                                                                    return el.id_pergunta == Number(_vv10);
                                                                  });
                                                                  _context14.next = 3;
                                                                  return _this14.changeCheck(cc, ccc, 2, true);

                                                                case 3:
                                                                case "end":
                                                                  return _context14.stop();
                                                              }
                                                            }
                                                          }, _loop27, _this14);
                                                        });
                                                        _iteratorNormalCompletion27 = true;
                                                        _didIteratorError27 = false;
                                                        _iteratorError27 = undefined;
                                                        _context15.prev = 18;
                                                        _iterator27 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_valor26);

                                                      case 20:
                                                        if (_iteratorNormalCompletion27 = (_step27 = _iterator27.next()).done) {
                                                          _context15.next = 26;
                                                          break;
                                                        }

                                                        _vv10 = _step27.value;
                                                        return _context15.delegateYield(_loop27(_vv10), "t0", 23);

                                                      case 23:
                                                        _iteratorNormalCompletion27 = true;
                                                        _context15.next = 20;
                                                        break;

                                                      case 26:
                                                        _context15.next = 32;
                                                        break;

                                                      case 28:
                                                        _context15.prev = 28;
                                                        _context15.t1 = _context15["catch"](18);
                                                        _didIteratorError27 = true;
                                                        _iteratorError27 = _context15.t1;

                                                      case 32:
                                                        _context15.prev = 32;
                                                        _context15.prev = 33;

                                                        if (!_iteratorNormalCompletion27 && _iterator27.return) {
                                                          _iterator27.return();
                                                        }

                                                      case 35:
                                                        _context15.prev = 35;

                                                        if (!_didIteratorError27) {
                                                          _context15.next = 38;
                                                          break;
                                                        }

                                                        throw _iteratorError27;

                                                      case 38:
                                                        return _context15.finish(35);

                                                      case 39:
                                                        return _context15.finish(32);

                                                      case 40:
                                                        _context15.next = 68;
                                                        break;

                                                      case 42:
                                                        if (!(ccc.children && ccc.children.length > 0)) {
                                                          _context15.next = 66;
                                                          break;
                                                        }

                                                        ccc.children = [].concat(ccc.children.map(function (el) {
                                                          return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, el);
                                                        }));

                                                        _loop28 = function _loop28(_xy8) {
                                                          var e = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                                            return el.id_pergunta == _xy8.id_pergunta;
                                                          }));

                                                          if (typeof e != "undefined") _xy8.valor = e.valor;
                                                        };

                                                        _iteratorNormalCompletion28 = true;
                                                        _didIteratorError28 = false;
                                                        _iteratorError28 = undefined;
                                                        _context15.prev = 48;
                                                        for (_iterator28 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(ccc.children); !(_iteratorNormalCompletion28 = (_step28 = _iterator28.next()).done); _iteratorNormalCompletion28 = true) {
                                                          _xy8 = _step28.value;

                                                          _loop28(_xy8);
                                                        }
                                                        _context15.next = 56;
                                                        break;

                                                      case 52:
                                                        _context15.prev = 52;
                                                        _context15.t2 = _context15["catch"](48);
                                                        _didIteratorError28 = true;
                                                        _iteratorError28 = _context15.t2;

                                                      case 56:
                                                        _context15.prev = 56;
                                                        _context15.prev = 57;

                                                        if (!_iteratorNormalCompletion28 && _iterator28.return) {
                                                          _iterator28.return();
                                                        }

                                                      case 59:
                                                        _context15.prev = 59;

                                                        if (!_didIteratorError28) {
                                                          _context15.next = 62;
                                                          break;
                                                        }

                                                        throw _iteratorError28;

                                                      case 62:
                                                        return _context15.finish(59);

                                                      case 63:
                                                        return _context15.finish(56);

                                                      case 64:
                                                        _context15.next = 68;
                                                        break;

                                                      case 66:
                                                        _el16 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                                          return el.id_pergunta == ccc.id_pergunta;
                                                        }));


                                                        if (typeof _el16 != "undefined") ccc.valor = _el16.valor;

                                                      case 68:
                                                      case "end":
                                                        return _context15.stop();
                                                    }
                                                  }
                                                }, _loop26, _this14, [[18, 28, 32, 40], [33,, 35, 39], [48, 52, 56, 64], [57,, 59, 63]]);
                                              });
                                              _iteratorNormalCompletion26 = true;
                                              _didIteratorError26 = false;
                                              _iteratorError26 = undefined;
                                              _context16.prev = 87;
                                              _iterator26 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_valor22);

                                            case 89:
                                              if (_iteratorNormalCompletion26 = (_step26 = _iterator26.next()).done) {
                                                _context16.next = 95;
                                                break;
                                              }

                                              _vv9 = _step26.value;
                                              return _context16.delegateYield(_loop26(_vv9), "t3", 92);

                                            case 92:
                                              _iteratorNormalCompletion26 = true;
                                              _context16.next = 89;
                                              break;

                                            case 95:
                                              _context16.next = 101;
                                              break;

                                            case 97:
                                              _context16.prev = 97;
                                              _context16.t4 = _context16["catch"](87);
                                              _didIteratorError26 = true;
                                              _iteratorError26 = _context16.t4;

                                            case 101:
                                              _context16.prev = 101;
                                              _context16.prev = 102;

                                              if (!_iteratorNormalCompletion26 && _iterator26.return) {
                                                _iterator26.return();
                                              }

                                            case 104:
                                              _context16.prev = 104;

                                              if (!_didIteratorError26) {
                                                _context16.next = 107;
                                                break;
                                              }

                                              throw _iteratorError26;

                                            case 107:
                                              return _context16.finish(104);

                                            case 108:
                                              return _context16.finish(101);

                                            case 109:
                                              _context16.next = 113;
                                              break;

                                            case 111:
                                              _el17 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                                return el.id_pergunta == cc.id_pergunta;
                                              }));


                                              if (typeof _el17 != "undefined") cc.valor = _el17.valor;

                                            case 113:
                                              _context16.next = 141;
                                              break;

                                            case 115:
                                              if (!(cc.children && cc.children.length > 0)) {
                                                _context16.next = 139;
                                                break;
                                              }

                                              cc.children = [].concat(cc.children.map(function (el) {
                                                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, el);
                                              }));

                                              _loop29 = function _loop29(_xy9) {
                                                var e = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                                  return el.id_pergunta == _xy9.id_pergunta;
                                                }));

                                                if (typeof e != "undefined") _xy9.valor = e.valor;
                                              };

                                              _iteratorNormalCompletion29 = true;
                                              _didIteratorError29 = false;
                                              _iteratorError29 = undefined;
                                              _context16.prev = 121;
                                              for (_iterator29 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(cc.children); !(_iteratorNormalCompletion29 = (_step29 = _iterator29.next()).done); _iteratorNormalCompletion29 = true) {
                                                _xy9 = _step29.value;

                                                _loop29(_xy9);
                                              }
                                              _context16.next = 129;
                                              break;

                                            case 125:
                                              _context16.prev = 125;
                                              _context16.t5 = _context16["catch"](121);
                                              _didIteratorError29 = true;
                                              _iteratorError29 = _context16.t5;

                                            case 129:
                                              _context16.prev = 129;
                                              _context16.prev = 130;

                                              if (!_iteratorNormalCompletion29 && _iterator29.return) {
                                                _iterator29.return();
                                              }

                                            case 132:
                                              _context16.prev = 132;

                                              if (!_didIteratorError29) {
                                                _context16.next = 135;
                                                break;
                                              }

                                              throw _iteratorError29;

                                            case 135:
                                              return _context16.finish(132);

                                            case 136:
                                              return _context16.finish(129);

                                            case 137:
                                              _context16.next = 141;
                                              break;

                                            case 139:
                                              _el18 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                                return el.id_pergunta == cc.id_pergunta;
                                              }));


                                              if (typeof _el18 != "undefined") cc.valor = _el18.valor;

                                            case 141:
                                            case "end":
                                              return _context16.stop();
                                          }
                                        }
                                      }, _loop23, _this14, [[30, 40, 44, 52], [45,, 47, 51], [60, 64, 68, 76], [69,, 71, 75], [87, 97, 101, 109], [102,, 104, 108], [121, 125, 129, 137], [130,, 132, 136]]);
                                    });
                                    _iteratorNormalCompletion23 = true;
                                    _didIteratorError23 = false;
                                    _iteratorError23 = undefined;
                                    _context17.prev = 192;
                                    _iterator23 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_valor21);

                                  case 194:
                                    if (_iteratorNormalCompletion23 = (_step23 = _iterator23.next()).done) {
                                      _context17.next = 200;
                                      break;
                                    }

                                    v = _step23.value;
                                    return _context17.delegateYield(_loop23(v), "t8", 197);

                                  case 197:
                                    _iteratorNormalCompletion23 = true;
                                    _context17.next = 194;
                                    break;

                                  case 200:
                                    _context17.next = 206;
                                    break;

                                  case 202:
                                    _context17.prev = 202;
                                    _context17.t9 = _context17["catch"](192);
                                    _didIteratorError23 = true;
                                    _iteratorError23 = _context17.t9;

                                  case 206:
                                    _context17.prev = 206;
                                    _context17.prev = 207;

                                    if (!_iteratorNormalCompletion23 && _iterator23.return) {
                                      _iterator23.return();
                                    }

                                  case 209:
                                    _context17.prev = 209;

                                    if (!_didIteratorError23) {
                                      _context17.next = 212;
                                      break;
                                    }

                                    throw _iteratorError23;

                                  case 212:
                                    return _context17.finish(209);

                                  case 213:
                                    return _context17.finish(206);

                                  case 214:
                                    _context17.next = 218;
                                    break;

                                  case 216:
                                    _el19 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this14.editedItem.children.find(function (el) {
                                      return el.id_pergunta == p.pergunta.id_pergunta;
                                    }));


                                    if (typeof _el19 != "undefined") p.pergunta.valor = _el19.valor;

                                  case 218:
                                  case "end":
                                    return _context17.stop();
                                }
                              }
                            }, _loop, _this14, [[12, 22, 26, 34], [27,, 29, 33], [70, 80, 84, 92], [85,, 87, 91], [100, 104, 108, 116], [109,, 111, 115], [127, 137, 141, 149], [142,, 144, 148], [161, 165, 169, 177], [170,, 172, 176], [192, 202, 206, 214], [207,, 209, 213]]);
                          });
                          _iteratorNormalCompletion = true;
                          _didIteratorError = false;
                          _iteratorError = undefined;
                          _context18.prev = 12;
                          _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(array);

                        case 14:
                          if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                            _context18.next = 20;
                            break;
                          }

                          p = _step.value;
                          return _context18.delegateYield(_loop(p), "t0", 17);

                        case 17:
                          _iteratorNormalCompletion = true;
                          _context18.next = 14;
                          break;

                        case 20:
                          _context18.next = 26;
                          break;

                        case 22:
                          _context18.prev = 22;
                          _context18.t1 = _context18["catch"](12);
                          _didIteratorError = true;
                          _iteratorError = _context18.t1;

                        case 26:
                          _context18.prev = 26;
                          _context18.prev = 27;

                          if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                          }

                        case 29:
                          _context18.prev = 29;

                          if (!_didIteratorError) {
                            _context18.next = 32;
                            break;
                          }

                          throw _iteratorError;

                        case 32:
                          return _context18.finish(29);

                        case 33:
                          return _context18.finish(26);

                        case 34:
                          if (!pdf) {
                            _context18.next = 59;
                            break;
                          }

                          aux = [];
                          i = 0;

                          _loop2 = function _loop2(f) {
                            i++;

                            if (aux.findIndex(function (el) {
                              return el.key == f.pergunta.id_dimensao;
                            }) == -1) aux.push({
                              key: f.pergunta.id_dimensao,
                              name: _this14.getDimensaoById(f.pergunta.id_dimensao).nome,
                              children: [f]
                            });else __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, aux.find(function (el) {
                              return el.key == f.pergunta.id_dimensao;
                            })).children.push(f);

                            if (i == array.length) {
                              _this14.exportarPdf(aux);
                            }
                          };

                          _iteratorNormalCompletion2 = true;
                          _didIteratorError2 = false;
                          _iteratorError2 = undefined;
                          _context18.prev = 41;

                          for (_iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(array.sort(function (a, b) {
                            return a.pergunta.ordem - b.pergunta.ordem;
                          })); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            f = _step2.value;

                            _loop2(f);
                          }
                          _context18.next = 49;
                          break;

                        case 45:
                          _context18.prev = 45;
                          _context18.t2 = _context18["catch"](41);
                          _didIteratorError2 = true;
                          _iteratorError2 = _context18.t2;

                        case 49:
                          _context18.prev = 49;
                          _context18.prev = 50;

                          if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                          }

                        case 52:
                          _context18.prev = 52;

                          if (!_didIteratorError2) {
                            _context18.next = 55;
                            break;
                          }

                          throw _iteratorError2;

                        case 55:
                          return _context18.finish(52);

                        case 56:
                          return _context18.finish(49);

                        case 57:
                          _context18.next = 83;
                          break;

                        case 59:
                          _aux = [];

                          _loop3 = function _loop3(_f) {
                            if (_aux.findIndex(function (el) {
                              return el.key == _f.pergunta.id_dimensao;
                            }) == -1) _aux.push({
                              key: _f.pergunta.id_dimensao,
                              name: _this14.getDimensaoById(_f.pergunta.id_dimensao).nome,
                              children: [_f]
                            });else __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _aux.find(function (el) {
                              return el.key == _f.pergunta.id_dimensao;
                            })).children.push(_f);
                          };

                          _iteratorNormalCompletion3 = true;
                          _didIteratorError3 = false;
                          _iteratorError3 = undefined;
                          _context18.prev = 64;


                          for (_iterator3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(array.sort(function (a, b) {
                            return a.pergunta.ordem - b.pergunta.ordem;
                          })); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                            _f = _step3.value;

                            _loop3(_f);
                          }

                          _context18.next = 72;
                          break;

                        case 68:
                          _context18.prev = 68;
                          _context18.t3 = _context18["catch"](64);
                          _didIteratorError3 = true;
                          _iteratorError3 = _context18.t3;

                        case 72:
                          _context18.prev = 72;
                          _context18.prev = 73;

                          if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                          }

                        case 75:
                          _context18.prev = 75;

                          if (!_didIteratorError3) {
                            _context18.next = 78;
                            break;
                          }

                          throw _iteratorError3;

                        case 78:
                          return _context18.finish(75);

                        case 79:
                          return _context18.finish(72);

                        case 80:
                          _this14.formulario = _aux;
                          _this14.generating = false;
                          _this14.reporteM = true;

                        case 83:

                          _this14.waiting = false;

                        case 84:
                        case "end":
                          return _context18.stop();
                      }
                    }
                  }, _callee2, _this14, [[12, 22, 26, 34], [27,, 29, 33], [41, 45, 49, 57], [50,, 52, 56], [64, 68, 72, 80], [73,, 75, 79]]);
                })));

              case 4:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee3, _this14);
      }))();
    },
    exportarPdf: function exportarPdf(array) {
      var _planificacao,
          _this15 = this;

      this.generating = false;
      var nome = Date.now();

      this.$store.dispatch("propostas/export", {
        nome: nome,
        planificacao: (_planificacao = {
          instituicao: this.getInstituicaoById(this.editedItem.id_instituicao).nome,
          ano: this.getAnoById(this.editedItem.id_ano).nome,
          acao: this.getAcaoById(this.editedItem.id_acao).nome,
          medida: this.getMedidaById(this.editedItem.id_medida).nome,
          objetivo: this.getObjetivoById(this.editedItem.id_objetivo).nome,
          quem: this.editedItem.quem,
          descricao: this.editedItem.descricao,
          design_acao: this.editedItem.design_acao,
          design_proj: this.editedItem.design_proj
        }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_planificacao, "descricao", this.editedItem.descricao), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_planificacao, "submetida", this.editedItem.submetida ? "Sim" : "Não"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_planificacao, "reporte", this.editedItem.reporte ? "Sim" : "Não"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_planificacao, "data_submetida", this.editedItem.data_submetida ? this.editedItem.data_submetida : "-"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_planificacao, "data_reporte", this.editedItem.data_reporte ? this.editedItem.data_reporte : "-"), _planificacao),
        reporte: array
      }).then(function (res) {
        if (res) {
          window.open("https://teste.areareservada.ened-portugal.pt" + "/enedapi/client/files/" + nome + ".pdf");

          _this15.generating = false;
          _this15.toast("success", "Listagem criada com sucesso");
        } else {
          _this15.generating = false;
          _this15.toast("error", "Ocorreu um erro na pesquisa.");
        }
      }).catch(function (err) {
        _this15.generating = false;
        _this15.toast("error", "Ocorreu um erro na pesquisa.");
      });
    },
    forceUpdate: function forceUpdate() {
      this.$forceUpdate();
    },
    changeCheck: function changeCheck(pergunta, child, type) {
      var ini = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      if (typeof pergunta == "undefined") return;

      if (type == 1) {
        if (ini) child.checked = true;else {
          if (child.checked) {
            var _iteratorNormalCompletion30 = true;
            var _didIteratorError30 = false;
            var _iteratorError30 = undefined;

            try {
              for (var _iterator30 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(pergunta.children), _step30; !(_iteratorNormalCompletion30 = (_step30 = _iterator30.next()).done); _iteratorNormalCompletion30 = true) {
                var p = _step30.value;

                if (p.id_pergunta != child.id_pergunta) p.checked = false;
              }
            } catch (err) {
              _didIteratorError30 = true;
              _iteratorError30 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion30 && _iterator30.return) {
                  _iterator30.return();
                }
              } finally {
                if (_didIteratorError30) {
                  throw _iteratorError30;
                }
              }
            }

            pergunta.valor = child.id_pergunta;
          } else {
            child.checked = false;
            pergunta.valor = null;

            if (child.children && child.children.length) {
              var _iteratorNormalCompletion31 = true;
              var _didIteratorError31 = false;
              var _iteratorError31 = undefined;

              try {
                for (var _iterator31 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(child.children), _step31; !(_iteratorNormalCompletion31 = (_step31 = _iterator31.next()).done); _iteratorNormalCompletion31 = true) {
                  var p = _step31.value;

                  p.checked = false;
                }
              } catch (err) {
                _didIteratorError31 = true;
                _iteratorError31 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion31 && _iterator31.return) {
                    _iterator31.return();
                  }
                } finally {
                  if (_didIteratorError31) {
                    throw _iteratorError31;
                  }
                }
              }
            }
          }
        }
      } else if (type == 2) {
        pergunta.valor = typeof pergunta.valor == "undefined" ? [] : pergunta.valor;

        if (ini) child.checked = true;else {
          if (pergunta.valor.findIndex(function (el) {
            return el == child.id_pergunta;
          }) > -1) pergunta.valor.splice(pergunta.valor.findIndex(function (el) {
            return el == child.id_pergunta;
          }), 1);else pergunta.valor.push(child.id_pergunta);

          if (!child.checked) {
            if (child.children && child.children.length) {
              var _iteratorNormalCompletion32 = true;
              var _didIteratorError32 = false;
              var _iteratorError32 = undefined;

              try {
                for (var _iterator32 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(child.children), _step32; !(_iteratorNormalCompletion32 = (_step32 = _iterator32.next()).done); _iteratorNormalCompletion32 = true) {
                  var p = _step32.value;

                  p.checked = false;
                }
              } catch (err) {
                _didIteratorError32 = true;
                _iteratorError32 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion32 && _iterator32.return) {
                    _iterator32.return();
                  }
                } finally {
                  if (_didIteratorError32) {
                    throw _iteratorError32;
                  }
                }
              }
            }
          }
        }
      }

      this.forceUpdate();
    },
    checkedPerguntaCompleted: function checkedPerguntaCompleted(item) {
      var aux = [];

      if (typeof item != "undefined" && item.hasOwnProperty("children")) {
        var _iteratorNormalCompletion33 = true;
        var _didIteratorError33 = false;
        var _iteratorError33 = undefined;

        try {
          for (var _iterator33 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(item.children), _step33; !(_iteratorNormalCompletion33 = (_step33 = _iterator33.next()).done); _iteratorNormalCompletion33 = true) {
            var pergunta = _step33.value;

            if (pergunta.pergunta.id_tipo == 5) {
              var _iteratorNormalCompletion34 = true;
              var _didIteratorError34 = false;
              var _iteratorError34 = undefined;

              try {
                for (var _iterator34 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(pergunta.pergunta.children), _step34; !(_iteratorNormalCompletion34 = (_step34 = _iterator34.next()).done); _iteratorNormalCompletion34 = true) {
                  var c = _step34.value;

                  if (c.required) {
                    if (!c.hasOwnProperty("valor")) aux.push(false);else {
                      if (c.id_tipo == 2) aux.push(c.valor.length > 0);else if (!c.valor) aux.push(false);
                    }
                  }
                }
              } catch (err) {
                _didIteratorError34 = true;
                _iteratorError34 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion34 && _iterator34.return) {
                    _iterator34.return();
                  }
                } finally {
                  if (_didIteratorError34) {
                    throw _iteratorError34;
                  }
                }
              }
            } else {
              if (pergunta.pergunta.required) {
                if (!pergunta.pergunta.hasOwnProperty("valor")) aux.push(false);else {
                  if (pergunta.pergunta.id_tipo == 2) aux.push(pergunta.pergunta.valor.length > 0);else if (!pergunta.pergunta.valor) aux.push(false);
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError33 = true;
          _iteratorError33 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion33 && _iterator33.return) {
              _iterator33.return();
            }
          } finally {
            if (_didIteratorError33) {
              throw _iteratorError33;
            }
          }
        }

        return aux.findIndex(function (el) {
          return el == false;
        }) == -1 ? true : false;
      } else return false;
    },
    getLegenda: function getLegenda(tipo) {
      switch (tipo) {
        case 1:
          return "Apenas uma opção";
          break;
        case 2:
          return "Várias opções";
          break;

        case 3:
          return "Campo de texto aberto";
          break;

        case 4:
          return "Campo numérico";
          break;

        case 5:
          return "Pergunta com vários níveis";
          break;

        case 6:
          return "Seleção de distrito";
          break;

        case 7:
          return "Seleção de setor";
          break;

        case 8:
          return "Campo de texto longo";
          break;

        default:
          break;
      }
    }
  }
});

/***/ }),

/***/ 470:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(9);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var cName = {
  upper: "Proposta",
  lower: "a proposta!"
};

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      table: "propostas",
      name: "proposta",
      INSTITUICAO: 0,
      DEFAULT_DATA: [],
      DATA: [],
      editedIndex: -1,
      valor: 0,
      max: 0,
      deleteM: false,
      array: [],
      TIPO_TABELA: 0,
      messages: {
        add: {
          success: cName.upper + " criada com sucesso!",
          error: "Ocorreu um erro ao criar " + cName.lower
        },
        update: {
          success: cName.upper + " alterada com sucesso!",
          error: "Ocorreu um erro ao alterar " + cName.lower
        },
        delete: {
          success: cName.upper + " eliminada com sucesso!",
          error: "Ocorreu um erro ao apagar " + cName.lower
        },
        default: {
          sucesso: "Sucesso",
          error: "Ocorreu um erro!"
        }
      },
      defaultRules: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])({
    getSession: "session/getState",
    getAll: "propostas/getAll",
    getObjetivos: "objetivos/getAll",
    getAcoes: "acoes/getAll",
    getMedidasByObjetivo: "medidas/getMedidasByObjetivo",
    getAcoesByMedida: "acoes/getAcoesByMedida",
    getAllInstituicoes: "instituicoes/getAllInstituicoes",
    getAnos: "anos/getAll",
    getAcaoAno: "propostas/getAcaoAno",
    getAcoesByInstituicao: "propostas/getAcoesByInstituicao"
  })),

  watch: {
    getAll: function getAll(val) {
      this.initialize();
    }
  },

  created: function created() {
    this.initialize();

    if (this.getSession.user.super == 0) this.INSTITUICAO = this.getSession.user.id_instituicao;
  },


  methods: {
    filtrar: function filtrar() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var array;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                array = [].concat(_this.DATA);

                if (!(_this.FILTRO.id_objetivo > 0)) {
                  _context.next = 5;
                  break;
                }

                _context.next = 4;
                return _this.filterObjetivo(array);

              case 4:
                array = _context.sent;

              case 5:
                if (!(_this.FILTRO.id_medida > 0)) {
                  _context.next = 9;
                  break;
                }

                _context.next = 8;
                return _this.filterMedida(array);

              case 8:
                array = _context.sent;

              case 9:
                if (!(_this.FILTRO.id_acao > 0)) {
                  _context.next = 13;
                  break;
                }

                _context.next = 12;
                return _this.filterAcao(array);

              case 12:
                array = _context.sent;

              case 13:
                if (!(_this.FILTRO.id_instituicao > 0)) {
                  _context.next = 17;
                  break;
                }

                _context.next = 16;
                return _this.filterInstituicao(array);

              case 16:
                array = _context.sent;

              case 17:
                if (!(_this.FILTRO.id_ano > 0)) {
                  _context.next = 21;
                  break;
                }

                _context.next = 20;
                return _this.filterAno(array);

              case 20:
                array = _context.sent;

              case 21:

                _this.DATA = array;

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    limpar: function limpar() {
      this.FILTRO = {
        id_objetivo: 0,
        id_medida: 0,
        id_acao: 0,
        id_ano: 0,
        id_instituicao: 0
      };
      this.initialize();
    },
    apagar: function apagar() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var aux;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this2.valor == 0)) {
                  _context2.next = 4;
                  break;
                }

                _this2.toast("error", "O valor deve ser superior a 0!");
                _context2.next = 12;
                break;

              case 4:
                if (!(_this2.valor <= _this2.max)) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 7;
                return _this2.prepareArray(_this2.array.slice(0, _this2.valor));

              case 7:
                aux = _context2.sent;


                _this2.$store.dispatch("propostas/remove", aux).then(function (res) {
                  if (res) {
                    _this2.toast("success", "Propostas removidas com sucesso!");

                    _this2.initialize();
                    _this2.close();
                  } else {
                    _this2.toast("error", "Ocorreu um erro ao remover as propostas.");
                    _this2.close();
                  }
                });
                _context2.next = 12;
                break;

              case 11:
                _this2.toast("error", "Pode remover no máximo" + _this2.max + " propostas!");

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    close: function close() {
      var _this3 = this;

      this.deleteM = false;

      setTimeout(function () {
        _this3.valor = 0;
        _this3.max = 0;
        _this3.array = [];
      }, 110);
    },
    prepareArray: function prepareArray(array) {
      var aux = [];

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(array), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var a = _step.value;

          aux.push({
            id_proposta: a.id_proposta
          });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return aux;
    },
    filterObjetivo: function filterObjetivo(array) {
      var _this4 = this;

      return array.filter(function (el) {
        return el.id_objetivo == _this4.FILTRO.id_objetivo;
      });
    },
    filterMedida: function filterMedida(array) {
      var _this5 = this;

      return array.filter(function (el) {
        return el.id_medida == _this5.FILTRO.id_medida;
      });
    },
    filterAcao: function filterAcao(array) {
      var _this6 = this;

      return array.filter(function (el) {
        return el.id_acao == _this6.FILTRO.id_acao;
      });
    },
    filterInstituicao: function filterInstituicao(array) {
      var _this7 = this;

      return array.filter(function (el) {
        return el.id_instituicao == _this7.FILTRO.id_instituicao;
      });
    },
    filterAno: function filterAno(array) {
      var _this8 = this;

      return array.filter(function (el) {
        return el.id_ano == _this8.FILTRO.id_ano;
      });
    },
    removeProposta: function removeProposta(instituicao, ano, acao) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this9.getAcoesByInstituicao(ano, acao, instituicao).filter(function (el) {
                  return el.auto_proposta == _this9.TIPO_TABELA;
                });

              case 2:
                _this9.array = _context3.sent;


                _this9.max = _this9.array.length;

                if (_this9.max > 0) _this9.deleteM = true;

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this9);
      }))();
    },
    toast: function toast(type, message) {
      if (type == "success") {
        return iziToast.show({
          title: "SUCESSO",
          color: "green",
          timeout: this.$toastTimeout,
          message: message,
          position: this.$toastPosition
        });
      } else {
        return iziToast.show({
          title: "AVISO",
          color: "red",
          timeout: this.$toastTimeout,
          message: message,
          position: this.$toastPosition
        });
      }
    },
    initialize: function initialize() {
      this.loading = true;
      this.DATA = this.getAll;
      this.DEFAULT_DATA = this.DATA;
      this.loading = false;
    }
  }
});

/***/ }),

/***/ 471:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_distritos_json__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_distritos_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__store_distritos_json__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      distritos: [],
      tipos_fins_lucrativos: ["Associação", "Cooperativa", "Fundação"],
      fins_lucrativos: ["Sem fins lucrativos", "Com fins lucrativos"],
      setores_publicos: ["Central", "Local", "Regional"],
      setores: [],
      classes: [{ id_classe: 1, nome: "Entidade signatária" }, { id_classe: 2, nome: "Associada de entidade signatária" }],
      associadas: [{ id_associada: 1, nome: "PPONGD" }, { id_associada: 2, nome: "ARIPESE" }, { id_associada: 3, nome: "ANIMAR" }],
      tipos: [{ id_tipo: 1, nome: "Público" }, { id_tipo: 2, nome: "Não Público" }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
    getSession: "session/getState",
    getInstituicaoById: "instituicoes/getById",
    getSectores: "setores/getAll"
  }), {
    instituicao: function instituicao() {
      return this.getInstituicaoById(this.getSession.user.id_instituicao);
    },
    listOfDistritos: function listOfDistritos() {
      return [{
        level: 1,
        code: 0,
        name: "Nacional"
      }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_4__store_distritos_json___default.a.filter(function (_ref) {
        var level = _ref.level;
        return level === 1;
      })));
    }
  }),

  methods: {
    submit: function submit() {
      var _this = this;

      var payload = {
        instituicao: this.getSession.user,
        setores: this.setores,
        publico: this.getSession.user.publico,
        fins_lucrativos: this.getSession.user.fins_lucrativos,
        tipo_fins_lucrativos: this.getSession.user.tipo_fins_lucrativos,
        setor_publico: this.getSession.user.setor_publico,
        trabalha_educacao: this.getSession.user.trabalha_educacao,
        trabalha_estrategicos: this.getSession.user.trabalha_estrategicos,
        distrito: this.getSession.user.distrito
      };
      this.$store.dispatch("instituicoes/updatePerfil", payload).then(function (res) {
        _this.toast("success", "dados alterados com sucesso!");
      });
    },
    toast: function toast(type, message) {
      if (type == "success") {
        return iziToast.show({
          title: "SUCESSO",
          color: "green",
          timeout: this.$toastTimeout,
          message: message,
          position: this.$toastPosition
        });
      } else {
        return iziToast.show({
          title: "AVISO",
          color: "red",
          timeout: this.$toastTimeout,
          message: message,
          position: this.$toastPosition
        });
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.distritos = __WEBPACK_IMPORTED_MODULE_4__store_distritos_json___default.a;

    var payload = {
      id_instituicao: this.getSession.user.id_instituicao
    };
    __WEBPACK_IMPORTED_MODULE_3__store_axios__["a" /* instance */].post("/user/setores/", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, payload)).then(function (res) {
      if (res.data.data == "Sem resultados") {
        _this2.setores = [];
      } else {
        _this2.setores = res.data.data;
      }
    });
  }
});

/***/ }),

/***/ 599:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_polyfill__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_session__ = __webpack_require__(1353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_session__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_idle_vue__ = __webpack_require__(1354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_idle_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_idle_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuetify_dist_vuetify_min_css__ = __webpack_require__(1356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__strings__ = __webpack_require__(1357);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.















__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vuetify___default.a);

var options = {
  persist: true
};
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_session___default.a, options);

var eventsHub = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]();
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_idle_vue___default.a, {
  eventEmitter: eventsHub,
  idleTime: 3600000
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$eventBus = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]();
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$toastPosition = 'bottomRight';
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$toastTimeout = '5000';

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$requiredField = '* Campo obrigatório';
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$invalidEmail = '* E-mail inválido';
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$invalidPassword = '* A password deve conter no minimo 8 carateres (maiúscula, minúscula, alfanumérico, simbolo) ';
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$invalidTelefone = '* Telefone inválido';
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$invalidTelemovel = '* Telemóvel inválido';
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$invalidCodPostal = '* Código postal inválido';

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$moment = __WEBPACK_IMPORTED_MODULE_9_moment___default.a;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$defaultPassword = 'abc123';

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */] },
  template: '<App/>',
  data: function data() {
    return {
      active: -1
    };
  },
  onIdle: function onIdle() {
    this.active = 0;
    this.$eventBus.$emit('logout');
  },
  onActive: function onActive() {
    this.active = 1;
  }
});

/***/ }),

/***/ 766:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_session__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_instituicoes__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_objetivos__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_medidas__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_acoes__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_dimensoes__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_perguntas__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_tipos__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_formularios__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_setores__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_distritos__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_propostas__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_anos__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_tipos_acao__ = __webpack_require__(1246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_fases__ = __webpack_require__(1247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modules_meses__ = __webpack_require__(1248);



















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    modules: {
        session: __WEBPACK_IMPORTED_MODULE_2__modules_session__["a" /* default */],
        instituicoes: __WEBPACK_IMPORTED_MODULE_3__modules_instituicoes__["a" /* default */],
        objetivos: __WEBPACK_IMPORTED_MODULE_4__modules_objetivos__["a" /* default */],
        medidas: __WEBPACK_IMPORTED_MODULE_5__modules_medidas__["a" /* default */],
        acoes: __WEBPACK_IMPORTED_MODULE_6__modules_acoes__["a" /* default */],
        dimensoes: __WEBPACK_IMPORTED_MODULE_7__modules_dimensoes__["a" /* default */],
        perguntas: __WEBPACK_IMPORTED_MODULE_8__modules_perguntas__["a" /* default */],
        tipos: __WEBPACK_IMPORTED_MODULE_9__modules_tipos__["a" /* default */],
        formularios: __WEBPACK_IMPORTED_MODULE_10__modules_formularios__["a" /* default */],
        setores: __WEBPACK_IMPORTED_MODULE_11__modules_setores__["a" /* default */],
        distritos: __WEBPACK_IMPORTED_MODULE_12__modules_distritos__["a" /* default */],
        propostas: __WEBPACK_IMPORTED_MODULE_13__modules_propostas__["a" /* default */],
        anos: __WEBPACK_IMPORTED_MODULE_14__modules_anos__["a" /* default */],
        tipos_acao: __WEBPACK_IMPORTED_MODULE_15__modules_tipos_acao__["a" /* default */],
        fases: __WEBPACK_IMPORTED_MODULE_16__modules_fases__["a" /* default */],
        meses: __WEBPACK_IMPORTED_MODULE_17__modules_meses__["a" /* default */]
    },
    strict: false
}));

/***/ }),

/***/ 767:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jsonwebtoken__);





var TABLE = '/user/';

// initial state
var state = {
    session: false,
    user: null

    // getters
};var getters = {
    getState: function getState(state) {
        return state;
    }

    // actions
};var actions = {
    getData: function getData(_ref, params) {
        var commit = _ref.commit;

        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].post(TABLE + "get/", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params)).then(function (res) {
            if (res.data.results == 1) {
                commit('setSessionData', res.data.data[0] || null);
                return true;
            } else {
                commit('setSessionData', null);
                return false;
            }
        }).catch(function (err) {
            commit('setSessionData', null);
            return false;
        });
    },
    signIn: function signIn(_ref2, params) {
        var commit = _ref2.commit;

        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].post(TABLE + "login/", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params)).then(function (res) {
            if (res.data.results == 1) {
                commit('setSessionData', res.data.data[0] || null);
                return true;
            } else {
                commit('setSessionData', null);
                return false;
            }
        }).catch(function (err) {
            commit('setSessionData', null);
            return false;
        });
    },
    update: function update(_ref3, params) {
        var dispatch = _ref3.dispatch;

        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].put(TABLE, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params)).then(function (res) {
            if (!res.data.errors) {
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    },
    setSessionData: function setSessionData(_ref4, data) {
        var commit = _ref4.commit;

        return commit('setSessionData', data);
    }
};

// mutations
var mutations = {
    setSessionData: function setSessionData(state, data) {
        if (data) {
            state.user = data;
            state.session = true;
        } else state.session = false;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ 800:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 802:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 837:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 838:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 839:
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),

/***/ 843:
/***/ (function(module, exports) {

module.exports = {"name":"elliptic","version":"6.4.1","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^1.4.3","coveralls":"^2.11.3","grunt":"^0.4.5","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^8.6.2","istanbul":"^0.4.2","jscs":"^2.9.0","jshint":"^2.6.0","mocha":"^2.1.0"},"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"}}

/***/ }),

/***/ 876:
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),

/***/ 897:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jsonwebtoken__);




var TABLE = '/user/';

// initial state
var state = {
    data: []

    // getters
};var getters = {
    getAllInstituicoes: function getAllInstituicoes(state) {
        return state.data.filter(function (el) {
            return el.super == 0;
        });
    },
    getAllSuper: function getAllSuper(state) {
        return state.data.filter(function (el) {
            return el.super == 1;
        });
    },
    getById: function getById(state) {
        return function (id) {
            return state.data.find(function (el) {
                return el.id_instituicao == id;
            });
        };
    }

    // actions
};var actions = {
    get: function get(_ref) {
        var commit = _ref.commit;

        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].get(TABLE).then(function (res) {
            commit('setData', res.data.data || null);
        }).catch(function (err) {
            commit('setData', null);
        });
    },
    insert: function insert(_ref2, params) {
        var dispatch = _ref2.dispatch;


        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].post(TABLE, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params)).then(function (res) {
            if (!res.data.errors) {
                dispatch('get');
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    },
    update: function update(_ref3, params) {
        var dispatch = _ref3.dispatch;

        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].put(TABLE, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params)).then(function (res) {
            if (!res.data.errors) {
                dispatch('get');
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    },
    delete: function _delete(_ref4, _ref5) {
        var dispatch = _ref4.dispatch;
        var id = _ref5.id;

        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].delete(TABLE + id).then(function (res) {
            if (!res.data.errors) {
                dispatch('get');
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    },
    updatePerfil: function updatePerfil(_ref6, params) {
        var dispatch = _ref6.dispatch;

        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].put(TABLE + 'update-perfil/', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params)).then(function (res) {
            if (!res.data.errors) {
                dispatch('get');
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    }
};

// mutations
var mutations = {
    setData: function setData(state, data) {
        state.data = data ? data : [];
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ 898:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jsonwebtoken__);




var TABLE = '/objetivo/';

// initial state
var state = {
    data: []

    // getters
};var getters = {
    getAll: function getAll(state) {
        return state.data;
    },
    getById: function getById(state) {
        return function (id) {
            if (!id) return;
            return state.data.find(function (el) {
                return el.id_objetivo == id;
            });
        };
    }

    // actions
};var actions = {
    get: function get(_ref) {
        var commit = _ref.commit;

        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].get(TABLE).then(function (res) {
            commit('setData', res.data.data || null);
        }).catch(function (err) {
            commit('setData', null);
        });
    },
    insert: function insert(_ref2, params) {
        var dispatch = _ref2.dispatch;


        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].post(TABLE, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params)).then(function (res) {
            if (!res.data.errors) {
                dispatch('get');
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    },
    update: function update(_ref3, params) {
        var dispatch = _ref3.dispatch;

        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].put(TABLE, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params)).then(function (res) {
            if (!res.data.errors) {
                dispatch('get');
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    },
    delete: function _delete(_ref4, _ref5) {
        var dispatch = _ref4.dispatch;
        var id = _ref5.id;

        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].delete(TABLE + id).then(function (res) {
            if (!res.data.errors) {
                dispatch('get');
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    }
};

// mutations
var mutations = {
    setData: function setData(state, data) {
        state.data = data ? data : [];
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ 899:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jsonwebtoken__);




var TABLE = '/medida/';

// initial state
var state = {
    data: []

    // getters
};var getters = {
    getAll: function getAll(state) {
        return state.data;
    },
    getById: function getById(state) {
        return function (id) {
            if (!id) return;
            return state.data.find(function (el) {
                return el.id_medida == id;
            });
        };
    },
    getMedidasByObjetivo: function getMedidasByObjetivo(state) {
        return function (id) {
            if (!id) return;
            return state.data.filter(function (el) {
                return el.id_objetivo == id;
            });
        };
    }

    // actions
};var actions = {
    get: function get(_ref) {
        var commit = _ref.commit;

        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].get(TABLE).then(function (res) {
            commit('setData', res.data.data || null);
        }).catch(function (err) {
            commit('setData', null);
        });
    },
    insert: function insert(_ref2, params) {
        var dispatch = _ref2.dispatch;


        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].post(TABLE, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params)).then(function (res) {
            if (!res.data.errors) {
                dispatch('get');
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    },
    update: function update(_ref3, params) {
        var dispatch = _ref3.dispatch;

        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].put(TABLE, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params)).then(function (res) {
            if (!res.data.errors) {
                dispatch('get');
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    },
    delete: function _delete(_ref4, _ref5) {
        var dispatch = _ref4.dispatch;
        var id = _ref5.id;

        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].delete(TABLE + id).then(function (res) {
            if (!res.data.errors) {
                dispatch('get');
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    }
};

// mutations
var mutations = {
    setData: function setData(state, data) {
        state.data = data ? data : [];
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ 900:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jsonwebtoken__);




var TABLE = '/acao/';

// initial state
var state = {
    data: []

    // getters
};var getters = {
    getAll: function getAll(state) {
        return state.data;
    },
    getById: function getById(state) {
        return function (id) {
            if (!id) return;
            return state.data.find(function (el) {
                return el.id_acao == id;
            });
        };
    },
    getAcoesByMedida: function getAcoesByMedida(state) {
        return function (id) {
            if (!id) return;
            return state.data.filter(function (el) {
                return el.id_medida == id;
            });
        };
    }

    // actions
};var actions = {
    get: function get(_ref) {
        var commit = _ref.commit;

        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].get(TABLE).then(function (res) {
            commit('setData', res.data.data || null);
        }).catch(function (err) {
            commit('setData', null);
        });
    },
    insert: function insert(_ref2, params) {
        var dispatch = _ref2.dispatch;


        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].post(TABLE, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params)).then(function (res) {
            if (!res.data.errors) {
                dispatch('get');
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    },
    update: function update(_ref3, params) {
        var dispatch = _ref3.dispatch;

        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].put(TABLE, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params)).then(function (res) {
            if (!res.data.errors) {
                dispatch('get');
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    },
    delete: function _delete(_ref4, _ref5) {
        var dispatch = _ref4.dispatch;
        var id = _ref5.id;

        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].delete(TABLE + id).then(function (res) {
            if (!res.data.errors) {
                dispatch('get');
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    }
};

// mutations
var mutations = {
    setData: function setData(state, data) {
        state.data = data ? data : [];
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ 901:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jsonwebtoken__);




var TABLE = '/dimensao/';

// initial state
var state = {
    data: []

    // getters
};var getters = {
    getAll: function getAll(state) {
        return state.data;
    },
    getById: function getById(state) {
        return function (id) {
            if (!id) return;
            return state.data.find(function (el) {
                return el.id_dimensao == id;
            });
        };
    }

    // actions
};var actions = {
    get: function get(_ref) {
        var commit = _ref.commit;

        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].get(TABLE).then(function (res) {
            commit('setData', res.data.data || null);
        }).catch(function (err) {
            commit('setData', null);
        });
    },
    insert: function insert(_ref2, params) {
        var dispatch = _ref2.dispatch;


        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].post(TABLE, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params)).then(function (res) {
            if (!res.data.errors) {
                dispatch('get');
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    },
    update: function update(_ref3, params) {
        var dispatch = _ref3.dispatch;

        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].put(TABLE, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params)).then(function (res) {
            if (!res.data.errors) {
                dispatch('get');
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    },
    delete: function _delete(_ref4, _ref5) {
        var dispatch = _ref4.dispatch;
        var id = _ref5.id;

        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].delete(TABLE + id).then(function (res) {
            if (!res.data.errors) {
                dispatch('get');
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    }
};

// mutations
var mutations = {
    setData: function setData(state, data) {
        state.data = data ? data : [];
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ 902:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jsonwebtoken__);




var TABLE = '/pergunta/';

// initial state
var state = {
    data: []

    // getters
};var getters = {
    getAll: function getAll(state) {
        return state.data;
    },
    getById: function getById(state) {
        return function (id) {
            if (!id) return;
            return state.data.find(function (el) {
                return el.id_pergunta == id;
            });
        };
    }

    // actions
};var actions = {
    get: function get(_ref) {
        var commit = _ref.commit;

        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].get(TABLE).then(function (res) {
            commit('setData', res.data.data || null);
        }).catch(function (err) {
            commit('setData', null);
        });
    },
    insert: function insert(_ref2, params) {
        var dispatch = _ref2.dispatch;


        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].post(TABLE, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params)).then(function (res) {
            if (!res.data.errors) {
                dispatch('get');
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    },
    update: function update(_ref3, params) {
        var dispatch = _ref3.dispatch;

        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].put(TABLE, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params)).then(function (res) {
            if (!res.data.errors) {
                dispatch('get');
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    },
    delete: function _delete(_ref4, _ref5) {
        var dispatch = _ref4.dispatch;
        var id = _ref5.id;

        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].delete(TABLE + id).then(function (res) {
            if (!res.data.errors) {
                dispatch('get');
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    }
};

// mutations
var mutations = {
    setData: function setData(state, data) {
        state.data = data ? data : [];
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ 903:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jsonwebtoken__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jsonwebtoken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jsonwebtoken__);



// initial state
var state = {
    data: [{
        id_tipo: 1,
        nome: 'Seleção única'
    }, {
        id_tipo: 2,
        nome: 'Seleção múltipla'
    }, {
        id_tipo: 3,
        nome: 'Campo texto aberto'
    }, {
        id_tipo: 4,
        nome: 'Campo numérico'
    }, {
        id_tipo: 5,
        nome: 'Níveis'
    }, {
        id_tipo: 6,
        nome: 'Seleção distrito'
    }, {
        id_tipo: 7,
        nome: 'Setores atividade'
    }, {
        id_tipo: 8,
        nome: 'Campo texto longo'
    }]

    // getters
};var getters = {
    getAll: function getAll(state) {
        return state.data;
    },
    getById: function getById(state) {
        return function (id) {
            if (!id) return;
            return state.data.find(function (el) {
                return el.id_tipo == id;
            });
        };
    }
};

var actions = {};

var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ 904:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jsonwebtoken__);




var TABLE = '/formulario/';

// initial state
var state = {
    data: []

    // getters
};var getters = {
    getAll: function getAll(state) {
        return state.data;
    },
    getById: function getById(state) {
        return function (id) {
            if (!id) return;
            return state.data.find(function (el) {
                return el.id_formulario == id;
            });
        };
    }

    // actions
};var actions = {
    get: function get(_ref) {
        var commit = _ref.commit;

        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].get(TABLE).then(function (res) {
            commit('setData', res.data.data || null);
        }).catch(function (err) {
            commit('setData', null);
        });
    },
    insert: function insert(_ref2, params) {
        var dispatch = _ref2.dispatch;


        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].post(TABLE, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params)).then(function (res) {
            if (!res.data.errors) {
                dispatch('get');
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    },
    update: function update(_ref3, params) {
        var dispatch = _ref3.dispatch;

        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].put(TABLE, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params)).then(function (res) {
            if (!res.data.errors) {
                dispatch('get');
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    },
    delete: function _delete(_ref4, _ref5) {
        var dispatch = _ref4.dispatch;
        var id = _ref5.id;

        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].delete(TABLE + id).then(function (res) {
            if (!res.data.errors) {
                dispatch('get');
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    }
};

// mutations
var mutations = {
    setData: function setData(state, data) {
        state.data = data ? data : [];
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ 905:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jsonwebtoken__);




var TABLE = '/setor/';

// initial state
var state = {
    data: []

    // getters
};var getters = {
    getAll: function getAll(state) {
        return state.data;
    },
    getById: function getById(state) {
        return function (id) {
            if (!id) return;
            return state.data.find(function (el) {
                return el.id_setor == id;
            });
        };
    }

    // actions
};var actions = {
    get: function get(_ref) {
        var commit = _ref.commit;

        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].get(TABLE).then(function (res) {
            commit('setData', res.data.data || null);
        }).catch(function (err) {
            commit('setData', null);
        });
    },
    insert: function insert(_ref2, params) {
        var dispatch = _ref2.dispatch;


        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].post(TABLE, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params)).then(function (res) {
            if (!res.data.errors) {
                dispatch('get');
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    },
    update: function update(_ref3, params) {
        var dispatch = _ref3.dispatch;

        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].put(TABLE, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params)).then(function (res) {
            if (!res.data.errors) {
                dispatch('get');
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    },
    delete: function _delete(_ref4, _ref5) {
        var dispatch = _ref4.dispatch;
        var id = _ref5.id;

        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].delete(TABLE + id).then(function (res) {
            if (!res.data.errors) {
                dispatch('get');
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    }
};

// mutations
var mutations = {
    setData: function setData(state, data) {
        state.data = data ? data : [];
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ 906:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jsonwebtoken__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jsonwebtoken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jsonwebtoken__);



var TABLE = '/acao/';

// initial state
var state = {
    data: [{
        id_distrito: '1',
        nome: 'Açores'
    }, {
        id_distrito: '2',
        nome: 'Aveiro'
    }, {
        id_distrito: '3',
        nome: 'Beja'
    }, {
        id_distrito: '4',
        nome: 'Braga'
    }, {
        id_distrito: '5',
        nome: 'Bragança'
    }, {
        id_distrito: '6',
        nome: 'Castelo Branco'
    }, {
        id_distrito: '7',
        nome: 'Coimbra'
    }, {
        id_distrito: '8',
        nome: 'Évora'
    }, {
        id_distrito: '9',
        nome: 'Faro'
    }, {
        id_distrito: '10',
        nome: 'Guarda'
    }, {
        id_distrito: '11',
        nome: 'Leiria'
    }, {
        id_distrito: '12',
        nome: 'Lisboa'
    }, {
        id_distrito: '13',
        nome: 'Madeira'
    }, {
        id_distrito: '14',
        nome: 'Portalegre'
    }, {
        id_distrito: '15',
        nome: 'Porto'
    }, {
        id_distrito: '16',
        nome: 'Santarém'
    }, {
        id_distrito: '17',
        nome: 'Setúbal'
    }, {
        id_distrito: '18',
        nome: 'Viana do Castelo'
    }, {
        id_distrito: '19',
        nome: 'Vila Real'
    }, {
        id_distrito: '20',
        nome: 'Viseu'
    }, {
        id_distrito: '21',
        nome: 'Nacional'
    }, {
        id_distrito: '22',
        nome: 'Fora de Portugal'
    }]

    // getters
};var getters = {
    getAll: function getAll(state) {
        return state.data;
    },
    getById: function getById(state) {
        return function (id) {
            if (!id) return;
            return state.data.find(function (el) {
                return el.id_distrito == id;
            });
        };
    }
};

var actions = {};

var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ 907:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jsonwebtoken__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3__ = __webpack_require__(908);





var TABLE = "/proposta/";

var calcActions = function calcActions(_ref) {
  var reportadas = _ref.reportadas,
      total = _ref.total;

  //return reportadas + "/" + total;
  try {
    var _total = reportadas > total ? reportadas : total;
    return reportadas + "/" + _total;
  } catch (error) {
    return reportadas + "/" + total;
  }
};

// initial state
var state = {
  data: [],
  stats: {
    objetivo: [],
    medida: [],
    acao: []
  }
};

// getters
var getters = {
  getAll: function getAll(state) {
    return state.data.filter(function (el) {
      return el.data_criacao;
    });
  },

  getPropostas: function getPropostas(state) {
    return state.data.filter(function (el) {
      return !el.data_criacao;
    });
  },

  getLivresAno: function getLivresAno(state) {
    return function (id, acao, instituicao) {
      if (!id || !acao || !instituicao) return;
      var array = state.data.filter(function (el) {
        return !el.data_criacao && el.id_ano == id && el.id_acao == acao && el.id_instituicao == instituicao;
      });

      return typeof array == "undefined" || array.length == 0 ? null : array[0].id_proposta;
    };
  },

  getAcoesByInstituicao: function getAcoesByInstituicao(state) {
    return function (id, acao, instituicao) {
      if (!id || !acao || !instituicao) return;

      var array = state.data.filter(function (el) {
        return !el.data_criacao && el.id_ano == id && el.id_acao == acao && el.id_instituicao == instituicao && el.submetida == 0 && el.reporte == 0;
      });

      return typeof array == "undefined" || array.length == 0 ? null : array;
    };
  },

  getStats: function getStats(state) {
    return state.stats;
  },

  getObjetivoAno: function getObjetivoAno(state) {
    return function (i, a, o) {
      if (!i || !a || !o) return;

      var obj = state.stats.objetivo.find(function (el) {
        var k = el.key.split("-");
        return Number(k[0]) == i && Number(k[1]) == a && Number(k[2]) == o;
      });

      if (typeof obj != "undefined") return obj.value.total > 0 ? calcActions(obj.value) : "-";else return "-";
    };
  },

  getMedidaAno: function getMedidaAno(state) {
    return function (i, a, m) {
      if (!i || !a || !m) return;

      var obj = state.stats.medida.find(function (el) {
        var k = el.key.split("-");
        return Number(k[0]) == i && Number(k[1]) == a && Number(k[2]) == m;
      });

      if (typeof obj != "undefined") return obj.value.total > 0 ? calcActions(obj.value) : "-";else return "-";
    };
  },

  getAcaoAno: function getAcaoAno(state) {
    return function (i, a, ac, tipo) {
      if (!i || !a || !ac) return;

      var obj = state.stats.acao.find(function (el) {
        var k = el.key.split("-");
        return Number(k[0]) == i && Number(k[1]) == a && Number(k[2]) == ac && Number(k[3]) == tipo;
      });

      if (typeof obj != "undefined") return obj.value.total > 0 ? calcActions(obj.value) : "-";else return "-";
    };
  },

  getById: function getById(state) {
    return function (id) {
      if (!id) return;
      return state.data.find(function (el) {
        return el.id_proposta == id;
      });
    };
  }
};

// actions
var actions = {
  get: function get(_ref2) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;
    var submetida = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].get(TABLE + "tipo/" + submetida).then(function (res) {
      if (res.data.data.length > 0) {
        if (submetida == 1) {
          commit("setData", res.data.data);
          //dispatch("get", 0);
        } else if (submetida == 0) {
          commit("updateData", res.data.data);
        }
      } else commit("setData", null);
      /*decode(res.data.data).then((r)=>{
                  if(r) {
                      if(submetida == 1){
                          commit('setData', r);
                          dispatch('get', 0);
                      }
                      else if(submetida == 0) {
                          commit('updateData', r);
                      }
                  }
                  else commit('setData', null)
              }); */
    }).catch(function (err) {
      commit("setData", null);
    });
  },
  getByInstituicao: function getByInstituicao(_ref3, id) {
    var commit = _ref3.commit;

    return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].get(TABLE + "params/" + id).then(function (res) {
      commit("setData", res.data.data || null);
    }).catch(function (err) {
      commit("setData", null);
    });
  },
  insert: function insert(_ref4, params) {
    var dispatch = _ref4.dispatch,
        rootState = _ref4.rootState;

    return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].post(TABLE, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params)).then(function (res) {
      if (!res.data.errors) {
        if (rootState.session.user.super == 0) dispatch("getByInstituicao", rootState.session.user.id_instituicao);else dispatch("get");

        return true;
      } else return false;
    }).catch(function (err) {
      return false;
    });
  },
  export: function _export(_ref5, params) {
    var dispatch = _ref5.dispatch;

    return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].post(TABLE + "exportar/", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params)).then(function (res) {
      if (!res.data.errors) return true;else return false;
    }).catch(function (err) {
      return false;
    });
  },
  add: function add(_ref6, params) {
    var dispatch = _ref6.dispatch,
        rootState = _ref6.rootState;

    return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].post(TABLE + "add/", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params)).then(function (res) {
      if (!res.data.errors) {
        if (rootState.session.user.super == 0) dispatch("getByInstituicao", rootState.session.user.id_instituicao);else dispatch("get");

        return true;
      } else return false;
    }).catch(function (err) {
      return false;
    });
  },
  clonar: function clonar(_ref7, params) {
    var dispatch = _ref7.dispatch,
        rootState = _ref7.rootState;

    return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].post(TABLE + "clonar/", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params)).then(function (res) {
      if (!res.data.errors) {
        if (rootState.session.user.super == 0) dispatch("getByInstituicao", rootState.session.user.id_instituicao);else dispatch("get");

        return true;
      } else return false;
    }).catch(function (err) {
      return false;
    });
  },
  remove: function remove(_ref8, params) {
    var dispatch = _ref8.dispatch,
        rootState = _ref8.rootState;

    return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].post(TABLE + "remove/", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params)).then(function (res) {
      if (!res.data.errors) {
        if (rootState.session.user.super == 0) dispatch("getByInstituicao", rootState.session.user.id_instituicao);else dispatch("get");

        return true;
      } else return false;
    }).catch(function (err) {
      return false;
    });
  },
  reporte: function reporte(_ref9, params) {
    var dispatch = _ref9.dispatch,
        rootState = _ref9.rootState;

    return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].post(TABLE + "reporte/", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params)).then(function (res) {
      if (!res.data.errors) {
        if (rootState.session.user.super == 0) dispatch("getByInstituicao", rootState.session.user.id_instituicao);else dispatch("get");

        return true;
      } else return false;
    }).catch(function (err) {
      return false;
    });
  },
  update: function update(_ref10, params) {
    var dispatch = _ref10.dispatch,
        rootState = _ref10.rootState;

    return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].put(TABLE, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params)).then(function (res) {
      if (!res.data.errors) {
        if (rootState.session.user.super == 0) dispatch("getByInstituicao", rootState.session.user.id_instituicao);else dispatch("get");

        return true;
      } else return false;
    }).catch(function (err) {
      return false;
    });
  },
  reverter_reporte: function reverter_reporte(_ref11, params) {
    var dispatch = _ref11.dispatch,
        rootState = _ref11.rootState;

    return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].put(TABLE + "reverter-reporte/", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params)).then(function (res) {
      if (!res.data.errors) {
        if (rootState.session.user.super == 0) dispatch("getByInstituicao", rootState.session.user.id_instituicao);else dispatch("get");

        return true;
      } else return false;
    }).catch(function (err) {
      return false;
    });
  },
  reverter_submissao: function reverter_submissao(_ref12, params) {
    var dispatch = _ref12.dispatch,
        rootState = _ref12.rootState;

    return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].put(TABLE + "reverter-submissao/", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params)).then(function (res) {
      if (!res.data.errors) {
        if (rootState.session.user.super == 0) dispatch("getByInstituicao", rootState.session.user.id_instituicao);else dispatch("get");

        return true;
      } else return false;
    }).catch(function (err) {
      return false;
    });
  },
  delete: function _delete(_ref13, _ref14) {
    var dispatch = _ref13.dispatch,
        rootState = _ref13.rootState;
    var id = _ref14.id;

    return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].delete(TABLE + id).then(function (res) {
      if (!res.data.errors) {
        if (rootState.session.user.super == 0) dispatch("getByInstituicao", rootState.session.user.id_instituicao);else dispatch("get");

        return true;
      } else return false;
    }).catch(function (err) {
      return false;
    });
  }
};

// mutations
var mutations = {
  setData: function setData(state, data) {
    state.data = data ? data : [];

    if (data) state.stats.acao = StatPerAcao(data);
  },
  updateData: function updateData(state, data) {
    if (data) {
      state.data = state.data.concat(data);
      state.stats.acao = state.stats.acao.concat(StatPerAcao(data));
    }
  }
};

function StatPerAcao(array) {
  var value = __WEBPACK_IMPORTED_MODULE_3_d3__["a" /* nest */]().key(function (d) {
    return d.id_instituicao + "-" + d.id_ano + "-" + d.id_acao + "-" + d.auto_proposta;
  }).rollup(function (v) {
    return {
      total: v.length,
      reportadas: __WEBPACK_IMPORTED_MODULE_3_d3__["b" /* sum */](v, function (d) {
        return d.reporte;
      })
    };
  }).entries(array);
  return value;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ })

},[599]);


// WEBPACK FOOTER //
// static/js/app.9e92c37055b303c537d0.js